if (T4AgentNT) {
    ! function(t, e) {
        "use strict";
        "object" == typeof module && "object" == typeof module.exports ? module.exports = t.document ? e(t, !0) : function(t) {
            if (!t.document) throw new Error("jQuery requires a window with a document");
            return e(t)
        } : e(t)
    }("undefined" != typeof window ? window : this, function(S, t) {
        "use strict";
        var e = [],
            n = Object.getPrototypeOf,
            a = e.slice,
            m = e.flat ? function(t) {
                return e.flat.call(t)
            } : function(t) {
                return e.concat.apply([], t)
            },
            l = e.push,
            o = e.indexOf,
            i = {},
            r = i.toString,
            g = i.hasOwnProperty,
            s = g.toString,
            u = s.call(Object),
            y = {},
            v = function(t) {
                return "function" == typeof t && "number" != typeof t.nodeType && "function" != typeof t.item
            },
            b = function(t) {
                return null != t && t === t.window
            },
            T = S.document,
            c = {
                type: !0,
                src: !0,
                nonce: !0,
                noModule: !0
            };

        function x(t, e, i) {
            var n, o, r = (i = i || T).createElement("script");
            if (r.text = t, e)
                for (n in c)(o = e[n] || e.getAttribute && e.getAttribute(n)) && r.setAttribute(n, o);
            i.head.appendChild(r).parentNode.removeChild(r)
        }

        function w(t) {
            return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? i[r.call(t)] || "object" : typeof t
        }
        var h = "3.6.0",
            E = function(t, e) {
                return new E.fn.init(t, e)
            };

        function d(t) {
            var e = !!t && "length" in t && t.length,
                i = w(t);
            return !v(t) && !b(t) && ("array" === i || 0 === e || "number" == typeof e && 0 < e && e - 1 in t)
        }
        E.fn = E.prototype = {
            jquery: h,
            constructor: E,
            length: 0,
            toArray: function() {
                return a.call(this)
            },
            get: function(t) {
                return null == t ? a.call(this) : t < 0 ? this[t + this.length] : this[t]
            },
            pushStack: function(t) {
                var e = E.merge(this.constructor(), t);
                return e.prevObject = this, e
            },
            each: function(t) {
                return E.each(this, t)
            },
            map: function(i) {
                return this.pushStack(E.map(this, function(t, e) {
                    return i.call(t, e, t)
                }))
            },
            slice: function() {
                return this.pushStack(a.apply(this, arguments))
            },
            first: function() {
                return this.eq(0)
            },
            last: function() {
                return this.eq(-1)
            },
            even: function() {
                return this.pushStack(E.grep(this, function(t, e) {
                    return (e + 1) % 2
                }))
            },
            odd: function() {
                return this.pushStack(E.grep(this, function(t, e) {
                    return e % 2
                }))
            },
            eq: function(t) {
                var e = this.length,
                    i = +t + (t < 0 ? e : 0);
                return this.pushStack(0 <= i && i < e ? [this[i]] : [])
            },
            end: function() {
                return this.prevObject || this.constructor()
            },
            push: l,
            sort: e.sort,
            splice: e.splice
        }, E.extend = E.fn.extend = function() {
            var t, e, i, n, o, r, s = arguments[0] || {},
                a = 1,
                l = arguments.length,
                u = !1;
            for ("boolean" == typeof s && (u = s, s = arguments[a] || {}, a++), "object" == typeof s || v(s) || (s = {}), a === l && (s = this, a--); a < l; a++)
                if (null != (t = arguments[a]))
                    for (e in t) n = t[e], "__proto__" !== e && s !== n && (u && n && (E.isPlainObject(n) || (o = Array.isArray(n))) ? (i = s[e], r = o && !Array.isArray(i) ? [] : o || E.isPlainObject(i) ? i : {}, o = !1, s[e] = E.extend(u, r, n)) : void 0 !== n && (s[e] = n));
            return s
        }, E.extend({
            expando: "jQuery" + (h + Math.random()).replace(/\D/g, ""),
            isReady: !0,
            error: function(t) {
                throw new Error(t)
            },
            noop: function() {},
            isPlainObject: function(t) {
                var e, i;
                return !(!t || "[object Object]" !== r.call(t) || (e = n(t)) && ("function" != typeof(i = g.call(e, "constructor") && e.constructor) || s.call(i) !== u))
            },
            isEmptyObject: function(t) {
                var e;
                for (e in t) return !1;
                return !0
            },
            globalEval: function(t, e, i) {
                x(t, {
                    nonce: e && e.nonce
                }, i)
            },
            each: function(t, e) {
                var i, n = 0;
                if (d(t))
                    for (i = t.length; n < i && !1 !== e.call(t[n], n, t[n]); n++);
                else
                    for (n in t)
                        if (!1 === e.call(t[n], n, t[n])) break;
                return t
            },
            makeArray: function(t, e) {
                var i = e || [];
                return null != t && (d(Object(t)) ? E.merge(i, "string" == typeof t ? [t] : t) : l.call(i, t)), i
            },
            inArray: function(t, e, i) {
                return null == e ? -1 : o.call(e, t, i)
            },
            merge: function(t, e) {
                for (var i = +e.length, n = 0, o = t.length; n < i; n++) t[o++] = e[n];
                return t.length = o, t
            },
            grep: function(t, e, i) {
                for (var n = [], o = 0, r = t.length, s = !i; o < r; o++) !e(t[o], o) !== s && n.push(t[o]);
                return n
            },
            map: function(t, e, i) {
                var n, o, r = 0,
                    s = [];
                if (d(t))
                    for (n = t.length; r < n; r++) null != (o = e(t[r], r, i)) && s.push(o);
                else
                    for (r in t) null != (o = e(t[r], r, i)) && s.push(o);
                return m(s)
            },
            guid: 1,
            support: y
        }), "function" == typeof Symbol && (E.fn[Symbol.iterator] = e[Symbol.iterator]), E.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(t, e) {
            i["[object " + e + "]"] = e.toLowerCase()
        });
        var f = function(i) {
            var t, f, x, r, o, p, h, m, w, l, u, _, S, s, T, g, a, c, y, E = "sizzle" + 1 * new Date,
                d = i.document,
                C = 0,
                n = 0,
                v = lt(),
                b = lt(),
                k = lt(),
                D = lt(),
                I = function(t, e) {
                    return t === e && (u = !0), 0
                },
                M = {}.hasOwnProperty,
                e = [],
                P = e.pop,
                O = e.push,
                z = e.push,
                L = e.slice,
                A = function(t, e) {
                    for (var i = 0, n = t.length; i < n; i++)
                        if (t[i] === e) return i;
                    return -1
                },
                N = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                j = "[\\x20\\t\\r\\n\\f]",
                W = "(?:\\\\[\\da-fA-F]{1,6}" + j + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
                R = "\\[" + j + "*(" + W + ")(?:" + j + "*([*^$|!~]?=)" + j + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + W + "))|)" + j + "*\\]",
                F = ":(" + W + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + R + ")*)|.*)\\)|)",
                H = new RegExp(j + "+", "g"),
                Y = new RegExp("^" + j + "+|((?:^|[^\\\\])(?:\\\\.)*)" + j + "+$", "g"),
                q = new RegExp("^" + j + "*," + j + "*"),
                B = new RegExp("^" + j + "*([>+~]|" + j + ")" + j + "*"),
                U = new RegExp(j + "|>"),
                $ = new RegExp(F),
                V = new RegExp("^" + W + "$"),
                G = {
                    ID: new RegExp("^#(" + W + ")"),
                    CLASS: new RegExp("^\\.(" + W + ")"),
                    TAG: new RegExp("^(" + W + "|[*])"),
                    ATTR: new RegExp("^" + R),
                    PSEUDO: new RegExp("^" + F),
                    CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + j + "*(even|odd|(([+-]|)(\\d*)n|)" + j + "*(?:([+-]|)" + j + "*(\\d+)|))" + j + "*\\)|)", "i"),
                    bool: new RegExp("^(?:" + N + ")$", "i"),
                    needsContext: new RegExp("^" + j + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + j + "*((?:-\\d)?\\d*)" + j + "*\\)|)(?=[^-]|$)", "i")
                },
                Q = /HTML$/i,
                X = /^(?:input|select|textarea|button)$/i,
                Z = /^h\d$/i,
                J = /^[^{]+\{\s*\[native \w/,
                K = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                tt = /[+~]/,
                et = new RegExp("\\\\[\\da-fA-F]{1,6}" + j + "?|\\\\([^\\r\\n\\f])", "g"),
                it = function(t, e) {
                    var i = "0x" + t.slice(1) - 65536;
                    return e || (i < 0 ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320))
                },
                nt = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                ot = function(t, e) {
                    return e ? "\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t
                },
                rt = function() {
                    _()
                },
                st = xt(function(t) {
                    return !0 === t.disabled && "fieldset" === t.nodeName.toLowerCase()
                }, {
                    dir: "parentNode",
                    next: "legend"
                });
            try {
                z.apply(e = L.call(d.childNodes), d.childNodes), e[d.childNodes.length].nodeType
            } catch (t) {
                z = {
                    apply: e.length ? function(t, e) {
                        O.apply(t, L.call(e))
                    } : function(t, e) {
                        for (var i = t.length, n = 0; t[i++] = e[n++];);
                        t.length = i - 1
                    }
                }
            }

            function at(t, e, i, n) {
                var o, r, s, a, l, u, c, h = e && e.ownerDocument,
                    d = e ? e.nodeType : 9;
                if (i = i || [], "string" != typeof t || !t || 1 !== d && 9 !== d && 11 !== d) return i;
                if (!n && (_(e), e = e || S, T)) {
                    if (11 !== d && (l = K.exec(t)))
                        if (o = l[1]) {
                            if (9 === d) {
                                if (!(s = e.getElementById(o))) return i;
                                if (s.id === o) return i.push(s), i
                            } else if (h && (s = h.getElementById(o)) && y(e, s) && s.id === o) return i.push(s), i
                        } else {
                            if (l[2]) return z.apply(i, e.getElementsByTagName(t)), i;
                            if ((o = l[3]) && f.getElementsByClassName && e.getElementsByClassName) return z.apply(i, e.getElementsByClassName(o)), i
                        } if (f.qsa && !D[t + " "] && (!g || !g.test(t)) && (1 !== d || "object" !== e.nodeName.toLowerCase())) {
                        if (c = t, h = e, 1 === d && (U.test(t) || B.test(t))) {
                            for ((h = tt.test(t) && yt(e.parentNode) || e) === e && f.scope || ((a = e.getAttribute("id")) ? a = a.replace(nt, ot) : e.setAttribute("id", a = E)), r = (u = p(t)).length; r--;) u[r] = (a ? "#" + a : ":scope") + " " + bt(u[r]);
                            c = u.join(",")
                        }
                        try {
                            return z.apply(i, h.querySelectorAll(c)), i
                        } catch (e) {
                            D(t, !0)
                        } finally {
                            a === E && e.removeAttribute("id")
                        }
                    }
                }
                return m(t.replace(Y, "$1"), e, i, n)
            }

            function lt() {
                var n = [];
                return function t(e, i) {
                    return n.push(e + " ") > x.cacheLength && delete t[n.shift()], t[e + " "] = i
                }
            }

            function ut(t) {
                return t[E] = !0, t
            }

            function ct(t) {
                var e = S.createElement("fieldset");
                try {
                    return !!t(e)
                } catch (t) {
                    return !1
                } finally {
                    e.parentNode && e.parentNode.removeChild(e), e = null
                }
            }

            function ht(t, e) {
                for (var i = t.split("|"), n = i.length; n--;) x.attrHandle[i[n]] = e
            }

            function dt(t, e) {
                var i = e && t,
                    n = i && 1 === t.nodeType && 1 === e.nodeType && t.sourceIndex - e.sourceIndex;
                if (n) return n;
                if (i)
                    for (; i = i.nextSibling;)
                        if (i === e) return -1;
                return t ? 1 : -1
            }

            function ft(e) {
                return function(t) {
                    return "input" === t.nodeName.toLowerCase() && t.type === e
                }
            }

            function pt(i) {
                return function(t) {
                    var e = t.nodeName.toLowerCase();
                    return ("input" === e || "button" === e) && t.type === i
                }
            }

            function mt(e) {
                return function(t) {
                    return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && st(t) === e : t.disabled === e : "label" in t && t.disabled === e
                }
            }

            function gt(s) {
                return ut(function(r) {
                    return r = +r, ut(function(t, e) {
                        for (var i, n = s([], t.length, r), o = n.length; o--;) t[i = n[o]] && (t[i] = !(e[i] = t[i]))
                    })
                })
            }

            function yt(t) {
                return t && void 0 !== t.getElementsByTagName && t
            }
            for (t in f = at.support = {}, o = at.isXML = function(t) {
                    var e = t && t.namespaceURI,
                        i = t && (t.ownerDocument || t).documentElement;
                    return !Q.test(e || i && i.nodeName || "HTML")
                }, _ = at.setDocument = function(t) {
                    var e, i, n = t ? t.ownerDocument || t : d;
                    return n != S && 9 === n.nodeType && n.documentElement && (s = (S = n).documentElement, T = !o(S), d != S && (i = S.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", rt, !1) : i.attachEvent && i.attachEvent("onunload", rt)), f.scope = ct(function(t) {
                        return s.appendChild(t).appendChild(S.createElement("div")), void 0 !== t.querySelectorAll && !t.querySelectorAll(":scope fieldset div").length
                    }), f.attributes = ct(function(t) {
                        return t.className = "i", !t.getAttribute("className")
                    }), f.getElementsByTagName = ct(function(t) {
                        return t.appendChild(S.createComment("")), !t.getElementsByTagName("*").length
                    }), f.getElementsByClassName = J.test(S.getElementsByClassName), f.getById = ct(function(t) {
                        return s.appendChild(t).id = E, !S.getElementsByName || !S.getElementsByName(E).length
                    }), f.getById ? (x.filter.ID = function(t) {
                        var e = t.replace(et, it);
                        return function(t) {
                            return t.getAttribute("id") === e
                        }
                    }, x.find.ID = function(t, e) {
                        if (void 0 !== e.getElementById && T) {
                            var i = e.getElementById(t);
                            return i ? [i] : []
                        }
                    }) : (x.filter.ID = function(t) {
                        var i = t.replace(et, it);
                        return function(t) {
                            var e = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
                            return e && e.value === i
                        }
                    }, x.find.ID = function(t, e) {
                        if (void 0 !== e.getElementById && T) {
                            var i, n, o, r = e.getElementById(t);
                            if (r) {
                                if ((i = r.getAttributeNode("id")) && i.value === t) return [r];
                                for (o = e.getElementsByName(t), n = 0; r = o[n++];)
                                    if ((i = r.getAttributeNode("id")) && i.value === t) return [r]
                            }
                            return []
                        }
                    }), x.find.TAG = f.getElementsByTagName ? function(t, e) {
                        return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : f.qsa ? e.querySelectorAll(t) : void 0
                    } : function(t, e) {
                        var i, n = [],
                            o = 0,
                            r = e.getElementsByTagName(t);
                        if ("*" !== t) return r;
                        for (; i = r[o++];) 1 === i.nodeType && n.push(i);
                        return n
                    }, x.find.CLASS = f.getElementsByClassName && function(t, e) {
                        if (void 0 !== e.getElementsByClassName && T) return e.getElementsByClassName(t)
                    }, a = [], g = [], (f.qsa = J.test(S.querySelectorAll)) && (ct(function(t) {
                        var e;
                        s.appendChild(t).innerHTML = "<a id='" + E + "'></a><select id='" + E + "-\r\\' msallowcapture=''><option selected=''></option></select>", t.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + j + "*(?:''|\"\")"), t.querySelectorAll("[selected]").length || g.push("\\[" + j + "*(?:value|" + N + ")"), t.querySelectorAll("[id~=" + E + "-]").length || g.push("~="), (e = S.createElement("input")).setAttribute("name", ""), t.appendChild(e), t.querySelectorAll("[name='']").length || g.push("\\[" + j + "*name" + j + "*=" + j + "*(?:''|\"\")"), t.querySelectorAll(":checked").length || g.push(":checked"), t.querySelectorAll("a#" + E + "+*").length || g.push(".#.+[+~]"), t.querySelectorAll("\\\f"), g.push("[\\r\\n\\f]")
                    }), ct(function(t) {
                        t.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                        var e = S.createElement("input");
                        e.setAttribute("type", "hidden"), t.appendChild(e).setAttribute("name", "D"), t.querySelectorAll("[name=d]").length && g.push("name" + j + "*[*^$|!~]?="), 2 !== t.querySelectorAll(":enabled").length && g.push(":enabled", ":disabled"), s.appendChild(t).disabled = !0, 2 !== t.querySelectorAll(":disabled").length && g.push(":enabled", ":disabled"), t.querySelectorAll("*,:x"), g.push(",.*:")
                    })), (f.matchesSelector = J.test(c = s.matches || s.webkitMatchesSelector || s.mozMatchesSelector || s.oMatchesSelector || s.msMatchesSelector)) && ct(function(t) {
                        f.disconnectedMatch = c.call(t, "*"), c.call(t, "[s!='']:x"), a.push("!=", F)
                    }), g = g.length && new RegExp(g.join("|")), a = a.length && new RegExp(a.join("|")), e = J.test(s.compareDocumentPosition), y = e || J.test(s.contains) ? function(t, e) {
                        var i = 9 === t.nodeType ? t.documentElement : t,
                            n = e && e.parentNode;
                        return t === n || !(!n || 1 !== n.nodeType || !(i.contains ? i.contains(n) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(n)))
                    } : function(t, e) {
                        if (e)
                            for (; e = e.parentNode;)
                                if (e === t) return !0;
                        return !1
                    }, I = e ? function(t, e) {
                        if (t === e) return u = !0, 0;
                        var i = !t.compareDocumentPosition - !e.compareDocumentPosition;
                        return i || (1 & (i = (t.ownerDocument || t) == (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || !f.sortDetached && e.compareDocumentPosition(t) === i ? t == S || t.ownerDocument == d && y(d, t) ? -1 : e == S || e.ownerDocument == d && y(d, e) ? 1 : l ? A(l, t) - A(l, e) : 0 : 4 & i ? -1 : 1)
                    } : function(t, e) {
                        if (t === e) return u = !0, 0;
                        var i, n = 0,
                            o = t.parentNode,
                            r = e.parentNode,
                            s = [t],
                            a = [e];
                        if (!o || !r) return t == S ? -1 : e == S ? 1 : o ? -1 : r ? 1 : l ? A(l, t) - A(l, e) : 0;
                        if (o === r) return dt(t, e);
                        for (i = t; i = i.parentNode;) s.unshift(i);
                        for (i = e; i = i.parentNode;) a.unshift(i);
                        for (; s[n] === a[n];) n++;
                        return n ? dt(s[n], a[n]) : s[n] == d ? -1 : a[n] == d ? 1 : 0
                    }), S
                }, at.matches = function(t, e) {
                    return at(t, null, null, e)
                }, at.matchesSelector = function(t, e) {
                    if (_(t), f.matchesSelector && T && !D[e + " "] && (!a || !a.test(e)) && (!g || !g.test(e))) try {
                        var i = c.call(t, e);
                        if (i || f.disconnectedMatch || t.document && 11 !== t.document.nodeType) return i
                    } catch (t) {
                        D(e, !0)
                    }
                    return 0 < at(e, S, null, [t]).length
                }, at.contains = function(t, e) {
                    return (t.ownerDocument || t) != S && _(t), y(t, e)
                }, at.attr = function(t, e) {
                    (t.ownerDocument || t) != S && _(t);
                    var i = x.attrHandle[e.toLowerCase()],
                        n = i && M.call(x.attrHandle, e.toLowerCase()) ? i(t, e, !T) : void 0;
                    return void 0 !== n ? n : f.attributes || !T ? t.getAttribute(e) : (n = t.getAttributeNode(e)) && n.specified ? n.value : null
                }, at.escape = function(t) {
                    return (t + "").replace(nt, ot)
                }, at.error = function(t) {
                    throw new Error("Syntax error, unrecognized expression: " + t)
                }, at.uniqueSort = function(t) {
                    var e, i = [],
                        n = 0,
                        o = 0;
                    if (u = !f.detectDuplicates, l = !f.sortStable && t.slice(0), t.sort(I), u) {
                        for (; e = t[o++];) e === t[o] && (n = i.push(o));
                        for (; n--;) t.splice(i[n], 1)
                    }
                    return l = null, t
                }, r = at.getText = function(t) {
                    var e, i = "",
                        n = 0,
                        o = t.nodeType;
                    if (o) {
                        if (1 === o || 9 === o || 11 === o) {
                            if ("string" == typeof t.textContent) return t.textContent;
                            for (t = t.firstChild; t; t = t.nextSibling) i += r(t)
                        } else if (3 === o || 4 === o) return t.nodeValue
                    } else
                        for (; e = t[n++];) i += r(e);
                    return i
                }, (x = at.selectors = {
                    cacheLength: 50,
                    createPseudo: ut,
                    match: G,
                    attrHandle: {},
                    find: {},
                    relative: {
                        ">": {
                            dir: "parentNode",
                            first: !0
                        },
                        " ": {
                            dir: "parentNode"
                        },
                        "+": {
                            dir: "previousSibling",
                            first: !0
                        },
                        "~": {
                            dir: "previousSibling"
                        }
                    },
                    preFilter: {
                        ATTR: function(t) {
                            return t[1] = t[1].replace(et, it), t[3] = (t[3] || t[4] || t[5] || "").replace(et, it), "~=" === t[2] && (t[3] = " " + t[3] + " "), t.slice(0, 4)
                        },
                        CHILD: function(t) {
                            return t[1] = t[1].toLowerCase(), "nth" === t[1].slice(0, 3) ? (t[3] || at.error(t[0]), t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])), t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && at.error(t[0]), t
                        },
                        PSEUDO: function(t) {
                            var e, i = !t[6] && t[2];
                            return G.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : i && $.test(i) && (e = p(i, !0)) && (e = i.indexOf(")", i.length - e) - i.length) && (t[0] = t[0].slice(0, e), t[2] = i.slice(0, e)), t.slice(0, 3))
                        }
                    },
                    filter: {
                        TAG: function(t) {
                            var e = t.replace(et, it).toLowerCase();
                            return "*" === t ? function() {
                                return !0
                            } : function(t) {
                                return t.nodeName && t.nodeName.toLowerCase() === e
                            }
                        },
                        CLASS: function(t) {
                            var e = v[t + " "];
                            return e || (e = new RegExp("(^|" + j + ")" + t + "(" + j + "|$)")) && v(t, function(t) {
                                return e.test("string" == typeof t.className && t.className || void 0 !== t.getAttribute && t.getAttribute("class") || "")
                            })
                        },
                        ATTR: function(i, n, o) {
                            return function(t) {
                                var e = at.attr(t, i);
                                return null == e ? "!=" === n : !n || (e += "", "=" === n ? e === o : "!=" === n ? e !== o : "^=" === n ? o && 0 === e.indexOf(o) : "*=" === n ? o && -1 < e.indexOf(o) : "$=" === n ? o && e.slice(-o.length) === o : "~=" === n ? -1 < (" " + e.replace(H, " ") + " ").indexOf(o) : "|=" === n && (e === o || e.slice(0, o.length + 1) === o + "-"))
                            }
                        },
                        CHILD: function(p, t, e, m, g) {
                            var y = "nth" !== p.slice(0, 3),
                                v = "last" !== p.slice(-4),
                                b = "of-type" === t;
                            return 1 === m && 0 === g ? function(t) {
                                return !!t.parentNode
                            } : function(t, e, i) {
                                var n, o, r, s, a, l, u = y !== v ? "nextSibling" : "previousSibling",
                                    c = t.parentNode,
                                    h = b && t.nodeName.toLowerCase(),
                                    d = !i && !b,
                                    f = !1;
                                if (c) {
                                    if (y) {
                                        for (; u;) {
                                            for (s = t; s = s[u];)
                                                if (b ? s.nodeName.toLowerCase() === h : 1 === s.nodeType) return !1;
                                            l = u = "only" === p && !l && "nextSibling"
                                        }
                                        return !0
                                    }
                                    if (l = [v ? c.firstChild : c.lastChild], v && d) {
                                        for (f = (a = (n = (o = (r = (s = c)[E] || (s[E] = {}))[s.uniqueID] || (r[s.uniqueID] = {}))[p] || [])[0] === C && n[1]) && n[2], s = a && c.childNodes[a]; s = ++a && s && s[u] || (f = a = 0) || l.pop();)
                                            if (1 === s.nodeType && ++f && s === t) {
                                                o[p] = [C, a, f];
                                                break
                                            }
                                    } else if (d && (f = a = (n = (o = (r = (s = t)[E] || (s[E] = {}))[s.uniqueID] || (r[s.uniqueID] = {}))[p] || [])[0] === C && n[1]), !1 === f)
                                        for (;
                                            (s = ++a && s && s[u] || (f = a = 0) || l.pop()) && ((b ? s.nodeName.toLowerCase() !== h : 1 !== s.nodeType) || !++f || (d && ((o = (r = s[E] || (s[E] = {}))[s.uniqueID] || (r[s.uniqueID] = {}))[p] = [C, f]), s !== t)););
                                    return (f -= g) === m || f % m == 0 && 0 <= f / m
                                }
                            }
                        },
                        PSEUDO: function(t, r) {
                            var e, s = x.pseudos[t] || x.setFilters[t.toLowerCase()] || at.error("unsupported pseudo: " + t);
                            return s[E] ? s(r) : 1 < s.length ? (e = [t, t, "", r], x.setFilters.hasOwnProperty(t.toLowerCase()) ? ut(function(t, e) {
                                for (var i, n = s(t, r), o = n.length; o--;) t[i = A(t, n[o])] = !(e[i] = n[o])
                            }) : function(t) {
                                return s(t, 0, e)
                            }) : s
                        }
                    },
                    pseudos: {
                        not: ut(function(t) {
                            var n = [],
                                o = [],
                                a = h(t.replace(Y, "$1"));
                            return a[E] ? ut(function(t, e, i, n) {
                                for (var o, r = a(t, null, n, []), s = t.length; s--;)(o = r[s]) && (t[s] = !(e[s] = o))
                            }) : function(t, e, i) {
                                return n[0] = t, a(n, null, i, o), n[0] = null, !o.pop()
                            }
                        }),
                        has: ut(function(e) {
                            return function(t) {
                                return 0 < at(e, t).length
                            }
                        }),
                        contains: ut(function(e) {
                            return e = e.replace(et, it),
                                function(t) {
                                    return -1 < (t.textContent || r(t)).indexOf(e)
                                }
                        }),
                        lang: ut(function(i) {
                            return V.test(i || "") || at.error("unsupported lang: " + i), i = i.replace(et, it).toLowerCase(),
                                function(t) {
                                    var e;
                                    do {
                                        if (e = T ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (e = e.toLowerCase()) === i || 0 === e.indexOf(i + "-")
                                    } while ((t = t.parentNode) && 1 === t.nodeType);
                                    return !1
                                }
                        }),
                        target: function(t) {
                            var e = i.location && i.location.hash;
                            return e && e.slice(1) === t.id
                        },
                        root: function(t) {
                            return t === s
                        },
                        focus: function(t) {
                            return t === S.activeElement && (!S.hasFocus || S.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                        },
                        enabled: mt(!1),
                        disabled: mt(!0),
                        checked: function(t) {
                            var e = t.nodeName.toLowerCase();
                            return "input" === e && !!t.checked || "option" === e && !!t.selected
                        },
                        selected: function(t) {
                            return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected
                        },
                        empty: function(t) {
                            for (t = t.firstChild; t; t = t.nextSibling)
                                if (t.nodeType < 6) return !1;
                            return !0
                        },
                        parent: function(t) {
                            return !x.pseudos.empty(t)
                        },
                        header: function(t) {
                            return Z.test(t.nodeName)
                        },
                        input: function(t) {
                            return X.test(t.nodeName)
                        },
                        button: function(t) {
                            var e = t.nodeName.toLowerCase();
                            return "input" === e && "button" === t.type || "button" === e
                        },
                        text: function(t) {
                            var e;
                            return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase())
                        },
                        first: gt(function() {
                            return [0]
                        }),
                        last: gt(function(t, e) {
                            return [e - 1]
                        }),
                        eq: gt(function(t, e, i) {
                            return [i < 0 ? i + e : i]
                        }),
                        even: gt(function(t, e) {
                            for (var i = 0; i < e; i += 2) t.push(i);
                            return t
                        }),
                        odd: gt(function(t, e) {
                            for (var i = 1; i < e; i += 2) t.push(i);
                            return t
                        }),
                        lt: gt(function(t, e, i) {
                            for (var n = i < 0 ? i + e : e < i ? e : i; 0 <= --n;) t.push(n);
                            return t
                        }),
                        gt: gt(function(t, e, i) {
                            for (var n = i < 0 ? i + e : i; ++n < e;) t.push(n);
                            return t
                        })
                    }
                }).pseudos.nth = x.pseudos.eq, {
                    radio: !0,
                    checkbox: !0,
                    file: !0,
                    password: !0,
                    image: !0
                }) x.pseudos[t] = ft(t);
            for (t in {
                    submit: !0,
                    reset: !0
                }) x.pseudos[t] = pt(t);

            function vt() {}

            function bt(t) {
                for (var e = 0, i = t.length, n = ""; e < i; e++) n += t[e].value;
                return n
            }

            function xt(a, t, e) {
                var l = t.dir,
                    u = t.next,
                    c = u || l,
                    h = e && "parentNode" === c,
                    d = n++;
                return t.first ? function(t, e, i) {
                    for (; t = t[l];)
                        if (1 === t.nodeType || h) return a(t, e, i);
                    return !1
                } : function(t, e, i) {
                    var n, o, r, s = [C, d];
                    if (i) {
                        for (; t = t[l];)
                            if ((1 === t.nodeType || h) && a(t, e, i)) return !0
                    } else
                        for (; t = t[l];)
                            if (1 === t.nodeType || h)
                                if (o = (r = t[E] || (t[E] = {}))[t.uniqueID] || (r[t.uniqueID] = {}), u && u === t.nodeName.toLowerCase()) t = t[l] || t;
                                else {
                                    if ((n = o[c]) && n[0] === C && n[1] === d) return s[2] = n[2];
                                    if ((o[c] = s)[2] = a(t, e, i)) return !0
                                } return !1
                }
            }

            function wt(o) {
                return 1 < o.length ? function(t, e, i) {
                    for (var n = o.length; n--;)
                        if (!o[n](t, e, i)) return !1;
                    return !0
                } : o[0]
            }

            function _t(t, e, i, n, o) {
                for (var r, s = [], a = 0, l = t.length, u = null != e; a < l; a++)(r = t[a]) && (i && !i(r, n, o) || (s.push(r), u && e.push(a)));
                return s
            }

            function St(f, p, m, g, y, t) {
                return g && !g[E] && (g = St(g)), y && !y[E] && (y = St(y, t)), ut(function(t, e, i, n) {
                    var o, r, s, a = [],
                        l = [],
                        u = e.length,
                        c = t || function(t, e, i) {
                            for (var n = 0, o = e.length; n < o; n++) at(t, e[n], i);
                            return i
                        }(p || "*", i.nodeType ? [i] : i, []),
                        h = !f || !t && p ? c : _t(c, a, f, i, n),
                        d = m ? y || (t ? f : u || g) ? [] : e : h;
                    if (m && m(h, d, i, n), g)
                        for (o = _t(d, l), g(o, [], i, n), r = o.length; r--;)(s = o[r]) && (d[l[r]] = !(h[l[r]] = s));
                    if (t) {
                        if (y || f) {
                            if (y) {
                                for (o = [], r = d.length; r--;)(s = d[r]) && o.push(h[r] = s);
                                y(null, d = [], o, n)
                            }
                            for (r = d.length; r--;)(s = d[r]) && -1 < (o = y ? A(t, s) : a[r]) && (t[o] = !(e[o] = s))
                        }
                    } else d = _t(d === e ? d.splice(u, d.length) : d), y ? y(null, e, d, n) : z.apply(e, d)
                })
            }

            function Tt(t) {
                for (var o, e, i, n = t.length, r = x.relative[t[0].type], s = r || x.relative[" "], a = r ? 1 : 0, l = xt(function(t) {
                        return t === o
                    }, s, !0), u = xt(function(t) {
                        return -1 < A(o, t)
                    }, s, !0), c = [function(t, e, i) {
                        var n = !r && (i || e !== w) || ((o = e).nodeType ? l(t, e, i) : u(t, e, i));
                        return o = null, n
                    }]; a < n; a++)
                    if (e = x.relative[t[a].type]) c = [xt(wt(c), e)];
                    else {
                        if ((e = x.filter[t[a].type].apply(null, t[a].matches))[E]) {
                            for (i = ++a; i < n && !x.relative[t[i].type]; i++);
                            return St(1 < a && wt(c), 1 < a && bt(t.slice(0, a - 1).concat({
                                value: " " === t[a - 2].type ? "*" : ""
                            })).replace(Y, "$1"), e, a < i && Tt(t.slice(a, i)), i < n && Tt(t = t.slice(i)), i < n && bt(t))
                        }
                        c.push(e)
                    } return wt(c)
            }
            return vt.prototype = x.filters = x.pseudos, x.setFilters = new vt, p = at.tokenize = function(t, e) {
                var i, n, o, r, s, a, l, u = b[t + " "];
                if (u) return e ? 0 : u.slice(0);
                for (s = t, a = [], l = x.preFilter; s;) {
                    for (r in i && !(n = q.exec(s)) || (n && (s = s.slice(n[0].length) || s), a.push(o = [])), i = !1, (n = B.exec(s)) && (i = n.shift(), o.push({
                            value: i,
                            type: n[0].replace(Y, " ")
                        }), s = s.slice(i.length)), x.filter) !(n = G[r].exec(s)) || l[r] && !(n = l[r](n)) || (i = n.shift(), o.push({
                        value: i,
                        type: r,
                        matches: n
                    }), s = s.slice(i.length));
                    if (!i) break
                }
                return e ? s.length : s ? at.error(t) : b(t, a).slice(0)
            }, h = at.compile = function(t, e) {
                var i, g, y, v, b, n, o = [],
                    r = [],
                    s = k[t + " "];
                if (!s) {
                    for (e || (e = p(t)), i = e.length; i--;)(s = Tt(e[i]))[E] ? o.push(s) : r.push(s);
                    (s = k(t, (g = r, v = 0 < (y = o).length, b = 0 < g.length, n = function(t, e, i, n, o) {
                        var r, s, a, l = 0,
                            u = "0",
                            c = t && [],
                            h = [],
                            d = w,
                            f = t || b && x.find.TAG("*", o),
                            p = C += null == d ? 1 : Math.random() || .1,
                            m = f.length;
                        for (o && (w = e == S || e || o); u !== m && null != (r = f[u]); u++) {
                            if (b && r) {
                                for (s = 0, e || r.ownerDocument == S || (_(r), i = !T); a = g[s++];)
                                    if (a(r, e || S, i)) {
                                        n.push(r);
                                        break
                                    } o && (C = p)
                            }
                            v && ((r = !a && r) && l--, t && c.push(r))
                        }
                        if (l += u, v && u !== l) {
                            for (s = 0; a = y[s++];) a(c, h, e, i);
                            if (t) {
                                if (0 < l)
                                    for (; u--;) c[u] || h[u] || (h[u] = P.call(n));
                                h = _t(h)
                            }
                            z.apply(n, h), o && !t && 0 < h.length && 1 < l + y.length && at.uniqueSort(n)
                        }
                        return o && (C = p, w = d), c
                    }, v ? ut(n) : n))).selector = t
                }
                return s
            }, m = at.select = function(t, e, i, n) {
                var o, r, s, a, l, u = "function" == typeof t && t,
                    c = !n && p(t = u.selector || t);
                if (i = i || [], 1 === c.length) {
                    if (2 < (r = c[0] = c[0].slice(0)).length && "ID" === (s = r[0]).type && 9 === e.nodeType && T && x.relative[r[1].type]) {
                        if (!(e = (x.find.ID(s.matches[0].replace(et, it), e) || [])[0])) return i;
                        u && (e = e.parentNode), t = t.slice(r.shift().value.length)
                    }
                    for (o = G.needsContext.test(t) ? 0 : r.length; o-- && (s = r[o], !x.relative[a = s.type]);)
                        if ((l = x.find[a]) && (n = l(s.matches[0].replace(et, it), tt.test(r[0].type) && yt(e.parentNode) || e))) {
                            if (r.splice(o, 1), !(t = n.length && bt(r))) return z.apply(i, n), i;
                            break
                        }
                }
                return (u || h(t, c))(n, e, !T, i, !e || tt.test(t) && yt(e.parentNode) || e), i
            }, f.sortStable = E.split("").sort(I).join("") === E, f.detectDuplicates = !!u, _(), f.sortDetached = ct(function(t) {
                return 1 & t.compareDocumentPosition(S.createElement("fieldset"))
            }), ct(function(t) {
                return t.innerHTML = "<a href='#'></a>", "#" === t.firstChild.getAttribute("href")
            }) || ht("type|href|height|width", function(t, e, i) {
                if (!i) return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
            }), f.attributes && ct(function(t) {
                return t.innerHTML = "<input/>", t.firstChild.setAttribute("value", ""), "" === t.firstChild.getAttribute("value")
            }) || ht("value", function(t, e, i) {
                if (!i && "input" === t.nodeName.toLowerCase()) return t.defaultValue
            }), ct(function(t) {
                return null == t.getAttribute("disabled")
            }) || ht(N, function(t, e, i) {
                var n;
                if (!i) return !0 === t[e] ? e.toLowerCase() : (n = t.getAttributeNode(e)) && n.specified ? n.value : null
            }), at
        }(S);
        E.find = f, E.expr = f.selectors, E.expr[":"] = E.expr.pseudos, E.uniqueSort = E.unique = f.uniqueSort, E.text = f.getText, E.isXMLDoc = f.isXML, E.contains = f.contains, E.escapeSelector = f.escape;
        var p = function(t, e, i) {
                for (var n = [], o = void 0 !== i;
                    (t = t[e]) && 9 !== t.nodeType;)
                    if (1 === t.nodeType) {
                        if (o && E(t).is(i)) break;
                        n.push(t)
                    } return n
            },
            _ = function(t, e) {
                for (var i = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && i.push(t);
                return i
            },
            C = E.expr.match.needsContext;

        function k(t, e) {
            return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
        }
        var D = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

        function I(t, i, n) {
            return v(i) ? E.grep(t, function(t, e) {
                return !!i.call(t, e, t) !== n
            }) : i.nodeType ? E.grep(t, function(t) {
                return t === i !== n
            }) : "string" != typeof i ? E.grep(t, function(t) {
                return -1 < o.call(i, t) !== n
            }) : E.filter(i, t, n)
        }
        E.filter = function(t, e, i) {
            var n = e[0];
            return i && (t = ":not(" + t + ")"), 1 === e.length && 1 === n.nodeType ? E.find.matchesSelector(n, t) ? [n] : [] : E.find.matches(t, E.grep(e, function(t) {
                return 1 === t.nodeType
            }))
        }, E.fn.extend({
            find: function(t) {
                var e, i, n = this.length,
                    o = this;
                if ("string" != typeof t) return this.pushStack(E(t).filter(function() {
                    for (e = 0; e < n; e++)
                        if (E.contains(o[e], this)) return !0
                }));
                for (i = this.pushStack([]), e = 0; e < n; e++) E.find(t, o[e], i);
                return 1 < n ? E.uniqueSort(i) : i
            },
            filter: function(t) {
                return this.pushStack(I(this, t || [], !1))
            },
            not: function(t) {
                return this.pushStack(I(this, t || [], !0))
            },
            is: function(t) {
                return !!I(this, "string" == typeof t && C.test(t) ? E(t) : t || [], !1).length
            }
        });
        var M, P = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
        (E.fn.init = function(t, e, i) {
            var n, o;
            if (!t) return this;
            if (i = i || M, "string" != typeof t) return t.nodeType ? (this[0] = t, this.length = 1, this) : v(t) ? void 0 !== i.ready ? i.ready(t) : t(E) : E.makeArray(t, this);
            if (!(n = "<" === t[0] && ">" === t[t.length - 1] && 3 <= t.length ? [null, t, null] : P.exec(t)) || !n[1] && e) return !e || e.jquery ? (e || i).find(t) : this.constructor(e).find(t);
            if (n[1]) {
                if (e = e instanceof E ? e[0] : e, E.merge(this, E.parseHTML(n[1], e && e.nodeType ? e.ownerDocument || e : T, !0)), D.test(n[1]) && E.isPlainObject(e))
                    for (n in e) v(this[n]) ? this[n](e[n]) : this.attr(n, e[n]);
                return this
            }
            return (o = T.getElementById(n[2])) && (this[0] = o, this.length = 1), this
        }).prototype = E.fn, M = E(T);
        var O = /^(?:parents|prev(?:Until|All))/,
            z = {
                children: !0,
                contents: !0,
                next: !0,
                prev: !0
            };

        function L(t, e) {
            for (;
                (t = t[e]) && 1 !== t.nodeType;);
            return t
        }
        E.fn.extend({
            has: function(t) {
                var e = E(t, this),
                    i = e.length;
                return this.filter(function() {
                    for (var t = 0; t < i; t++)
                        if (E.contains(this, e[t])) return !0
                })
            },
            closest: function(t, e) {
                var i, n = 0,
                    o = this.length,
                    r = [],
                    s = "string" != typeof t && E(t);
                if (!C.test(t))
                    for (; n < o; n++)
                        for (i = this[n]; i && i !== e; i = i.parentNode)
                            if (i.nodeType < 11 && (s ? -1 < s.index(i) : 1 === i.nodeType && E.find.matchesSelector(i, t))) {
                                r.push(i);
                                break
                            } return this.pushStack(1 < r.length ? E.uniqueSort(r) : r)
            },
            index: function(t) {
                return t ? "string" == typeof t ? o.call(E(t), this[0]) : o.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
            },
            add: function(t, e) {
                return this.pushStack(E.uniqueSort(E.merge(this.get(), E(t, e))))
            },
            addBack: function(t) {
                return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
            }
        }), E.each({
            parent: function(t) {
                var e = t.parentNode;
                return e && 11 !== e.nodeType ? e : null
            },
            parents: function(t) {
                return p(t, "parentNode")
            },
            parentsUntil: function(t, e, i) {
                return p(t, "parentNode", i)
            },
            next: function(t) {
                return L(t, "nextSibling")
            },
            prev: function(t) {
                return L(t, "previousSibling")
            },
            nextAll: function(t) {
                return p(t, "nextSibling")
            },
            prevAll: function(t) {
                return p(t, "previousSibling")
            },
            nextUntil: function(t, e, i) {
                return p(t, "nextSibling", i)
            },
            prevUntil: function(t, e, i) {
                return p(t, "previousSibling", i)
            },
            siblings: function(t) {
                return _((t.parentNode || {}).firstChild, t)
            },
            children: function(t) {
                return _(t.firstChild)
            },
            contents: function(t) {
                return null != t.contentDocument && n(t.contentDocument) ? t.contentDocument : (k(t, "template") && (t = t.content || t), E.merge([], t.childNodes))
            }
        }, function(n, o) {
            E.fn[n] = function(t, e) {
                var i = E.map(this, o, t);
                return "Until" !== n.slice(-5) && (e = t), e && "string" == typeof e && (i = E.filter(e, i)), 1 < this.length && (z[n] || E.uniqueSort(i), O.test(n) && i.reverse()), this.pushStack(i)
            }
        });
        var A = /[^\x20\t\r\n\f]+/g;

        function N(t) {
            return t
        }

        function j(t) {
            throw t
        }

        function W(t, e, i, n) {
            var o;
            try {
                t && v(o = t.promise) ? o.call(t).done(e).fail(i) : t && v(o = t.then) ? o.call(t, e, i) : e.apply(void 0, [t].slice(n))
            } catch (t) {
                i.apply(void 0, [t])
            }
        }
        E.Callbacks = function(n) {
            var t, i;
            n = "string" == typeof n ? (t = n, i = {}, E.each(t.match(A) || [], function(t, e) {
                i[e] = !0
            }), i) : E.extend({}, n);
            var o, e, r, s, a = [],
                l = [],
                u = -1,
                c = function() {
                    for (s = s || n.once, r = o = !0; l.length; u = -1)
                        for (e = l.shift(); ++u < a.length;) !1 === a[u].apply(e[0], e[1]) && n.stopOnFalse && (u = a.length, e = !1);
                    n.memory || (e = !1), o = !1, s && (a = e ? [] : "")
                },
                h = {
                    add: function() {
                        return a && (e && !o && (u = a.length - 1, l.push(e)), function i(t) {
                            E.each(t, function(t, e) {
                                v(e) ? n.unique && h.has(e) || a.push(e) : e && e.length && "string" !== w(e) && i(e)
                            })
                        }(arguments), e && !o && c()), this
                    },
                    remove: function() {
                        return E.each(arguments, function(t, e) {
                            for (var i; - 1 < (i = E.inArray(e, a, i));) a.splice(i, 1), i <= u && u--
                        }), this
                    },
                    has: function(t) {
                        return t ? -1 < E.inArray(t, a) : 0 < a.length
                    },
                    empty: function() {
                        return a && (a = []), this
                    },
                    disable: function() {
                        return s = l = [], a = e = "", this
                    },
                    disabled: function() {
                        return !a
                    },
                    lock: function() {
                        return s = l = [], e || o || (a = e = ""), this
                    },
                    locked: function() {
                        return !!s
                    },
                    fireWith: function(t, e) {
                        return s || (e = [t, (e = e || []).slice ? e.slice() : e], l.push(e), o || c()), this
                    },
                    fire: function() {
                        return h.fireWith(this, arguments), this
                    },
                    fired: function() {
                        return !!r
                    }
                };
            return h
        }, E.extend({
            Deferred: function(t) {
                var r = [
                        ["notify", "progress", E.Callbacks("memory"), E.Callbacks("memory"), 2],
                        ["resolve", "done", E.Callbacks("once memory"), E.Callbacks("once memory"), 0, "resolved"],
                        ["reject", "fail", E.Callbacks("once memory"), E.Callbacks("once memory"), 1, "rejected"]
                    ],
                    o = "pending",
                    s = {
                        state: function() {
                            return o
                        },
                        always: function() {
                            return a.done(arguments).fail(arguments), this
                        },
                        catch: function(t) {
                            return s.then(null, t)
                        },
                        pipe: function() {
                            var o = arguments;
                            return E.Deferred(function(n) {
                                E.each(r, function(t, e) {
                                    var i = v(o[e[4]]) && o[e[4]];
                                    a[e[1]](function() {
                                        var t = i && i.apply(this, arguments);
                                        t && v(t.promise) ? t.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[e[0] + "With"](this, i ? [t] : arguments)
                                    })
                                }), o = null
                            }).promise()
                        },
                        then: function(e, i, n) {
                            var l = 0;

                            function u(o, r, s, a) {
                                return function() {
                                    var i = this,
                                        n = arguments,
                                        t = function() {
                                            var t, e;
                                            if (!(o < l)) {
                                                if ((t = s.apply(i, n)) === r.promise()) throw new TypeError("Thenable self-resolution");
                                                e = t && ("object" == typeof t || "function" == typeof t) && t.then, v(e) ? a ? e.call(t, u(l, r, N, a), u(l, r, j, a)) : (l++, e.call(t, u(l, r, N, a), u(l, r, j, a), u(l, r, N, r.notifyWith))) : (s !== N && (i = void 0, n = [t]), (a || r.resolveWith)(i, n))
                                            }
                                        },
                                        e = a ? t : function() {
                                            try {
                                                t()
                                            } catch (t) {
                                                E.Deferred.exceptionHook && E.Deferred.exceptionHook(t, e.stackTrace), l <= o + 1 && (s !== j && (i = void 0, n = [t]), r.rejectWith(i, n))
                                            }
                                        };
                                    o ? e() : (E.Deferred.getStackHook && (e.stackTrace = E.Deferred.getStackHook()), S.setTimeout(e))
                                }
                            }
                            return E.Deferred(function(t) {
                                r[0][3].add(u(0, t, v(n) ? n : N, t.notifyWith)), r[1][3].add(u(0, t, v(e) ? e : N)), r[2][3].add(u(0, t, v(i) ? i : j))
                            }).promise()
                        },
                        promise: function(t) {
                            return null != t ? E.extend(t, s) : s
                        }
                    },
                    a = {};
                return E.each(r, function(t, e) {
                    var i = e[2],
                        n = e[5];
                    s[e[1]] = i.add, n && i.add(function() {
                        o = n
                    }, r[3 - t][2].disable, r[3 - t][3].disable, r[0][2].lock, r[0][3].lock), i.add(e[3].fire), a[e[0]] = function() {
                        return a[e[0] + "With"](this === a ? void 0 : this, arguments), this
                    }, a[e[0] + "With"] = i.fireWith
                }), s.promise(a), t && t.call(a, a), a
            },
            when: function(t) {
                var i = arguments.length,
                    e = i,
                    n = Array(e),
                    o = a.call(arguments),
                    r = E.Deferred(),
                    s = function(e) {
                        return function(t) {
                            n[e] = this, o[e] = 1 < arguments.length ? a.call(arguments) : t, --i || r.resolveWith(n, o)
                        }
                    };
                if (i <= 1 && (W(t, r.done(s(e)).resolve, r.reject, !i), "pending" === r.state() || v(o[e] && o[e].then))) return r.then();
                for (; e--;) W(o[e], s(e), r.reject);
                return r.promise()
            }
        });
        var R = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
        E.Deferred.exceptionHook = function(t, e) {
            S.console && S.console.warn && t && R.test(t.name) && S.console.warn("jQuery.Deferred exception: " + t.message, t.stack, e)
        }, E.readyException = function(t) {
            S.setTimeout(function() {
                throw t
            })
        };
        var F = E.Deferred();

        function H() {
            T.removeEventListener("DOMContentLoaded", H), S.removeEventListener("load", H), E.ready()
        }
        E.fn.ready = function(t) {
            return F.then(t).catch(function(t) {
                E.readyException(t)
            }), this
        }, E.extend({
            isReady: !1,
            readyWait: 1,
            ready: function(t) {
                (!0 === t ? --E.readyWait : E.isReady) || (E.isReady = !0) !== t && 0 < --E.readyWait || F.resolveWith(T, [E])
            }
        }), E.ready.then = F.then, "complete" === T.readyState || "loading" !== T.readyState && !T.documentElement.doScroll ? S.setTimeout(E.ready) : (T.addEventListener("DOMContentLoaded", H), S.addEventListener("load", H));
        var Y = function(t, e, i, n, o, r, s) {
                var a = 0,
                    l = t.length,
                    u = null == i;
                if ("object" === w(i))
                    for (a in o = !0, i) Y(t, e, a, i[a], !0, r, s);
                else if (void 0 !== n && (o = !0, v(n) || (s = !0), u && (e = s ? (e.call(t, n), null) : (u = e, function(t, e, i) {
                        return u.call(E(t), i)
                    })), e))
                    for (; a < l; a++) e(t[a], i, s ? n : n.call(t[a], a, e(t[a], i)));
                return o ? t : u ? e.call(t) : l ? e(t[0], i) : r
            },
            q = /^-ms-/,
            B = /-([a-z])/g;

        function U(t, e) {
            return e.toUpperCase()
        }

        function $(t) {
            return t.replace(q, "ms-").replace(B, U)
        }
        var V = function(t) {
            return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
        };

        function G() {
            this.expando = E.expando + G.uid++
        }
        G.uid = 1, G.prototype = {
            cache: function(t) {
                var e = t[this.expando];
                return e || (e = {}, V(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {
                    value: e,
                    configurable: !0
                }))), e
            },
            set: function(t, e, i) {
                var n, o = this.cache(t);
                if ("string" == typeof e) o[$(e)] = i;
                else
                    for (n in e) o[$(n)] = e[n];
                return o
            },
            get: function(t, e) {
                return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][$(e)]
            },
            access: function(t, e, i) {
                return void 0 === e || e && "string" == typeof e && void 0 === i ? this.get(t, e) : (this.set(t, e, i), void 0 !== i ? i : e)
            },
            remove: function(t, e) {
                var i, n = t[this.expando];
                if (void 0 !== n) {
                    if (void 0 !== e) {
                        i = (e = Array.isArray(e) ? e.map($) : (e = $(e)) in n ? [e] : e.match(A) || []).length;
                        for (; i--;) delete n[e[i]]
                    }(void 0 === e || E.isEmptyObject(n)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
                }
            },
            hasData: function(t) {
                var e = t[this.expando];
                return void 0 !== e && !E.isEmptyObject(e)
            }
        };
        var Q = new G,
            X = new G,
            Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            J = /[A-Z]/g;

        function K(t, e, i) {
            var n, o;
            if (void 0 === i && 1 === t.nodeType)
                if (n = "data-" + e.replace(J, "-$&").toLowerCase(), "string" == typeof(i = t.getAttribute(n))) {
                    try {
                        i = "true" === (o = i) || "false" !== o && ("null" === o ? null : o === +o + "" ? +o : Z.test(o) ? JSON.parse(o) : o)
                    } catch (t) {}
                    X.set(t, e, i)
                } else i = void 0;
            return i
        }
        E.extend({
            hasData: function(t) {
                return X.hasData(t) || Q.hasData(t)
            },
            data: function(t, e, i) {
                return X.access(t, e, i)
            },
            removeData: function(t, e) {
                X.remove(t, e)
            },
            _data: function(t, e, i) {
                return Q.access(t, e, i)
            },
            _removeData: function(t, e) {
                Q.remove(t, e)
            }
        }), E.fn.extend({
            data: function(i, t) {
                var e, n, o, r = this[0],
                    s = r && r.attributes;
                if (void 0 !== i) return "object" == typeof i ? this.each(function() {
                    X.set(this, i)
                }) : Y(this, function(t) {
                    var e;
                    if (r && void 0 === t) return void 0 !== (e = X.get(r, i)) ? e : void 0 !== (e = K(r, i)) ? e : void 0;
                    this.each(function() {
                        X.set(this, i, t)
                    })
                }, null, t, 1 < arguments.length, null, !0);
                if (this.length && (o = X.get(r), 1 === r.nodeType && !Q.get(r, "hasDataAttrs"))) {
                    for (e = s.length; e--;) s[e] && 0 === (n = s[e].name).indexOf("data-") && (n = $(n.slice(5)), K(r, n, o[n]));
                    Q.set(r, "hasDataAttrs", !0)
                }
                return o
            },
            removeData: function(t) {
                return this.each(function() {
                    X.remove(this, t)
                })
            }
        }), E.extend({
            queue: function(t, e, i) {
                var n;
                if (t) return e = (e || "fx") + "queue", n = Q.get(t, e), i && (!n || Array.isArray(i) ? n = Q.access(t, e, E.makeArray(i)) : n.push(i)), n || []
            },
            dequeue: function(t, e) {
                e = e || "fx";
                var i = E.queue(t, e),
                    n = i.length,
                    o = i.shift(),
                    r = E._queueHooks(t, e);
                "inprogress" === o && (o = i.shift(), n--), o && ("fx" === e && i.unshift("inprogress"), delete r.stop, o.call(t, function() {
                    E.dequeue(t, e)
                }, r)), !n && r && r.empty.fire()
            },
            _queueHooks: function(t, e) {
                var i = e + "queueHooks";
                return Q.get(t, i) || Q.access(t, i, {
                    empty: E.Callbacks("once memory").add(function() {
                        Q.remove(t, [e + "queue", i])
                    })
                })
            }
        }), E.fn.extend({
            queue: function(e, i) {
                var t = 2;
                return "string" != typeof e && (i = e, e = "fx", t--), arguments.length < t ? E.queue(this[0], e) : void 0 === i ? this : this.each(function() {
                    var t = E.queue(this, e, i);
                    E._queueHooks(this, e), "fx" === e && "inprogress" !== t[0] && E.dequeue(this, e)
                })
            },
            dequeue: function(t) {
                return this.each(function() {
                    E.dequeue(this, t)
                })
            },
            clearQueue: function(t) {
                return this.queue(t || "fx", [])
            },
            promise: function(t, e) {
                var i, n = 1,
                    o = E.Deferred(),
                    r = this,
                    s = this.length,
                    a = function() {
                        --n || o.resolveWith(r, [r])
                    };
                for ("string" != typeof t && (e = t, t = void 0), t = t || "fx"; s--;)(i = Q.get(r[s], t + "queueHooks")) && i.empty && (n++, i.empty.add(a));
                return a(), o.promise(e)
            }
        });
        var tt = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            et = new RegExp("^(?:([+-])=|)(" + tt + ")([a-z%]*)$", "i"),
            it = ["Top", "Right", "Bottom", "Left"],
            nt = T.documentElement,
            ot = function(t) {
                return E.contains(t.ownerDocument, t)
            },
            rt = {
                composed: !0
            };
        nt.getRootNode && (ot = function(t) {
            return E.contains(t.ownerDocument, t) || t.getRootNode(rt) === t.ownerDocument
        });
        var st = function(t, e) {
            return "none" === (t = e || t).style.display || "" === t.style.display && ot(t) && "none" === E.css(t, "display")
        };

        function at(t, e, i, n) {
            var o, r, s = 20,
                a = n ? function() {
                    return n.cur()
                } : function() {
                    return E.css(t, e, "")
                },
                l = a(),
                u = i && i[3] || (E.cssNumber[e] ? "" : "px"),
                c = t.nodeType && (E.cssNumber[e] || "px" !== u && +l) && et.exec(E.css(t, e));
            if (c && c[3] !== u) {
                for (l /= 2, u = u || c[3], c = +l || 1; s--;) E.style(t, e, c + u), (1 - r) * (1 - (r = a() / l || .5)) <= 0 && (s = 0), c /= r;
                c *= 2, E.style(t, e, c + u), i = i || []
            }
            return i && (c = +c || +l || 0, o = i[1] ? c + (i[1] + 1) * i[2] : +i[2], n && (n.unit = u, n.start = c, n.end = o)), o
        }
        var lt = {};

        function ut(t, e) {
            for (var i, n, o, r, s, a, l, u = [], c = 0, h = t.length; c < h; c++)(n = t[c]).style && (i = n.style.display, e ? ("none" === i && (u[c] = Q.get(n, "display") || null, u[c] || (n.style.display = "")), "" === n.style.display && st(n) && (u[c] = (l = s = r = void 0, s = (o = n).ownerDocument, a = o.nodeName, (l = lt[a]) || (r = s.body.appendChild(s.createElement(a)), l = E.css(r, "display"), r.parentNode.removeChild(r), "none" === l && (l = "block"), lt[a] = l)))) : "none" !== i && (u[c] = "none", Q.set(n, "display", i)));
            for (c = 0; c < h; c++) null != u[c] && (t[c].style.display = u[c]);
            return t
        }
        E.fn.extend({
            show: function() {
                return ut(this, !0)
            },
            hide: function() {
                return ut(this)
            },
            toggle: function(t) {
                return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each(function() {
                    st(this) ? E(this).show() : E(this).hide()
                })
            }
        });
        var ct, ht, dt = /^(?:checkbox|radio)$/i,
            ft = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
            pt = /^$|^module$|\/(?:java|ecma)script/i;
        ct = T.createDocumentFragment().appendChild(T.createElement("div")), (ht = T.createElement("input")).setAttribute("type", "radio"), ht.setAttribute("checked", "checked"), ht.setAttribute("name", "t"), ct.appendChild(ht), y.checkClone = ct.cloneNode(!0).cloneNode(!0).lastChild.checked, ct.innerHTML = "<textarea>x</textarea>", y.noCloneChecked = !!ct.cloneNode(!0).lastChild.defaultValue, ct.innerHTML = "<option></option>", y.option = !!ct.lastChild;
        var mt = {
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""]
        };

        function gt(t, e) {
            var i;
            return i = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : [], void 0 === e || e && k(t, e) ? E.merge([t], i) : i
        }

        function yt(t, e) {
            for (var i = 0, n = t.length; i < n; i++) Q.set(t[i], "globalEval", !e || Q.get(e[i], "globalEval"))
        }
        mt.tbody = mt.tfoot = mt.colgroup = mt.caption = mt.thead, mt.th = mt.td, y.option || (mt.optgroup = mt.option = [1, "<select multiple='multiple'>", "</select>"]);
        var vt = /<|&#?\w+;/;

        function bt(t, e, i, n, o) {
            for (var r, s, a, l, u, c, h = e.createDocumentFragment(), d = [], f = 0, p = t.length; f < p; f++)
                if ((r = t[f]) || 0 === r)
                    if ("object" === w(r)) E.merge(d, r.nodeType ? [r] : r);
                    else if (vt.test(r)) {
                for (s = s || h.appendChild(e.createElement("div")), a = (ft.exec(r) || ["", ""])[1].toLowerCase(), l = mt[a] || mt._default, s.innerHTML = l[1] + E.htmlPrefilter(r) + l[2], c = l[0]; c--;) s = s.lastChild;
                E.merge(d, s.childNodes), (s = h.firstChild).textContent = ""
            } else d.push(e.createTextNode(r));
            for (h.textContent = "", f = 0; r = d[f++];)
                if (n && -1 < E.inArray(r, n)) o && o.push(r);
                else if (u = ot(r), s = gt(h.appendChild(r), "script"), u && yt(s), i)
                for (c = 0; r = s[c++];) pt.test(r.type || "") && i.push(r);
            return h
        }
        var xt = /^([^.]*)(?:\.(.+)|)/;

        function wt() {
            return !0
        }

        function _t() {
            return !1
        }

        function St(t, e) {
            return t === function() {
                try {
                    return T.activeElement
                } catch (t) {}
            }() == ("focus" === e)
        }

        function Tt(t, e, i, n, o, r) {
            var s, a;
            if ("object" == typeof e) {
                for (a in "string" != typeof i && (n = n || i, i = void 0), e) Tt(t, a, i, n, e[a], r);
                return t
            }
            if (null == n && null == o ? (o = i, n = i = void 0) : null == o && ("string" == typeof i ? (o = n, n = void 0) : (o = n, n = i, i = void 0)), !1 === o) o = _t;
            else if (!o) return t;
            return 1 === r && (s = o, (o = function(t) {
                return E().off(t), s.apply(this, arguments)
            }).guid = s.guid || (s.guid = E.guid++)), t.each(function() {
                E.event.add(this, e, o, n, i)
            })
        }

        function Et(t, o, r) {
            r ? (Q.set(t, o, !1), E.event.add(t, o, {
                namespace: !1,
                handler: function(t) {
                    var e, i, n = Q.get(this, o);
                    if (1 & t.isTrigger && this[o]) {
                        if (n.length)(E.event.special[o] || {}).delegateType && t.stopPropagation();
                        else if (n = a.call(arguments), Q.set(this, o, n), e = r(this, o), this[o](), n !== (i = Q.get(this, o)) || e ? Q.set(this, o, !1) : i = {}, n !== i) return t.stopImmediatePropagation(), t.preventDefault(), i && i.value
                    } else n.length && (Q.set(this, o, {
                        value: E.event.trigger(E.extend(n[0], E.Event.prototype), n.slice(1), this)
                    }), t.stopImmediatePropagation())
                }
            })) : void 0 === Q.get(t, o) && E.event.add(t, o, wt)
        }
        E.event = {
            global: {},
            add: function(e, t, i, n, o) {
                var r, s, a, l, u, c, h, d, f, p, m, g = Q.get(e);
                if (V(e))
                    for (i.handler && (i = (r = i).handler, o = r.selector), o && E.find.matchesSelector(nt, o), i.guid || (i.guid = E.guid++), (l = g.events) || (l = g.events = Object.create(null)), (s = g.handle) || (s = g.handle = function(t) {
                            return void 0 !== E && E.event.triggered !== t.type ? E.event.dispatch.apply(e, arguments) : void 0
                        }), u = (t = (t || "").match(A) || [""]).length; u--;) f = m = (a = xt.exec(t[u]) || [])[1], p = (a[2] || "").split(".").sort(), f && (h = E.event.special[f] || {}, f = (o ? h.delegateType : h.bindType) || f, h = E.event.special[f] || {}, c = E.extend({
                        type: f,
                        origType: m,
                        data: n,
                        handler: i,
                        guid: i.guid,
                        selector: o,
                        needsContext: o && E.expr.match.needsContext.test(o),
                        namespace: p.join(".")
                    }, r), (d = l[f]) || ((d = l[f] = []).delegateCount = 0, h.setup && !1 !== h.setup.call(e, n, p, s) || e.addEventListener && e.addEventListener(f, s)), h.add && (h.add.call(e, c), c.handler.guid || (c.handler.guid = i.guid)), o ? d.splice(d.delegateCount++, 0, c) : d.push(c), E.event.global[f] = !0)
            },
            remove: function(t, e, i, n, o) {
                var r, s, a, l, u, c, h, d, f, p, m, g = Q.hasData(t) && Q.get(t);
                if (g && (l = g.events)) {
                    for (u = (e = (e || "").match(A) || [""]).length; u--;)
                        if (f = m = (a = xt.exec(e[u]) || [])[1], p = (a[2] || "").split(".").sort(), f) {
                            for (h = E.event.special[f] || {}, d = l[f = (n ? h.delegateType : h.bindType) || f] || [], a = a[2] && new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = r = d.length; r--;) c = d[r], !o && m !== c.origType || i && i.guid !== c.guid || a && !a.test(c.namespace) || n && n !== c.selector && ("**" !== n || !c.selector) || (d.splice(r, 1), c.selector && d.delegateCount--, h.remove && h.remove.call(t, c));
                            s && !d.length && (h.teardown && !1 !== h.teardown.call(t, p, g.handle) || E.removeEvent(t, f, g.handle), delete l[f])
                        } else
                            for (f in l) E.event.remove(t, f + e[u], i, n, !0);
                    E.isEmptyObject(l) && Q.remove(t, "handle events")
                }
            },
            dispatch: function(t) {
                var e, i, n, o, r, s, a = new Array(arguments.length),
                    l = E.event.fix(t),
                    u = (Q.get(this, "events") || Object.create(null))[l.type] || [],
                    c = E.event.special[l.type] || {};
                for (a[0] = l, e = 1; e < arguments.length; e++) a[e] = arguments[e];
                if (l.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, l)) {
                    for (s = E.event.handlers.call(this, l, u), e = 0;
                        (o = s[e++]) && !l.isPropagationStopped();)
                        for (l.currentTarget = o.elem, i = 0;
                            (r = o.handlers[i++]) && !l.isImmediatePropagationStopped();) l.rnamespace && !1 !== r.namespace && !l.rnamespace.test(r.namespace) || (l.handleObj = r, l.data = r.data, void 0 !== (n = ((E.event.special[r.origType] || {}).handle || r.handler).apply(o.elem, a)) && !1 === (l.result = n) && (l.preventDefault(), l.stopPropagation()));
                    return c.postDispatch && c.postDispatch.call(this, l), l.result
                }
            },
            handlers: function(t, e) {
                var i, n, o, r, s, a = [],
                    l = e.delegateCount,
                    u = t.target;
                if (l && u.nodeType && !("click" === t.type && 1 <= t.button))
                    for (; u !== this; u = u.parentNode || this)
                        if (1 === u.nodeType && ("click" !== t.type || !0 !== u.disabled)) {
                            for (r = [], s = {}, i = 0; i < l; i++) void 0 === s[o = (n = e[i]).selector + " "] && (s[o] = n.needsContext ? -1 < E(o, this).index(u) : E.find(o, this, null, [u]).length), s[o] && r.push(n);
                            r.length && a.push({
                                elem: u,
                                handlers: r
                            })
                        } return u = this, l < e.length && a.push({
                    elem: u,
                    handlers: e.slice(l)
                }), a
            },
            addProp: function(e, t) {
                Object.defineProperty(E.Event.prototype, e, {
                    enumerable: !0,
                    configurable: !0,
                    get: v(t) ? function() {
                        if (this.originalEvent) return t(this.originalEvent)
                    } : function() {
                        if (this.originalEvent) return this.originalEvent[e]
                    },
                    set: function(t) {
                        Object.defineProperty(this, e, {
                            enumerable: !0,
                            configurable: !0,
                            writable: !0,
                            value: t
                        })
                    }
                })
            },
            fix: function(t) {
                return t[E.expando] ? t : new E.Event(t)
            },
            special: {
                load: {
                    noBubble: !0
                },
                click: {
                    setup: function(t) {
                        var e = this || t;
                        return dt.test(e.type) && e.click && k(e, "input") && Et(e, "click", wt), !1
                    },
                    trigger: function(t) {
                        var e = this || t;
                        return dt.test(e.type) && e.click && k(e, "input") && Et(e, "click"), !0
                    },
                    _default: function(t) {
                        var e = t.target;
                        return dt.test(e.type) && e.click && k(e, "input") && Q.get(e, "click") || k(e, "a")
                    }
                },
                beforeunload: {
                    postDispatch: function(t) {
                        void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
                    }
                }
            }
        }, E.removeEvent = function(t, e, i) {
            t.removeEventListener && t.removeEventListener(e, i)
        }, E.Event = function(t, e) {
            if (!(this instanceof E.Event)) return new E.Event(t, e);
            t && t.type ? (this.originalEvent = t, this.type = t.type, this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && !1 === t.returnValue ? wt : _t, this.target = t.target && 3 === t.target.nodeType ? t.target.parentNode : t.target, this.currentTarget = t.currentTarget, this.relatedTarget = t.relatedTarget) : this.type = t, e && E.extend(this, e), this.timeStamp = t && t.timeStamp || Date.now(), this[E.expando] = !0
        }, E.Event.prototype = {
            constructor: E.Event,
            isDefaultPrevented: _t,
            isPropagationStopped: _t,
            isImmediatePropagationStopped: _t,
            isSimulated: !1,
            preventDefault: function() {
                var t = this.originalEvent;
                this.isDefaultPrevented = wt, t && !this.isSimulated && t.preventDefault()
            },
            stopPropagation: function() {
                var t = this.originalEvent;
                this.isPropagationStopped = wt, t && !this.isSimulated && t.stopPropagation()
            },
            stopImmediatePropagation: function() {
                var t = this.originalEvent;
                this.isImmediatePropagationStopped = wt, t && !this.isSimulated && t.stopImmediatePropagation(), this.stopPropagation()
            }
        }, E.each({
            altKey: !0,
            bubbles: !0,
            cancelable: !0,
            changedTouches: !0,
            ctrlKey: !0,
            detail: !0,
            eventPhase: !0,
            metaKey: !0,
            pageX: !0,
            pageY: !0,
            shiftKey: !0,
            view: !0,
            char: !0,
            code: !0,
            charCode: !0,
            key: !0,
            keyCode: !0,
            button: !0,
            buttons: !0,
            clientX: !0,
            clientY: !0,
            offsetX: !0,
            offsetY: !0,
            pointerId: !0,
            pointerType: !0,
            screenX: !0,
            screenY: !0,
            targetTouches: !0,
            toElement: !0,
            touches: !0,
            which: !0
        }, E.event.addProp), E.each({
            focus: "focusin",
            blur: "focusout"
        }, function(t, e) {
            E.event.special[t] = {
                setup: function() {
                    return Et(this, t, St), !1
                },
                trigger: function() {
                    return Et(this, t), !0
                },
                _default: function() {
                    return !0
                },
                delegateType: e
            }
        }), E.each({
            mouseenter: "mouseover",
            mouseleave: "mouseout",
            pointerenter: "pointerover",
            pointerleave: "pointerout"
        }, function(t, o) {
            E.event.special[t] = {
                delegateType: o,
                bindType: o,
                handle: function(t) {
                    var e, i = t.relatedTarget,
                        n = t.handleObj;
                    return i && (i === this || E.contains(this, i)) || (t.type = n.origType, e = n.handler.apply(this, arguments), t.type = o), e
                }
            }
        }), E.fn.extend({
            on: function(t, e, i, n) {
                return Tt(this, t, e, i, n)
            },
            one: function(t, e, i, n) {
                return Tt(this, t, e, i, n, 1)
            },
            off: function(t, e, i) {
                var n, o;
                if (t && t.preventDefault && t.handleObj) return n = t.handleObj, E(t.delegateTarget).off(n.namespace ? n.origType + "." + n.namespace : n.origType, n.selector, n.handler), this;
                if ("object" != typeof t) return !1 !== e && "function" != typeof e || (i = e, e = void 0), !1 === i && (i = _t), this.each(function() {
                    E.event.remove(this, t, i, e)
                });
                for (o in t) this.off(o, e, t[o]);
                return this
            }
        });
        var Ct = /<script|<style|<link/i,
            kt = /checked\s*(?:[^=]|=\s*.checked.)/i,
            Dt = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

        function It(t, e) {
            return k(t, "table") && k(11 !== e.nodeType ? e : e.firstChild, "tr") && E(t).children("tbody")[0] || t
        }

        function Mt(t) {
            return t.type = (null !== t.getAttribute("type")) + "/" + t.type, t
        }

        function Pt(t) {
            return "true/" === (t.type || "").slice(0, 5) ? t.type = t.type.slice(5) : t.removeAttribute("type"), t
        }

        function Ot(t, e) {
            var i, n, o, r, s, a;
            if (1 === e.nodeType) {
                if (Q.hasData(t) && (a = Q.get(t).events))
                    for (o in Q.remove(e, "handle events"), a)
                        for (i = 0, n = a[o].length; i < n; i++) E.event.add(e, o, a[o][i]);
                X.hasData(t) && (r = X.access(t), s = E.extend({}, r), X.set(e, s))
            }
        }

        function zt(i, n, o, r) {
            n = m(n);
            var t, e, s, a, l, u, c = 0,
                h = i.length,
                d = h - 1,
                f = n[0],
                p = v(f);
            if (p || 1 < h && "string" == typeof f && !y.checkClone && kt.test(f)) return i.each(function(t) {
                var e = i.eq(t);
                p && (n[0] = f.call(this, t, e.html())), zt(e, n, o, r)
            });
            if (h && (e = (t = bt(n, i[0].ownerDocument, !1, i, r)).firstChild, 1 === t.childNodes.length && (t = e), e || r)) {
                for (a = (s = E.map(gt(t, "script"), Mt)).length; c < h; c++) l = t, c !== d && (l = E.clone(l, !0, !0), a && E.merge(s, gt(l, "script"))), o.call(i[c], l, c);
                if (a)
                    for (u = s[s.length - 1].ownerDocument, E.map(s, Pt), c = 0; c < a; c++) l = s[c], pt.test(l.type || "") && !Q.access(l, "globalEval") && E.contains(u, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? E._evalUrl && !l.noModule && E._evalUrl(l.src, {
                        nonce: l.nonce || l.getAttribute("nonce")
                    }, u) : x(l.textContent.replace(Dt, ""), l, u))
            }
            return i
        }

        function Lt(t, e, i) {
            for (var n, o = e ? E.filter(e, t) : t, r = 0; null != (n = o[r]); r++) i || 1 !== n.nodeType || E.cleanData(gt(n)), n.parentNode && (i && ot(n) && yt(gt(n, "script")), n.parentNode.removeChild(n));
            return t
        }
        E.extend({
            htmlPrefilter: function(t) {
                return t
            },
            clone: function(t, e, i) {
                var n, o, r, s, a, l, u, c = t.cloneNode(!0),
                    h = ot(t);
                if (!(y.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || E.isXMLDoc(t)))
                    for (s = gt(c), n = 0, o = (r = gt(t)).length; n < o; n++) a = r[n], "input" === (u = (l = s[n]).nodeName.toLowerCase()) && dt.test(a.type) ? l.checked = a.checked : "input" !== u && "textarea" !== u || (l.defaultValue = a.defaultValue);
                if (e)
                    if (i)
                        for (r = r || gt(t), s = s || gt(c), n = 0, o = r.length; n < o; n++) Ot(r[n], s[n]);
                    else Ot(t, c);
                return 0 < (s = gt(c, "script")).length && yt(s, !h && gt(t, "script")), c
            },
            cleanData: function(t) {
                for (var e, i, n, o = E.event.special, r = 0; void 0 !== (i = t[r]); r++)
                    if (V(i)) {
                        if (e = i[Q.expando]) {
                            if (e.events)
                                for (n in e.events) o[n] ? E.event.remove(i, n) : E.removeEvent(i, n, e.handle);
                            i[Q.expando] = void 0
                        }
                        i[X.expando] && (i[X.expando] = void 0)
                    }
            }
        }), E.fn.extend({
            detach: function(t) {
                return Lt(this, t, !0)
            },
            remove: function(t) {
                return Lt(this, t)
            },
            text: function(t) {
                return Y(this, function(t) {
                    return void 0 === t ? E.text(this) : this.empty().each(function() {
                        1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t)
                    })
                }, null, t, arguments.length)
            },
            append: function() {
                return zt(this, arguments, function(t) {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || It(this, t).appendChild(t)
                })
            },
            prepend: function() {
                return zt(this, arguments, function(t) {
                    if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                        var e = It(this, t);
                        e.insertBefore(t, e.firstChild)
                    }
                })
            },
            before: function() {
                return zt(this, arguments, function(t) {
                    this.parentNode && this.parentNode.insertBefore(t, this)
                })
            },
            after: function() {
                return zt(this, arguments, function(t) {
                    this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
                })
            },
            empty: function() {
                for (var t, e = 0; null != (t = this[e]); e++) 1 === t.nodeType && (E.cleanData(gt(t, !1)), t.textContent = "");
                return this
            },
            clone: function(t, e) {
                return t = null != t && t, e = null == e ? t : e, this.map(function() {
                    return E.clone(this, t, e)
                })
            },
            html: function(t) {
                return Y(this, function(t) {
                    var e = this[0] || {},
                        i = 0,
                        n = this.length;
                    if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                    if ("string" == typeof t && !Ct.test(t) && !mt[(ft.exec(t) || ["", ""])[1].toLowerCase()]) {
                        t = E.htmlPrefilter(t);
                        try {
                            for (; i < n; i++) 1 === (e = this[i] || {}).nodeType && (E.cleanData(gt(e, !1)), e.innerHTML = t);
                            e = 0
                        } catch (t) {}
                    }
                    e && this.empty().append(t)
                }, null, t, arguments.length)
            },
            replaceWith: function() {
                var i = [];
                return zt(this, arguments, function(t) {
                    var e = this.parentNode;
                    E.inArray(this, i) < 0 && (E.cleanData(gt(this)), e && e.replaceChild(t, this))
                }, i)
            }
        }), E.each({
            appendTo: "append",
            prependTo: "prepend",
            insertBefore: "before",
            insertAfter: "after",
            replaceAll: "replaceWith"
        }, function(t, s) {
            E.fn[t] = function(t) {
                for (var e, i = [], n = E(t), o = n.length - 1, r = 0; r <= o; r++) e = r === o ? this : this.clone(!0), E(n[r])[s](e), l.apply(i, e.get());
                return this.pushStack(i)
            }
        });
        var At = new RegExp("^(" + tt + ")(?!px)[a-z%]+$", "i"),
            Nt = function(t) {
                var e = t.ownerDocument.defaultView;
                return e && e.opener || (e = S), e.getComputedStyle(t)
            },
            jt = function(t, e, i) {
                var n, o, r = {};
                for (o in e) r[o] = t.style[o], t.style[o] = e[o];
                for (o in n = i.call(t), e) t.style[o] = r[o];
                return n
            },
            Wt = new RegExp(it.join("|"), "i");

        function Rt(t, e, i) {
            var n, o, r, s, a = t.style;
            return (i = i || Nt(t)) && ("" !== (s = i.getPropertyValue(e) || i[e]) || ot(t) || (s = E.style(t, e)), !y.pixelBoxStyles() && At.test(s) && Wt.test(e) && (n = a.width, o = a.minWidth, r = a.maxWidth, a.minWidth = a.maxWidth = a.width = s, s = i.width, a.width = n, a.minWidth = o, a.maxWidth = r)), void 0 !== s ? s + "" : s
        }

        function Ft(t, e) {
            return {
                get: function() {
                    if (!t()) return (this.get = e).apply(this, arguments);
                    delete this.get
                }
            }
        }! function() {
            function t() {
                if (u) {
                    l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", u.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", nt.appendChild(l).appendChild(u);
                    var t = S.getComputedStyle(u);
                    i = "1%" !== t.top, a = 12 === e(t.marginLeft), u.style.right = "60%", r = 36 === e(t.right), n = 36 === e(t.width), u.style.position = "absolute", o = 12 === e(u.offsetWidth / 3), nt.removeChild(l), u = null
                }
            }

            function e(t) {
                return Math.round(parseFloat(t))
            }
            var i, n, o, r, s, a, l = T.createElement("div"),
                u = T.createElement("div");
            u.style && (u.style.backgroundClip = "content-box", u.cloneNode(!0).style.backgroundClip = "", y.clearCloneStyle = "content-box" === u.style.backgroundClip, E.extend(y, {
                boxSizingReliable: function() {
                    return t(), n
                },
                pixelBoxStyles: function() {
                    return t(), r
                },
                pixelPosition: function() {
                    return t(), i
                },
                reliableMarginLeft: function() {
                    return t(), a
                },
                scrollboxSize: function() {
                    return t(), o
                },
                reliableTrDimensions: function() {
                    var t, e, i, n;
                    return null == s && (t = T.createElement("table"), e = T.createElement("tr"), i = T.createElement("div"), t.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", e.style.cssText = "border:1px solid", e.style.height = "1px", i.style.height = "9px", i.style.display = "block", nt.appendChild(t).appendChild(e).appendChild(i), n = S.getComputedStyle(e), s = parseInt(n.height, 10) + parseInt(n.borderTopWidth, 10) + parseInt(n.borderBottomWidth, 10) === e.offsetHeight, nt.removeChild(t)), s
                }
            }))
        }();
        var Ht = ["Webkit", "Moz", "ms"],
            Yt = T.createElement("div").style,
            qt = {};

        function Bt(t) {
            return E.cssProps[t] || qt[t] || (t in Yt ? t : qt[t] = function(t) {
                for (var e = t[0].toUpperCase() + t.slice(1), i = Ht.length; i--;)
                    if ((t = Ht[i] + e) in Yt) return t
            }(t) || t)
        }
        var Ut = /^(none|table(?!-c[ea]).+)/,
            $t = /^--/,
            Vt = {
                position: "absolute",
                visibility: "hidden",
                display: "block"
            },
            Gt = {
                letterSpacing: "0",
                fontWeight: "400"
            };

        function Qt(t, e, i) {
            var n = et.exec(e);
            return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : e
        }

        function Xt(t, e, i, n, o, r) {
            var s = "width" === e ? 1 : 0,
                a = 0,
                l = 0;
            if (i === (n ? "border" : "content")) return 0;
            for (; s < 4; s += 2) "margin" === i && (l += E.css(t, i + it[s], !0, o)), n ? ("content" === i && (l -= E.css(t, "padding" + it[s], !0, o)), "margin" !== i && (l -= E.css(t, "border" + it[s] + "Width", !0, o))) : (l += E.css(t, "padding" + it[s], !0, o), "padding" !== i ? l += E.css(t, "border" + it[s] + "Width", !0, o) : a += E.css(t, "border" + it[s] + "Width", !0, o));
            return !n && 0 <= r && (l += Math.max(0, Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - r - l - a - .5)) || 0), l
        }

        function Zt(t, e, i) {
            var n = Nt(t),
                o = (!y.boxSizingReliable() || i) && "border-box" === E.css(t, "boxSizing", !1, n),
                r = o,
                s = Rt(t, e, n),
                a = "offset" + e[0].toUpperCase() + e.slice(1);
            if (At.test(s)) {
                if (!i) return s;
                s = "auto"
            }
            return (!y.boxSizingReliable() && o || !y.reliableTrDimensions() && k(t, "tr") || "auto" === s || !parseFloat(s) && "inline" === E.css(t, "display", !1, n)) && t.getClientRects().length && (o = "border-box" === E.css(t, "boxSizing", !1, n), (r = a in t) && (s = t[a])), (s = parseFloat(s) || 0) + Xt(t, e, i || (o ? "border" : "content"), r, n, s) + "px"
        }

        function Jt(t, e, i, n, o) {
            return new Jt.prototype.init(t, e, i, n, o)
        }
        E.extend({
            cssHooks: {
                opacity: {
                    get: function(t, e) {
                        if (e) {
                            var i = Rt(t, "opacity");
                            return "" === i ? "1" : i
                        }
                    }
                }
            },
            cssNumber: {
                animationIterationCount: !0,
                columnCount: !0,
                fillOpacity: !0,
                flexGrow: !0,
                flexShrink: !0,
                fontWeight: !0,
                gridArea: !0,
                gridColumn: !0,
                gridColumnEnd: !0,
                gridColumnStart: !0,
                gridRow: !0,
                gridRowEnd: !0,
                gridRowStart: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0
            },
            cssProps: {},
            style: function(t, e, i, n) {
                if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                    var o, r, s, a = $(e),
                        l = $t.test(e),
                        u = t.style;
                    if (l || (e = Bt(a)), s = E.cssHooks[e] || E.cssHooks[a], void 0 === i) return s && "get" in s && void 0 !== (o = s.get(t, !1, n)) ? o : u[e];
                    "string" == (r = typeof i) && (o = et.exec(i)) && o[1] && (i = at(t, e, o), r = "number"), null != i && i == i && ("number" !== r || l || (i += o && o[3] || (E.cssNumber[a] ? "" : "px")), y.clearCloneStyle || "" !== i || 0 !== e.indexOf("background") || (u[e] = "inherit"), s && "set" in s && void 0 === (i = s.set(t, i, n)) || (l ? u.setProperty(e, i) : u[e] = i))
                }
            },
            css: function(t, e, i, n) {
                var o, r, s, a = $(e);
                return $t.test(e) || (e = Bt(a)), (s = E.cssHooks[e] || E.cssHooks[a]) && "get" in s && (o = s.get(t, !0, i)), void 0 === o && (o = Rt(t, e, n)), "normal" === o && e in Gt && (o = Gt[e]), "" === i || i ? (r = parseFloat(o), !0 === i || isFinite(r) ? r || 0 : o) : o
            }
        }), E.each(["height", "width"], function(t, l) {
            E.cssHooks[l] = {
                get: function(t, e, i) {
                    if (e) return !Ut.test(E.css(t, "display")) || t.getClientRects().length && t.getBoundingClientRect().width ? Zt(t, l, i) : jt(t, Vt, function() {
                        return Zt(t, l, i)
                    })
                },
                set: function(t, e, i) {
                    var n, o = Nt(t),
                        r = !y.scrollboxSize() && "absolute" === o.position,
                        s = (r || i) && "border-box" === E.css(t, "boxSizing", !1, o),
                        a = i ? Xt(t, l, i, s, o) : 0;
                    return s && r && (a -= Math.ceil(t["offset" + l[0].toUpperCase() + l.slice(1)] - parseFloat(o[l]) - Xt(t, l, "border", !1, o) - .5)), a && (n = et.exec(e)) && "px" !== (n[3] || "px") && (t.style[l] = e, e = E.css(t, l)), Qt(0, e, a)
                }
            }
        }), E.cssHooks.marginLeft = Ft(y.reliableMarginLeft, function(t, e) {
            if (e) return (parseFloat(Rt(t, "marginLeft")) || t.getBoundingClientRect().left - jt(t, {
                marginLeft: 0
            }, function() {
                return t.getBoundingClientRect().left
            })) + "px"
        }), E.each({
            margin: "",
            padding: "",
            border: "Width"
        }, function(o, r) {
            E.cssHooks[o + r] = {
                expand: function(t) {
                    for (var e = 0, i = {}, n = "string" == typeof t ? t.split(" ") : [t]; e < 4; e++) i[o + it[e] + r] = n[e] || n[e - 2] || n[0];
                    return i
                }
            }, "margin" !== o && (E.cssHooks[o + r].set = Qt)
        }), E.fn.extend({
            css: function(t, e) {
                return Y(this, function(t, e, i) {
                    var n, o, r = {},
                        s = 0;
                    if (Array.isArray(e)) {
                        for (n = Nt(t), o = e.length; s < o; s++) r[e[s]] = E.css(t, e[s], !1, n);
                        return r
                    }
                    return void 0 !== i ? E.style(t, e, i) : E.css(t, e)
                }, t, e, 1 < arguments.length)
            }
        }), ((E.Tween = Jt).prototype = {
            constructor: Jt,
            init: function(t, e, i, n, o, r) {
                this.elem = t, this.prop = i, this.easing = o || E.easing._default, this.options = e, this.start = this.now = this.cur(), this.end = n, this.unit = r || (E.cssNumber[i] ? "" : "px")
            },
            cur: function() {
                var t = Jt.propHooks[this.prop];
                return t && t.get ? t.get(this) : Jt.propHooks._default.get(this)
            },
            run: function(t) {
                var e, i = Jt.propHooks[this.prop];
                return this.options.duration ? this.pos = e = E.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t, this.now = (this.end - this.start) * e + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), i && i.set ? i.set(this) : Jt.propHooks._default.set(this), this
            }
        }).init.prototype = Jt.prototype, (Jt.propHooks = {
            _default: {
                get: function(t) {
                    var e;
                    return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (e = E.css(t.elem, t.prop, "")) && "auto" !== e ? e : 0
                },
                set: function(t) {
                    E.fx.step[t.prop] ? E.fx.step[t.prop](t) : 1 !== t.elem.nodeType || !E.cssHooks[t.prop] && null == t.elem.style[Bt(t.prop)] ? t.elem[t.prop] = t.now : E.style(t.elem, t.prop, t.now + t.unit)
                }
            }
        }).scrollTop = Jt.propHooks.scrollLeft = {
            set: function(t) {
                t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
            }
        }, E.easing = {
            linear: function(t) {
                return t
            },
            swing: function(t) {
                return .5 - Math.cos(t * Math.PI) / 2
            },
            _default: "swing"
        }, E.fx = Jt.prototype.init, E.fx.step = {};
        var Kt, te, ee, ie, ne = /^(?:toggle|show|hide)$/,
            oe = /queueHooks$/;

        function re() {
            te && (!1 === T.hidden && S.requestAnimationFrame ? S.requestAnimationFrame(re) : S.setTimeout(re, E.fx.interval), E.fx.tick())
        }

        function se() {
            return S.setTimeout(function() {
                Kt = void 0
            }), Kt = Date.now()
        }

        function ae(t, e) {
            var i, n = 0,
                o = {
                    height: t
                };
            for (e = e ? 1 : 0; n < 4; n += 2 - e) o["margin" + (i = it[n])] = o["padding" + i] = t;
            return e && (o.opacity = o.width = t), o
        }

        function le(t, e, i) {
            for (var n, o = (ue.tweeners[e] || []).concat(ue.tweeners["*"]), r = 0, s = o.length; r < s; r++)
                if (n = o[r].call(i, e, t)) return n
        }

        function ue(r, t, e) {
            var i, s, n = 0,
                o = ue.prefilters.length,
                a = E.Deferred().always(function() {
                    delete l.elem
                }),
                l = function() {
                    if (s) return !1;
                    for (var t = Kt || se(), e = Math.max(0, u.startTime + u.duration - t), i = 1 - (e / u.duration || 0), n = 0, o = u.tweens.length; n < o; n++) u.tweens[n].run(i);
                    return a.notifyWith(r, [u, i, e]), i < 1 && o ? e : (o || a.notifyWith(r, [u, 1, 0]), a.resolveWith(r, [u]), !1)
                },
                u = a.promise({
                    elem: r,
                    props: E.extend({}, t),
                    opts: E.extend(!0, {
                        specialEasing: {},
                        easing: E.easing._default
                    }, e),
                    originalProperties: t,
                    originalOptions: e,
                    startTime: Kt || se(),
                    duration: e.duration,
                    tweens: [],
                    createTween: function(t, e) {
                        var i = E.Tween(r, u.opts, t, e, u.opts.specialEasing[t] || u.opts.easing);
                        return u.tweens.push(i), i
                    },
                    stop: function(t) {
                        var e = 0,
                            i = t ? u.tweens.length : 0;
                        if (s) return this;
                        for (s = !0; e < i; e++) u.tweens[e].run(1);
                        return t ? (a.notifyWith(r, [u, 1, 0]), a.resolveWith(r, [u, t])) : a.rejectWith(r, [u, t]), this
                    }
                }),
                c = u.props;
            for (function(t, e) {
                    var i, n, o, r, s;
                    for (i in t)
                        if (o = e[n = $(i)], r = t[i], Array.isArray(r) && (o = r[1], r = t[i] = r[0]), i !== n && (t[n] = r, delete t[i]), (s = E.cssHooks[n]) && "expand" in s)
                            for (i in r = s.expand(r), delete t[n], r) i in t || (t[i] = r[i], e[i] = o);
                        else e[n] = o
                }(c, u.opts.specialEasing); n < o; n++)
                if (i = ue.prefilters[n].call(u, r, c, u.opts)) return v(i.stop) && (E._queueHooks(u.elem, u.opts.queue).stop = i.stop.bind(i)), i;
            return E.map(c, le, u), v(u.opts.start) && u.opts.start.call(r, u), u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always), E.fx.timer(E.extend(l, {
                elem: r,
                anim: u,
                queue: u.opts.queue
            })), u
        }
        E.Animation = E.extend(ue, {
            tweeners: {
                "*": [function(t, e) {
                    var i = this.createTween(t, e);
                    return at(i.elem, t, et.exec(e), i), i
                }]
            },
            tweener: function(t, e) {
                for (var i, n = 0, o = (t = v(t) ? (e = t, ["*"]) : t.match(A)).length; n < o; n++) i = t[n], ue.tweeners[i] = ue.tweeners[i] || [], ue.tweeners[i].unshift(e)
            },
            prefilters: [function(t, e, i) {
                var n, o, r, s, a, l, u, c, h = "width" in e || "height" in e,
                    d = this,
                    f = {},
                    p = t.style,
                    m = t.nodeType && st(t),
                    g = Q.get(t, "fxshow");
                for (n in i.queue || (null == (s = E._queueHooks(t, "fx")).unqueued && (s.unqueued = 0, a = s.empty.fire, s.empty.fire = function() {
                        s.unqueued || a()
                    }), s.unqueued++, d.always(function() {
                        d.always(function() {
                            s.unqueued--, E.queue(t, "fx").length || s.empty.fire()
                        })
                    })), e)
                    if (o = e[n], ne.test(o)) {
                        if (delete e[n], r = r || "toggle" === o, o === (m ? "hide" : "show")) {
                            if ("show" !== o || !g || void 0 === g[n]) continue;
                            m = !0
                        }
                        f[n] = g && g[n] || E.style(t, n)
                    } if ((l = !E.isEmptyObject(e)) || !E.isEmptyObject(f))
                    for (n in h && 1 === t.nodeType && (i.overflow = [p.overflow, p.overflowX, p.overflowY], null == (u = g && g.display) && (u = Q.get(t, "display")), "none" === (c = E.css(t, "display")) && (u ? c = u : (ut([t], !0), u = t.style.display || u, c = E.css(t, "display"), ut([t]))), ("inline" === c || "inline-block" === c && null != u) && "none" === E.css(t, "float") && (l || (d.done(function() {
                            p.display = u
                        }), null == u && (c = p.display, u = "none" === c ? "" : c)), p.display = "inline-block")), i.overflow && (p.overflow = "hidden", d.always(function() {
                            p.overflow = i.overflow[0], p.overflowX = i.overflow[1], p.overflowY = i.overflow[2]
                        })), l = !1, f) l || (g ? "hidden" in g && (m = g.hidden) : g = Q.access(t, "fxshow", {
                        display: u
                    }), r && (g.hidden = !m), m && ut([t], !0), d.done(function() {
                        for (n in m || ut([t]), Q.remove(t, "fxshow"), f) E.style(t, n, f[n])
                    })), l = le(m ? g[n] : 0, n, d), n in g || (g[n] = l.start, m && (l.end = l.start, l.start = 0))
            }],
            prefilter: function(t, e) {
                e ? ue.prefilters.unshift(t) : ue.prefilters.push(t)
            }
        }), E.speed = function(t, e, i) {
            var n = t && "object" == typeof t ? E.extend({}, t) : {
                complete: i || !i && e || v(t) && t,
                duration: t,
                easing: i && e || e && !v(e) && e
            };
            return E.fx.off ? n.duration = 0 : "number" != typeof n.duration && (n.duration in E.fx.speeds ? n.duration = E.fx.speeds[n.duration] : n.duration = E.fx.speeds._default), null != n.queue && !0 !== n.queue || (n.queue = "fx"), n.old = n.complete, n.complete = function() {
                v(n.old) && n.old.call(this), n.queue && E.dequeue(this, n.queue)
            }, n
        }, E.fn.extend({
            fadeTo: function(t, e, i, n) {
                return this.filter(st).css("opacity", 0).show().end().animate({
                    opacity: e
                }, t, i, n)
            },
            animate: function(e, t, i, n) {
                var o = E.isEmptyObject(e),
                    r = E.speed(t, i, n),
                    s = function() {
                        var t = ue(this, E.extend({}, e), r);
                        (o || Q.get(this, "finish")) && t.stop(!0)
                    };
                return s.finish = s, o || !1 === r.queue ? this.each(s) : this.queue(r.queue, s)
            },
            stop: function(o, t, r) {
                var s = function(t) {
                    var e = t.stop;
                    delete t.stop, e(r)
                };
                return "string" != typeof o && (r = t, t = o, o = void 0), t && this.queue(o || "fx", []), this.each(function() {
                    var t = !0,
                        e = null != o && o + "queueHooks",
                        i = E.timers,
                        n = Q.get(this);
                    if (e) n[e] && n[e].stop && s(n[e]);
                    else
                        for (e in n) n[e] && n[e].stop && oe.test(e) && s(n[e]);
                    for (e = i.length; e--;) i[e].elem !== this || null != o && i[e].queue !== o || (i[e].anim.stop(r), t = !1, i.splice(e, 1));
                    !t && r || E.dequeue(this, o)
                })
            },
            finish: function(s) {
                return !1 !== s && (s = s || "fx"), this.each(function() {
                    var t, e = Q.get(this),
                        i = e[s + "queue"],
                        n = e[s + "queueHooks"],
                        o = E.timers,
                        r = i ? i.length : 0;
                    for (e.finish = !0, E.queue(this, s, []), n && n.stop && n.stop.call(this, !0), t = o.length; t--;) o[t].elem === this && o[t].queue === s && (o[t].anim.stop(!0), o.splice(t, 1));
                    for (t = 0; t < r; t++) i[t] && i[t].finish && i[t].finish.call(this);
                    delete e.finish
                })
            }
        }), E.each(["toggle", "show", "hide"], function(t, n) {
            var o = E.fn[n];
            E.fn[n] = function(t, e, i) {
                return null == t || "boolean" == typeof t ? o.apply(this, arguments) : this.animate(ae(n, !0), t, e, i)
            }
        }), E.each({
            slideDown: ae("show"),
            slideUp: ae("hide"),
            slideToggle: ae("toggle"),
            fadeIn: {
                opacity: "show"
            },
            fadeOut: {
                opacity: "hide"
            },
            fadeToggle: {
                opacity: "toggle"
            }
        }, function(t, n) {
            E.fn[t] = function(t, e, i) {
                return this.animate(n, t, e, i)
            }
        }), E.timers = [], E.fx.tick = function() {
            var t, e = 0,
                i = E.timers;
            for (Kt = Date.now(); e < i.length; e++)(t = i[e])() || i[e] !== t || i.splice(e--, 1);
            i.length || E.fx.stop(), Kt = void 0
        }, E.fx.timer = function(t) {
            E.timers.push(t), E.fx.start()
        }, E.fx.interval = 13, E.fx.start = function() {
            te || (te = !0, re())
        }, E.fx.stop = function() {
            te = null
        }, E.fx.speeds = {
            slow: 600,
            fast: 200,
            _default: 400
        }, E.fn.delay = function(n, t) {
            return n = E.fx && E.fx.speeds[n] || n, t = t || "fx", this.queue(t, function(t, e) {
                var i = S.setTimeout(t, n);
                e.stop = function() {
                    S.clearTimeout(i)
                }
            })
        }, ee = T.createElement("input"), ie = T.createElement("select").appendChild(T.createElement("option")), ee.type = "checkbox", y.checkOn = "" !== ee.value, y.optSelected = ie.selected, (ee = T.createElement("input")).value = "t", ee.type = "radio", y.radioValue = "t" === ee.value;
        var ce, he = E.expr.attrHandle;
        E.fn.extend({
            attr: function(t, e) {
                return Y(this, E.attr, t, e, 1 < arguments.length)
            },
            removeAttr: function(t) {
                return this.each(function() {
                    E.removeAttr(this, t)
                })
            }
        }), E.extend({
            attr: function(t, e, i) {
                var n, o, r = t.nodeType;
                if (3 !== r && 8 !== r && 2 !== r) return void 0 === t.getAttribute ? E.prop(t, e, i) : (1 === r && E.isXMLDoc(t) || (o = E.attrHooks[e.toLowerCase()] || (E.expr.match.bool.test(e) ? ce : void 0)), void 0 !== i ? null === i ? void E.removeAttr(t, e) : o && "set" in o && void 0 !== (n = o.set(t, i, e)) ? n : (t.setAttribute(e, i + ""), i) : o && "get" in o && null !== (n = o.get(t, e)) ? n : null == (n = E.find.attr(t, e)) ? void 0 : n)
            },
            attrHooks: {
                type: {
                    set: function(t, e) {
                        if (!y.radioValue && "radio" === e && k(t, "input")) {
                            var i = t.value;
                            return t.setAttribute("type", e), i && (t.value = i), e
                        }
                    }
                }
            },
            removeAttr: function(t, e) {
                var i, n = 0,
                    o = e && e.match(A);
                if (o && 1 === t.nodeType)
                    for (; i = o[n++];) t.removeAttribute(i)
            }
        }), ce = {
            set: function(t, e, i) {
                return !1 === e ? E.removeAttr(t, i) : t.setAttribute(i, i), i
            }
        }, E.each(E.expr.match.bool.source.match(/\w+/g), function(t, e) {
            var s = he[e] || E.find.attr;
            he[e] = function(t, e, i) {
                var n, o, r = e.toLowerCase();
                return i || (o = he[r], he[r] = n, n = null != s(t, e, i) ? r : null, he[r] = o), n
            }
        });
        var de = /^(?:input|select|textarea|button)$/i,
            fe = /^(?:a|area)$/i;

        function pe(t) {
            return (t.match(A) || []).join(" ")
        }

        function me(t) {
            return t.getAttribute && t.getAttribute("class") || ""
        }

        function ge(t) {
            return Array.isArray(t) ? t : "string" == typeof t && t.match(A) || []
        }
        E.fn.extend({
            prop: function(t, e) {
                return Y(this, E.prop, t, e, 1 < arguments.length)
            },
            removeProp: function(t) {
                return this.each(function() {
                    delete this[E.propFix[t] || t]
                })
            }
        }), E.extend({
            prop: function(t, e, i) {
                var n, o, r = t.nodeType;
                if (3 !== r && 8 !== r && 2 !== r) return 1 === r && E.isXMLDoc(t) || (e = E.propFix[e] || e, o = E.propHooks[e]), void 0 !== i ? o && "set" in o && void 0 !== (n = o.set(t, i, e)) ? n : t[e] = i : o && "get" in o && null !== (n = o.get(t, e)) ? n : t[e]
            },
            propHooks: {
                tabIndex: {
                    get: function(t) {
                        var e = E.find.attr(t, "tabindex");
                        return e ? parseInt(e, 10) : de.test(t.nodeName) || fe.test(t.nodeName) && t.href ? 0 : -1
                    }
                }
            },
            propFix: {
                for: "htmlFor",
                class: "className"
            }
        }), y.optSelected || (E.propHooks.selected = {
            get: function(t) {
                var e = t.parentNode;
                return e && e.parentNode && e.parentNode.selectedIndex, null
            },
            set: function(t) {
                var e = t.parentNode;
                e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex)
            }
        }), E.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
            E.propFix[this.toLowerCase()] = this
        }), E.fn.extend({
            addClass: function(e) {
                var t, i, n, o, r, s, a, l = 0;
                if (v(e)) return this.each(function(t) {
                    E(this).addClass(e.call(this, t, me(this)))
                });
                if ((t = ge(e)).length)
                    for (; i = this[l++];)
                        if (o = me(i), n = 1 === i.nodeType && " " + pe(o) + " ") {
                            for (s = 0; r = t[s++];) n.indexOf(" " + r + " ") < 0 && (n += r + " ");
                            o !== (a = pe(n)) && i.setAttribute("class", a)
                        } return this
            },
            removeClass: function(e) {
                var t, i, n, o, r, s, a, l = 0;
                if (v(e)) return this.each(function(t) {
                    E(this).removeClass(e.call(this, t, me(this)))
                });
                if (!arguments.length) return this.attr("class", "");
                if ((t = ge(e)).length)
                    for (; i = this[l++];)
                        if (o = me(i), n = 1 === i.nodeType && " " + pe(o) + " ") {
                            for (s = 0; r = t[s++];)
                                for (; - 1 < n.indexOf(" " + r + " ");) n = n.replace(" " + r + " ", " ");
                            o !== (a = pe(n)) && i.setAttribute("class", a)
                        } return this
            },
            toggleClass: function(o, e) {
                var r = typeof o,
                    s = "string" === r || Array.isArray(o);
                return "boolean" == typeof e && s ? e ? this.addClass(o) : this.removeClass(o) : v(o) ? this.each(function(t) {
                    E(this).toggleClass(o.call(this, t, me(this), e), e)
                }) : this.each(function() {
                    var t, e, i, n;
                    if (s)
                        for (e = 0, i = E(this), n = ge(o); t = n[e++];) i.hasClass(t) ? i.removeClass(t) : i.addClass(t);
                    else void 0 !== o && "boolean" !== r || ((t = me(this)) && Q.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === o ? "" : Q.get(this, "__className__") || ""))
                })
            },
            hasClass: function(t) {
                var e, i, n = 0;
                for (e = " " + t + " "; i = this[n++];)
                    if (1 === i.nodeType && -1 < (" " + pe(me(i)) + " ").indexOf(e)) return !0;
                return !1
            }
        });
        var ye = /\r/g;
        E.fn.extend({
            val: function(i) {
                var n, t, o, e = this[0];
                return arguments.length ? (o = v(i), this.each(function(t) {
                    var e;
                    1 === this.nodeType && (null == (e = o ? i.call(this, t, E(this).val()) : i) ? e = "" : "number" == typeof e ? e += "" : Array.isArray(e) && (e = E.map(e, function(t) {
                        return null == t ? "" : t + ""
                    })), (n = E.valHooks[this.type] || E.valHooks[this.nodeName.toLowerCase()]) && "set" in n && void 0 !== n.set(this, e, "value") || (this.value = e))
                })) : e ? (n = E.valHooks[e.type] || E.valHooks[e.nodeName.toLowerCase()]) && "get" in n && void 0 !== (t = n.get(e, "value")) ? t : "string" == typeof(t = e.value) ? t.replace(ye, "") : null == t ? "" : t : void 0
            }
        }), E.extend({
            valHooks: {
                option: {
                    get: function(t) {
                        var e = E.find.attr(t, "value");
                        return null != e ? e : pe(E.text(t))
                    }
                },
                select: {
                    get: function(t) {
                        var e, i, n, o = t.options,
                            r = t.selectedIndex,
                            s = "select-one" === t.type,
                            a = s ? null : [],
                            l = s ? r + 1 : o.length;
                        for (n = r < 0 ? l : s ? r : 0; n < l; n++)
                            if (((i = o[n]).selected || n === r) && !i.disabled && (!i.parentNode.disabled || !k(i.parentNode, "optgroup"))) {
                                if (e = E(i).val(), s) return e;
                                a.push(e)
                            } return a
                    },
                    set: function(t, e) {
                        for (var i, n, o = t.options, r = E.makeArray(e), s = o.length; s--;)((n = o[s]).selected = -1 < E.inArray(E.valHooks.option.get(n), r)) && (i = !0);
                        return i || (t.selectedIndex = -1), r
                    }
                }
            }
        }), E.each(["radio", "checkbox"], function() {
            E.valHooks[this] = {
                set: function(t, e) {
                    if (Array.isArray(e)) return t.checked = -1 < E.inArray(E(t).val(), e)
                }
            }, y.checkOn || (E.valHooks[this].get = function(t) {
                return null === t.getAttribute("value") ? "on" : t.value
            })
        }), y.focusin = "onfocusin" in S;
        var ve = /^(?:focusinfocus|focusoutblur)$/,
            be = function(t) {
                t.stopPropagation()
            };
        E.extend(E.event, {
            trigger: function(t, e, i, n) {
                var o, r, s, a, l, u, c, h, d = [i || T],
                    f = g.call(t, "type") ? t.type : t,
                    p = g.call(t, "namespace") ? t.namespace.split(".") : [];
                if (r = h = s = i = i || T, 3 !== i.nodeType && 8 !== i.nodeType && !ve.test(f + E.event.triggered) && (-1 < f.indexOf(".") && (f = (p = f.split(".")).shift(), p.sort()), l = f.indexOf(":") < 0 && "on" + f, (t = t[E.expando] ? t : new E.Event(f, "object" == typeof t && t)).isTrigger = n ? 2 : 3, t.namespace = p.join("."), t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = i), e = null == e ? [t] : E.makeArray(e, [t]), c = E.event.special[f] || {}, n || !c.trigger || !1 !== c.trigger.apply(i, e))) {
                    if (!n && !c.noBubble && !b(i)) {
                        for (a = c.delegateType || f, ve.test(a + f) || (r = r.parentNode); r; r = r.parentNode) d.push(r), s = r;
                        s === (i.ownerDocument || T) && d.push(s.defaultView || s.parentWindow || S)
                    }
                    for (o = 0;
                        (r = d[o++]) && !t.isPropagationStopped();) h = r, t.type = 1 < o ? a : c.bindType || f, (u = (Q.get(r, "events") || Object.create(null))[t.type] && Q.get(r, "handle")) && u.apply(r, e), (u = l && r[l]) && u.apply && V(r) && (t.result = u.apply(r, e), !1 === t.result && t.preventDefault());
                    return t.type = f, n || t.isDefaultPrevented() || c._default && !1 !== c._default.apply(d.pop(), e) || !V(i) || l && v(i[f]) && !b(i) && ((s = i[l]) && (i[l] = null), E.event.triggered = f, t.isPropagationStopped() && h.addEventListener(f, be), i[f](), t.isPropagationStopped() && h.removeEventListener(f, be), E.event.triggered = void 0, s && (i[l] = s)), t.result
                }
            },
            simulate: function(t, e, i) {
                var n = E.extend(new E.Event, i, {
                    type: t,
                    isSimulated: !0
                });
                E.event.trigger(n, null, e)
            }
        }), E.fn.extend({
            trigger: function(t, e) {
                return this.each(function() {
                    E.event.trigger(t, e, this)
                })
            },
            triggerHandler: function(t, e) {
                var i = this[0];
                if (i) return E.event.trigger(t, e, i, !0)
            }
        }), y.focusin || E.each({
            focus: "focusin",
            blur: "focusout"
        }, function(i, n) {
            var o = function(t) {
                E.event.simulate(n, t.target, E.event.fix(t))
            };
            E.event.special[n] = {
                setup: function() {
                    var t = this.ownerDocument || this.document || this,
                        e = Q.access(t, n);
                    e || t.addEventListener(i, o, !0), Q.access(t, n, (e || 0) + 1)
                },
                teardown: function() {
                    var t = this.ownerDocument || this.document || this,
                        e = Q.access(t, n) - 1;
                    e ? Q.access(t, n, e) : (t.removeEventListener(i, o, !0), Q.remove(t, n))
                }
            }
        });
        var xe = S.location,
            we = {
                guid: Date.now()
            },
            _e = /\?/;
        E.parseXML = function(t) {
            var e, i;
            if (!t || "string" != typeof t) return null;
            try {
                e = (new S.DOMParser).parseFromString(t, "text/xml")
            } catch (t) {}
            return i = e && e.getElementsByTagName("parsererror")[0], e && !i || E.error("Invalid XML: " + (i ? E.map(i.childNodes, function(t) {
                return t.textContent
            }).join("\n") : t)), e
        };
        var Se = /\[\]$/,
            Te = /\r?\n/g,
            Ee = /^(?:submit|button|image|reset|file)$/i,
            Ce = /^(?:input|select|textarea|keygen)/i;

        function ke(i, t, n, o) {
            var e;
            if (Array.isArray(t)) E.each(t, function(t, e) {
                n || Se.test(i) ? o(i, e) : ke(i + "[" + ("object" == typeof e && null != e ? t : "") + "]", e, n, o)
            });
            else if (n || "object" !== w(t)) o(i, t);
            else
                for (e in t) ke(i + "[" + e + "]", t[e], n, o)
        }
        E.param = function(t, e) {
            var i, n = [],
                o = function(t, e) {
                    var i = v(e) ? e() : e;
                    n[n.length] = encodeURIComponent(t) + "=" + encodeURIComponent(null == i ? "" : i)
                };
            if (null == t) return "";
            if (Array.isArray(t) || t.jquery && !E.isPlainObject(t)) E.each(t, function() {
                o(this.name, this.value)
            });
            else
                for (i in t) ke(i, t[i], e, o);
            return n.join("&")
        }, E.fn.extend({
            serialize: function() {
                return E.param(this.serializeArray())
            },
            serializeArray: function() {
                return this.map(function() {
                    var t = E.prop(this, "elements");
                    return t ? E.makeArray(t) : this
                }).filter(function() {
                    var t = this.type;
                    return this.name && !E(this).is(":disabled") && Ce.test(this.nodeName) && !Ee.test(t) && (this.checked || !dt.test(t))
                }).map(function(t, e) {
                    var i = E(this).val();
                    return null == i ? null : Array.isArray(i) ? E.map(i, function(t) {
                        return {
                            name: e.name,
                            value: t.replace(Te, "\r\n")
                        }
                    }) : {
                        name: e.name,
                        value: i.replace(Te, "\r\n")
                    }
                }).get()
            }
        });
        var De = /%20/g,
            Ie = /#.*$/,
            Me = /([?&])_=[^&]*/,
            Pe = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            Oe = /^(?:GET|HEAD)$/,
            ze = /^\/\//,
            Le = {},
            Ae = {},
            Ne = "*/".concat("*"),
            je = T.createElement("a");

        function We(r) {
            return function(t, e) {
                "string" != typeof t && (e = t, t = "*");
                var i, n = 0,
                    o = t.toLowerCase().match(A) || [];
                if (v(e))
                    for (; i = o[n++];) "+" === i[0] ? (i = i.slice(1) || "*", (r[i] = r[i] || []).unshift(e)) : (r[i] = r[i] || []).push(e)
            }
        }

        function Re(e, o, r, s) {
            var a = {},
                l = e === Ae;

            function u(t) {
                var n;
                return a[t] = !0, E.each(e[t] || [], function(t, e) {
                    var i = e(o, r, s);
                    return "string" != typeof i || l || a[i] ? l ? !(n = i) : void 0 : (o.dataTypes.unshift(i), u(i), !1)
                }), n
            }
            return u(o.dataTypes[0]) || !a["*"] && u("*")
        }

        function Fe(t, e) {
            var i, n, o = E.ajaxSettings.flatOptions || {};
            for (i in e) void 0 !== e[i] && ((o[i] ? t : n || (n = {}))[i] = e[i]);
            return n && E.extend(!0, t, n), t
        }
        je.href = xe.href, E.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
                url: xe.href,
                type: "GET",
                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(xe.protocol),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: {
                    "*": Ne,
                    text: "text/plain",
                    html: "text/html",
                    xml: "application/xml, text/xml",
                    json: "application/json, text/javascript"
                },
                contents: {
                    xml: /\bxml\b/,
                    html: /\bhtml/,
                    json: /\bjson\b/
                },
                responseFields: {
                    xml: "responseXML",
                    text: "responseText",
                    json: "responseJSON"
                },
                converters: {
                    "* text": String,
                    "text html": !0,
                    "text json": JSON.parse,
                    "text xml": E.parseXML
                },
                flatOptions: {
                    url: !0,
                    context: !0
                }
            },
            ajaxSetup: function(t, e) {
                return e ? Fe(Fe(t, E.ajaxSettings), e) : Fe(E.ajaxSettings, t)
            },
            ajaxPrefilter: We(Le),
            ajaxTransport: We(Ae),
            ajax: function(t, e) {
                "object" == typeof t && (e = t, t = void 0), e = e || {};
                var c, h, d, i, f, n, p, m, o, r, g = E.ajaxSetup({}, e),
                    y = g.context || g,
                    v = g.context && (y.nodeType || y.jquery) ? E(y) : E.event,
                    b = E.Deferred(),
                    x = E.Callbacks("once memory"),
                    w = g.statusCode || {},
                    s = {},
                    a = {},
                    l = "canceled",
                    _ = {
                        readyState: 0,
                        getResponseHeader: function(t) {
                            var e;
                            if (p) {
                                if (!i)
                                    for (i = {}; e = Pe.exec(d);) i[e[1].toLowerCase() + " "] = (i[e[1].toLowerCase() + " "] || []).concat(e[2]);
                                e = i[t.toLowerCase() + " "]
                            }
                            return null == e ? null : e.join(", ")
                        },
                        getAllResponseHeaders: function() {
                            return p ? d : null
                        },
                        setRequestHeader: function(t, e) {
                            return null == p && (t = a[t.toLowerCase()] = a[t.toLowerCase()] || t, s[t] = e), this
                        },
                        overrideMimeType: function(t) {
                            return null == p && (g.mimeType = t), this
                        },
                        statusCode: function(t) {
                            var e;
                            if (t)
                                if (p) _.always(t[_.status]);
                                else
                                    for (e in t) w[e] = [w[e], t[e]];
                            return this
                        },
                        abort: function(t) {
                            var e = t || l;
                            return c && c.abort(e), u(0, e), this
                        }
                    };
                if (b.promise(_), g.url = ((t || g.url || xe.href) + "").replace(ze, xe.protocol + "//"), g.type = e.method || e.type || g.method || g.type, g.dataTypes = (g.dataType || "*").toLowerCase().match(A) || [""], null == g.crossDomain) {
                    n = T.createElement("a");
                    try {
                        n.href = g.url, n.href = n.href, g.crossDomain = je.protocol + "//" + je.host != n.protocol + "//" + n.host
                    } catch (t) {
                        g.crossDomain = !0
                    }
                }
                if (g.data && g.processData && "string" != typeof g.data && (g.data = E.param(g.data, g.traditional)), Re(Le, g, e, _), p) return _;
                for (o in (m = E.event && g.global) && 0 == E.active++ && E.event.trigger("ajaxStart"), g.type = g.type.toUpperCase(), g.hasContent = !Oe.test(g.type), h = g.url.replace(Ie, ""), g.hasContent ? g.data && g.processData && 0 === (g.contentType || "").indexOf("application/x-www-form-urlencoded") && (g.data = g.data.replace(De, "+")) : (r = g.url.slice(h.length), g.data && (g.processData || "string" == typeof g.data) && (h += (_e.test(h) ? "&" : "?") + g.data, delete g.data), !1 === g.cache && (h = h.replace(Me, "$1"), r = (_e.test(h) ? "&" : "?") + "_=" + we.guid++ + r), g.url = h + r), g.ifModified && (E.lastModified[h] && _.setRequestHeader("If-Modified-Since", E.lastModified[h]), E.etag[h] && _.setRequestHeader("If-None-Match", E.etag[h])), (g.data && g.hasContent && !1 !== g.contentType || e.contentType) && _.setRequestHeader("Content-Type", g.contentType), _.setRequestHeader("Accept", g.dataTypes[0] && g.accepts[g.dataTypes[0]] ? g.accepts[g.dataTypes[0]] + ("*" !== g.dataTypes[0] ? ", " + Ne + "; q=0.01" : "") : g.accepts["*"]), g.headers) _.setRequestHeader(o, g.headers[o]);
                if (g.beforeSend && (!1 === g.beforeSend.call(y, _, g) || p)) return _.abort();
                if (l = "abort", x.add(g.complete), _.done(g.success), _.fail(g.error), c = Re(Ae, g, e, _)) {
                    if (_.readyState = 1, m && v.trigger("ajaxSend", [_, g]), p) return _;
                    g.async && 0 < g.timeout && (f = S.setTimeout(function() {
                        _.abort("timeout")
                    }, g.timeout));
                    try {
                        p = !1, c.send(s, u)
                    } catch (t) {
                        if (p) throw t;
                        u(-1, t)
                    }
                } else u(-1, "No Transport");

                function u(t, e, i, n) {
                    var o, r, s, a, l, u = e;
                    p || (p = !0, f && S.clearTimeout(f), c = void 0, d = n || "", _.readyState = 0 < t ? 4 : 0, o = 200 <= t && t < 300 || 304 === t, i && (a = function(t, e, i) {
                        for (var n, o, r, s, a = t.contents, l = t.dataTypes;
                            "*" === l[0];) l.shift(), void 0 === n && (n = t.mimeType || e.getResponseHeader("Content-Type"));
                        if (n)
                            for (o in a)
                                if (a[o] && a[o].test(n)) {
                                    l.unshift(o);
                                    break
                                } if (l[0] in i) r = l[0];
                        else {
                            for (o in i) {
                                if (!l[0] || t.converters[o + " " + l[0]]) {
                                    r = o;
                                    break
                                }
                                s || (s = o)
                            }
                            r = r || s
                        }
                        if (r) return r !== l[0] && l.unshift(r), i[r]
                    }(g, _, i)), !o && -1 < E.inArray("script", g.dataTypes) && E.inArray("json", g.dataTypes) < 0 && (g.converters["text script"] = function() {}), a = function(t, e, i, n) {
                        var o, r, s, a, l, u = {},
                            c = t.dataTypes.slice();
                        if (c[1])
                            for (s in t.converters) u[s.toLowerCase()] = t.converters[s];
                        for (r = c.shift(); r;)
                            if (t.responseFields[r] && (i[t.responseFields[r]] = e), !l && n && t.dataFilter && (e = t.dataFilter(e, t.dataType)), l = r, r = c.shift())
                                if ("*" === r) r = l;
                                else if ("*" !== l && l !== r) {
                            if (!(s = u[l + " " + r] || u["* " + r]))
                                for (o in u)
                                    if ((a = o.split(" "))[1] === r && (s = u[l + " " + a[0]] || u["* " + a[0]])) {
                                        !0 === s ? s = u[o] : !0 !== u[o] && (r = a[0], c.unshift(a[1]));
                                        break
                                    } if (!0 !== s)
                                if (s && t.throws) e = s(e);
                                else try {
                                    e = s(e)
                                } catch (t) {
                                    return {
                                        state: "parsererror",
                                        error: s ? t : "No conversion from " + l + " to " + r
                                    }
                                }
                        }
                        return {
                            state: "success",
                            data: e
                        }
                    }(g, a, _, o), o ? (g.ifModified && ((l = _.getResponseHeader("Last-Modified")) && (E.lastModified[h] = l), (l = _.getResponseHeader("etag")) && (E.etag[h] = l)), 204 === t || "HEAD" === g.type ? u = "nocontent" : 304 === t ? u = "notmodified" : (u = a.state, r = a.data, o = !(s = a.error))) : (s = u, !t && u || (u = "error", t < 0 && (t = 0))), _.status = t, _.statusText = (e || u) + "", o ? b.resolveWith(y, [r, u, _]) : b.rejectWith(y, [_, u, s]), _.statusCode(w), w = void 0, m && v.trigger(o ? "ajaxSuccess" : "ajaxError", [_, g, o ? r : s]), x.fireWith(y, [_, u]), m && (v.trigger("ajaxComplete", [_, g]), --E.active || E.event.trigger("ajaxStop")))
                }
                return _
            },
            getJSON: function(t, e, i) {
                return E.get(t, e, i, "json")
            },
            getScript: function(t, e) {
                return E.get(t, void 0, e, "script")
            }
        }), E.each(["get", "post"], function(t, o) {
            E[o] = function(t, e, i, n) {
                return v(e) && (n = n || i, i = e, e = void 0), E.ajax(E.extend({
                    url: t,
                    type: o,
                    dataType: n,
                    data: e,
                    success: i
                }, E.isPlainObject(t) && t))
            }
        }), E.ajaxPrefilter(function(t) {
            var e;
            for (e in t.headers) "content-type" === e.toLowerCase() && (t.contentType = t.headers[e] || "")
        }), E._evalUrl = function(t, e, i) {
            return E.ajax({
                url: t,
                type: "GET",
                dataType: "script",
                cache: !0,
                async: !1,
                global: !1,
                converters: {
                    "text script": function() {}
                },
                dataFilter: function(t) {
                    E.globalEval(t, e, i)
                }
            })
        }, E.fn.extend({
            wrapAll: function(t) {
                var e;
                return this[0] && (v(t) && (t = t.call(this[0])), e = E(t, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && e.insertBefore(this[0]), e.map(function() {
                    for (var t = this; t.firstElementChild;) t = t.firstElementChild;
                    return t
                }).append(this)), this
            },
            wrapInner: function(i) {
                return v(i) ? this.each(function(t) {
                    E(this).wrapInner(i.call(this, t))
                }) : this.each(function() {
                    var t = E(this),
                        e = t.contents();
                    e.length ? e.wrapAll(i) : t.append(i)
                })
            },
            wrap: function(e) {
                var i = v(e);
                return this.each(function(t) {
                    E(this).wrapAll(i ? e.call(this, t) : e)
                })
            },
            unwrap: function(t) {
                return this.parent(t).not("body").each(function() {
                    E(this).replaceWith(this.childNodes)
                }), this
            }
        }), E.expr.pseudos.hidden = function(t) {
            return !E.expr.pseudos.visible(t)
        }, E.expr.pseudos.visible = function(t) {
            return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
        }, E.ajaxSettings.xhr = function() {
            try {
                return new S.XMLHttpRequest
            } catch (t) {}
        };
        var He = {
                0: 200,
                1223: 204
            },
            Ye = E.ajaxSettings.xhr();
        y.cors = !!Ye && "withCredentials" in Ye, y.ajax = Ye = !!Ye, E.ajaxTransport(function(o) {
            var r, s;
            if (y.cors || Ye && !o.crossDomain) return {
                send: function(t, e) {
                    var i, n = o.xhr();
                    if (n.open(o.type, o.url, o.async, o.username, o.password), o.xhrFields)
                        for (i in o.xhrFields) n[i] = o.xhrFields[i];
                    for (i in o.mimeType && n.overrideMimeType && n.overrideMimeType(o.mimeType), o.crossDomain || t["X-Requested-With"] || (t["X-Requested-With"] = "XMLHttpRequest"), t) n.setRequestHeader(i, t[i]);
                    r = function(t) {
                        return function() {
                            r && (r = s = n.onload = n.onerror = n.onabort = n.ontimeout = n.onreadystatechange = null, "abort" === t ? n.abort() : "error" === t ? "number" != typeof n.status ? e(0, "error") : e(n.status, n.statusText) : e(He[n.status] || n.status, n.statusText, "text" !== (n.responseType || "text") || "string" != typeof n.responseText ? {
                                binary: n.response
                            } : {
                                text: n.responseText
                            }, n.getAllResponseHeaders()))
                        }
                    }, n.onload = r(), s = n.onerror = n.ontimeout = r("error"), void 0 !== n.onabort ? n.onabort = s : n.onreadystatechange = function() {
                        4 === n.readyState && S.setTimeout(function() {
                            r && s()
                        })
                    }, r = r("abort");
                    try {
                        n.send(o.hasContent && o.data || null)
                    } catch (t) {
                        if (r) throw t
                    }
                },
                abort: function() {
                    r && r()
                }
            }
        }), E.ajaxPrefilter(function(t) {
            t.crossDomain && (t.contents.script = !1)
        }), E.ajaxSetup({
            accepts: {
                script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
            },
            contents: {
                script: /\b(?:java|ecma)script\b/
            },
            converters: {
                "text script": function(t) {
                    return E.globalEval(t), t
                }
            }
        }), E.ajaxPrefilter("script", function(t) {
            void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET")
        }), E.ajaxTransport("script", function(i) {
            var n, o;
            if (i.crossDomain || i.scriptAttrs) return {
                send: function(t, e) {
                    n = E("<script>").attr(i.scriptAttrs || {}).prop({
                        charset: i.scriptCharset,
                        src: i.url
                    }).on("load error", o = function(t) {
                        n.remove(), o = null, t && e("error" === t.type ? 404 : 200, t.type)
                    }), T.head.appendChild(n[0])
                },
                abort: function() {
                    o && o()
                }
            }
        });
        var qe, Be = [],
            Ue = /(=)\?(?=&|$)|\?\?/;
        E.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function() {
                var t = Be.pop() || E.expando + "_" + we.guid++;
                return this[t] = !0, t
            }
        }), E.ajaxPrefilter("json jsonp", function(t, e, i) {
            var n, o, r, s = !1 !== t.jsonp && (Ue.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Ue.test(t.data) && "data");
            if (s || "jsonp" === t.dataTypes[0]) return n = t.jsonpCallback = v(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, s ? t[s] = t[s].replace(Ue, "$1" + n) : !1 !== t.jsonp && (t.url += (_e.test(t.url) ? "&" : "?") + t.jsonp + "=" + n), t.converters["script json"] = function() {
                return r || E.error(n + " was not called"), r[0]
            }, t.dataTypes[0] = "json", o = S[n], S[n] = function() {
                r = arguments
            }, i.always(function() {
                void 0 === o ? E(S).removeProp(n) : S[n] = o, t[n] && (t.jsonpCallback = e.jsonpCallback, Be.push(n)), r && v(o) && o(r[0]), r = o = void 0
            }), "script"
        }), y.createHTMLDocument = ((qe = T.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === qe.childNodes.length), E.parseHTML = function(t, e, i) {
            return "string" != typeof t ? [] : ("boolean" == typeof e && (i = e, e = !1), e || (y.createHTMLDocument ? ((n = (e = T.implementation.createHTMLDocument("")).createElement("base")).href = T.location.href, e.head.appendChild(n)) : e = T), r = !i && [], (o = D.exec(t)) ? [e.createElement(o[1])] : (o = bt([t], e, r), r && r.length && E(r).remove(), E.merge([], o.childNodes)));
            var n, o, r
        }, E.fn.load = function(t, e, i) {
            var n, o, r, s = this,
                a = t.indexOf(" ");
            return -1 < a && (n = pe(t.slice(a)), t = t.slice(0, a)), v(e) ? (i = e, e = void 0) : e && "object" == typeof e && (o = "POST"), 0 < s.length && E.ajax({
                url: t,
                type: o || "GET",
                dataType: "html",
                data: e
            }).done(function(t) {
                r = arguments, s.html(n ? E("<div>").append(E.parseHTML(t)).find(n) : t)
            }).always(i && function(t, e) {
                s.each(function() {
                    i.apply(this, r || [t.responseText, e, t])
                })
            }), this
        }, E.expr.pseudos.animated = function(e) {
            return E.grep(E.timers, function(t) {
                return e === t.elem
            }).length
        }, E.offset = {
            setOffset: function(t, e, i) {
                var n, o, r, s, a, l, u = E.css(t, "position"),
                    c = E(t),
                    h = {};
                "static" === u && (t.style.position = "relative"), a = c.offset(), r = E.css(t, "top"), l = E.css(t, "left"), o = ("absolute" === u || "fixed" === u) && -1 < (r + l).indexOf("auto") ? (s = (n = c.position()).top, n.left) : (s = parseFloat(r) || 0, parseFloat(l) || 0), v(e) && (e = e.call(t, i, E.extend({}, a))), null != e.top && (h.top = e.top - a.top + s), null != e.left && (h.left = e.left - a.left + o), "using" in e ? e.using.call(t, h) : c.css(h)
            }
        }, E.fn.extend({
            offset: function(e) {
                if (arguments.length) return void 0 === e ? this : this.each(function(t) {
                    E.offset.setOffset(this, e, t)
                });
                var t, i, n = this[0];
                return n ? n.getClientRects().length ? (t = n.getBoundingClientRect(), i = n.ownerDocument.defaultView, {
                    top: t.top + i.pageYOffset,
                    left: t.left + i.pageXOffset
                }) : {
                    top: 0,
                    left: 0
                } : void 0
            },
            position: function() {
                if (this[0]) {
                    var t, e, i, n = this[0],
                        o = {
                            top: 0,
                            left: 0
                        };
                    if ("fixed" === E.css(n, "position")) e = n.getBoundingClientRect();
                    else {
                        for (e = this.offset(), i = n.ownerDocument, t = n.offsetParent || i.documentElement; t && (t === i.body || t === i.documentElement) && "static" === E.css(t, "position");) t = t.parentNode;
                        t && t !== n && 1 === t.nodeType && ((o = E(t).offset()).top += E.css(t, "borderTopWidth", !0), o.left += E.css(t, "borderLeftWidth", !0))
                    }
                    return {
                        top: e.top - o.top - E.css(n, "marginTop", !0),
                        left: e.left - o.left - E.css(n, "marginLeft", !0)
                    }
                }
            },
            offsetParent: function() {
                return this.map(function() {
                    for (var t = this.offsetParent; t && "static" === E.css(t, "position");) t = t.offsetParent;
                    return t || nt
                })
            }
        }), E.each({
            scrollLeft: "pageXOffset",
            scrollTop: "pageYOffset"
        }, function(e, o) {
            var r = "pageYOffset" === o;
            E.fn[e] = function(t) {
                return Y(this, function(t, e, i) {
                    var n;
                    if (b(t) ? n = t : 9 === t.nodeType && (n = t.defaultView), void 0 === i) return n ? n[o] : t[e];
                    n ? n.scrollTo(r ? n.pageXOffset : i, r ? i : n.pageYOffset) : t[e] = i
                }, e, t, arguments.length)
            }
        }), E.each(["top", "left"], function(t, i) {
            E.cssHooks[i] = Ft(y.pixelPosition, function(t, e) {
                if (e) return e = Rt(t, i), At.test(e) ? E(t).position()[i] + "px" : e
            })
        }), E.each({
            Height: "height",
            Width: "width"
        }, function(s, a) {
            E.each({
                padding: "inner" + s,
                content: a,
                "": "outer" + s
            }, function(n, r) {
                E.fn[r] = function(t, e) {
                    var i = arguments.length && (n || "boolean" != typeof t),
                        o = n || (!0 === t || !0 === e ? "margin" : "border");
                    return Y(this, function(t, e, i) {
                        var n;
                        return b(t) ? 0 === r.indexOf("outer") ? t["inner" + s] : t.document.documentElement["client" + s] : 9 === t.nodeType ? (n = t.documentElement, Math.max(t.body["scroll" + s], n["scroll" + s], t.body["offset" + s], n["offset" + s], n["client" + s])) : void 0 === i ? E.css(t, e, o) : E.style(t, e, i, o)
                    }, a, i ? t : void 0, i)
                }
            })
        }), E.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(t, e) {
            E.fn[e] = function(t) {
                return this.on(e, t)
            }
        }), E.fn.extend({
            bind: function(t, e, i) {
                return this.on(t, null, e, i)
            },
            unbind: function(t, e) {
                return this.off(t, null, e)
            },
            delegate: function(t, e, i, n) {
                return this.on(e, t, i, n)
            },
            undelegate: function(t, e, i) {
                return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", i)
            },
            hover: function(t, e) {
                return this.mouseenter(t).mouseleave(e || t)
            }
        }), E.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(t, i) {
            E.fn[i] = function(t, e) {
                return 0 < arguments.length ? this.on(i, null, t, e) : this.trigger(i)
            }
        });
        var $e = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        E.proxy = function(t, e) {
            var i, n, o;
            if ("string" == typeof e && (i = t[e], e = t, t = i), v(t)) return n = a.call(arguments, 2), (o = function() {
                return t.apply(e || this, n.concat(a.call(arguments)))
            }).guid = t.guid = t.guid || E.guid++, o
        }, E.holdReady = function(t) {
            t ? E.readyWait++ : E.ready(!0)
        }, E.isArray = Array.isArray, E.parseJSON = JSON.parse, E.nodeName = k, E.isFunction = v, E.isWindow = b, E.camelCase = $, E.type = w, E.now = Date.now, E.isNumeric = function(t) {
            var e = E.type(t);
            return ("number" === e || "string" === e) && !isNaN(t - parseFloat(t))
        }, E.trim = function(t) {
            return null == t ? "" : (t + "").replace($e, "")
        }, "function" == typeof define && define.amd && define("jquery", [], function() {
            return E
        });
        var Ve = S.jQuery,
            Ge = S.$;
        return E.noConflict = function(t) {
            return S.$ === E && (S.$ = Ge), t && S.jQuery === E && (S.jQuery = Ve), E
        }, void 0 === t && (S.jQuery = S.$ = E), E
    });
    var jQuery_T4NT = jQuery,
        jsBdThe4 = document.querySelector("body"),
        RtlThe4 = jsBdThe4.classList.contains("rtl_true"),
        LtrThe4 = !RtlThe4;
    ! function(e, i) {
        "function" == typeof define && define.amd ? define("jQuery_T4NT-bridget/jQuery_T4NT-bridget", ["jQuery_T4NT"], function(t) {
            return i(e, t)
        }) : "object" == typeof module && module.exports ? module.exports = i(e, require("jQuery_T4NT")) : e.jQuery_T4NTBridget = i(e, e.jQuery_T4NT)
    }(window, function(t, e) {
        "use strict";
        var i = Array.prototype.slice,
            n = t.console,
            h = void 0 === n ? function() {} : function(t) {
                n.error(t)
            };

        function o(u, o, c) {
            (c = c || e || t.jQuery_T4NT) && (o.prototype.option || (o.prototype.option = function(t) {
                c.isPlainObject(t) && (this.options = c.extend(!0, this.options, t))
            }), c.fn[u] = function(t) {
                return "string" == typeof t ? (this, r = t, s = i.call(arguments, 1), l = "$()." + u + '("' + r + '")', this.each(function(t, e) {
                    var i = c.data(e, u);
                    if (i) {
                        var n = i[r];
                        if (n && "_" != r.charAt(0)) {
                            var o = n.apply(i, s);
                            a = void 0 === a ? o : a
                        } else h(l + " is not a valid method")
                    } else h(u + " not initialized. Cannot call methods, i.e. " + l)
                }), void 0 !== a ? a : this) : (n = t, this.each(function(t, e) {
                    var i = c.data(e, u);
                    i ? (i.option(n), i._init()) : (i = new o(e, n), c.data(e, u, i))
                }), this);
                var n, r, s, a, l
            }, r(c))
        }

        function r(t) {
            !t || t && t.bridget || (t.bridget = o)
        }
        return r(e || t.jQuery_T4NT), o
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
    }("undefined" != typeof window ? window : this, function() {
        function t() {}
        var e = t.prototype;
        return e.on = function(t, e) {
            if (t && e) {
                var i = this._events = this._events || {},
                    n = i[t] = i[t] || [];
                return -1 == n.indexOf(e) && n.push(e), this
            }
        }, e.once = function(t, e) {
            if (t && e) {
                this.on(t, e);
                var i = this._onceEvents = this._onceEvents || {};
                return (i[t] = i[t] || {})[e] = !0, this
            }
        }, e.off = function(t, e) {
            var i = this._events && this._events[t];
            if (i && i.length) {
                var n = i.indexOf(e);
                return -1 != n && i.splice(n, 1), this
            }
        }, e.emitEvent = function(t, e) {
            var i = this._events && this._events[t];
            if (i && i.length) {
                i = i.slice(0), e = e || [];
                for (var n = this._onceEvents && this._onceEvents[t], o = 0; o < i.length; o++) {
                    var r = i[o];
                    n && n[r] && (this.off(t, r), delete n[r]), r.apply(this, e)
                }
                return this
            }
        }, e.allOff = function() {
            delete this._events, delete this._onceEvents
        }, t
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
    }(window, function() {
        "use strict";

        function v(t) {
            var e = parseFloat(t);
            return -1 == t.indexOf("%") && !isNaN(e) && e
        }
        var i = "undefined" == typeof console ? function() {} : function(t) {
                console.error(t)
            },
            b = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
            x = b.length;

        function w(t) {
            var e = getComputedStyle(t);
            return e || i("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), e
        }
        var _, S = !1;
        return function n(t) {
            if (function() {
                    if (!S) {
                        S = !0;
                        var t = document.createElement("div");
                        t.style.width = "200px", t.style.padding = "1px 2px 3px 4px", t.style.borderStyle = "solid", t.style.borderWidth = "1px 2px 3px 4px", t.style.boxSizing = "border-box";
                        var e = document.body || document.documentElement;
                        e.appendChild(t);
                        var i = w(t);
                        _ = 200 == Math.round(v(i.width)), n.isBoxSizeOuter = _, e.removeChild(t)
                    }
                }(), "string" == typeof t && (t = document.querySelector(t)), t && "object" == typeof t && t.nodeType) {
                var e = w(t);
                if ("none" == e.display) return function() {
                    for (var t = {
                            width: 0,
                            height: 0,
                            innerWidth: 0,
                            innerHeight: 0,
                            outerWidth: 0,
                            outerHeight: 0
                        }, e = 0; e < x; e++) t[b[e]] = 0;
                    return t
                }();
                var i = {};
                i.width = t.offsetWidth, i.height = t.offsetHeight;
                for (var o = i.isBorderBox = "border-box" == e.boxSizing, r = 0; r < x; r++) {
                    var s = b[r],
                        a = e[s],
                        l = parseFloat(a);
                    i[s] = isNaN(l) ? 0 : l
                }
                var u = i.paddingLeft + i.paddingRight,
                    c = i.paddingTop + i.paddingBottom,
                    h = i.marginLeft + i.marginRight,
                    d = i.marginTop + i.marginBottom,
                    f = i.borderLeftWidth + i.borderRightWidth,
                    p = i.borderTopWidth + i.borderBottomWidth,
                    m = o && _,
                    g = v(e.width);
                !1 !== g && (i.width = g + (m ? 0 : u + f));
                var y = v(e.height);
                return !1 !== y && (i.height = y + (m ? 0 : c + p)), i.innerWidth = i.width - (u + f), i.innerHeight = i.height - (c + p), i.outerWidth = i.width + h, i.outerHeight = i.height + d, i
            }
        }
    }),
    function(t, e) {
        "use strict";
        "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e()
    }(window, function() {
        "use strict";
        var i = function() {
            var t = window.Element.prototype;
            if (t.matches) return "matches";
            if (t.matchesSelector) return "matchesSelector";
            for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
                var n = e[i] + "MatchesSelector";
                if (t[n]) return n
            }
        }();
        return function(t, e) {
            return t[i](e)
        }
    }),
    function(e, i) {
        "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function(t) {
            return i(e, t)
        }) : "object" == typeof module && module.exports ? module.exports = i(e, require("desandro-matches-selector")) : e.fizzyUIUtils = i(e, e.matchesSelector)
    }(window, function(u, r) {
        var c = {
                extend: function(t, e) {
                    for (var i in e) t[i] = e[i];
                    return t
                },
                modulo: function(t, e) {
                    return (t % e + e) % e
                }
            },
            e = Array.prototype.slice;
        c.makeArray = function(t) {
            return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? e.call(t) : [t]
        }, c.removeFrom = function(t, e) {
            var i = t.indexOf(e); - 1 != i && t.splice(i, 1)
        }, c.getParent = function(t, e) {
            for (; t.parentNode && t != document.body;)
                if (t = t.parentNode, r(t, e)) return t
        }, c.getQueryElement = function(t) {
            return "string" == typeof t ? document.querySelector(t) : t
        }, c.handleEvent = function(t) {
            var e = "on" + t.type;
            this[e] && this[e](t)
        }, c.filterFindElements = function(t, n) {
            t = c.makeArray(t);
            var o = [];
            return t.forEach(function(t) {
                if (t instanceof HTMLElement)
                    if (n) {
                        r(t, n) && o.push(t);
                        for (var e = t.querySelectorAll(n), i = 0; i < e.length; i++) o.push(e[i])
                    } else o.push(t)
            }), o
        }, c.debounceMethod = function(t, e, n) {
            n = n || 100;
            var o = t.prototype[e],
                r = e + "Timeout";
            t.prototype[e] = function() {
                var t = this[r];
                clearTimeout(t);
                var e = arguments,
                    i = this;
                this[r] = setTimeout(function() {
                    o.apply(i, e), delete i[r]
                }, n)
            }
        }, c.docReady = function(t) {
            var e = document.readyState;
            "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
        }, c.toDashed = function(t) {
            return t.replace(/(.)([A-Z])/g, function(t, e, i) {
                return e + "-" + i
            }).toLowerCase()
        };
        var h = u.console;
        return c.htmlInit = function(a, l) {
            c.docReady(function() {
                var t = c.toDashed(l),
                    o = "data-" + t,
                    e = document.querySelectorAll("[" + o + "]"),
                    i = document.querySelectorAll(".js-" + t),
                    n = c.makeArray(e).concat(c.makeArray(i)),
                    r = o + "-options",
                    s = u.jQuery_T4NT;
                n.forEach(function(t) {
                    var e, i = t.getAttribute(o) || t.getAttribute(r);
                    try {
                        e = i && JSON.parse(i)
                    } catch (e) {
                        return void(h && h.error("Error parsing " + o + " on " + t.className + ": " + e))
                    }
                    var n = new a(t, e);
                    s && s.data(t, l, n)
                })
            })
        }, c
    }),
    function(e, i) {
        "function" == typeof define && define.amd ? define("flickity/js/cell", ["get-size/get-size"], function(t) {
            return i(e, t)
        }) : "object" == typeof module && module.exports ? module.exports = i(e, require("get-size")) : (e.Flickity = e.Flickity || {}, e.Flickity.Cell = i(e, e.getSize))
    }(window, function(t, e) {
        function i(t, e) {
            this.element = t, this.parent = e, this.create()
        }
        var n = i.prototype;
        return n.create = function() {
            this.element.style.position = "absolute", this.element.setAttribute("aria-hidden", "true"), this.x = 0, this.shift = 0
        }, n.destroy = function() {
            this.unselect(), this.element.style.position = "";
            var t = this.parent.originSide;
            this.element.style[t] = ""
        }, n.getSize = function() {
            this.size = e(this.element)
        }, n.setPosition = function(t) {
            this.x = t, this.updateTarget(), this.renderPosition(t)
        }, n.updateTarget = n.setDefaultTarget = function() {
            var t = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
            this.target = this.x + this.size[t] + this.size.width * this.parent.cellAlign
        }, n.renderPosition = function(t) {
            var e = this.parent.originSide;
            this.element.style[e] = this.parent.getPositionValue(t)
        }, n.select = function() {
            this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden")
        }, n.unselect = function() {
            this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true")
        }, n.wrapShift = function(t) {
            this.shift = t, this.renderPosition(this.x + this.parent.slideableWidth * t)
        }, n.remove = function() {
            this.element.parentNode.removeChild(this.element)
        }, i
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("flickity/js/slide", e) : "object" == typeof module && module.exports ? module.exports = e() : (t.Flickity = t.Flickity || {}, t.Flickity.Slide = e())
    }(window, function() {
        "use strict";

        function t(t) {
            this.parent = t, this.isOriginLeft = "left" == t.originSide, this.cells = [], this.outerWidth = 0, this.height = 0
        }
        var e = t.prototype;
        return e.addCell = function(t) {
            if (this.cells.push(t), this.outerWidth += t.size.outerWidth, this.height = Math.max(t.size.outerHeight, this.height), 1 == this.cells.length) {
                this.x = t.x;
                var e = this.isOriginLeft ? "marginLeft" : "marginRight";
                this.firstMargin = t.size[e]
            }
        }, e.updateTarget = function() {
            var t = this.isOriginLeft ? "marginRight" : "marginLeft",
                e = this.getLastCell(),
                i = e ? e.size[t] : 0,
                n = this.outerWidth - (this.firstMargin + i);
            this.target = this.x + this.firstMargin + n * this.parent.cellAlign
        }, e.getLastCell = function() {
            return this.cells[this.cells.length - 1]
        }, e.select = function() {
            this.cells.forEach(function(t) {
                t.select()
            })
        }, e.unselect = function() {
            this.cells.forEach(function(t) {
                t.unselect()
            })
        }, e.getCellElements = function() {
            return this.cells.map(function(t) {
                return t.element
            })
        }, t
    }),
    function(e, i) {
        "function" == typeof define && define.amd ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function(t) {
            return i(e, t)
        }) : "object" == typeof module && module.exports ? module.exports = i(e, require("fizzy-ui-utils")) : (e.Flickity = e.Flickity || {}, e.Flickity.animatePrototype = i(e, e.fizzyUIUtils))
    }(window, function(t, e) {
        return {
            startAnimation: function() {
                this.isAnimating || (this.isAnimating = !0, this.restingFrames = 0, this.animate())
            },
            animate: function() {
                this.applyDragForce(), this.applySelectedAttraction();
                var t = this.x;
                if (this.integratePhysics(), this.positionSlider(), this.settle(t), this.isAnimating) {
                    var e = this;
                    requestAnimationFrame(function() {
                        e.animate()
                    })
                }
            },
            positionSlider: function() {
                var t = this.x;
                this.options.wrapAround && 1 < this.cells.length && (t = e.modulo(t, this.slideableWidth), t -= this.slideableWidth, this.shiftWrapCells(t)), this.setTranslateX(t, this.isAnimating), this.dispatchScrollEvent()
            },
            setTranslateX: function(t, e) {
                t += this.cursorPosition, t = RtlThe4 ? -t : t;
                var i = this.getPositionValue(t);
                this.slider.style.transform = e ? "translate3d(" + i + ",0,0)" : "translateX(" + i + ")"
            },
            dispatchScrollEvent: function() {
                var t = this.slides[0];
                if (t) {
                    var e = -this.x - t.target,
                        i = e / this.slidesWidth;
                    this.dispatchEvent("scroll", null, [i, e])
                }
            },
            positionSliderAtSelected: function() {
                this.cells.length && (this.x = -this.selectedSlide.target, this.velocity = 0, this.positionSlider())
            },
            getPositionValue: function(t) {
                return this.options.percentPosition ? .01 * Math.round(t / this.size.innerWidth * 1e4) + "%" : Math.round(t) + "px"
            },
            settle: function(t) {
                this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * t) || this.restingFrames++, 2 < this.restingFrames && (this.isAnimating = !1, delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle", null, [this.selectedIndex]))
            },
            shiftWrapCells: function(t) {
                var e = this.cursorPosition + t;
                this._shiftCells(this.beforeShiftCells, e, -1);
                var i = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition);
                this._shiftCells(this.afterShiftCells, i, 1)
            },
            _shiftCells: function(t, e, i) {
                for (var n = 0; n < t.length; n++) {
                    var o = t[n],
                        r = 0 < e ? i : 0;
                    o.wrapShift(r), e -= o.size.outerWidth
                }
            },
            _unshiftCells: function(t) {
                if (t && t.length)
                    for (var e = 0; e < t.length; e++) t[e].wrapShift(0)
            },
            integratePhysics: function() {
                this.x += this.velocity, this.velocity *= this.getFrictionFactor()
            },
            applyForce: function(t) {
                this.velocity += t
            },
            getFrictionFactor: function() {
                return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
            },
            getRestingPosition: function() {
                return this.x + this.velocity / (1 - this.getFrictionFactor())
            },
            applyDragForce: function() {
                if (this.isDraggable && this.isPointerDown) {
                    var t = this.dragX - this.x - this.velocity;
                    this.applyForce(t)
                }
            },
            applySelectedAttraction: function() {
                if ((!this.isDraggable || !this.isPointerDown) && !this.isFreeScrolling && this.slides.length) {
                    var t = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
                    this.applyForce(t)
                }
            }
        }
    }),
    function(s, a) {
        if ("function" == typeof define && define.amd) define("flickity/js/flickity", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate"], function(t, e, i, n, o, r) {
            return a(s, t, e, i, n, o, r)
        });
        else if ("object" == typeof module && module.exports) module.exports = a(s, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate"));
        else {
            var t = s.Flickity;
            s.Flickity = a(s, s.EvEmitter, s.getSize, s.fizzyUIUtils, t.Cell, t.Slide, t.animatePrototype)
        }
    }(window, function(n, t, e, a, i, s, o) {
        var l = n.jQuery_T4NT,
            r = n.getComputedStyle,
            u = n.console;

        function c(t, e) {
            for (t = a.makeArray(t); t.length;) e.appendChild(t.shift())
        }
        var h = 0,
            d = {};

        function f(t, e) {
            var i = a.getQueryElement(t);
            if (i) {
                if (this.element = i, this.element.flickityGUID) {
                    var n = d[this.element.flickityGUID];
                    return n.option(e), n
                }
                l && (this.$element = l(this.element)), this.options = a.extend({}, this.constructor.defaults), this.option(e), this._create()
            } else u && u.error("Bad element for Flickity: " + (i || t))
        }
        f.defaults = {
            accessibility: !0,
            cellAlign: "center",
            freeScrollFriction: .075,
            friction: .28,
            namespacejQuery_T4NTEvents: !0,
            percentPosition: !0,
            resize: !0,
            selectedAttraction: .025,
            setGallerySize: !0
        }, f.createMethods = [];
        var p = f.prototype;
        a.extend(p, t.prototype), p._create = function() {
            var t = this.guid = ++h;
            for (var e in this.element.flickityGUID = t, (d[t] = this).selectedIndex = 0, this.restingFrames = 0, this.x = 0, this.velocity = 0, this.originSide = RtlThe4 ? "right" : "left", this.viewport = document.createElement("div"), this.viewport.className = "flickity-viewport", this._createSlider(), (this.options.resize || this.options.watchCSS) && n.addEventListener("resize", this), this.options.on) {
                var i = this.options.on[e];
                this.on(e, i)
            }
            f.createMethods.forEach(function(t) {
                this[t]()
            }, this), this.options.watchCSS ? this.watchCSS() : this.activate()
        }, p.option = function(t) {
            a.extend(this.options, t)
        }, p.activate = function() {
            this.isActive || (this.isActive = !0, this.element.classList.add("flickity-enabled"), RtlThe4 && this.element.classList.add("flickity-rtl"), this.getSize(), c(this._filterFindCellElements(this.element.children), this.slider), this.viewport.appendChild(this.slider), this.element.appendChild(this.viewport), this.reloadCells(), this.options.accessibility && (this.element.tabIndex = 0, this.element.addEventListener("keydown", this)), this.emitEvent("activate"), this.selectInitialIndex(), this.isInitActivated = !0, this.dispatchEvent("ready"))
        }, p._createSlider = function() {
            var t = document.createElement("div");
            t.className = "flickity-slider", t.style[this.originSide] = 0, this.slider = t
        }, p._filterFindCellElements = function(t) {
            return a.filterFindElements(t, this.options.cellSelector)
        }, p.reloadCells = function() {
            this.cells = this._makeCells(this.slider.children), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize()
        }, p._makeCells = function(t) {
            return this._filterFindCellElements(t).map(function(t) {
                return new i(t, this)
            }, this)
        }, p.getLastCell = function() {
            return this.cells[this.cells.length - 1]
        }, p.getLastSlide = function() {
            return this.slides[this.slides.length - 1]
        }, p.positionCells = function() {
            this._sizeCells(this.cells), this._positionCells(0)
        }, p._positionCells = function(t) {
            t = t || 0, this.maxCellHeight = t && this.maxCellHeight || 0;
            var e = 0;
            if (0 < t) {
                var i = this.cells[t - 1];
                e = i.x + i.size.outerWidth
            }
            for (var n = this.cells.length, o = t; o < n; o++) {
                var r = this.cells[o];
                r.setPosition(e), e += r.size.outerWidth, this.maxCellHeight = Math.max(r.size.outerHeight, this.maxCellHeight)
            }
            this.slideableWidth = e, this.updateSlides(), this._containSlides(), this.slidesWidth = n ? this.getLastSlide().target - this.slides[0].target : 0
        }, p._sizeCells = function(t) {
            t.forEach(function(t) {
                t.getSize()
            })
        }, p.updateSlides = function() {
            if (this.slides = [], this.cells.length) {
                var n = new s(this);
                this.slides.push(n);
                var o = "left" == this.originSide ? "marginRight" : "marginLeft",
                    r = this._getCanCellFit();
                this.cells.forEach(function(t, e) {
                    if (n.cells.length) {
                        var i = n.outerWidth - n.firstMargin + (t.size.outerWidth - t.size[o]);
                        r.call(this, e, i) || (n.updateTarget(), n = new s(this), this.slides.push(n)), n.addCell(t)
                    } else n.addCell(t)
                }, this), n.updateTarget(), this.updateSelectedSlide()
            }
        }, p._getCanCellFit = function() {
            var t = this.options.groupCells;
            if (!t) return function() {
                return !1
            };
            if ("number" == typeof t) {
                var e = parseInt(t, 10);
                return function(t) {
                    return t % e != 0
                }
            }
            var i = "string" == typeof t && t.match(/^(\d+)%$/),
                n = i ? parseInt(i[1], 10) / 100 : 1;
            return function(t, e) {
                return e <= (this.size.innerWidth + 1) * n
            }
        }, p._init = p.reposition = function() {
            this.positionCells(), this.positionSliderAtSelected()
        }, p.getSize = function() {
            this.size = e(this.element), this.setCellAlign(), this.cursorPosition = this.size.innerWidth * this.cellAlign
        };
        var m = {
            center: {
                left: .5,
                right: .5
            },
            left: {
                left: 0,
                right: 1
            },
            right: {
                right: 0,
                left: 1
            }
        };
        return p.setCellAlign = function() {
            var t = m[this.options.cellAlign];
            this.cellAlign = t ? t[this.originSide] : this.options.cellAlign
        }, p.setGallerySize = function() {
            if (this.options.setGallerySize) {
                var t = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                this.viewport.style.height = t + "px"
            }
        }, p._getWrapShiftCells = function() {
            if (this.options.wrapAround) {
                this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
                var t = this.cursorPosition,
                    e = this.cells.length - 1;
                this.beforeShiftCells = this._getGapCells(t, e, -1), t = this.size.innerWidth - this.cursorPosition, this.afterShiftCells = this._getGapCells(t, 0, 1)
            }
        }, p._getGapCells = function(t, e, i) {
            for (var n = []; 0 < t;) {
                var o = this.cells[e];
                if (!o) break;
                n.push(o), e += i, t -= o.size.outerWidth
            }
            return n
        }, p._containSlides = function() {
            if (this.options.contain && !this.options.wrapAround && this.cells.length) {
                var t = RtlThe4 ? "marginRight" : "marginLeft",
                    e = RtlThe4 ? "marginLeft" : "marginRight",
                    i = this.slideableWidth - this.getLastCell().size[e],
                    n = i < this.size.innerWidth,
                    o = this.cursorPosition + this.cells[0].size[t],
                    r = i - this.size.innerWidth * (1 - this.cellAlign);
                this.slides.forEach(function(t) {
                    t.target = n ? i * this.cellAlign : (t.target = Math.max(t.target, o), Math.min(t.target, r))
                }, this)
            }
        }, p.dispatchEvent = function(t, e, i) {
            var n = e ? [e].concat(i) : i;
            if (this.emitEvent(t, n), l && this.$element) {
                var o = t += this.options.namespacejQuery_T4NTEvents ? ".flickity" : "";
                if (e) {
                    var r = l.Event(e);
                    r.type = t, o = r
                }
                this.$element.trigger(o, i)
            }
        }, p.select = function(t, e, i) {
            if (this.isActive && (t = parseInt(t, 10), this._wrapSelect(t), (this.options.wrapAround || e) && (t = a.modulo(t, this.slides.length)), this.slides[t])) {
                var n = this.selectedIndex;
                this.selectedIndex = t, this.updateSelectedSlide(), i ? this.positionSliderAtSelected() : this.startAnimation(), this.options.adaptiveHeight && this.setGallerySize(), this.dispatchEvent("select", null, [t]), t != n && this.dispatchEvent("change", null, [t]), this.dispatchEvent("cellSelect")
            }
        }, p._wrapSelect = function(t) {
            var e = this.slides.length;
            if (!(this.options.wrapAround && 1 < e)) return t;
            var i = a.modulo(t, e),
                n = Math.abs(i - this.selectedIndex),
                o = Math.abs(i + e - this.selectedIndex),
                r = Math.abs(i - e - this.selectedIndex);
            !this.isDragSelect && o < n ? t += e : !this.isDragSelect && r < n && (t -= e), t < 0 ? this.x -= this.slideableWidth : e <= t && (this.x += this.slideableWidth)
        }, p.previous = function(t, e) {
            this.select(this.selectedIndex - 1, t, e)
        }, p.next = function(t, e) {
            this.select(this.selectedIndex + 1, t, e)
        }, p.updateSelectedSlide = function() {
            var t = this.slides[this.selectedIndex];
            t && (this.unselectSelectedSlide(), (this.selectedSlide = t).select(), this.selectedCells = t.cells, this.selectedElements = t.getCellElements(), this.selectedCell = t.cells[0], this.selectedElement = this.selectedElements[0])
        }, p.unselectSelectedSlide = function() {
            this.selectedSlide && this.selectedSlide.unselect()
        }, p.selectInitialIndex = function() {
            var t = this.options.initialIndex;
            if (this.isInitActivated) this.select(this.selectedIndex, !1, !0);
            else {
                if (t && "string" == typeof t && this.queryCell(t)) return void this.selectCell(t, !1, !0);
                var e = 0;
                t && this.slides[t] && (e = t), this.select(e, !1, !0)
            }
        }, p.selectCell = function(t, e, i) {
            var n = this.queryCell(t);
            if (n) {
                var o = this.getCellSlideIndex(n);
                this.select(o, e, i)
            }
        }, p.getCellSlideIndex = function(t) {
            for (var e = 0; e < this.slides.length; e++)
                if (-1 != this.slides[e].cells.indexOf(t)) return e
        }, p.getCell = function(t) {
            for (var e = 0; e < this.cells.length; e++) {
                var i = this.cells[e];
                if (i.element == t) return i
            }
        }, p.getCells = function(t) {
            t = a.makeArray(t);
            var i = [];
            return t.forEach(function(t) {
                var e = this.getCell(t);
                e && i.push(e)
            }, this), i
        }, p.getCellElements = function() {
            return this.cells.map(function(t) {
                return t.element
            })
        }, p.getParentCell = function(t) {
            return this.getCell(t) || (t = a.getParent(t, ".flickity-slider > *"), this.getCell(t))
        }, p.getAdjacentCellElements = function(t, e) {
            if (!t) return this.selectedSlide.getCellElements();
            e = void 0 === e ? this.selectedIndex : e;
            var i = this.slides.length;
            if (i <= 1 + 2 * t) return this.getCellElements();
            for (var n = [], o = e - t; o <= e + t; o++) {
                var r = this.options.wrapAround ? a.modulo(o, i) : o,
                    s = this.slides[r];
                s && (n = n.concat(s.getCellElements()))
            }
            return n
        }, p.queryCell = function(t) {
            if ("number" == typeof t) return this.cells[t];
            if ("string" == typeof t) {
                if (t.match(/^[#\.]?[\d\/]/)) return;
                t = this.element.querySelector(t)
            }
            return this.getCell(t)
        }, p.uiChange = function() {
            this.emitEvent("uiChange")
        }, p.childUIPointerDown = function(t) {
            "touchstart" != t.type && t.preventDefault(), this.focus()
        }, p.onresize = function() {
            this.watchCSS(), this.resize()
        }, a.debounceMethod(f, "onresize", 150), p.resize = function() {
            if (this.isActive) {
                this.getSize(), this.options.wrapAround && (this.x = a.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
                var t = this.selectedElements && this.selectedElements[0];
                this.selectCell(t, !1, !0)
            }
        }, p.watchCSS = function() {
            this.options.watchCSS && (-1 != r(this.element, ":after").content.indexOf("flickity") ? this.activate() : this.deactivate())
        }, p.onkeydown = function(t) {
            var e = document.activeElement && document.activeElement != this.element;
            if (this.options.accessibility && !e) {
                var i = f.keyboardHandlers[t.keyCode];
                i && i.call(this)
            }
        }, f.keyboardHandlers = {
            37: function() {
                var t = RtlThe4 ? "next" : "previous";
                this.uiChange(), this[t]()
            },
            39: function() {
                var t = RtlThe4 ? "previous" : "next";
                this.uiChange(), this[t]()
            }
        }, p.focus = function() {
            var t = n.pageYOffset;
            this.element.focus({
                preventScroll: !0
            }), n.pageYOffset != t && n.scrollTo(n.pageXOffset, t)
        }, p.deactivate = function() {
            this.isActive && (this.element.classList.remove("flickity-enabled"), this.element.classList.remove("flickity-rtl"), this.unselectSelectedSlide(), this.cells.forEach(function(t) {
                t.destroy()
            }), this.element.removeChild(this.viewport), c(this.slider.children, this.element), this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)), this.isActive = !1, this.emitEvent("deactivate"))
        }, p.destroy = function() {
            this.deactivate(), n.removeEventListener("resize", this), this.allOff(), this.emitEvent("destroy"), l && this.$element && l.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete d[this.guid]
        }, a.extend(p, o), f.data = function(t) {
            var e = (t = a.getQueryElement(t)) && t.flickityGUID;
            return e && d[e]
        }, a.htmlInit(f, "flickity"), l && l.bridget && l.bridget("flickity", f), f.setjQuery_T4NT = function(t) {
            l = t
        }, f.Cell = i, f.Slide = s, f
    }),
    function(e, i) {
        "function" == typeof define && define.amd ? define("unipointer/unipointer", ["ev-emitter/ev-emitter"], function(t) {
            return i(e, t)
        }) : "object" == typeof module && module.exports ? module.exports = i(e, require("ev-emitter")) : e.Unipointer = i(e, e.EvEmitter)
    }(window, function(o, t) {
        function e() {}
        var i = e.prototype = Object.create(t.prototype);
        i.bindStartEvent = function(t) {
            this._bindStartEvent(t, !0)
        }, i.unbindStartEvent = function(t) {
            this._bindStartEvent(t, !1)
        }, i._bindStartEvent = function(t, e) {
            var i = (e = void 0 === e || e) ? "addEventListener" : "removeEventListener",
                n = "mousedown";
            o.PointerEvent ? n = "pointerdown" : "ontouchstart" in o && (n = "touchstart"), t[i](n, this)
        }, i.handleEvent = function(t) {
            var e = "on" + t.type;
            this[e] && this[e](t)
        }, i.getTouch = function(t) {
            for (var e = 0; e < t.length; e++) {
                var i = t[e];
                if (i.identifier == this.pointerIdentifier) return i
            }
        }, i.onmousedown = function(t) {
            var e = t.button;
            e && 0 !== e && 1 !== e || this._pointerDown(t, t)
        }, i.ontouchstart = function(t) {
            this._pointerDown(t, t.changedTouches[0])
        }, i.onpointerdown = function(t) {
            this._pointerDown(t, t)
        }, i._pointerDown = function(t, e) {
            t.button || this.isPointerDown || (this.isPointerDown = !0, this.pointerIdentifier = void 0 !== e.pointerId ? e.pointerId : e.identifier, this.pointerDown(t, e))
        }, i.pointerDown = function(t, e) {
            this._bindPostStartEvents(t), this.emitEvent("pointerDown", [t, e])
        };
        var n = {
            mousedown: ["mousemove", "mouseup"],
            touchstart: ["touchmove", "touchend", "touchcancel"],
            pointerdown: ["pointermove", "pointerup", "pointercancel"]
        };
        return i._bindPostStartEvents = function(t) {
            if (t) {
                var e = n[t.type];
                e.forEach(function(t) {
                    o.addEventListener(t, this)
                }, this), this._boundPointerEvents = e
            }
        }, i._unbindPostStartEvents = function() {
            this._boundPointerEvents && (this._boundPointerEvents.forEach(function(t) {
                o.removeEventListener(t, this)
            }, this), delete this._boundPointerEvents)
        }, i.onmousemove = function(t) {
            this._pointerMove(t, t)
        }, i.onpointermove = function(t) {
            t.pointerId == this.pointerIdentifier && this._pointerMove(t, t)
        }, i.ontouchmove = function(t) {
            var e = this.getTouch(t.changedTouches);
            e && this._pointerMove(t, e)
        }, i._pointerMove = function(t, e) {
            this.pointerMove(t, e)
        }, i.pointerMove = function(t, e) {
            this.emitEvent("pointerMove", [t, e])
        }, i.onmouseup = function(t) {
            this._pointerUp(t, t)
        }, i.onpointerup = function(t) {
            t.pointerId == this.pointerIdentifier && this._pointerUp(t, t)
        }, i.ontouchend = function(t) {
            var e = this.getTouch(t.changedTouches);
            e && this._pointerUp(t, e)
        }, i._pointerUp = function(t, e) {
            this._pointerDone(), this.pointerUp(t, e)
        }, i.pointerUp = function(t, e) {
            this.emitEvent("pointerUp", [t, e])
        }, i._pointerDone = function() {
            this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone()
        }, i._pointerReset = function() {
            this.isPointerDown = !1, delete this.pointerIdentifier
        }, i.pointerDone = function() {}, i.onpointercancel = function(t) {
            t.pointerId == this.pointerIdentifier && this._pointerCancel(t, t)
        }, i.ontouchcancel = function(t) {
            var e = this.getTouch(t.changedTouches);
            e && this._pointerCancel(t, e)
        }, i._pointerCancel = function(t, e) {
            this._pointerDone(), this.pointerCancel(t, e)
        }, i.pointerCancel = function(t, e) {
            this.emitEvent("pointerCancel", [t, e])
        }, e.getPointerPoint = function(t) {
            return {
                x: t.pageX,
                y: t.pageY
            }
        }, e
    }),
    function(e, i) {
        "function" == typeof define && define.amd ? define("unidragger/unidragger", ["unipointer/unipointer"], function(t) {
            return i(e, t)
        }) : "object" == typeof module && module.exports ? module.exports = i(e, require("unipointer")) : e.Unidragger = i(e, e.Unipointer)
    }(window, function(r, t) {
        function e() {}
        var i = e.prototype = Object.create(t.prototype);
        i.bindHandles = function() {
            this._bindHandles(!0)
        }, i.unbindHandles = function() {
            this._bindHandles(!1)
        }, i._bindHandles = function(t) {
            for (var e = (t = void 0 === t || t) ? "addEventListener" : "removeEventListener", i = t ? this._touchActionValue : "", n = 0; n < this.handles.length; n++) {
                var o = this.handles[n];
                this._bindStartEvent(o, t), o[e]("click", this), r.PointerEvent && (o.style.touchAction = i)
            }
        }, i._touchActionValue = "none", i.pointerDown = function(t, e) {
            this.okayPointerDown(t) && (this.pointerDownPointer = e, t.preventDefault(), this.pointerDownBlur(), this._bindPostStartEvents(t), this.emitEvent("pointerDown", [t, e]))
        };
        var o = {
                TEXTAREA: !0,
                INPUT: !0,
                SELECT: !0,
                OPTION: !0
            },
            s = {
                radio: !0,
                checkbox: !0,
                button: !0,
                submit: !0,
                image: !0,
                file: !0
            };
        return i.okayPointerDown = function(t) {
            var e = o[t.target.nodeName],
                i = s[t.target.type],
                n = !e || i;
            return n || this._pointerReset(), n
        }, i.pointerDownBlur = function() {
            var t = document.activeElement;
            t && t.blur && t != document.body && t.blur()
        }, i.pointerMove = function(t, e) {
            var i = this._dragPointerMove(t, e);
            this.emitEvent("pointerMove", [t, e, i]), this._dragMove(t, e, i)
        }, i._dragPointerMove = function(t, e) {
            var i = {
                x: e.pageX - this.pointerDownPointer.pageX,
                y: e.pageY - this.pointerDownPointer.pageY
            };
            return !this.isDragging && this.hasDragStarted(i) && this._dragStart(t, e), i
        }, i.hasDragStarted = function(t) {
            return 3 < Math.abs(t.x) || 3 < Math.abs(t.y)
        }, i.pointerUp = function(t, e) {
            this.emitEvent("pointerUp", [t, e]), this._dragPointerUp(t, e)
        }, i._dragPointerUp = function(t, e) {
            this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e)
        }, i._dragStart = function(t, e) {
            this.isDragging = !0, this.isPreventingClicks = !0, this.dragStart(t, e)
        }, i.dragStart = function(t, e) {
            this.emitEvent("dragStart", [t, e])
        }, i._dragMove = function(t, e, i) {
            this.isDragging && this.dragMove(t, e, i)
        }, i.dragMove = function(t, e, i) {
            t.preventDefault(), this.emitEvent("dragMove", [t, e, i])
        }, i._dragEnd = function(t, e) {
            this.isDragging = !1, setTimeout(function() {
                delete this.isPreventingClicks
            }.bind(this)), this.dragEnd(t, e)
        }, i.dragEnd = function(t, e) {
            this.emitEvent("dragEnd", [t, e])
        }, i.onclick = function(t) {
            this.isPreventingClicks && t.preventDefault()
        }, i._staticClick = function(t, e) {
            this.isIgnoringMouseUp && "mouseup" == t.type || (this.staticClick(t, e), "mouseup" != t.type && (this.isIgnoringMouseUp = !0, setTimeout(function() {
                delete this.isIgnoringMouseUp
            }.bind(this), 400)))
        }, i.staticClick = function(t, e) {
            this.emitEvent("staticClick", [t, e])
        }, e.getPointerPoint = t.getPointerPoint, e
    }),
    function(n, o) {
        "function" == typeof define && define.amd ? define("flickity/js/drag", ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], function(t, e, i) {
            return o(n, t, e, i)
        }) : "object" == typeof module && module.exports ? module.exports = o(n, require("./flickity"), require("unidragger"), require("fizzy-ui-utils")) : n.Flickity = o(n, n.Flickity, n.Unidragger, n.fizzyUIUtils)
    }(window, function(i, t, e, a) {
        a.extend(t.defaults, {
            draggable: ">1",
            dragThreshold: 3
        }), t.createMethods.push("_createDrag");
        var n = t.prototype;
        a.extend(n, e.prototype), n._touchActionValue = "pan-y";
        var o = "createTouch" in document,
            r = !1;
        n._createDrag = function() {
            this.on("activate", this.onActivateDrag), this.on("uiChange", this._uiChangeDrag), this.on("deactivate", this.onDeactivateDrag), this.on("cellChange", this.updateDraggable), o && !r && (i.addEventListener("touchmove", function() {}), r = !0)
        }, n.onActivateDrag = function() {
            this.handles = [this.viewport], this.bindHandles(), this.updateDraggable()
        }, n.onDeactivateDrag = function() {
            this.unbindHandles(), this.element.classList.remove("is-draggable")
        }, n.updateDraggable = function() {
            ">1" == this.options.draggable ? this.isDraggable = 1 < this.slides.length : this.isDraggable = this.options.draggable, this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable")
        }, n.bindDrag = function() {
            this.options.draggable = !0, this.updateDraggable()
        }, n.unbindDrag = function() {
            this.options.draggable = !1, this.updateDraggable()
        }, n._uiChangeDrag = function() {
            delete this.isFreeScrolling
        }, n.pointerDown = function(t, e) {
            this.isDraggable ? this.okayPointerDown(t) && (this._pointerDownPreventDefault(t), this.pointerDownFocus(t), document.activeElement != this.element && this.pointerDownBlur(), this.dragX = this.x, this.viewport.classList.add("is-pointer-down"), this.pointerDownScroll = l(), i.addEventListener("scroll", this), this._pointerDownDefault(t, e)) : this._pointerDownDefault(t, e)
        }, n._pointerDownDefault = function(t, e) {
            this.pointerDownPointer = {
                pageX: e.pageX,
                pageY: e.pageY
            }, this._bindPostStartEvents(t), this.dispatchEvent("pointerDown", t, [e])
        };
        var s = {
            INPUT: !0,
            TEXTAREA: !0,
            SELECT: !0
        };

        function l() {
            return {
                x: i.pageXOffset,
                y: i.pageYOffset
            }
        }
        return n.pointerDownFocus = function(t) {
            s[t.target.nodeName] || this.focus()
        }, n._pointerDownPreventDefault = function(t) {
            var e = "touchstart" == t.type,
                i = "touch" == t.pointerType,
                n = s[t.target.nodeName];
            e || i || n || t.preventDefault()
        }, n.hasDragStarted = function(t) {
            return Math.abs(t.x) > this.options.dragThreshold
        }, n.pointerUp = function(t, e) {
            delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), this.dispatchEvent("pointerUp", t, [e]), this._dragPointerUp(t, e)
        }, n.pointerDone = function() {
            i.removeEventListener("scroll", this), delete this.pointerDownScroll
        }, n.dragStart = function(t, e) {
            this.isDraggable && (this.dragStartPosition = this.x, this.startAnimation(), i.removeEventListener("scroll", this), this.dispatchEvent("dragStart", t, [e]))
        }, n.pointerMove = function(t, e) {
            var i = this._dragPointerMove(t, e);
            this.dispatchEvent("pointerMove", t, [e, i]), this._dragMove(t, e, i)
        }, n.dragMove = function(t, e, i) {
            if (this.isDraggable) {
                t.preventDefault(), this.previousDragX = this.dragX;
                var n = RtlThe4 ? -1 : 1;
                this.options.wrapAround && (i.x = i.x % this.slideableWidth);
                var o = this.dragStartPosition + i.x * n;
                if (!this.options.wrapAround && this.slides.length) {
                    var r = Math.max(-this.slides[0].target, this.dragStartPosition);
                    o = r < o ? .5 * (o + r) : o;
                    var s = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                    o = o < s ? .5 * (o + s) : o
                }
                this.dragX = o, this.dragMoveTime = new Date, this.dispatchEvent("dragMove", t, [e, i])
            }
        }, n.dragEnd = function(t, e) {
            if (this.isDraggable) {
                this.options.freeScroll && (this.isFreeScrolling = !0);
                var i = this.dragEndRestingSelect();
                if (this.options.freeScroll && !this.options.wrapAround) {
                    var n = this.getRestingPosition();
                    this.isFreeScrolling = -n > this.slides[0].target && -n < this.getLastSlide().target
                } else this.options.freeScroll || i != this.selectedIndex || (i += this.dragEndBoostSelect());
                delete this.previousDragX, this.isDragSelect = this.options.wrapAround, this.select(i), delete this.isDragSelect, this.dispatchEvent("dragEnd", t, [e])
            }
        }, n.dragEndRestingSelect = function() {
            var t = this.getRestingPosition(),
                e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
                i = this._getClosestResting(t, e, 1),
                n = this._getClosestResting(t, e, -1);
            return i.distance < n.distance ? i.index : n.index
        }, n._getClosestResting = function(t, e, i) {
            for (var n = this.selectedIndex, o = 1 / 0, r = this.options.contain && !this.options.wrapAround ? function(t, e) {
                    return t <= e
                } : function(t, e) {
                    return t < e
                }; r(e, o) && (n += i, o = e, null !== (e = this.getSlideDistance(-t, n)));) e = Math.abs(e);
            return {
                distance: o,
                index: n - i
            }
        }, n.getSlideDistance = function(t, e) {
            var i = this.slides.length,
                n = this.options.wrapAround && 1 < i,
                o = n ? a.modulo(e, i) : e,
                r = this.slides[o];
            if (!r) return null;
            var s = n ? this.slideableWidth * Math.floor(e / i) : 0;
            return t - (r.target + s)
        }, n.dragEndBoostSelect = function() {
            if (void 0 === this.previousDragX || !this.dragMoveTime || 100 < new Date - this.dragMoveTime) return 0;
            var t = this.getSlideDistance(-this.dragX, this.selectedIndex),
                e = this.previousDragX - this.dragX;
            return 0 < t && 0 < e ? 1 : t < 0 && e < 0 ? -1 : 0
        }, n.staticClick = function(t, e) {
            var i = this.getParentCell(t.target),
                n = i && i.element,
                o = i && this.cells.indexOf(i);
            this.dispatchEvent("staticClick", t, [e, n, o])
        }, n.onscroll = function() {
            var t = l(),
                e = this.pointerDownScroll.x - t.x,
                i = this.pointerDownScroll.y - t.y;
            (3 < Math.abs(e) || 3 < Math.abs(i)) && this._pointerDone()
        }, t
    }),
    function(n, o) {
        "function" == typeof define && define.amd ? define("flickity/js/prev-next-button", ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"], function(t, e, i) {
            return o(n, t, e, i)
        }) : "object" == typeof module && module.exports ? module.exports = o(n, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")) : o(n, n.Flickity, n.Unipointer, n.fizzyUIUtils)
    }(window, function(t, e, i, n) {
        "use strict";
        var o = "http://www.w3.org/2000/svg";

        function r(t, e) {
            this.direction = t, this.parent = e, this._create()
        }(r.prototype = Object.create(i.prototype))._create = function() {
            this.isEnabled = !0, this.isPrevious = -1 == this.direction;
            var t = this.parent.options.rightToLeft ? 1 : -1;
            this.isLeft = this.direction == t;
            var e = this.element = document.createElement("button");
            e.className = "flickity-button flickity-prev-next-button", e.className += this.isPrevious ? " previous" : " next", e.setAttribute("type", "button"), this.disable(), e.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
            var i = this.createSVG();
            e.appendChild(i), this.parent.on("select", this.update.bind(this)), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
        }, r.prototype.activate = function() {
            this.bindStartEvent(this.element), this.element.addEventListener("click", this), this.parent.element.appendChild(this.element)
        }, r.prototype.deactivate = function() {
            this.parent.element.removeChild(this.element), this.unbindStartEvent(this.element), this.element.removeEventListener("click", this)
        }, r.prototype.createSVG = function() {
            var t = document.createElementNS(o, "svg");
            t.setAttribute("class", "flickity-button-icon"), t.setAttribute("viewBox", "0 0 100 100");
            var e, i = document.createElementNS(o, "path"),
                n = "string" != typeof(e = this.parent.options.arrowShape) ? "M " + e.x0 + ",50 L " + e.x1 + "," + (e.y1 + 50) + " L " + e.x2 + "," + (e.y2 + 50) + " L " + e.x3 + ",50  L " + e.x2 + "," + (50 - e.y2) + " L " + e.x1 + "," + (50 - e.y1) + " Z" : e;
            return i.setAttribute("d", n), i.setAttribute("class", "arrow"), this.isLeft || i.setAttribute("transform", "translate(100, 100) rotate(180) "), t.appendChild(i), t
        }, r.prototype.handleEvent = n.handleEvent, r.prototype.onclick = function() {
            if (this.isEnabled) {
                this.parent.uiChange();
                var t = this.isPrevious ? "previous" : "next";
                this.parent[t]()
            }
        }, r.prototype.enable = function() {
            this.isEnabled || (this.element.disabled = !1, this.isEnabled = !0)
        }, r.prototype.disable = function() {
            this.isEnabled && (this.element.disabled = !0, this.isEnabled = !1)
        }, r.prototype.update = function() {
            var t = this.parent.slides;
            if (this.parent.options.wrapAround && 1 < t.length) this.enable();
            else {
                var e = t.length ? t.length - 1 : 0,
                    i = this.isPrevious ? 0 : e;
                this[this.parent.selectedIndex == i ? "disable" : "enable"]()
            }
        }, r.prototype.destroy = function() {
            this.deactivate(), this.allOff()
        }, n.extend(e.defaults, {
            prevNextButtons: !0,
            arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 70,
                y2: 40,
                x3: 30
            }
        }), e.createMethods.push("_createPrevNextButtons");
        var s = e.prototype;
        return s._createPrevNextButtons = function() {
            this.options.prevNextButtons && (this.prevButton = new r(-1, this), this.nextButton = new r(1, this), this.on("activate", this.activatePrevNextButtons))
        }, s.activatePrevNextButtons = function() {
            this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons)
        }, s.deactivatePrevNextButtons = function() {
            this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons)
        }, e.PrevNextButton = r, e
    }),
    function(n, o) {
        "function" == typeof define && define.amd ? define("flickity/js/page-dots", ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"], function(t, e, i) {
            return o(n, t, e, i)
        }) : "object" == typeof module && module.exports ? module.exports = o(n, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")) : o(n, n.Flickity, n.Unipointer, n.fizzyUIUtils)
    }(window, function(t, e, i, n) {
        function o(t) {
            this.parent = t, this._create()
        }(o.prototype = Object.create(i.prototype))._create = function() {
            this.holder = document.createElement("ol"), this.holder.className = "flickity-page-dots", this.dots = [], this.handleClick = this.onClick.bind(this), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
        }, o.prototype.activate = function() {
            this.setDots(), this.holder.addEventListener("click", this.handleClick), this.bindStartEvent(this.holder), this.parent.element.appendChild(this.holder)
        }, o.prototype.deactivate = function() {
            this.holder.removeEventListener("click", this.handleClick), this.unbindStartEvent(this.holder), this.parent.element.removeChild(this.holder)
        }, o.prototype.setDots = function() {
            var t = this.parent.slides.length - this.dots.length;
            0 < t ? this.addDots(t) : t < 0 && this.removeDots(-t)
        }, o.prototype.addDots = function(t) {
            for (var e = document.createDocumentFragment(), i = [], n = this.dots.length, o = n + t, r = n; r < o; r++) {
                var s = document.createElement("li");
                s.className = "dot", s.setAttribute("aria-label", "Page dot " + (r + 1)), e.appendChild(s), i.push(s)
            }
            this.holder.appendChild(e), this.dots = this.dots.concat(i)
        }, o.prototype.removeDots = function(t) {
            this.dots.splice(this.dots.length - t, t).forEach(function(t) {
                this.holder.removeChild(t)
            }, this)
        }, o.prototype.updateSelected = function() {
            this.selectedDot && (this.selectedDot.className = "dot", this.selectedDot.removeAttribute("aria-current")), this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex], this.selectedDot.className = "dot is-selected", this.selectedDot.setAttribute("aria-current", "step"))
        }, o.prototype.onTap = o.prototype.onClick = function(t) {
            var e = t.target;
            if ("LI" == e.nodeName) {
                this.parent.uiChange();
                var i = this.dots.indexOf(e);
                this.parent.select(i)
            }
        }, o.prototype.destroy = function() {
            this.deactivate(), this.allOff()
        }, e.PageDots = o, n.extend(e.defaults, {
            pageDots: !0
        }), e.createMethods.push("_createPageDots");
        var r = e.prototype;
        return r._createPageDots = function() {
            this.options.pageDots && (this.pageDots = new o(this), this.on("activate", this.activatePageDots), this.on("select", this.updateSelectedPageDots), this.on("cellChange", this.updatePageDots), this.on("resize", this.updatePageDots), this.on("deactivate", this.deactivatePageDots))
        }, r.activatePageDots = function() {
            this.pageDots.activate()
        }, r.updateSelectedPageDots = function() {
            this.pageDots.updateSelected()
        }, r.updatePageDots = function() {
            this.pageDots.setDots()
        }, r.deactivatePageDots = function() {
            this.pageDots.deactivate()
        }, e.PageDots = o, e
    }),
    function(t, n) {
        "function" == typeof define && define.amd ? define("flickity/js/player", ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"], function(t, e, i) {
            return n(t, e, i)
        }) : "object" == typeof module && module.exports ? module.exports = n(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity")) : n(t.EvEmitter, t.fizzyUIUtils, t.Flickity)
    }(window, function(t, e, i) {
        function n(t) {
            this.parent = t, this.state = "stopped", this.onVisibilityChange = this.visibilityChange.bind(this), this.onVisibilityPlay = this.visibilityPlay.bind(this)
        }(n.prototype = Object.create(t.prototype)).play = function() {
            "playing" != this.state && (document.hidden ? document.addEventListener("visibilitychange", this.onVisibilityPlay) : (this.state = "playing", document.addEventListener("visibilitychange", this.onVisibilityChange), this.tick()))
        }, n.prototype.tick = function() {
            if ("playing" == this.state) {
                var t = this.parent.options.autoPlay;
                t = "number" == typeof t ? t : 3e3;
                var e = this;
                this.clear(), this.timeout = setTimeout(function() {
                    e.parent.next(!0), e.tick()
                }, t)
            }
        }, n.prototype.stop = function() {
            this.state = "stopped", this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange)
        }, n.prototype.clear = function() {
            clearTimeout(this.timeout)
        }, n.prototype.pause = function() {
            "playing" == this.state && (this.state = "paused", this.clear())
        }, n.prototype.unpause = function() {
            "paused" == this.state && this.play()
        }, n.prototype.visibilityChange = function() {
            this[document.hidden ? "pause" : "unpause"]()
        }, n.prototype.visibilityPlay = function() {
            this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay)
        }, e.extend(i.defaults, {
            pauseAutoPlayOnHover: !0
        }), i.createMethods.push("_createPlayer");
        var o = i.prototype;
        return o._createPlayer = function() {
            this.player = new n(this), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer)
        }, o.activatePlayer = function() {
            this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this))
        }, o.playPlayer = function() {
            this.player.play()
        }, o.stopPlayer = function() {
            this.player.stop()
        }, o.pausePlayer = function() {
            this.player.pause()
        }, o.unpausePlayer = function() {
            this.player.unpause()
        }, o.deactivatePlayer = function() {
            this.player.stop(), this.element.removeEventListener("mouseenter", this)
        }, o.onmouseenter = function() {
            this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this))
        }, o.onmouseleave = function() {
            this.player.unpause(), this.element.removeEventListener("mouseleave", this)
        }, i.Player = n, i
    }),
    function(i, n) {
        "function" == typeof define && define.amd ? define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], function(t, e) {
            return n(i, t, e)
        }) : "object" == typeof module && module.exports ? module.exports = n(i, require("./flickity"), require("fizzy-ui-utils")) : n(i, i.Flickity, i.fizzyUIUtils)
    }(window, function(t, e, n) {
        var i = e.prototype;
        return i.insert = function(t, e) {
            var i, n, o = this._makeCells(t);
            if (o && o.length) {
                var r = this.cells.length;
                e = void 0 === e ? r : e;
                var s = (i = o, n = document.createDocumentFragment(), i.forEach(function(t) {
                        n.appendChild(t.element)
                    }), n),
                    a = e == r;
                if (a) this.slider.appendChild(s);
                else {
                    var l = this.cells[e].element;
                    this.slider.insertBefore(s, l)
                }
                if (0 === e) this.cells = o.concat(this.cells);
                else if (a) this.cells = this.cells.concat(o);
                else {
                    var u = this.cells.splice(e, r - e);
                    this.cells = this.cells.concat(o).concat(u)
                }
                this._sizeCells(o), this.cellChange(e, !0)
            }
        }, i.append = function(t) {
            this.insert(t, this.cells.length)
        }, i.prepend = function(t) {
            this.insert(t, 0)
        }, i.remove = function(t) {
            var e = this.getCells(t);
            if (e && e.length) {
                var i = this.cells.length - 1;
                e.forEach(function(t) {
                    t.remove();
                    var e = this.cells.indexOf(t);
                    i = Math.min(e, i), n.removeFrom(this.cells, t)
                }, this), this.cellChange(i, !0)
            }
        }, i.cellSizeChange = function(t) {
            var e = this.getCell(t);
            if (e) {
                e.getSize();
                var i = this.cells.indexOf(e);
                this.cellChange(i)
            }
        }, i.cellChange = function(t, e) {
            var i = this.selectedElement;
            this._positionCells(t), this._getWrapShiftCells(), this.setGallerySize();
            var n = this.getCell(i);
            n && (this.selectedIndex = this.getCellSlideIndex(n)), this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex), this.emitEvent("cellChange", [t]), this.select(this.selectedIndex), e && this.positionSliderAtSelected()
        }, e
    }),
    function(i, n) {
        "function" == typeof define && define.amd ? define("flickity/js/lazyload", ["./flickity", "fizzy-ui-utils/utils"], function(t, e) {
            return n(i, t, e)
        }) : "object" == typeof module && module.exports ? module.exports = n(i, require("./flickity"), require("fizzy-ui-utils")) : n(i, i.Flickity, i.fizzyUIUtils)
    }(window, function(t, e, r) {
        "use strict";
        e.createMethods.push("_createLazyload");
        var i = e.prototype;

        function o(t, e) {
            this.img = t, this.flickity = e, this.load()
        }
        return i._createLazyload = function() {
            this.on("select", this.lazyLoad)
        }, i.lazyLoad = function() {
            var t = this.options.lazyLoad;
            if (t) {
                var e = "number" == typeof t ? t : 0,
                    i = this.getAdjacentCellElements(e),
                    n = [];
                i.forEach(function(t) {
                    var e = function(t) {
                        if ("IMG" == t.nodeName) {
                            var e = t.getAttribute("data-flickity-lazyload"),
                                i = t.getAttribute("data-flickity-lazyload-src"),
                                n = t.getAttribute("data-flickity-lazyload-srcset");
                            if (e || i || n) return [t]
                        }
                        var o = t.querySelectorAll("img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]");
                        return r.makeArray(o)
                    }(t);
                    n = n.concat(e)
                }), n.forEach(function(t) {
                    new o(t, this)
                }, this)
            }
        }, o.prototype.handleEvent = r.handleEvent, o.prototype.load = function() {
            this.img.addEventListener("load", this), this.img.addEventListener("error", this);
            var t = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src"),
                e = this.img.getAttribute("data-flickity-lazyload-srcset");
            this.img.src = t, e && this.img.setAttribute("srcset", e), this.img.removeAttribute("data-flickity-lazyload"), this.img.removeAttribute("data-flickity-lazyload-src"), this.img.removeAttribute("data-flickity-lazyload-srcset")
        }, o.prototype.onload = function(t) {
            this.complete(t, "flickity-lazyloaded")
        }, o.prototype.onerror = function(t) {
            this.complete(t, "flickity-lazyerror")
        }, o.prototype.complete = function(t, e) {
            this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
            var i = this.flickity.getParentCell(this.img),
                n = i && i.element;
            this.flickity.cellSizeChange(n), this.img.classList.add(e), this.flickity.dispatchEvent("lazyLoad", t, n)
        }, e.LazyLoader = o, e
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], e) : "object" == typeof module && module.exports && (module.exports = e(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")))
    }(window, function(t) {
        return t
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("flickity-as-nav-for/as-nav-for", ["flickity/js/index", "fizzy-ui-utils/utils"], e) : "object" == typeof module && module.exports ? module.exports = e(require("flickity"), require("fizzy-ui-utils")) : t.Flickity = e(t.Flickity, t.fizzyUIUtils)
    }(window, function(n, o) {
        n.createMethods.push("_createAsNavFor");
        var t = n.prototype;
        return t._createAsNavFor = function() {
            this.on("activate", this.activateAsNavFor), this.on("deactivate", this.deactivateAsNavFor), this.on("destroy", this.destroyAsNavFor);
            var t = this.options.asNavFor;
            if (t) {
                var e = this;
                setTimeout(function() {
                    e.setNavCompanion(t)
                })
            }
        }, t.setNavCompanion = function(t) {
            t = o.getQueryElement(t);
            var e = n.data(t);
            if (e && e != this) {
                this.navCompanion = e;
                var i = this;
                this.onNavCompanionSelect = function() {
                    i.navCompanionSelect()
                }, e.on("select", this.onNavCompanionSelect), this.on("staticClick", this.onNavStaticClick), this.navCompanionSelect(!0)
            }
        }, t.navCompanionSelect = function(t) {
            var e, i = this.navCompanion && this.navCompanion.selectedCells;
            if (i) {
                var n = i[0],
                    o = this.navCompanion.cells.indexOf(n),
                    r = o + i.length - 1,
                    s = Math.floor((r - (e = o)) * this.navCompanion.cellAlign + e);
                if (this.selectCell(s, !1, t), this.removeNavSelectedElements(), !(s >= this.cells.length)) {
                    var a = this.cells.slice(o, 1 + r);
                    this.navSelectedElements = a.map(function(t) {
                        return t.element
                    }), this.changeNavSelectedClass("add")
                }
            }
        }, t.changeNavSelectedClass = function(e) {
            this.navSelectedElements.forEach(function(t) {
                t.classList[e]("is-nav-selected")
            })
        }, t.activateAsNavFor = function() {
            this.navCompanionSelect(!0)
        }, t.removeNavSelectedElements = function() {
            this.navSelectedElements && (this.changeNavSelectedClass("remove"), delete this.navSelectedElements)
        }, t.onNavStaticClick = function(t, e, i, n) {
            "number" == typeof n && this.navCompanion.selectCell(n)
        }, t.deactivateAsNavFor = function() {
            this.removeNavSelectedElements()
        }, t.destroyAsNavFor = function() {
            this.navCompanion && (this.navCompanion.off("select", this.onNavCompanionSelect), this.off("staticClick", this.onNavStaticClick), delete this.navCompanion)
        }, n
    }),
    function(e, i) {
        "use strict";
        "function" == typeof define && define.amd ? define("imagesloaded/imagesloaded", ["ev-emitter/ev-emitter"], function(t) {
            return i(e, t)
        }) : "object" == typeof module && module.exports ? module.exports = i(e, require("ev-emitter")) : e.imagesLoaded = i(e, e.EvEmitter)
    }("undefined" != typeof window ? window : this, function(e, t) {
        var r = e.jQuery_T4NT,
            s = e.console;

        function a(t, e) {
            for (var i in e) t[i] = e[i];
            return t
        }
        var l = Array.prototype.slice;

        function u(t, e, i) {
            if (!(this instanceof u)) return new u(t, e, i);
            var n, o = t;
            "string" == typeof t && (o = document.querySelectorAll(t)), o ? (this.elements = (n = o, Array.isArray(n) ? n : "object" == typeof n && "number" == typeof n.length ? l.call(n) : [n]), this.options = a({}, this.options), "function" == typeof e ? i = e : a(this.options, e), i && this.on("always", i), this.getImages(), r && (this.jqDeferred = new r.Deferred), setTimeout(this.check.bind(this))) : s.error("Bad element for imagesLoaded " + (o || t))
        }(u.prototype = Object.create(t.prototype)).options = {}, u.prototype.getImages = function() {
            this.images = [], this.elements.forEach(this.addElementImages, this)
        }, u.prototype.addElementImages = function(t) {
            "IMG" == t.nodeName && this.addImage(t), !0 === this.options.background && this.addElementBackgroundImages(t);
            var e = t.nodeType;
            if (e && c[e]) {
                for (var i = t.querySelectorAll("img"), n = 0; n < i.length; n++) {
                    var o = i[n];
                    this.addImage(o)
                }
                if ("string" == typeof this.options.background) {
                    var r = t.querySelectorAll(this.options.background);
                    for (n = 0; n < r.length; n++) {
                        var s = r[n];
                        this.addElementBackgroundImages(s)
                    }
                }
            }
        };
        var c = {
            1: !0,
            9: !0,
            11: !0
        };

        function i(t) {
            this.img = t
        }

        function n(t, e) {
            this.url = t, this.element = e, this.img = new Image
        }
        return u.prototype.addElementBackgroundImages = function(t) {
            var e = getComputedStyle(t);
            if (e)
                for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(e.backgroundImage); null !== n;) {
                    var o = n && n[2];
                    o && this.addBackground(o, t), n = i.exec(e.backgroundImage)
                }
        }, u.prototype.addImage = function(t) {
            var e = new i(t);
            this.images.push(e)
        }, u.prototype.addBackground = function(t, e) {
            var i = new n(t, e);
            this.images.push(i)
        }, u.prototype.check = function() {
            var n = this;

            function e(t, e, i) {
                setTimeout(function() {
                    n.progress(t, e, i)
                })
            }
            this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? this.images.forEach(function(t) {
                t.once("progress", e), t.check()
            }) : this.complete()
        }, u.prototype.progress = function(t, e, i) {
            this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded, this.emitEvent("progress", [this, t, e]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t), this.progressedCount == this.images.length && this.complete(), this.options.debug && s && s.log("progress: " + i, t, e)
        }, u.prototype.complete = function() {
            var t = this.hasAnyBroken ? "fail" : "done";
            if (this.isComplete = !0, this.emitEvent(t, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
                var e = this.hasAnyBroken ? "reject" : "resolve";
                this.jqDeferred[e](this)
            }
        }, (i.prototype = Object.create(t.prototype)).check = function() {
            this.getIsImageComplete() ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image, this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.proxyImage.src = this.img.src)
        }, i.prototype.getIsImageComplete = function() {
            return this.img.complete && this.img.naturalWidth
        }, i.prototype.confirm = function(t, e) {
            this.isLoaded = t, this.emitEvent("progress", [this, this.img, e])
        }, i.prototype.handleEvent = function(t) {
            var e = "on" + t.type;
            this[e] && this[e](t)
        }, i.prototype.onload = function() {
            this.confirm(!0, "onload"), this.unbindEvents()
        }, i.prototype.onerror = function() {
            this.confirm(!1, "onerror"), this.unbindEvents()
        }, i.prototype.unbindEvents = function() {
            this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
        }, (n.prototype = Object.create(i.prototype)).check = function() {
            this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url, this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents())
        }, n.prototype.unbindEvents = function() {
            this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
        }, n.prototype.confirm = function(t, e) {
            this.isLoaded = t, this.emitEvent("progress", [this, this.element, e])
        }, u.makejQuery_T4NTPlugin = function(t) {
            (t = t || e.jQuery_T4NT) && ((r = t).fn.imagesLoaded = function(t, e) {
                return new u(this, t, e).jqDeferred.promise(r(this))
            })
        }, u.makejQuery_T4NTPlugin(), u
    }),
    function(i, n) {
        "function" == typeof define && define.amd ? define(["flickity/js/index", "imagesloaded/imagesloaded"], function(t, e) {
            return n(i, t, e)
        }) : "object" == typeof module && module.exports ? module.exports = n(i, require("flickity"), require("imagesloaded")) : i.Flickity = n(i, i.Flickity, i.imagesLoaded)
    }(window, function(t, e, i) {
        "use strict";
        e.createMethods.push("_createImagesLoaded");
        var n = e.prototype;
        return n._createImagesLoaded = function() {
            this.on("activate", this.imagesLoaded)
        }, n.imagesLoaded = function() {
            if (this.options.imagesLoaded) {
                var n = this;
                i(this.slider).on("progress", function(t, e) {
                    var i = n.getParentCell(e.img);
                    n.cellSizeChange(i && i.element), n.options.freeScroll || n.positionSliderAtSelected()
                })
            }
        }, e
    }),
    function(e, i) {
        "function" == typeof define && define.amd ? define("jQuery_T4NT-bridget/jQuery_T4NT-bridget", ["jQuery_T4NT"], function(t) {
            return i(e, t)
        }) : "object" == typeof module && module.exports ? module.exports = i(e, require("jQuery_T4NT")) : e.jQuery_T4NTBridget = i(e, e.jQuery_T4NT)
    }(window, function(t, e) {
        "use strict";

        function i(u, o, c) {
            (c = c || e || t.jQuery_T4NT) && (o.prototype.option || (o.prototype.option = function(t) {
                c.isPlainObject(t) && (this.options = c.extend(!0, this.options, t))
            }), c.fn[u] = function(t) {
                if ("string" != typeof t) return n = t, this.each(function(t, e) {
                    var i = c.data(e, u);
                    i ? (i.option(n), i._init()) : (i = new o(e, n), c.data(e, u, i))
                }), this;
                var e, r, s, a, l, n, i = h.call(arguments, 1);
                return s = i, l = "$()." + u + '("' + (r = t) + '")', (e = this).each(function(t, e) {
                    var i = c.data(e, u);
                    if (i) {
                        var n = i[r];
                        if (n && "_" != r.charAt(0)) {
                            var o = n.apply(i, s);
                            a = void 0 === a ? o : a
                        } else d(l + " is not a valid method")
                    } else d(u + " not initialized. Cannot call methods, i.e. " + l)
                }), void 0 !== a ? a : e
            }, n(c))
        }

        function n(t) {
            !t || t && t.bridget || (t.bridget = i)
        }
        var h = Array.prototype.slice,
            o = t.console,
            d = void 0 === o ? function() {} : function(t) {
                o.error(t)
            };
        return n(e || t.jQuery_T4NT), i
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
    }("undefined" != typeof window ? window : this, function() {
        function t() {}
        var e = t.prototype;
        return e.on = function(t, e) {
            if (t && e) {
                var i = this._events = this._events || {},
                    n = i[t] = i[t] || [];
                return -1 == n.indexOf(e) && n.push(e), this
            }
        }, e.once = function(t, e) {
            if (t && e) {
                this.on(t, e);
                var i = this._onceEvents = this._onceEvents || {};
                return (i[t] = i[t] || {})[e] = !0, this
            }
        }, e.off = function(t, e) {
            var i = this._events && this._events[t];
            if (i && i.length) {
                var n = i.indexOf(e);
                return -1 != n && i.splice(n, 1), this
            }
        }, e.emitEvent = function(t, e) {
            var i = this._events && this._events[t];
            if (i && i.length) {
                i = i.slice(0), e = e || [];
                for (var n = this._onceEvents && this._onceEvents[t], o = 0; o < i.length; o++) {
                    var r = i[o];
                    n && n[r] && (this.off(t, r), delete n[r]), r.apply(this, e)
                }
                return this
            }
        }, e.allOff = function() {
            delete this._events, delete this._onceEvents
        }, t
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
    }(window, function() {
        "use strict";

        function v(t) {
            var e = parseFloat(t);
            return -1 == t.indexOf("%") && !isNaN(e) && e
        }

        function b(t) {
            var e = getComputedStyle(t);
            return e || i("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), e
        }
        var x, i = "undefined" == typeof console ? function() {} : function(t) {
                console.error(t)
            },
            w = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
            _ = w.length,
            S = !1;
        return function n(t) {
            if (function() {
                    if (!S) {
                        S = !0;
                        var t = document.createElement("div");
                        t.style.width = "200px", t.style.padding = "1px 2px 3px 4px", t.style.borderStyle = "solid", t.style.borderWidth = "1px 2px 3px 4px", t.style.boxSizing = "border-box";
                        var e = document.body || document.documentElement;
                        e.appendChild(t);
                        var i = b(t);
                        x = 200 == Math.round(v(i.width)), n.isBoxSizeOuter = x, e.removeChild(t)
                    }
                }(), "string" == typeof t && (t = document.querySelector(t)), t && "object" == typeof t && t.nodeType) {
                var e = b(t);
                if ("none" == e.display) return function() {
                    for (var t = {
                            width: 0,
                            height: 0,
                            innerWidth: 0,
                            innerHeight: 0,
                            outerWidth: 0,
                            outerHeight: 0
                        }, e = 0; e < _; e++) t[w[e]] = 0;
                    return t
                }();
                var i = {};
                i.width = t.offsetWidth, i.height = t.offsetHeight;
                for (var o = i.isBorderBox = "border-box" == e.boxSizing, r = 0; r < _; r++) {
                    var s = w[r],
                        a = e[s],
                        l = parseFloat(a);
                    i[s] = isNaN(l) ? 0 : l
                }
                var u = i.paddingLeft + i.paddingRight,
                    c = i.paddingTop + i.paddingBottom,
                    h = i.marginLeft + i.marginRight,
                    d = i.marginTop + i.marginBottom,
                    f = i.borderLeftWidth + i.borderRightWidth,
                    p = i.borderTopWidth + i.borderBottomWidth,
                    m = o && x,
                    g = v(e.width);
                !1 !== g && (i.width = g + (m ? 0 : u + f));
                var y = v(e.height);
                return !1 !== y && (i.height = y + (m ? 0 : c + p)), i.innerWidth = i.width - (u + f), i.innerHeight = i.height - (c + p), i.outerWidth = i.width + h, i.outerHeight = i.height + d, i
            }
        }
    }),
    function(t, e) {
        "use strict";
        "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e()
    }(window, function() {
        "use strict";
        var i = function() {
            var t = window.Element.prototype;
            if (t.matches) return "matches";
            if (t.matchesSelector) return "matchesSelector";
            for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
                var n = e[i] + "MatchesSelector";
                if (t[n]) return n
            }
        }();
        return function(t, e) {
            return t[i](e)
        }
    }),
    function(e, i) {
        "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function(t) {
            return i(e, t)
        }) : "object" == typeof module && module.exports ? module.exports = i(e, require("desandro-matches-selector")) : e.fizzyUIUtils = i(e, e.matchesSelector)
    }(window, function(u, r) {
        var c = {
                extend: function(t, e) {
                    for (var i in e) t[i] = e[i];
                    return t
                },
                modulo: function(t, e) {
                    return (t % e + e) % e
                }
            },
            e = Array.prototype.slice;
        c.makeArray = function(t) {
            return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? e.call(t) : [t]
        }, c.removeFrom = function(t, e) {
            var i = t.indexOf(e); - 1 != i && t.splice(i, 1)
        }, c.getParent = function(t, e) {
            for (; t.parentNode && t != document.body;)
                if (t = t.parentNode, r(t, e)) return t
        }, c.getQueryElement = function(t) {
            return "string" == typeof t ? document.querySelector(t) : t
        }, c.handleEvent = function(t) {
            var e = "on" + t.type;
            this[e] && this[e](t)
        }, c.filterFindElements = function(t, n) {
            t = c.makeArray(t);
            var o = [];
            return t.forEach(function(t) {
                if (t instanceof HTMLElement) {
                    if (!n) return void o.push(t);
                    r(t, n) && o.push(t);
                    for (var e = t.querySelectorAll(n), i = 0; i < e.length; i++) o.push(e[i])
                }
            }), o
        }, c.debounceMethod = function(t, e, n) {
            n = n || 100;
            var o = t.prototype[e],
                r = e + "Timeout";
            t.prototype[e] = function() {
                var t = this[r];
                clearTimeout(t);
                var e = arguments,
                    i = this;
                this[r] = setTimeout(function() {
                    o.apply(i, e), delete i[r]
                }, n)
            }
        }, c.docReady = function(t) {
            var e = document.readyState;
            "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
        }, c.toDashed = function(t) {
            return t.replace(/(.)([A-Z])/g, function(t, e, i) {
                return e + "-" + i
            }).toLowerCase()
        };
        var h = u.console;
        return c.htmlInit = function(a, l) {
            c.docReady(function() {
                var t = c.toDashed(l),
                    o = "data-" + t,
                    e = document.querySelectorAll("[" + o + "]"),
                    i = document.querySelectorAll(".js-" + t),
                    n = c.makeArray(e).concat(c.makeArray(i)),
                    r = o + "-options",
                    s = u.jQuery_T4NT;
                n.forEach(function(t) {
                    var e, i = t.getAttribute(o) || t.getAttribute(r);
                    try {
                        e = i && JSON.parse(i)
                    } catch (e) {
                        return void(h && h.error("Error parsing " + o + " on " + t.className + ": " + e))
                    }
                    var n = new a(t, e);
                    s && s.data(t, l, n)
                })
            })
        }, c
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("ev-emitter"), require("get-size")) : (t.Outlayer = {}, t.Outlayer.Item = e(t.EvEmitter, t.getSize))
    }(window, function(t, e) {
        "use strict";

        function i(t, e) {
            t && (this.element = t, this.layout = e, this.position = {
                x: 0,
                y: 0
            }, this._create())
        }
        var n = document.documentElement.style,
            o = "string" == typeof n.transition ? "transition" : "WebkitTransition",
            r = "string" == typeof n.transform ? "transform" : "WebkitTransform",
            s = {
                WebkitTransition: "webkitTransitionEnd",
                transition: "transitionend"
            } [o],
            a = {
                transform: r,
                transition: o,
                transitionDuration: o + "Duration",
                transitionProperty: o + "Property",
                transitionDelay: o + "Delay"
            },
            l = i.prototype = Object.create(t.prototype);
        l.constructor = i, l._create = function() {
            this._transn = {
                ingProperties: {},
                clean: {},
                onEnd: {}
            }, this.css({
                position: "absolute"
            })
        }, l.handleEvent = function(t) {
            var e = "on" + t.type;
            this[e] && this[e](t)
        }, l.getSize = function() {
            this.size = e(this.element)
        }, l.css = function(t) {
            var e = this.element.style;
            for (var i in t) e[a[i] || i] = t[i]
        }, l.getPosition = function() {
            var t = getComputedStyle(this.element),
                e = LtrThe4,
                i = this.layout._getOption("originTop"),
                n = t[e ? "left" : "right"],
                o = t[i ? "top" : "bottom"],
                r = parseFloat(n),
                s = parseFloat(o),
                a = this.layout.size; - 1 != n.indexOf("%") && (r = r / 100 * a.width), -1 != o.indexOf("%") && (s = s / 100 * a.height), r = isNaN(r) ? 0 : r, s = isNaN(s) ? 0 : s, r -= e ? a.paddingLeft : a.paddingRight, s -= i ? a.paddingTop : a.paddingBottom, this.position.x = r, this.position.y = s
        }, l.layoutPosition = function() {
            var t = this.layout.size,
                e = {},
                i = LtrThe4,
                n = this.layout._getOption("originTop"),
                o = i ? "paddingLeft" : "paddingRight",
                r = i ? "left" : "right",
                s = i ? "right" : "left",
                a = this.position.x + t[o];
            e[r] = this.getXValue(a), e[s] = "";
            var l = n ? "paddingTop" : "paddingBottom",
                u = n ? "top" : "bottom",
                c = n ? "bottom" : "top",
                h = this.position.y + t[l];
            e[u] = this.getYValue(h), e[c] = "", this.css(e), this.emitEvent("layout", [this])
        }, l.getXValue = function(t) {
            var e = this.layout._getOption("horizontal");
            return this.layout.options.percentPosition && !e ? t / this.layout.size.width * 100 + "%" : t + "px"
        }, l.getYValue = function(t) {
            var e = this.layout._getOption("horizontal");
            return this.layout.options.percentPosition && e ? t / this.layout.size.height * 100 + "%" : t + "px"
        }, l._transitionTo = function(t, e) {
            this.getPosition();
            var i = this.position.x,
                n = this.position.y,
                o = t == this.position.x && e == this.position.y;
            if (this.setPosition(t, e), !o || this.isTransitioning) {
                var r = t - i,
                    s = e - n,
                    a = {};
                a.transform = this.getTranslate(r, s), this.transition({
                    to: a,
                    onTransitionEnd: {
                        transform: this.layoutPosition
                    },
                    isCleaning: !0
                })
            } else this.layoutPosition()
        }, l.getTranslate = function(t, e) {
            return "translate3d(" + (t = LtrThe4 ? t : -t) + "px, " + (e = this.layout._getOption("originTop") ? e : -e) + "px, 0)"
        }, l.goTo = function(t, e) {
            this.setPosition(t, e), this.layoutPosition()
        }, l.moveTo = l._transitionTo, l.setPosition = function(t, e) {
            this.position.x = parseFloat(t), this.position.y = parseFloat(e)
        }, l._nonTransition = function(t) {
            for (var e in this.css(t.to), t.isCleaning && this._removeStyles(t.to), t.onTransitionEnd) t.onTransitionEnd[e].call(this)
        }, l.transition = function(t) {
            if (parseFloat(this.layout.options.transitionDuration)) {
                var e = this._transn;
                for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i];
                for (i in t.to) e.ingProperties[i] = !0, t.isCleaning && (e.clean[i] = !0);
                t.from && (this.css(t.from), this.element.offsetHeight), this.enableTransition(t.to), this.css(t.to), this.isTransitioning = !0
            } else this._nonTransition(t)
        };
        var u = "opacity," + r.replace(/([A-Z])/g, function(t) {
            return "-" + t.toLowerCase()
        });
        l.enableTransition = function() {
            if (!this.isTransitioning) {
                var t = this.layout.options.transitionDuration;
                t = "number" == typeof t ? t + "ms" : t, this.css({
                    transitionProperty: u,
                    transitionDuration: t,
                    transitionDelay: this.staggerDelay || 0
                }), this.element.addEventListener(s, this, !1)
            }
        }, l.onwebkitTransitionEnd = function(t) {
            this.ontransitionend(t)
        }, l.onotransitionend = function(t) {
            this.ontransitionend(t)
        };
        var c = {
            "-webkit-transform": "transform"
        };
        l.ontransitionend = function(t) {
            if (t.target === this.element) {
                var e = this._transn,
                    i = c[t.propertyName] || t.propertyName;
                delete e.ingProperties[i],
                    function(t) {
                        for (var e in t) return !1;
                        return !0
                    }(e.ingProperties) && this.disableTransition(), i in e.clean && (this.element.style[t.propertyName] = "", delete e.clean[i]), i in e.onEnd && (e.onEnd[i].call(this), delete e.onEnd[i]), this.emitEvent("transitionEnd", [this])
            }
        }, l.disableTransition = function() {
            this.removeTransitionStyles(), this.element.removeEventListener(s, this, !1), this.isTransitioning = !1
        }, l._removeStyles = function(t) {
            var e = {};
            for (var i in t) e[i] = "";
            this.css(e)
        };
        var h = {
            transitionProperty: "",
            transitionDuration: "",
            transitionDelay: ""
        };
        return l.removeTransitionStyles = function() {
            this.css(h)
        }, l.stagger = function(t) {
            t = isNaN(t) ? 0 : t, this.staggerDelay = t + "ms"
        }, l.removeElem = function() {
            this.element.parentNode.removeChild(this.element), this.css({
                display: ""
            }), this.emitEvent("remove", [this])
        }, l.remove = function() {
            return o && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function() {
                this.removeElem()
            }), void this.hide()) : void this.removeElem()
        }, l.reveal = function() {
            delete this.isHidden, this.css({
                display: ""
            });
            var t = this.layout.options,
                e = {};
            e[this.getHideRevealTransitionEndProperty("visibleStyle")] = this.onRevealTransitionEnd, this.transition({
                from: t.hiddenStyle,
                to: t.visibleStyle,
                isCleaning: !0,
                onTransitionEnd: e
            })
        }, l.onRevealTransitionEnd = function() {
            this.isHidden || this.emitEvent("reveal")
        }, l.getHideRevealTransitionEndProperty = function(t) {
            var e = this.layout.options[t];
            if (e.opacity) return "opacity";
            for (var i in e) return i
        }, l.hide = function() {
            this.isHidden = !0, this.css({
                display: ""
            });
            var t = this.layout.options,
                e = {};
            e[this.getHideRevealTransitionEndProperty("hiddenStyle")] = this.onHideTransitionEnd, this.transition({
                from: t.visibleStyle,
                to: t.hiddenStyle,
                isCleaning: !0,
                onTransitionEnd: e
            })
        }, l.onHideTransitionEnd = function() {
            this.isHidden && (this.css({
                display: "none"
            }), this.emitEvent("hide"))
        }, l.destroy = function() {
            this.css({
                position: "",
                left: "",
                right: "",
                top: "",
                bottom: "",
                transition: "",
                transform: ""
            })
        }, i
    }),
    function(o, r) {
        "use strict";
        "function" == typeof define && define.amd ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function(t, e, i, n) {
            return r(o, t, e, i, n)
        }) : "object" == typeof module && module.exports ? module.exports = r(o, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : o.Outlayer = r(o, o.EvEmitter, o.getSize, o.fizzyUIUtils, o.Outlayer.Item)
    }(window, function(t, e, o, r, n) {
        "use strict";

        function s(t, e) {
            var i = r.getQueryElement(t);
            if (i) {
                this.element = i, u && (this.$element = u(this.element)), this.options = r.extend({}, this.constructor.defaults), this.option(e);
                var n = ++c;
                this.element.outlayerGUID = n, (h[n] = this)._create(), this._getOption("initLayout") && this.layout()
            } else l && l.error("Bad element for " + this.constructor.namespace + ": " + (i || t))
        }

        function a(t) {
            function e() {
                t.apply(this, arguments)
            }
            return (e.prototype = Object.create(t.prototype)).constructor = e
        }
        var l = t.console,
            u = t.jQuery_T4NT,
            i = function() {},
            c = 0,
            h = {};
        s.namespace = "outlayer", s.Item = n, s.defaults = {
            containerStyle: {
                position: "relative"
            },
            initLayout: !0,
            originLeft: !0,
            originTop: !0,
            resize: !0,
            resizeContainer: !0,
            transitionDuration: "0.4s",
            hiddenStyle: {
                opacity: 0,
                transform: "scale(0.001)"
            },
            visibleStyle: {
                opacity: 1,
                transform: "scale(1)"
            }
        };
        var d = s.prototype;
        r.extend(d, e.prototype), d.option = function(t) {
            r.extend(this.options, t)
        }, d._getOption = function(t) {
            var e = this.constructor.compatOptions[t];
            return e && void 0 !== this.options[e] ? this.options[e] : this.options[t]
        }, s.compatOptions = {
            initLayout: "isInitLayout",
            horizontal: "isHorizontal",
            layoutInstant: "isLayoutInstant",
            originLeft: "isOriginLeft",
            originTop: "isOriginTop",
            resize: "isResizeBound",
            resizeContainer: "isResizingContainer"
        }, d._create = function() {
            this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), r.extend(this.element.style, this.options.containerStyle), this._getOption("resize") && this.bindResize()
        }, d.reloadItems = function() {
            this.items = this._itemize(this.element.children)
        }, d._itemize = function(t) {
            for (var e = this._filterFindItemElements(t), i = this.constructor.Item, n = [], o = 0; o < e.length; o++) {
                var r = new i(e[o], this);
                n.push(r)
            }
            return n
        }, d._filterFindItemElements = function(t) {
            return r.filterFindElements(t, this.options.itemSelector)
        }, d.getItemElements = function() {
            return this.items.map(function(t) {
                return t.element
            })
        }, d.layout = function() {
            this._resetLayout(), this._manageStamps();
            var t = this._getOption("layoutInstant"),
                e = void 0 !== t ? t : !this._isLayoutInited;
            this.layoutItems(this.items, e), this._isLayoutInited = !0
        }, d._init = d.layout, d._resetLayout = function() {
            this.getSize()
        }, d.getSize = function() {
            this.size = o(this.element)
        }, d._getMeasurement = function(t, e) {
            var i, n = this.options[t];
            this[t] = n ? ("string" == typeof n ? i = this.element.querySelector(n) : n instanceof HTMLElement && (i = n), i ? o(i)[e] : n) : 0
        }, d.layoutItems = function(t, e) {
            t = this._getItemsForLayout(t), this._layoutItems(t, e), this._postLayout()
        }, d._getItemsForLayout = function(t) {
            return t.filter(function(t) {
                return !t.isIgnored
            })
        }, d._layoutItems = function(t, i) {
            if (this._emitCompleteOnItems("layout", t), t && t.length) {
                var n = [];
                t.forEach(function(t) {
                    var e = this._getItemLayoutPosition(t);
                    e.item = t, e.isInstant = i || t.isLayoutInstant, n.push(e)
                }, this), this._processLayoutQueue(n)
            }
        }, d._getItemLayoutPosition = function() {
            return {
                x: 0,
                y: 0
            }
        }, d._processLayoutQueue = function(t) {
            this.updateStagger(), t.forEach(function(t, e) {
                this._positionItem(t.item, t.x, t.y, t.isInstant, e)
            }, this)
        }, d.updateStagger = function() {
            var o = this.options.stagger;
            return null == o ? void(this.stagger = 0) : (this.stagger = function(t) {
                if ("number" == typeof o) return o;
                var e = o.match(/(^\d*\.?\d*)(\w*)/),
                    i = e && e[1],
                    n = e && e[2];
                return i.length ? (i = parseFloat(i)) * (f[n] || 1) : 0
            }(), this.stagger)
        }, d._positionItem = function(t, e, i, n, o) {
            n ? t.goTo(e, i) : (t.stagger(o * this.stagger), t.moveTo(e, i))
        }, d._postLayout = function() {
            this.resizeContainer()
        }, d.resizeContainer = function() {
            if (this._getOption("resizeContainer")) {
                var t = this._getContainerSize();
                t && (this._setContainerMeasure(t.width, !0), this._setContainerMeasure(t.height, !1))
            }
        }, d._getContainerSize = i, d._setContainerMeasure = function(t, e) {
            if (void 0 !== t) {
                var i = this.size;
                i.isBorderBox && (t += e ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth), t = Math.max(t, 0), this.element.style[e ? "width" : "height"] = t + "px"
            }
        }, d._emitCompleteOnItems = function(e, t) {
            function i() {
                o.dispatchEvent(e + "Complete", null, [t])
            }

            function n() {
                ++s == r && i()
            }
            var o = this,
                r = t.length;
            if (t && r) {
                var s = 0;
                t.forEach(function(t) {
                    t.once(e, n)
                })
            } else i()
        }, d.dispatchEvent = function(t, e, i) {
            var n = e ? [e].concat(i) : i;
            if (this.emitEvent(t, n), u)
                if (this.$element = this.$element || u(this.element), e) {
                    var o = u.Event(e);
                    o.type = t, this.$element.trigger(o, i)
                } else this.$element.trigger(t, i)
        }, d.ignore = function(t) {
            var e = this.getItem(t);
            e && (e.isIgnored = !0)
        }, d.unignore = function(t) {
            var e = this.getItem(t);
            e && delete e.isIgnored
        }, d.stamp = function(t) {
            (t = this._find(t)) && (this.stamps = this.stamps.concat(t), t.forEach(this.ignore, this))
        }, d.unstamp = function(t) {
            (t = this._find(t)) && t.forEach(function(t) {
                r.removeFrom(this.stamps, t), this.unignore(t)
            }, this)
        }, d._find = function(t) {
            if (t) return "string" == typeof t && (t = this.element.querySelectorAll(t)), r.makeArray(t)
        }, d._manageStamps = function() {
            this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this))
        }, d._getBoundingRect = function() {
            var t = this.element.getBoundingClientRect(),
                e = this.size;
            this._boundingRect = {
                left: t.left + e.paddingLeft + e.borderLeftWidth,
                top: t.top + e.paddingTop + e.borderTopWidth,
                right: t.right - (e.paddingRight + e.borderRightWidth),
                bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth)
            }
        }, d._manageStamp = i, d._getElementOffset = function(t) {
            var e = t.getBoundingClientRect(),
                i = this._boundingRect,
                n = o(t);
            return {
                left: e.left - i.left - n.marginLeft,
                top: e.top - i.top - n.marginTop,
                right: i.right - e.right - n.marginRight,
                bottom: i.bottom - e.bottom - n.marginBottom
            }
        }, d.handleEvent = r.handleEvent, d.bindResize = function() {
            t.addEventListener("resize", this), this.isResizeBound = !0
        }, d.unbindResize = function() {
            t.removeEventListener("resize", this), this.isResizeBound = !1
        }, d.onresize = function() {
            this.resize()
        }, r.debounceMethod(s, "onresize", 100), d.resize = function() {
            this.isResizeBound && this.needsResizeLayout() && this.layout()
        }, d.needsResizeLayout = function() {
            var t = o(this.element);
            return this.size && t && t.innerWidth !== this.size.innerWidth
        }, d.addItems = function(t) {
            var e = this._itemize(t);
            return e.length && (this.items = this.items.concat(e)), e
        }, d.appended = function(t) {
            var e = this.addItems(t);
            e.length && (this.layoutItems(e, !0), this.reveal(e))
        }, d.prepended = function(t) {
            var e = this._itemize(t);
            if (e.length) {
                var i = this.items.slice(0);
                this.items = e.concat(i), this._resetLayout(), this._manageStamps(), this.layoutItems(e, !0), this.reveal(e), this.layoutItems(i)
            }
        }, d.reveal = function(t) {
            if (this._emitCompleteOnItems("reveal", t), t && t.length) {
                var i = this.updateStagger();
                t.forEach(function(t, e) {
                    t.stagger(e * i), t.reveal()
                })
            }
        }, d.hide = function(t) {
            if (this._emitCompleteOnItems("hide", t), t && t.length) {
                var i = this.updateStagger();
                t.forEach(function(t, e) {
                    t.stagger(e * i), t.hide()
                })
            }
        }, d.revealItemElements = function(t) {
            var e = this.getItems(t);
            this.reveal(e)
        }, d.hideItemElements = function(t) {
            var e = this.getItems(t);
            this.hide(e)
        }, d.getItem = function(t) {
            for (var e = 0; e < this.items.length; e++) {
                var i = this.items[e];
                if (i.element == t) return i
            }
        }, d.getItems = function(t) {
            t = r.makeArray(t);
            var i = [];
            return t.forEach(function(t) {
                var e = this.getItem(t);
                e && i.push(e)
            }, this), i
        }, d.remove = function(t) {
            var e = this.getItems(t);
            this._emitCompleteOnItems("remove", e), e && e.length && e.forEach(function(t) {
                t.remove(), r.removeFrom(this.items, t)
            }, this)
        }, d.destroy = function() {
            var t = this.element.style;
            t.height = "", t.position = "", t.width = "", this.items.forEach(function(t) {
                t.destroy()
            }), this.unbindResize();
            var e = this.element.outlayerGUID;
            delete h[e], delete this.element.outlayerGUID, u && u.removeData(this.element, this.constructor.namespace)
        }, s.data = function(t) {
            var e = (t = r.getQueryElement(t)) && t.outlayerGUID;
            return e && h[e]
        }, s.create = function(t, e) {
            var i = a(s);
            return i.defaults = r.extend({}, s.defaults), r.extend(i.defaults, e), i.compatOptions = r.extend({}, s.compatOptions), i.namespace = t, i.data = s.data, i.Item = a(n), r.htmlInit(i, t), u && u.bridget && u.bridget(t, i), i
        };
        var f = {
            ms: 1,
            s: 1e3
        };
        return s.Item = n, s
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("isotope-layout/js/item", ["outlayer/outlayer"], e) : "object" == typeof module && module.exports ? module.exports = e(require("outlayer")) : (t.Isotope = t.Isotope || {}, t.Isotope.Item = e(t.Outlayer))
    }(window, function(t) {
        "use strict";

        function e() {
            t.Item.apply(this, arguments)
        }
        var i = e.prototype = Object.create(t.Item.prototype),
            n = i._create;
        i._create = function() {
            this.id = this.layout.itemGUID++, n.call(this), this.sortData = {}
        }, i.updateSortData = function() {
            if (!this.isIgnored) {
                this.sortData.id = this.id, this.sortData["original-order"] = this.id, this.sortData.random = Math.random();
                var t = this.layout.options.getSortData,
                    e = this.layout._sorters;
                for (var i in t) {
                    var n = e[i];
                    this.sortData[i] = n(this.element, this)
                }
            }
        };
        var o = i.destroy;
        return i.destroy = function() {
            o.apply(this, arguments), this.css({
                display: ""
            })
        }, e
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("isotope-layout/js/layout-mode", ["get-size/get-size", "outlayer/outlayer"], e) : "object" == typeof module && module.exports ? module.exports = e(require("get-size"), require("outlayer")) : (t.Isotope = t.Isotope || {}, t.Isotope.LayoutMode = e(t.getSize, t.Outlayer))
    }(window, function(e, i) {
        "use strict";

        function n(t) {
            (this.isotope = t) && (this.options = t.options[this.namespace], this.element = t.element, this.items = t.filteredItems, this.size = t.size)
        }
        var o = n.prototype;
        return ["_resetLayout", "_getItemLayoutPosition", "_manageStamp", "_getContainerSize", "_getElementOffset", "needsResizeLayout", "_getOption"].forEach(function(t) {
            o[t] = function() {
                return i.prototype[t].apply(this.isotope, arguments)
            }
        }), o.needsVerticalResizeLayout = function() {
            var t = e(this.isotope.element);
            return this.isotope.size && t && t.innerHeight != this.isotope.size.innerHeight
        }, o._getMeasurement = function() {
            this.isotope._getMeasurement.apply(this, arguments)
        }, o.getColumnWidth = function() {
            this.getSegmentSize("column", "Width")
        }, o.getRowHeight = function() {
            this.getSegmentSize("row", "Height")
        }, o.getSegmentSize = function(t, e) {
            var i = t + e,
                n = "outer" + e;
            if (this._getMeasurement(i, n), !this[i]) {
                var o = this.getFirstItemSize();
                this[i] = o && o[n] || this.isotope.size["inner" + e]
            }
        }, o.getFirstItemSize = function() {
            var t = this.isotope.filteredItems[0];
            return t && t.element && e(t.element)
        }, o.layout = function() {
            this.isotope.layout.apply(this.isotope, arguments)
        }, o.getSize = function() {
            this.isotope.getSize(), this.size = this.isotope.size
        }, n.modes = {}, n.create = function(t, e) {
            function i() {
                n.apply(this, arguments)
            }
            return (i.prototype = Object.create(o)).constructor = i, e && (i.options = e), n.modes[i.prototype.namespace = t] = i
        }, n
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("masonry-layout/masonry", ["outlayer/outlayer", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("outlayer"), require("get-size")) : t.Masonry = e(t.Outlayer, t.getSize)
    }(window, function(t, u) {
        var e = t.create("masonry");
        e.compatOptions.fitWidth = "isFitWidth";
        var i = e.prototype;
        return i._resetLayout = function() {
            this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), this.colYs = [];
            for (var t = 0; t < this.cols; t++) this.colYs.push(0);
            this.maxY = 0, this.horizontalColIndex = 0
        }, i.measureColumns = function() {
            if (this.getContainerWidth(), !this.columnWidth) {
                var t = this.items[0],
                    e = t && t.element;
                this.columnWidth = e && u(e).outerWidth || this.containerWidth
            }
            var i = this.columnWidth += this.gutter,
                n = this.containerWidth + this.gutter,
                o = n / i,
                r = i - n % i;
            o = Math[r && r < 1 ? "round" : "floor"](o), this.cols = Math.max(o, 1)
        }, i.getContainerWidth = function() {
            var t = this._getOption("fitWidth") ? this.element.parentNode : this.element,
                e = u(t);
            this.containerWidth = e && e.innerWidth
        }, i._getItemLayoutPosition = function(t) {
            t.getSize();
            var e = t.size.outerWidth % this.columnWidth,
                i = Math[e && e < 1 ? "round" : "ceil"](t.size.outerWidth / this.columnWidth);
            i = Math.min(i, this.cols);
            for (var n = this[this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition"](i, t), o = {
                    x: this.columnWidth * n.col,
                    y: n.y
                }, r = n.y + t.size.outerHeight, s = i + n.col, a = n.col; a < s; a++) this.colYs[a] = r;
            return o
        }, i._getTopColPosition = function(t) {
            var e = this._getTopColGroup(t),
                i = Math.min.apply(Math, e);
            return {
                col: e.indexOf(i),
                y: i
            }
        }, i._getTopColGroup = function(t) {
            if (t < 2) return this.colYs;
            for (var e = [], i = this.cols + 1 - t, n = 0; n < i; n++) e[n] = this._getColGroupY(n, t);
            return e
        }, i._getColGroupY = function(t, e) {
            if (e < 2) return this.colYs[t];
            var i = this.colYs.slice(t, t + e);
            return Math.max.apply(Math, i)
        }, i._getHorizontalColPosition = function(t, e) {
            var i = this.horizontalColIndex % this.cols;
            i = 1 < t && i + t > this.cols ? 0 : i;
            var n = e.size.outerWidth && e.size.outerHeight;
            return this.horizontalColIndex = n ? i + t : this.horizontalColIndex, {
                col: i,
                y: this._getColGroupY(i, t)
            }
        }, i._manageStamp = function(t) {
            var e = u(t),
                i = this._getElementOffset(t),
                n = this._getOption("originLeft") ? i.left : i.right,
                o = n + e.outerWidth,
                r = Math.floor(n / this.columnWidth);
            r = Math.max(0, r);
            var s = Math.floor(o / this.columnWidth);
            s -= o % this.columnWidth ? 0 : 1, s = Math.min(this.cols - 1, s);
            for (var a = (this._getOption("originTop") ? i.top : i.bottom) + e.outerHeight, l = r; l <= s; l++) this.colYs[l] = Math.max(a, this.colYs[l])
        }, i._getContainerSize = function() {
            this.maxY = Math.max.apply(Math, this.colYs);
            var t = {
                height: this.maxY
            };
            return this._getOption("fitWidth") && (t.width = this._getContainerFitWidth()), t
        }, i._getContainerFitWidth = function() {
            for (var t = 0, e = this.cols; --e && 0 === this.colYs[e];) t++;
            return (this.cols - t) * this.columnWidth - this.gutter
        }, i.needsResizeLayout = function() {
            var t = this.containerWidth;
            return this.getContainerWidth(), t != this.containerWidth
        }, e
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("isotope-layout/js/layout-modes/masonry", ["../layout-mode", "masonry-layout/masonry"], e) : "object" == typeof module && module.exports ? module.exports = e(require("../layout-mode"), require("masonry-layout")) : e(t.Isotope.LayoutMode, t.Masonry)
    }(window, function(t, e) {
        "use strict";
        var i = t.create("masonry"),
            n = i.prototype,
            o = {
                _getElementOffset: !0,
                layout: !0,
                _getMeasurement: !0
            };
        for (var r in e.prototype) o[r] || (n[r] = e.prototype[r]);
        var s = n.measureColumns;
        n.measureColumns = function() {
            this.items = this.isotope.filteredItems, s.call(this)
        };
        var a = n._getOption;
        return n._getOption = function(t) {
            return "fitWidth" == t ? void 0 !== this.options.isFitWidth ? this.options.isFitWidth : this.options.fitWidth : a.apply(this.isotope, arguments)
        }, i
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("isotope-layout/js/layout-modes/fit-rows", ["../layout-mode"], e) : "object" == typeof exports ? module.exports = e(require("../layout-mode")) : e(t.Isotope.LayoutMode)
    }(window, function(t) {
        "use strict";
        var e = t.create("fitRows"),
            i = e.prototype;
        return i._resetLayout = function() {
            this.x = 0, this.y = 0, this.maxY = 0, this._getMeasurement("gutter", "outerWidth")
        }, i._getItemLayoutPosition = function(t) {
            t.getSize();
            var e = t.size.outerWidth + this.gutter,
                i = this.isotope.size.innerWidth + this.gutter;
            0 !== this.x && e + this.x > i && (this.x = 0, this.y = this.maxY);
            var n = {
                x: this.x,
                y: this.y
            };
            return this.maxY = Math.max(this.maxY, this.y + t.size.outerHeight), this.x += e, n
        }, i._getContainerSize = function() {
            return {
                height: this.maxY
            }
        }, e
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("isotope-layout/js/layout-modes/vertical", ["../layout-mode"], e) : "object" == typeof module && module.exports ? module.exports = e(require("../layout-mode")) : e(t.Isotope.LayoutMode)
    }(window, function(t) {
        "use strict";
        var e = t.create("vertical", {
                horizontalAlignment: 0
            }),
            i = e.prototype;
        return i._resetLayout = function() {
            this.y = 0
        }, i._getItemLayoutPosition = function(t) {
            t.getSize();
            var e = (this.isotope.size.innerWidth - t.size.outerWidth) * this.options.horizontalAlignment,
                i = this.y;
            return this.y += t.size.outerHeight, {
                x: e,
                y: i
            }
        }, i._getContainerSize = function() {
            return {
                height: this.y
            }
        }, e
    }),
    function(s, a) {
        "function" == typeof define && define.amd ? define(["outlayer/outlayer", "get-size/get-size", "desandro-matches-selector/matches-selector", "fizzy-ui-utils/utils", "isotope-layout/js/item", "isotope-layout/js/layout-mode", "isotope-layout/js/layout-modes/masonry", "isotope-layout/js/layout-modes/fit-rows", "isotope-layout/js/layout-modes/vertical"], function(t, e, i, n, o, r) {
            return a(s, t, e, i, n, o, r)
        }) : "object" == typeof module && module.exports ? module.exports = a(s, require("outlayer"), require("get-size"), require("desandro-matches-selector"), require("fizzy-ui-utils"), require("isotope-layout/js/item"), require("isotope-layout/js/layout-mode"), require("isotope-layout/js/layout-modes/masonry"), require("isotope-layout/js/layout-modes/fit-rows"), require("isotope-layout/js/layout-modes/vertical")) : s.Isotope = a(s, s.Outlayer, s.getSize, s.matchesSelector, s.fizzyUIUtils, s.Isotope.Item, s.Isotope.LayoutMode)
    }(window, function(t, i, e, n, r, o, s) {
        var a = t.jQuery_T4NT,
            u = String.prototype.trim ? function(t) {
                return t.trim()
            } : function(t) {
                return t.replace(/^\s+|\s+$/g, "")
            },
            c = i.create("isotope", {
                layoutMode: "masonry",
                isjQuery_T4NTFiltering: !0,
                sortAscending: !0
            });
        c.Item = o, c.LayoutMode = s;
        var l = c.prototype;
        l._create = function() {
            for (var t in this.itemGUID = 0, this._sorters = {}, this._getSorters(), i.prototype._create.call(this), this.modes = {}, this.filteredItems = this.items, this.sortHistory = ["original-order"], s.modes) this._initLayoutMode(t)
        }, l.reloadItems = function() {
            this.itemGUID = 0, i.prototype.reloadItems.call(this)
        }, l._itemize = function() {
            for (var t = i.prototype._itemize.apply(this, arguments), e = 0; e < t.length; e++) t[e].id = this.itemGUID++;
            return this._updateItemsSortData(t), t
        }, l._initLayoutMode = function(t) {
            var e = s.modes[t],
                i = this.options[t] || {};
            this.options[t] = e.options ? r.extend(e.options, i) : i, this.modes[t] = new e(this)
        }, l.layout = function() {
            return !this._isLayoutInited && this._getOption("initLayout") ? void this.arrange() : void this._layout()
        }, l._layout = function() {
            var t = this._getIsInstant();
            this._resetLayout(), this._manageStamps(), this.layoutItems(this.filteredItems, t), this._isLayoutInited = !0
        }, l.arrange = function(t) {
            this.option(t), this._getIsInstant();
            var e = this._filter(this.items);
            this.filteredItems = e.matches, this._bindArrangeComplete(), this._isInstant ? this._noTransition(this._hideReveal, [e]) : this._hideReveal(e), this._sort(), this._layout()
        }, l._init = l.arrange, l._hideReveal = function(t) {
            this.reveal(t.needReveal), this.hide(t.needHide)
        }, l._getIsInstant = function() {
            var t = this._getOption("layoutInstant"),
                e = void 0 !== t ? t : !this._isLayoutInited;
            return this._isInstant = e
        }, l._bindArrangeComplete = function() {
            function t() {
                e && i && n && o.dispatchEvent("arrangeComplete", null, [o.filteredItems])
            }
            var e, i, n, o = this;
            this.once("layoutComplete", function() {
                e = !0, t()
            }), this.once("hideComplete", function() {
                i = !0, t()
            }), this.once("revealComplete", function() {
                n = !0, t()
            })
        }, l._filter = function(t) {
            var e = this.options.filter;
            e = e || "*";
            for (var i = [], n = [], o = [], r = this._getFilterTest(e), s = 0; s < t.length; s++) {
                var a = t[s];
                if (!a.isIgnored) {
                    var l = r(a);
                    l && i.push(a), l && a.isHidden ? n.push(a) : l || a.isHidden || o.push(a)
                }
            }
            return {
                matches: i,
                needReveal: n,
                needHide: o
            }
        }, l._getFilterTest = function(e) {
            return a && this.options.isjQuery_T4NTFiltering ? function(t) {
                return a(t.element).is(e)
            } : "function" == typeof e ? function(t) {
                return e(t.element)
            } : function(t) {
                return n(t.element, e)
            }
        }, l.updateSortData = function(t) {
            var e;
            e = t ? (t = r.makeArray(t), this.getItems(t)) : this.items, this._getSorters(), this._updateItemsSortData(e)
        }, l._getSorters = function() {
            var t = this.options.getSortData;
            for (var e in t) {
                var i = t[e];
                this._sorters[e] = h(i)
            }
        }, l._updateItemsSortData = function(t) {
            for (var e = t && t.length, i = 0; e && i < e; i++) t[i].updateSortData()
        };
        var h = function(t) {
            if ("string" != typeof t) return t;
            var e, i, n = u(t).split(" "),
                o = n[0],
                r = o.match(/^\[(.+)\]$/),
                s = r && r[1],
                a = (i = o, (e = s) ? function(t) {
                    return t.getAttribute(e)
                } : function(t) {
                    var e = t.querySelector(i);
                    return e && e.textContent
                }),
                l = c.sortDataParsers[n[1]];
            return l ? function(t) {
                return t && l(a(t))
            } : function(t) {
                return t && a(t)
            }
        };
        c.sortDataParsers = {
            parseInt: function(t) {
                return parseInt(t, 10)
            },
            parseFloat: function(t) {
                return parseFloat(t)
            }
        }, l._sort = function() {
            if (this.options.sortBy) {
                var t = r.makeArray(this.options.sortBy);
                this._getIsSameSortBy(t) || (this.sortHistory = t.concat(this.sortHistory));
                var e = (s = this.sortHistory, a = this.options.sortAscending, function(t, e) {
                    for (var i = 0; i < s.length; i++) {
                        var n = s[i],
                            o = t.sortData[n],
                            r = e.sortData[n];
                        if (r < o || o < r) return (r < o ? 1 : -1) * ((void 0 !== a[n] ? a[n] : a) ? 1 : -1)
                    }
                    return 0
                });
                this.filteredItems.sort(e)
            }
            var s, a
        }, l._getIsSameSortBy = function(t) {
            for (var e = 0; e < t.length; e++)
                if (t[e] != this.sortHistory[e]) return !1;
            return !0
        }, l._mode = function() {
            var t = this.options.layoutMode,
                e = this.modes[t];
            if (!e) throw new Error("No layout mode: " + t);
            return e.options = this.options[t], e
        }, l._resetLayout = function() {
            i.prototype._resetLayout.call(this), this._mode()._resetLayout()
        }, l._getItemLayoutPosition = function(t) {
            return this._mode()._getItemLayoutPosition(t)
        }, l._manageStamp = function(t) {
            this._mode()._manageStamp(t)
        }, l._getContainerSize = function() {
            return this._mode()._getContainerSize()
        }, l.needsResizeLayout = function() {
            return this._mode().needsResizeLayout()
        }, l.appended = function(t) {
            var e = this.addItems(t);
            if (e.length) {
                var i = this._filterRevealAdded(e);
                this.filteredItems = this.filteredItems.concat(i)
            }
        }, l.prepended = function(t) {
            var e = this._itemize(t);
            if (e.length) {
                this._resetLayout(), this._manageStamps();
                var i = this._filterRevealAdded(e);
                this.layoutItems(this.filteredItems), this.filteredItems = i.concat(this.filteredItems), this.items = e.concat(this.items)
            }
        }, l._filterRevealAdded = function(t) {
            var e = this._filter(t);
            return this.hide(e.needHide), this.reveal(e.matches), this.layoutItems(e.matches, !0), e.matches
        }, l.insert = function(t) {
            var e = this.addItems(t);
            if (e.length) {
                var i, n, o = e.length;
                for (i = 0; i < o; i++) n = e[i], this.element.appendChild(n.element);
                var r = this._filter(e).matches;
                for (i = 0; i < o; i++) e[i].isLayoutInstant = !0;
                for (this.arrange(), i = 0; i < o; i++) delete e[i].isLayoutInstant;
                this.reveal(r)
            }
        };
        var d = l.remove;
        return l.remove = function(t) {
            t = r.makeArray(t);
            var e = this.getItems(t);
            d.call(this, t);
            for (var i = e && e.length, n = 0; i && n < i; n++) {
                var o = e[n];
                r.removeFrom(this.filteredItems, o)
            }
        }, l.shuffle = function() {
            for (var t = 0; t < this.items.length; t++) this.items[t].sortData.random = Math.random();
            this.options.sortBy = "random", this._sort(), this._layout()
        }, l._noTransition = function(t, e) {
            var i = this.options.transitionDuration;
            this.options.transitionDuration = 0;
            var n = t.apply(this, e);
            return this.options.transitionDuration = i, n
        }, l.getFilteredItemElements = function() {
            return this.filteredItems.map(function(t) {
                return t.element
            })
        }, c
    }),
    function(e, i) {
        "function" == typeof define && define.amd ? define("jQuery_T4NT-bridget/jQuery_T4NT-bridget", ["jQuery_T4NT"], function(t) {
            return i(e, t)
        }) : "object" == typeof module && module.exports ? module.exports = i(e, require("jQuery_T4NT")) : e.jQuery_T4NTBridget = i(e, e.jQuery_T4NT)
    }(window, function(t, e) {
        "use strict";

        function i(u, o, c) {
            (c = c || e || t.jQuery_T4NT) && (o.prototype.option || (o.prototype.option = function(t) {
                c.isPlainObject(t) && (this.options = c.extend(!0, this.options, t))
            }), c.fn[u] = function(t) {
                if ("string" != typeof t) return n = t, this.each(function(t, e) {
                    var i = c.data(e, u);
                    i ? (i.option(n), i._init()) : (i = new o(e, n), c.data(e, u, i))
                }), this;
                var e, r, s, a, l, n, i = h.call(arguments, 1);
                return s = i, l = "$()." + u + '("' + (r = t) + '")', (e = this).each(function(t, e) {
                    var i = c.data(e, u);
                    if (i) {
                        var n = i[r];
                        if (n && "_" != r.charAt(0)) {
                            var o = n.apply(i, s);
                            a = void 0 === a ? o : a
                        } else d(l + " is not a valid method")
                    } else d(u + " not initialized. Cannot call methods, i.e. " + l)
                }), void 0 !== a ? a : e
            }, n(c))
        }

        function n(t) {
            !t || t && t.bridget || (t.bridget = i)
        }
        var h = Array.prototype.slice,
            o = t.console,
            d = void 0 === o ? function() {} : function(t) {
                o.error(t)
            };
        return n(e || t.jQuery_T4NT), i
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
    }(window, function() {
        "use strict";

        function v(t) {
            var e = parseFloat(t);
            return -1 == t.indexOf("%") && !isNaN(e) && e
        }

        function b(t) {
            var e = getComputedStyle(t);
            return e || i("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), e
        }
        var x, i = "undefined" == typeof console ? function() {} : function(t) {
                console.error(t)
            },
            w = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
            _ = w.length,
            S = !1;
        return function n(t) {
            if (function() {
                    if (!S) {
                        S = !0;
                        var t = document.createElement("div");
                        t.style.width = "200px", t.style.padding = "1px 2px 3px 4px", t.style.borderStyle = "solid", t.style.borderWidth = "1px 2px 3px 4px", t.style.boxSizing = "border-box";
                        var e = document.body || document.documentElement;
                        e.appendChild(t);
                        var i = b(t);
                        x = 200 == Math.round(v(i.width)), n.isBoxSizeOuter = x, e.removeChild(t)
                    }
                }(), "string" == typeof t && (t = document.querySelector(t)), t && "object" == typeof t && t.nodeType) {
                var e = b(t);
                if ("none" == e.display) return function() {
                    for (var t = {
                            width: 0,
                            height: 0,
                            innerWidth: 0,
                            innerHeight: 0,
                            outerWidth: 0,
                            outerHeight: 0
                        }, e = 0; e < _; e++) t[w[e]] = 0;
                    return t
                }();
                var i = {};
                i.width = t.offsetWidth, i.height = t.offsetHeight;
                for (var o = i.isBorderBox = "border-box" == e.boxSizing, r = 0; r < _; r++) {
                    var s = w[r],
                        a = e[s],
                        l = parseFloat(a);
                    i[s] = isNaN(l) ? 0 : l
                }
                var u = i.paddingLeft + i.paddingRight,
                    c = i.paddingTop + i.paddingBottom,
                    h = i.marginLeft + i.marginRight,
                    d = i.marginTop + i.marginBottom,
                    f = i.borderLeftWidth + i.borderRightWidth,
                    p = i.borderTopWidth + i.borderBottomWidth,
                    m = o && x,
                    g = v(e.width);
                !1 !== g && (i.width = g + (m ? 0 : u + f));
                var y = v(e.height);
                return !1 !== y && (i.height = y + (m ? 0 : c + p)), i.innerWidth = i.width - (u + f), i.innerHeight = i.height - (c + p), i.outerWidth = i.width + h, i.outerHeight = i.height + d, i
            }
        }
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
    }("undefined" != typeof window ? window : this, function() {
        function t() {}
        var e = t.prototype;
        return e.on = function(t, e) {
            if (t && e) {
                var i = this._events = this._events || {},
                    n = i[t] = i[t] || [];
                return -1 == n.indexOf(e) && n.push(e), this
            }
        }, e.once = function(t, e) {
            if (t && e) {
                this.on(t, e);
                var i = this._onceEvents = this._onceEvents || {};
                return (i[t] = i[t] || {})[e] = !0, this
            }
        }, e.off = function(t, e) {
            var i = this._events && this._events[t];
            if (i && i.length) {
                var n = i.indexOf(e);
                return -1 != n && i.splice(n, 1), this
            }
        }, e.emitEvent = function(t, e) {
            var i = this._events && this._events[t];
            if (i && i.length) {
                i = i.slice(0), e = e || [];
                for (var n = this._onceEvents && this._onceEvents[t], o = 0; o < i.length; o++) {
                    var r = i[o];
                    n && n[r] && (this.off(t, r), delete n[r]), r.apply(this, e)
                }
                return this
            }
        }, e.allOff = function() {
            delete this._events, delete this._onceEvents
        }, t
    }),
    function(t, e) {
        "use strict";
        "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e()
    }(window, function() {
        "use strict";
        var i = function() {
            var t = window.Element.prototype;
            if (t.matches) return "matches";
            if (t.matchesSelector) return "matchesSelector";
            for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
                var n = e[i] + "MatchesSelector";
                if (t[n]) return n
            }
        }();
        return function(t, e) {
            return t[i](e)
        }
    }),
    function(e, i) {
        "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function(t) {
            return i(e, t)
        }) : "object" == typeof module && module.exports ? module.exports = i(e, require("desandro-matches-selector")) : e.fizzyUIUtils = i(e, e.matchesSelector)
    }(window, function(u, r) {
        var c = {
                extend: function(t, e) {
                    for (var i in e) t[i] = e[i];
                    return t
                },
                modulo: function(t, e) {
                    return (t % e + e) % e
                }
            },
            e = Array.prototype.slice;
        c.makeArray = function(t) {
            return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? e.call(t) : [t]
        }, c.removeFrom = function(t, e) {
            var i = t.indexOf(e); - 1 != i && t.splice(i, 1)
        }, c.getParent = function(t, e) {
            for (; t.parentNode && t != document.body;)
                if (t = t.parentNode, r(t, e)) return t
        }, c.getQueryElement = function(t) {
            return "string" == typeof t ? document.querySelector(t) : t
        }, c.handleEvent = function(t) {
            var e = "on" + t.type;
            this[e] && this[e](t)
        }, c.filterFindElements = function(t, n) {
            t = c.makeArray(t);
            var o = [];
            return t.forEach(function(t) {
                if (t instanceof HTMLElement) {
                    if (!n) return void o.push(t);
                    r(t, n) && o.push(t);
                    for (var e = t.querySelectorAll(n), i = 0; i < e.length; i++) o.push(e[i])
                }
            }), o
        }, c.debounceMethod = function(t, e, n) {
            n = n || 100;
            var o = t.prototype[e],
                r = e + "Timeout";
            t.prototype[e] = function() {
                var t = this[r];
                clearTimeout(t);
                var e = arguments,
                    i = this;
                this[r] = setTimeout(function() {
                    o.apply(i, e), delete i[r]
                }, n)
            }
        }, c.docReady = function(t) {
            var e = document.readyState;
            "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
        }, c.toDashed = function(t) {
            return t.replace(/(.)([A-Z])/g, function(t, e, i) {
                return e + "-" + i
            }).toLowerCase()
        };
        var h = u.console;
        return c.htmlInit = function(a, l) {
            c.docReady(function() {
                var t = c.toDashed(l),
                    o = "data-" + t,
                    e = document.querySelectorAll("[" + o + "]"),
                    i = document.querySelectorAll(".js-" + t),
                    n = c.makeArray(e).concat(c.makeArray(i)),
                    r = o + "-options",
                    s = u.jQuery_T4NT;
                n.forEach(function(t) {
                    var e, i = t.getAttribute(o) || t.getAttribute(r);
                    try {
                        e = i && JSON.parse(i)
                    } catch (e) {
                        return void(h && h.error("Error parsing " + o + " on " + t.className + ": " + e))
                    }
                    var n = new a(t, e);
                    s && s.data(t, l, n)
                })
            })
        }, c
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("ev-emitter"), require("get-size")) : (t.Outlayer = {}, t.Outlayer.Item = e(t.EvEmitter, t.getSize))
    }(window, function(t, e) {
        "use strict";

        function i(t, e) {
            t && (this.element = t, this.layout = e, this.position = {
                x: 0,
                y: 0
            }, this._create())
        }
        var n = document.documentElement.style,
            o = "string" == typeof n.transition ? "transition" : "WebkitTransition",
            r = "string" == typeof n.transform ? "transform" : "WebkitTransform",
            s = {
                WebkitTransition: "webkitTransitionEnd",
                transition: "transitionend"
            } [o],
            a = {
                transform: r,
                transition: o,
                transitionDuration: o + "Duration",
                transitionProperty: o + "Property",
                transitionDelay: o + "Delay"
            },
            l = i.prototype = Object.create(t.prototype);
        l.constructor = i, l._create = function() {
            this._transn = {
                ingProperties: {},
                clean: {},
                onEnd: {}
            }, this.css({
                position: "absolute"
            })
        }, l.handleEvent = function(t) {
            var e = "on" + t.type;
            this[e] && this[e](t)
        }, l.getSize = function() {
            this.size = e(this.element)
        }, l.css = function(t) {
            var e = this.element.style;
            for (var i in t) e[a[i] || i] = t[i]
        }, l.getPosition = function() {
            var t = getComputedStyle(this.element),
                e = LtrThe4,
                i = this.layout._getOption("originTop"),
                n = t[e ? "left" : "right"],
                o = t[i ? "top" : "bottom"],
                r = parseFloat(n),
                s = parseFloat(o),
                a = this.layout.size; - 1 != n.indexOf("%") && (r = r / 100 * a.width), -1 != o.indexOf("%") && (s = s / 100 * a.height), r = isNaN(r) ? 0 : r, s = isNaN(s) ? 0 : s, r -= e ? a.paddingLeft : a.paddingRight, s -= i ? a.paddingTop : a.paddingBottom, this.position.x = r, this.position.y = s
        }, l.layoutPosition = function() {
            var t = this.layout.size,
                e = {},
                i = LtrThe4,
                n = this.layout._getOption("originTop"),
                o = i ? "paddingLeft" : "paddingRight",
                r = i ? "left" : "right",
                s = i ? "right" : "left",
                a = this.position.x + t[o];
            e[r] = this.getXValue(a), e[s] = "";
            var l = n ? "paddingTop" : "paddingBottom",
                u = n ? "top" : "bottom",
                c = n ? "bottom" : "top",
                h = this.position.y + t[l];
            e[u] = this.getYValue(h), e[c] = "", this.css(e), this.emitEvent("layout", [this])
        }, l.getXValue = function(t) {
            var e = this.layout._getOption("horizontal");
            return this.layout.options.percentPosition && !e ? t / this.layout.size.width * 100 + "%" : t + "px"
        }, l.getYValue = function(t) {
            var e = this.layout._getOption("horizontal");
            return this.layout.options.percentPosition && e ? t / this.layout.size.height * 100 + "%" : t + "px"
        }, l._transitionTo = function(t, e) {
            this.getPosition();
            var i = this.position.x,
                n = this.position.y,
                o = t == this.position.x && e == this.position.y;
            if (this.setPosition(t, e), !o || this.isTransitioning) {
                var r = t - i,
                    s = e - n,
                    a = {};
                a.transform = this.getTranslate(r, s), this.transition({
                    to: a,
                    onTransitionEnd: {
                        transform: this.layoutPosition
                    },
                    isCleaning: !0
                })
            } else this.layoutPosition()
        }, l.getTranslate = function(t, e) {
            return "translate3d(" + (t = LtrThe4 ? t : -t) + "px, " + (e = this.layout._getOption("originTop") ? e : -e) + "px, 0)"
        }, l.goTo = function(t, e) {
            this.setPosition(t, e), this.layoutPosition()
        }, l.moveTo = l._transitionTo, l.setPosition = function(t, e) {
            this.position.x = parseFloat(t), this.position.y = parseFloat(e)
        }, l._nonTransition = function(t) {
            for (var e in this.css(t.to), t.isCleaning && this._removeStyles(t.to), t.onTransitionEnd) t.onTransitionEnd[e].call(this)
        }, l.transition = function(t) {
            if (parseFloat(this.layout.options.transitionDuration)) {
                var e = this._transn;
                for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i];
                for (i in t.to) e.ingProperties[i] = !0, t.isCleaning && (e.clean[i] = !0);
                t.from && (this.css(t.from), this.element.offsetHeight), this.enableTransition(t.to), this.css(t.to), this.isTransitioning = !0
            } else this._nonTransition(t)
        };
        var u = "opacity," + r.replace(/([A-Z])/g, function(t) {
            return "-" + t.toLowerCase()
        });
        l.enableTransition = function() {
            if (!this.isTransitioning) {
                var t = this.layout.options.transitionDuration;
                t = "number" == typeof t ? t + "ms" : t, this.css({
                    transitionProperty: u,
                    transitionDuration: t,
                    transitionDelay: this.staggerDelay || 0
                }), this.element.addEventListener(s, this, !1)
            }
        }, l.onwebkitTransitionEnd = function(t) {
            this.ontransitionend(t)
        }, l.onotransitionend = function(t) {
            this.ontransitionend(t)
        };
        var c = {
            "-webkit-transform": "transform"
        };
        l.ontransitionend = function(t) {
            if (t.target === this.element) {
                var e = this._transn,
                    i = c[t.propertyName] || t.propertyName;
                delete e.ingProperties[i],
                    function(t) {
                        for (var e in t) return !1;
                        return !0
                    }(e.ingProperties) && this.disableTransition(), i in e.clean && (this.element.style[t.propertyName] = "", delete e.clean[i]), i in e.onEnd && (e.onEnd[i].call(this), delete e.onEnd[i]), this.emitEvent("transitionEnd", [this])
            }
        }, l.disableTransition = function() {
            this.removeTransitionStyles(), this.element.removeEventListener(s, this, !1), this.isTransitioning = !1
        }, l._removeStyles = function(t) {
            var e = {};
            for (var i in t) e[i] = "";
            this.css(e)
        };
        var h = {
            transitionProperty: "",
            transitionDuration: "",
            transitionDelay: ""
        };
        return l.removeTransitionStyles = function() {
            this.css(h)
        }, l.stagger = function(t) {
            t = isNaN(t) ? 0 : t, this.staggerDelay = t + "ms"
        }, l.removeElem = function() {
            this.element.parentNode.removeChild(this.element), this.css({
                display: ""
            }), this.emitEvent("remove", [this])
        }, l.remove = function() {
            return o && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function() {
                this.removeElem()
            }), void this.hide()) : void this.removeElem()
        }, l.reveal = function() {
            delete this.isHidden, this.css({
                display: ""
            });
            var t = this.layout.options,
                e = {};
            e[this.getHideRevealTransitionEndProperty("visibleStyle")] = this.onRevealTransitionEnd, this.transition({
                from: t.hiddenStyle,
                to: t.visibleStyle,
                isCleaning: !0,
                onTransitionEnd: e
            })
        }, l.onRevealTransitionEnd = function() {
            this.isHidden || this.emitEvent("reveal")
        }, l.getHideRevealTransitionEndProperty = function(t) {
            var e = this.layout.options[t];
            if (e.opacity) return "opacity";
            for (var i in e) return i
        }, l.hide = function() {
            this.isHidden = !0, this.css({
                display: ""
            });
            var t = this.layout.options,
                e = {};
            e[this.getHideRevealTransitionEndProperty("hiddenStyle")] = this.onHideTransitionEnd, this.transition({
                from: t.visibleStyle,
                to: t.hiddenStyle,
                isCleaning: !0,
                onTransitionEnd: e
            })
        }, l.onHideTransitionEnd = function() {
            this.isHidden && (this.css({
                display: "none"
            }), this.emitEvent("hide"))
        }, l.destroy = function() {
            this.css({
                position: "",
                left: "",
                right: "",
                top: "",
                bottom: "",
                transition: "",
                transform: ""
            })
        }, i
    }),
    function(o, r) {
        "use strict";
        "function" == typeof define && define.amd ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function(t, e, i, n) {
            return r(o, t, e, i, n)
        }) : "object" == typeof module && module.exports ? module.exports = r(o, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : o.Outlayer = r(o, o.EvEmitter, o.getSize, o.fizzyUIUtils, o.Outlayer.Item)
    }(window, function(t, e, o, r, n) {
        "use strict";

        function s(t, e) {
            var i = r.getQueryElement(t);
            if (i) {
                this.element = i, u && (this.$element = u(this.element)), this.options = r.extend({}, this.constructor.defaults), this.option(e);
                var n = ++c;
                this.element.outlayerGUID = n, (h[n] = this)._create(), this._getOption("initLayout") && this.layout()
            } else l && l.error("Bad element for " + this.constructor.namespace + ": " + (i || t))
        }

        function a(t) {
            function e() {
                t.apply(this, arguments)
            }
            return (e.prototype = Object.create(t.prototype)).constructor = e
        }
        var l = t.console,
            u = t.jQuery_T4NT,
            i = function() {},
            c = 0,
            h = {};
        s.namespace = "outlayer", s.Item = n, s.defaults = {
            containerStyle: {
                position: "relative"
            },
            initLayout: !0,
            originLeft: !0,
            originTop: !0,
            resize: !0,
            resizeContainer: !0,
            transitionDuration: "0.4s",
            hiddenStyle: {
                opacity: 0,
                transform: "scale(0.001)"
            },
            visibleStyle: {
                opacity: 1,
                transform: "scale(1)"
            }
        };
        var d = s.prototype;
        r.extend(d, e.prototype), d.option = function(t) {
            r.extend(this.options, t)
        }, d._getOption = function(t) {
            var e = this.constructor.compatOptions[t];
            return e && void 0 !== this.options[e] ? this.options[e] : this.options[t]
        }, s.compatOptions = {
            initLayout: "isInitLayout",
            horizontal: "isHorizontal",
            layoutInstant: "isLayoutInstant",
            originLeft: "isOriginLeft",
            originTop: "isOriginTop",
            resize: "isResizeBound",
            resizeContainer: "isResizingContainer"
        }, d._create = function() {
            this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), r.extend(this.element.style, this.options.containerStyle), this._getOption("resize") && this.bindResize()
        }, d.reloadItems = function() {
            this.items = this._itemize(this.element.children)
        }, d._itemize = function(t) {
            for (var e = this._filterFindItemElements(t), i = this.constructor.Item, n = [], o = 0; o < e.length; o++) {
                var r = new i(e[o], this);
                n.push(r)
            }
            return n
        }, d._filterFindItemElements = function(t) {
            return r.filterFindElements(t, this.options.itemSelector)
        }, d.getItemElements = function() {
            return this.items.map(function(t) {
                return t.element
            })
        }, d.layout = function() {
            this._resetLayout(), this._manageStamps();
            var t = this._getOption("layoutInstant"),
                e = void 0 !== t ? t : !this._isLayoutInited;
            this.layoutItems(this.items, e), this._isLayoutInited = !0
        }, d._init = d.layout, d._resetLayout = function() {
            this.getSize()
        }, d.getSize = function() {
            this.size = o(this.element)
        }, d._getMeasurement = function(t, e) {
            var i, n = this.options[t];
            this[t] = n ? ("string" == typeof n ? i = this.element.querySelector(n) : n instanceof HTMLElement && (i = n), i ? o(i)[e] : n) : 0
        }, d.layoutItems = function(t, e) {
            t = this._getItemsForLayout(t), this._layoutItems(t, e), this._postLayout()
        }, d._getItemsForLayout = function(t) {
            return t.filter(function(t) {
                return !t.isIgnored
            })
        }, d._layoutItems = function(t, i) {
            if (this._emitCompleteOnItems("layout", t), t && t.length) {
                var n = [];
                t.forEach(function(t) {
                    var e = this._getItemLayoutPosition(t);
                    e.item = t, e.isInstant = i || t.isLayoutInstant, n.push(e)
                }, this), this._processLayoutQueue(n)
            }
        }, d._getItemLayoutPosition = function() {
            return {
                x: 0,
                y: 0
            }
        }, d._processLayoutQueue = function(t) {
            this.updateStagger(), t.forEach(function(t, e) {
                this._positionItem(t.item, t.x, t.y, t.isInstant, e)
            }, this)
        }, d.updateStagger = function() {
            var o = this.options.stagger;
            return null == o ? void(this.stagger = 0) : (this.stagger = function(t) {
                if ("number" == typeof o) return o;
                var e = o.match(/(^\d*\.?\d*)(\w*)/),
                    i = e && e[1],
                    n = e && e[2];
                return i.length ? (i = parseFloat(i)) * (f[n] || 1) : 0
            }(), this.stagger)
        }, d._positionItem = function(t, e, i, n, o) {
            n ? t.goTo(e, i) : (t.stagger(o * this.stagger), t.moveTo(e, i))
        }, d._postLayout = function() {
            this.resizeContainer()
        }, d.resizeContainer = function() {
            if (this._getOption("resizeContainer")) {
                var t = this._getContainerSize();
                t && (this._setContainerMeasure(t.width, !0), this._setContainerMeasure(t.height, !1))
            }
        }, d._getContainerSize = i, d._setContainerMeasure = function(t, e) {
            if (void 0 !== t) {
                var i = this.size;
                i.isBorderBox && (t += e ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth), t = Math.max(t, 0), this.element.style[e ? "width" : "height"] = t + "px"
            }
        }, d._emitCompleteOnItems = function(e, t) {
            function i() {
                o.dispatchEvent(e + "Complete", null, [t])
            }

            function n() {
                ++s == r && i()
            }
            var o = this,
                r = t.length;
            if (t && r) {
                var s = 0;
                t.forEach(function(t) {
                    t.once(e, n)
                })
            } else i()
        }, d.dispatchEvent = function(t, e, i) {
            var n = e ? [e].concat(i) : i;
            if (this.emitEvent(t, n), u)
                if (this.$element = this.$element || u(this.element), e) {
                    var o = u.Event(e);
                    o.type = t, this.$element.trigger(o, i)
                } else this.$element.trigger(t, i)
        }, d.ignore = function(t) {
            var e = this.getItem(t);
            e && (e.isIgnored = !0)
        }, d.unignore = function(t) {
            var e = this.getItem(t);
            e && delete e.isIgnored
        }, d.stamp = function(t) {
            (t = this._find(t)) && (this.stamps = this.stamps.concat(t), t.forEach(this.ignore, this))
        }, d.unstamp = function(t) {
            (t = this._find(t)) && t.forEach(function(t) {
                r.removeFrom(this.stamps, t), this.unignore(t)
            }, this)
        }, d._find = function(t) {
            return t ? ("string" == typeof t && (t = this.element.querySelectorAll(t)), t = r.makeArray(t)) : void 0
        }, d._manageStamps = function() {
            this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this))
        }, d._getBoundingRect = function() {
            var t = this.element.getBoundingClientRect(),
                e = this.size;
            this._boundingRect = {
                left: t.left + e.paddingLeft + e.borderLeftWidth,
                top: t.top + e.paddingTop + e.borderTopWidth,
                right: t.right - (e.paddingRight + e.borderRightWidth),
                bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth)
            }
        }, d._manageStamp = i, d._getElementOffset = function(t) {
            var e = t.getBoundingClientRect(),
                i = this._boundingRect,
                n = o(t);
            return {
                left: e.left - i.left - n.marginLeft,
                top: e.top - i.top - n.marginTop,
                right: i.right - e.right - n.marginRight,
                bottom: i.bottom - e.bottom - n.marginBottom
            }
        }, d.handleEvent = r.handleEvent, d.bindResize = function() {
            t.addEventListener("resize", this), this.isResizeBound = !0
        }, d.unbindResize = function() {
            t.removeEventListener("resize", this), this.isResizeBound = !1
        }, d.onresize = function() {
            this.resize()
        }, r.debounceMethod(s, "onresize", 100), d.resize = function() {
            this.isResizeBound && this.needsResizeLayout() && this.layout()
        }, d.needsResizeLayout = function() {
            var t = o(this.element);
            return this.size && t && t.innerWidth !== this.size.innerWidth
        }, d.addItems = function(t) {
            var e = this._itemize(t);
            return e.length && (this.items = this.items.concat(e)), e
        }, d.appended = function(t) {
            var e = this.addItems(t);
            e.length && (this.layoutItems(e, !0), this.reveal(e))
        }, d.prepended = function(t) {
            var e = this._itemize(t);
            if (e.length) {
                var i = this.items.slice(0);
                this.items = e.concat(i), this._resetLayout(), this._manageStamps(), this.layoutItems(e, !0), this.reveal(e), this.layoutItems(i)
            }
        }, d.reveal = function(t) {
            if (this._emitCompleteOnItems("reveal", t), t && t.length) {
                var i = this.updateStagger();
                t.forEach(function(t, e) {
                    t.stagger(e * i), t.reveal()
                })
            }
        }, d.hide = function(t) {
            if (this._emitCompleteOnItems("hide", t), t && t.length) {
                var i = this.updateStagger();
                t.forEach(function(t, e) {
                    t.stagger(e * i), t.hide()
                })
            }
        }, d.revealItemElements = function(t) {
            var e = this.getItems(t);
            this.reveal(e)
        }, d.hideItemElements = function(t) {
            var e = this.getItems(t);
            this.hide(e)
        }, d.getItem = function(t) {
            for (var e = 0; e < this.items.length; e++) {
                var i = this.items[e];
                if (i.element == t) return i
            }
        }, d.getItems = function(t) {
            t = r.makeArray(t);
            var i = [];
            return t.forEach(function(t) {
                var e = this.getItem(t);
                e && i.push(e)
            }, this), i
        }, d.remove = function(t) {
            var e = this.getItems(t);
            this._emitCompleteOnItems("remove", e), e && e.length && e.forEach(function(t) {
                t.remove(), r.removeFrom(this.items, t)
            }, this)
        }, d.destroy = function() {
            var t = this.element.style;
            t.height = "", t.position = "", t.width = "", this.items.forEach(function(t) {
                t.destroy()
            }), this.unbindResize();
            var e = this.element.outlayerGUID;
            delete h[e], delete this.element.outlayerGUID, u && u.removeData(this.element, this.constructor.namespace)
        }, s.data = function(t) {
            var e = (t = r.getQueryElement(t)) && t.outlayerGUID;
            return e && h[e]
        }, s.create = function(t, e) {
            var i = a(s);
            return i.defaults = r.extend({}, s.defaults), r.extend(i.defaults, e), i.compatOptions = r.extend({}, s.compatOptions), i.namespace = t, i.data = s.data, i.Item = a(n), r.htmlInit(i, t), u && u.bridget && u.bridget(t, i), i
        };
        var f = {
            ms: 1,
            s: 1e3
        };
        return s.Item = n, s
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("packery/js/rect", e) : "object" == typeof module && module.exports ? module.exports = e() : (t.Packery = t.Packery || {}, t.Packery.Rect = e())
    }(window, function() {
        "use strict";

        function a(t) {
            for (var e in a.defaults) this[e] = a.defaults[e];
            for (e in t) this[e] = t[e]
        }
        a.defaults = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        var t = a.prototype;
        return t.contains = function(t) {
            var e = t.width || 0,
                i = t.height || 0;
            return this.x <= t.x && this.y <= t.y && this.x + this.width >= t.x + e && this.y + this.height >= t.y + i
        }, t.overlaps = function(t) {
            var e = this.x + this.width,
                i = this.y + this.height,
                n = t.x + t.width,
                o = t.y + t.height;
            return this.x < n && e > t.x && this.y < o && i > t.y
        }, t.getMaximalFreeRects = function(t) {
            if (!this.overlaps(t)) return !1;
            var e, i = [],
                n = this.x + this.width,
                o = this.y + this.height,
                r = t.x + t.width,
                s = t.y + t.height;
            return this.y < t.y && (e = new a({
                x: this.x,
                y: this.y,
                width: this.width,
                height: t.y - this.y
            }), i.push(e)), r < n && (e = new a({
                x: r,
                y: this.y,
                width: n - r,
                height: this.height
            }), i.push(e)), s < o && (e = new a({
                x: this.x,
                y: s,
                width: this.width,
                height: o - s
            }), i.push(e)), this.x < t.x && (e = new a({
                x: this.x,
                y: this.y,
                width: t.x - this.x,
                height: this.height
            }), i.push(e)), i
        }, t.canFit = function(t) {
            return this.width >= t.width && this.height >= t.height
        }, a
    }),
    function(t, e) {
        if ("function" == typeof define && define.amd) define("packery/js/packer", ["./rect"], e);
        else if ("object" == typeof module && module.exports) module.exports = e(require("./rect"));
        else {
            var i = t.Packery = t.Packery || {};
            i.Packer = e(i.Rect)
        }
    }(window, function(e) {
        "use strict";

        function t(t, e, i) {
            this.width = t || 0, this.height = e || 0, this.sortDirection = i || "downwardLeftToRight", this.reset()
        }
        var i = t.prototype;
        i.reset = function() {
            this.spaces = [];
            var t = new e({
                x: 0,
                y: 0,
                width: this.width,
                height: this.height
            });
            this.spaces.push(t), this.sorter = n[this.sortDirection] || n.downwardLeftToRight
        }, i.pack = function(t) {
            for (var e = 0; e < this.spaces.length; e++) {
                var i = this.spaces[e];
                if (i.canFit(t)) {
                    this.placeInSpace(t, i);
                    break
                }
            }
        }, i.columnPack = function(t) {
            for (var e = 0; e < this.spaces.length; e++) {
                var i = this.spaces[e];
                if (i.x <= t.x && i.x + i.width >= t.x + t.width && i.height >= t.height - .01) {
                    t.y = i.y, this.placed(t);
                    break
                }
            }
        }, i.rowPack = function(t) {
            for (var e = 0; e < this.spaces.length; e++) {
                var i = this.spaces[e];
                if (i.y <= t.y && i.y + i.height >= t.y + t.height && i.width >= t.width - .01) {
                    t.x = i.x, this.placed(t);
                    break
                }
            }
        }, i.placeInSpace = function(t, e) {
            t.x = e.x, t.y = e.y, this.placed(t)
        }, i.placed = function(t) {
            for (var e = [], i = 0; i < this.spaces.length; i++) {
                var n = this.spaces[i],
                    o = n.getMaximalFreeRects(t);
                o ? e.push.apply(e, o) : e.push(n)
            }
            this.spaces = e, this.mergeSortSpaces()
        }, i.mergeSortSpaces = function() {
            t.mergeRects(this.spaces), this.spaces.sort(this.sorter)
        }, i.addSpace = function(t) {
            this.spaces.push(t), this.mergeSortSpaces()
        }, t.mergeRects = function(t) {
            var e = 0,
                i = t[e];
            t: for (; i;) {
                for (var n = 0, o = t[e + n]; o;) {
                    if (o == i) n++;
                    else {
                        if (o.contains(i)) {
                            t.splice(e, 1), i = t[e];
                            continue t
                        }
                        i.contains(o) ? t.splice(e + n, 1) : n++
                    }
                    o = t[e + n]
                }
                i = t[++e]
            }
            return t
        };
        var n = {
            downwardLeftToRight: function(t, e) {
                return t.y - e.y || t.x - e.x
            },
            rightwardTopToBottom: function(t, e) {
                return t.x - e.x || t.y - e.y
            }
        };
        return t
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define("packery/js/item", ["outlayer/outlayer", "./rect"], e) : "object" == typeof module && module.exports ? module.exports = e(require("outlayer"), require("./rect")) : t.Packery.Item = e(t.Outlayer, t.Packery.Rect)
    }(window, function(t, e) {
        "use strict";
        var i = "string" == typeof document.documentElement.style.transform ? "transform" : "WebkitTransform",
            n = function() {
                t.Item.apply(this, arguments)
            },
            o = n.prototype = Object.create(t.Item.prototype),
            r = o._create;
        o._create = function() {
            r.call(this), this.rect = new e
        };
        var s = o.moveTo;
        return o.moveTo = function(t, e) {
            var i = Math.abs(this.position.x - t),
                n = Math.abs(this.position.y - e);
            return this.layout.dragItemCount && !this.isPlacing && !this.isTransitioning && i < 1 && n < 1 ? void this.goTo(t, e) : void s.apply(this, arguments)
        }, o.enablePlacing = function() {
            this.removeTransitionStyles(), this.isTransitioning && i && (this.element.style[i] = "none"), this.isTransitioning = !1, this.getSize(), this.layout._setRectSize(this.element, this.rect), this.isPlacing = !0
        }, o.disablePlacing = function() {
            this.isPlacing = !1
        }, o.removeElem = function() {
            var t = this.element.parentNode;
            t && t.removeChild(this.element), this.layout.packer.addSpace(this.rect), this.emitEvent("remove", [this])
        }, o.showDropPlaceholder = function() {
            var t = this.dropPlaceholder;
            t || ((t = this.dropPlaceholder = document.createElement("div")).className = "packery-drop-placeholder", t.style.position = "absolute"), t.style.width = this.size.width + "px", t.style.height = this.size.height + "px", this.positionDropPlaceholder(), this.layout.element.appendChild(t)
        }, o.positionDropPlaceholder = function() {
            this.dropPlaceholder.style[i] = "translate(" + this.rect.x + "px, " + this.rect.y + "px)"
        }, o.hideDropPlaceholder = function() {
            var t = this.dropPlaceholder.parentNode;
            t && t.removeChild(this.dropPlaceholder)
        }, n
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define(["get-size/get-size", "outlayer/outlayer", "packery/js/rect", "packery/js/packer", "packery/js/item"], e) : "object" == typeof module && module.exports ? module.exports = e(require("get-size"), require("outlayer"), require("./rect"), require("./packer"), require("./item")) : t.Packery = e(t.getSize, t.Outlayer, t.Packery.Rect, t.Packery.Packer, t.Packery.Item)
    }(window, function(c, t, m, e, i) {
        "use strict";

        function n(t, e) {
            return t.position.y - e.position.y || t.position.x - e.position.x
        }

        function o(t, e) {
            return t.position.x - e.position.x || t.position.y - e.position.y
        }
        m.prototype.canFit = function(t) {
            return this.width >= t.width - 1 && this.height >= t.height - 1
        };
        var r = t.create("packery");
        r.Item = i;
        var s = r.prototype;
        s._create = function() {
            t.prototype._create.call(this), this.packer = new e, this.shiftPacker = new e, this.isEnabled = !0, this.dragItemCount = 0;
            var i = this;
            this.handleDraggabilly = {
                dragStart: function() {
                    i.itemDragStart(this.element)
                },
                dragMove: function() {
                    i.itemDragMove(this.element, this.position.x, this.position.y)
                },
                dragEnd: function() {
                    i.itemDragEnd(this.element)
                }
            }, this.handleUIDraggable = {
                start: function(t, e) {
                    e && i.itemDragStart(t.currentTarget)
                },
                drag: function(t, e) {
                    e && i.itemDragMove(t.currentTarget, e.position.left, e.position.top)
                },
                stop: function(t, e) {
                    e && i.itemDragEnd(t.currentTarget)
                }
            }
        }, s._resetLayout = function() {
            var t, e, i;
            this.getSize(), this._getMeasurements(), i = this._getOption("horizontal") ? (t = 1 / 0, e = this.size.innerHeight + this.gutter, "rightwardTopToBottom") : (t = this.size.innerWidth + this.gutter, e = 1 / 0, "downwardLeftToRight"), this.packer.width = this.shiftPacker.width = t, this.packer.height = this.shiftPacker.height = e, this.packer.sortDirection = this.shiftPacker.sortDirection = i, this.packer.reset(), this.maxY = 0, this.maxX = 0
        }, s._getMeasurements = function() {
            this._getMeasurement("columnWidth", "width"), this._getMeasurement("rowHeight", "height"), this._getMeasurement("gutter", "width")
        }, s._getItemLayoutPosition = function(t) {
            if (this._setRectSize(t.element, t.rect), this.isShifting || 0 < this.dragItemCount) {
                var e = this._getPackMethod();
                this.packer[e](t.rect)
            } else this.packer.pack(t.rect);
            return this._setMaxXY(t.rect), t.rect
        }, s.shiftLayout = function() {
            this.isShifting = !0, this.layout(), delete this.isShifting
        }, s._getPackMethod = function() {
            return this._getOption("horizontal") ? "rowPack" : "columnPack"
        }, s._setMaxXY = function(t) {
            this.maxX = Math.max(t.x + t.width, this.maxX), this.maxY = Math.max(t.y + t.height, this.maxY)
        }, s._setRectSize = function(t, e) {
            var i = c(t),
                n = i.outerWidth,
                o = i.outerHeight;
            (n || o) && (n = this._applyGridGutter(n, this.columnWidth), o = this._applyGridGutter(o, this.rowHeight)), e.width = Math.min(n, this.packer.width), e.height = Math.min(o, this.packer.height)
        }, s._applyGridGutter = function(t, e) {
            if (!e) return t + this.gutter;
            var i = t % (e += this.gutter);
            return Math[i && i < 1 ? "round" : "ceil"](t / e) * e
        }, s._getContainerSize = function() {
            return this._getOption("horizontal") ? {
                width: this.maxX - this.gutter
            } : {
                height: this.maxY - this.gutter
            }
        }, s._manageStamp = function(t) {
            var e, i = this.getItem(t);
            if (i && i.isPlacing) e = i.rect;
            else {
                var n = this._getElementOffset(t);
                e = new m({
                    x: this._getOption("originLeft") ? n.left : n.right,
                    y: this._getOption("originTop") ? n.top : n.bottom
                })
            }
            this._setRectSize(t, e), this.packer.placed(e), this._setMaxXY(e)
        }, s.sortItemsByPosition = function() {
            var t = this._getOption("horizontal") ? o : n;
            this.items.sort(t)
        }, s.fit = function(t, e, i) {
            var n = this.getItem(t);
            n && (this.stamp(n.element), n.enablePlacing(), this.updateShiftTargets(n), e = void 0 === e ? n.rect.x : e, i = void 0 === i ? n.rect.y : i, this.shift(n, e, i), this._bindFitEvents(n), n.moveTo(n.rect.x, n.rect.y), this.shiftLayout(), this.unstamp(n.element), this.sortItemsByPosition(), n.disablePlacing())
        }, s._bindFitEvents = function(t) {
            function e() {
                2 == ++n && i.dispatchEvent("fitComplete", null, [t])
            }
            var i = this,
                n = 0;
            t.once("layout", e), this.once("layoutComplete", e)
        }, s.resize = function() {
            this.isResizeBound && this.needsResizeLayout() && (this.options.shiftPercentResize ? this.resizeShiftPercentLayout() : this.layout())
        }, s.needsResizeLayout = function() {
            var t = c(this.element),
                e = this._getOption("horizontal") ? "innerHeight" : "innerWidth";
            return t[e] != this.size[e]
        }, s.resizeShiftPercentLayout = function() {
            var t = this._getItemsForLayout(this.items),
                e = this._getOption("horizontal"),
                i = e ? "y" : "x",
                n = e ? "height" : "width",
                o = e ? "rowHeight" : "columnWidth",
                r = e ? "innerHeight" : "innerWidth",
                s = this[o];
            if (s = s && s + this.gutter) {
                this._getMeasurements();
                var a = this[o] + this.gutter;
                t.forEach(function(t) {
                    var e = Math.round(t.rect[i] / s);
                    t.rect[i] = e * a
                })
            } else {
                var l = c(this.element)[r] + this.gutter,
                    u = this.packer[n];
                t.forEach(function(t) {
                    t.rect[i] = t.rect[i] / u * l
                })
            }
            this.shiftLayout()
        }, s.itemDragStart = function(t) {
            if (this.isEnabled) {
                this.stamp(t);
                var e = this.getItem(t);
                e && (e.enablePlacing(), e.showDropPlaceholder(), this.dragItemCount++, this.updateShiftTargets(e))
            }
        }, s.updateShiftTargets = function(t) {
            this.shiftPacker.reset(), this._getBoundingRect();
            var o = this._getOption("originLeft"),
                r = this._getOption("originTop");
            this.stamps.forEach(function(t) {
                var e = this.getItem(t);
                if (!e || !e.isPlacing) {
                    var i = this._getElementOffset(t),
                        n = new m({
                            x: o ? i.left : i.right,
                            y: r ? i.top : i.bottom
                        });
                    this._setRectSize(t, n), this.shiftPacker.placed(n)
                }
            }, this);
            var l = this._getOption("horizontal"),
                e = l ? "rowHeight" : "columnWidth",
                u = l ? "height" : "width";
            this.shiftTargetKeys = [], this.shiftTargets = [];
            var c, h = this[e];
            if (h = h && h + this.gutter) {
                var i = Math.ceil(t.rect[u] / h),
                    n = Math.floor((this.shiftPacker[u] + this.gutter) / h);
                c = (n - i) * h;
                for (var s = 0; s < n; s++) {
                    var a = l ? 0 : s * h,
                        d = l ? s * h : 0;
                    this._addShiftTarget(a, d, c)
                }
            } else c = this.shiftPacker[u] + this.gutter - t.rect[u], this._addShiftTarget(0, 0, c);
            var f = this._getItemsForLayout(this.items),
                p = this._getPackMethod();
            f.forEach(function(t) {
                var e = t.rect;
                this._setRectSize(t.element, e), this.shiftPacker[p](e), this._addShiftTarget(e.x, e.y, c);
                var i = l ? e.x + e.width : e.x,
                    n = l ? e.y : e.y + e.height;
                if (this._addShiftTarget(i, n, c), h)
                    for (var o = Math.round(e[u] / h), r = 1; r < o; r++) {
                        var s = l ? i : e.x + h * r,
                            a = l ? e.y + h * r : n;
                        this._addShiftTarget(s, a, c)
                    }
            }, this)
        }, s._addShiftTarget = function(t, e, i) {
            var n = this._getOption("horizontal") ? e : t;
            if (!(0 !== n && i < n)) {
                var o = t + "," + e; - 1 != this.shiftTargetKeys.indexOf(o) || (this.shiftTargetKeys.push(o), this.shiftTargets.push({
                    x: t,
                    y: e
                }))
            }
        }, s.shift = function(t, e, i) {
            var s, a = 1 / 0,
                l = {
                    x: e,
                    y: i
                };
            this.shiftTargets.forEach(function(t) {
                var e, i, n, o, r = (n = (i = l).x - (e = t).x, o = i.y - e.y, Math.sqrt(n * n + o * o));
                r < a && (s = t, a = r)
            }), t.rect.x = s.x, t.rect.y = s.y
        }, s.itemDragMove = function(t, e, i) {
            function n() {
                r.shift(o, e, i), o.positionDropPlaceholder(), r.layout()
            }
            var o = this.isEnabled && this.getItem(t);
            if (o) {
                e -= this.size.paddingLeft, i -= this.size.paddingTop;
                var r = this,
                    s = new Date;
                this._itemDragTime && s - this._itemDragTime < 120 ? (clearTimeout(this.dragTimeout), this.dragTimeout = setTimeout(n, 120)) : (n(), this._itemDragTime = s)
            }
        }, s.itemDragEnd = function(t) {
            function e() {
                2 == ++n && (i.element.classList.remove("is-positioning-post-drag"), i.hideDropPlaceholder(), o.dispatchEvent("dragItemPositioned", null, [i]))
            }
            var i = this.isEnabled && this.getItem(t);
            if (i) {
                clearTimeout(this.dragTimeout), i.element.classList.add("is-positioning-post-drag");
                var n = 0,
                    o = this;
                i.once("layout", e), this.once("layoutComplete", e), i.moveTo(i.rect.x, i.rect.y), this.layout(), this.dragItemCount = Math.max(0, this.dragItemCount - 1), this.sortItemsByPosition(), i.disablePlacing(), this.unstamp(i.element)
            }
        }, s.bindDraggabillyEvents = function(t) {
            this._bindDraggabillyEvents(t, "on")
        }, s.unbindDraggabillyEvents = function(t) {
            this._bindDraggabillyEvents(t, "off")
        }, s._bindDraggabillyEvents = function(t, e) {
            var i = this.handleDraggabilly;
            t[e]("dragStart", i.dragStart), t[e]("dragMove", i.dragMove), t[e]("dragEnd", i.dragEnd)
        }, s.bindUIDraggableEvents = function(t) {
            this._bindUIDraggableEvents(t, "on")
        }, s.unbindUIDraggableEvents = function(t) {
            this._bindUIDraggableEvents(t, "off")
        }, s._bindUIDraggableEvents = function(t, e) {
            var i = this.handleUIDraggable;
            t[e]("dragstart", i.start)[e]("drag", i.drag)[e]("dragstop", i.stop)
        };
        var a = s.destroy;
        return s.destroy = function() {
            a.apply(this, arguments), this.isEnabled = !1
        }, r.Rect = m, r.Packer = e, r
    }),
    function(t, e) {
        "function" == typeof define && define.amd ? define(["flickity/js/index", "fizzy-ui-utils/utils"], e) : "object" == typeof module && module.exports ? module.exports = e(require("flickity"), require("fizzy-ui-utils")) : e(t.Flickity, t.fizzyUIUtils)
    }(this, function(t, a) {
        var e = t.Slide,
            o = e.prototype.updateTarget;
        e.prototype.updateTarget = function() {
            if (o.apply(this, arguments), this.parent.options.fade) {
                var i = this.target - this.x,
                    n = this.cells[0].x;
                this.cells.forEach(function(t) {
                    var e = t.x - n - i;
                    t.renderPosition(e)
                })
            }
        }, e.prototype.setOpacity = function(e) {
            this.cells.forEach(function(t) {
                t.element.style.opacity = e
            })
        };
        var i = t.prototype;
        t.createMethods.push("_createFade"), i._createFade = function() {
            this.fadeIndex = this.selectedIndex, this.prevSelectedIndex = this.selectedIndex, this.on("select", this.onSelectFade), this.on("dragEnd", this.onDragEndFade), this.on("settle", this.onSettleFade), this.on("activate", this.onActivateFade), this.on("deactivate", this.onDeactivateFade)
        };
        var n = i.updateSlides;
        i.updateSlides = function() {
            n.apply(this, arguments), this.options.fade && this.slides.forEach(function(t, e) {
                var i = e == this.selectedIndex ? 1 : 0;
                t.setOpacity(i)
            }, this)
        }, i.onSelectFade = function() {
            this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1), this.prevSelectedIndex = this.selectedIndex
        }, i.onSettleFade = function() {
            delete this.didDragEnd, this.options.fade && (this.selectedSlide.setOpacity(1), this.slides[this.fadeIndex] && this.fadeIndex != this.selectedIndex && this.slides[this.fadeIndex].setOpacity(0))
        }, i.onDragEndFade = function() {
            this.didDragEnd = !0
        }, i.onActivateFade = function() {
            this.options.fade && this.element.classList.add("is-fade")
        }, i.onDeactivateFade = function() {
            this.options.fade && (this.element.classList.remove("is-fade"), this.slides.forEach(function(t) {
                t.setOpacity("")
            }))
        };
        var r = i.positionSlider;
        i.positionSlider = function() {
            this.options.fade ? (this.fadeSlides(), this.dispatchScrollEvent()) : r.apply(this, arguments)
        };
        var s = i.positionSliderAtSelected;
        i.positionSliderAtSelected = function() {
            this.options.fade && this.setTranslateX(0), s.apply(this, arguments)
        }, i.fadeSlides = function() {
            if (!(this.slides.length < 2)) {
                var t = this.getFadeIndexes(),
                    e = this.slides[t.a],
                    i = this.slides[t.b],
                    n = this.wrapDifference(e.target, i.target),
                    o = this.wrapDifference(e.target, -this.x);
                o /= n, e.setOpacity(1 - o), i.setOpacity(o);
                var r = t.a;
                this.isDragging && (r = .5 < o ? t.a : t.b), null != this.fadeHideIndex && this.fadeHideIndex != r && this.fadeHideIndex != t.a && this.fadeHideIndex != t.b && this.slides[this.fadeHideIndex].setOpacity(0), this.fadeHideIndex = r
            }
        }, i.getFadeIndexes = function() {
            return this.isDragging || this.didDragEnd ? this.options.wrapAround ? this.getFadeDragWrapIndexes() : this.getFadeDragLimitIndexes() : {
                a: this.fadeIndex,
                b: this.selectedIndex
            }
        }, i.getFadeDragWrapIndexes = function() {
            var t = this.slides.map(function(t, e) {
                    return this.getSlideDistance(-this.x, e)
                }, this),
                e = t.map(function(t) {
                    return Math.abs(t)
                }),
                i = Math.min.apply(Math, e),
                n = e.indexOf(i),
                o = t[n],
                r = this.slides.length,
                s = 0 <= o ? 1 : -1;
            return {
                a: n,
                b: a.modulo(n + s, r)
            }
        }, i.getFadeDragLimitIndexes = function() {
            for (var t = 0, e = 0; e < this.slides.length - 1; e++) {
                var i = this.slides[e];
                if (-this.x < i.target) break;
                t = e
            }
            return {
                a: t,
                b: t + 1
            }
        }, i.wrapDifference = function(t, e) {
            var i = e - t;
            if (!this.options.wrapAround) return i;
            var n = i + this.slideableWidth,
                o = i - this.slideableWidth;
            return Math.abs(n) < Math.abs(i) && (i = n), Math.abs(o) < Math.abs(i) && (i = o), i
        };
        var l = i._getWrapShiftCells;
        i._getWrapShiftCells = function() {
            this.options.fade || l.apply(this, arguments)
        };
        var u = i.shiftWrapCells;
        return i.shiftWrapCells = function() {
            this.options.fade || u.apply(this, arguments)
        }, t
    });
    var PrevNextButton = Flickity.PrevNextButton;
    PrevNextButton.prototype.update = function() {
            var t = this.parent.slides;
            if (this.parent.options.wrapAround && 1 < t.length) this.enable();
            else {
                var e = t.length ? t.length - 1 : 0,
                    i = this.isPrevious ? 0 : e,
                    n = this.isPrevious ? "prev_" : "next_",
                    o = this.parent.selectedIndex == i ? "disable" : "enable",
                    r = "disable" == o ? "enable" : "disable";
                this[o](), this.parent.element.classList.remove("flickity_" + n + r), this.parent.element.classList.add("flickity_" + n + o)
            }
        },
        function(t) {
            "function" == typeof define && define.amd ? define(["jQuery_T4NT"], t) : t("object" == typeof exports ? require("jQuery_T4NT") : window.jQuery_T4NT || window.Zepto)
        }(function(c) {
            var h, n, d, o, f, e, a = "Close",
                l = "BeforeClose",
                p = "MarkupParse",
                i = ".mfp",
                m = "mfp-ready",
                r = "mfp-removing",
                s = "mfp-prevent-close",
                t = function() {},
                u = !!window.jQuery_T4NT,
                g = c(window),
                y = function(t, e) {
                    h.ev.on("mfp" + t + i, e)
                },
                v = function(t, e, i, n) {
                    var o = document.createElement("div");
                    return o.className = "mfp-" + t, i && (o.innerHTML = i), n ? e && e.appendChild(o) : (o = c(o), e && o.appendTo(e)), o
                },
                b = function(t, e) {
                    h.ev.triggerHandler("mfp" + t, e), h.st.callbacks && (t = t.charAt(0).toLowerCase() + t.slice(1), h.st.callbacks[t] && h.st.callbacks[t].apply(h, c.isArray(e) ? e : [e]))
                },
                x = function(t) {
                    return t === e && h.currTemplate.closeBtn || (h.currTemplate.closeBtn = c(h.st.closeMarkup.replace("%title%", h.st.tClose)), e = t), h.currTemplate.closeBtn
                },
                w = function() {
                    c.magnificPopup.instance || ((h = new t).init(), c.magnificPopup.instance = h)
                };
            t.prototype = {
                constructor: t,
                init: function() {
                    var t = navigator.appVersion;
                    h.isLowIE = h.isIE8 = document.all && !document.addEventListener, h.isAndroid = /android/gi.test(t), h.isIOS = /iphone|ipad|ipod/gi.test(t), h.supportsTransition = function() {
                        var t = document.createElement("p").style,
                            e = ["ms", "O", "Moz", "Webkit"];
                        if (void 0 !== t.transition) return !0;
                        for (; e.length;)
                            if (e.pop() + "Transition" in t) return !0;
                        return !1
                    }(), h.probablyMobile = h.isAndroid || h.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), d = c(document), h.popupsCache = {}
                },
                open: function(t) {
                    var e;
                    if (!1 === t.isObj) {
                        h.items = t.items.toArray(), h.index = 0;
                        var i, n = t.items;
                        for (e = 0; e < n.length; e++)
                            if ((i = n[e]).parsed && (i = i.el[0]), i === t.el[0]) {
                                h.index = e;
                                break
                            }
                    } else h.items = c.isArray(t.items) ? t.items : [t.items], h.index = t.index || 0;
                    if (!h.isOpen) {
                        h.types = [], f = "", t.mainEl && t.mainEl.length ? h.ev = t.mainEl.eq(0) : h.ev = d, t.key ? (h.popupsCache[t.key] || (h.popupsCache[t.key] = {}), h.currTemplate = h.popupsCache[t.key]) : h.currTemplate = {}, h.st = c.extend(!0, {}, c.magnificPopup.defaults, t), h.fixedContentPos = "auto" === h.st.fixedContentPos ? !h.probablyMobile : h.st.fixedContentPos, h.st.modal && (h.st.closeOnContentClick = !1, h.st.closeOnBgClick = !1, h.st.showCloseBtn = !1, h.st.enableEscapeKey = !1), h.bgOverlay || (h.bgOverlay = v("bg").on("click.mfp", function() {
                            h.close()
                        }), h.wrap = v("wrap").attr("tabindex", -1).on("click.mfp", function(t) {
                            h._checkIfClose(t.target) && h.close()
                        }), h.container = v("container", h.wrap)), h.contentContainer = v("content"), h.st.preloader && (h.preloader = v("preloader", h.container, h.st.tLoading));
                        var o = c.magnificPopup.modules;
                        for (e = 0; e < o.length; e++) {
                            var r = o[e];
                            r = r.charAt(0).toUpperCase() + r.slice(1), h["init" + r].call(h)
                        }
                        b("BeforeOpen"), h.st.showCloseBtn && (h.st.closeBtnInside ? (y(p, function(t, e, i, n) {
                            i.close_replaceWith = x(n.type)
                        }), f += " mfp-close-btn-in") : h.wrap.append(x())), h.st.alignTop && (f += " mfp-align-top"), h.fixedContentPos ? h.wrap.css({
                            overflow: h.st.overflowY,
                            overflowX: "hidden",
                            overflowY: h.st.overflowY
                        }) : h.wrap.css({
                            top: g.scrollTop(),
                            position: "absolute"
                        }), (!1 === h.st.fixedBgPos || "auto" === h.st.fixedBgPos && !h.fixedContentPos) && h.bgOverlay.css({
                            height: d.height(),
                            position: "absolute"
                        }), h.st.enableEscapeKey && d.on("keyup.mfp", function(t) {
                            27 === t.keyCode && h.close()
                        }), g.on("resize.mfp", function() {
                            h.updateSize()
                        }), h.st.closeOnContentClick || (f += " mfp-auto-cursor"), f && h.wrap.addClass(f);
                        var s = h.wH = g.height(),
                            a = {};
                        if (h.fixedContentPos && h._hasScrollBar(s)) {
                            var l = h._getScrollbarSize();
                            l && (a.marginRight = l)
                        }
                        h.fixedContentPos && (h.isIE7 ? c("body, html").css("overflow", "hidden") : a.overflow = "hidden");
                        var u = h.st.mainClass;
                        return h.isIE7 && (u += " mfp-ie7"), u && h._addClassToMFP(u), h.updateItemHTML(), b("BuildControls"), c("html").css(a), h.bgOverlay.add(h.wrap).prependTo(h.st.prependTo || c(document.body)), h._lastFocusedEl = document.activeElement, setTimeout(function() {
                            h.content ? (h._addClassToMFP(m), h._setFocus()) : h.bgOverlay.addClass(m), d.on("focusin.mfp", h._onFocusIn)
                        }, 16), h.isOpen = !0, h.updateSize(s), b("Open"), t
                    }
                    h.updateItemHTML()
                },
                close: function() {
                    h.isOpen && (b(l), h.isOpen = !1, h.st.removalDelay && !h.isLowIE && h.supportsTransition ? (h._addClassToMFP(r), setTimeout(function() {
                        h._close()
                    }, h.st.removalDelay)) : h._close())
                },
                _close: function() {
                    b(a);
                    var t = r + " " + m + " ";
                    if (h.bgOverlay.detach(), h.wrap.detach(), h.container.empty(), h.st.mainClass && (t += h.st.mainClass + " "), h._removeClassFromMFP(t), h.fixedContentPos) {
                        var e = {
                            marginRight: ""
                        };
                        h.isIE7 ? c("body, html").css("overflow", "") : e.overflow = "", c("html").css(e)
                    }
                    d.off("keyup.mfp focusin.mfp"), h.ev.off(i), h.wrap.attr("class", "mfp-wrap").removeAttr("style"), h.bgOverlay.attr("class", "mfp-bg"), h.container.attr("class", "mfp-container"), !h.st.showCloseBtn || h.st.closeBtnInside && !0 !== h.currTemplate[h.currItem.type] || h.currTemplate.closeBtn && h.currTemplate.closeBtn.detach(), h.st.autoFocusLast && h._lastFocusedEl && c(h._lastFocusedEl).focus(), h.currItem = null, h.content = null, h.currTemplate = null, h.prevHeight = 0, b("AfterClose")
                },
                updateSize: function(t) {
                    if (h.isIOS) {
                        var e = document.documentElement.clientWidth / window.innerWidth,
                            i = window.innerHeight * e;
                        h.wrap.css("height", i), h.wH = i
                    } else h.wH = t || g.height();
                    h.fixedContentPos || h.wrap.css("height", h.wH), b("Resize")
                },
                updateItemHTML: function() {
                    var t = h.items[h.index];
                    h.contentContainer.detach(), h.content && h.content.detach(), t.parsed || (t = h.parseEl(h.index));
                    var e = t.type;
                    if (b("BeforeChange", [h.currItem ? h.currItem.type : "", e]), h.currItem = t, !h.currTemplate[e]) {
                        var i = !!h.st[e] && h.st[e].markup;
                        b("FirstMarkupParse", i), h.currTemplate[e] = !i || c(i)
                    }
                    o && o !== t.type && h.container.removeClass("mfp-" + o + "-holder");
                    var n = h["get" + e.charAt(0).toUpperCase() + e.slice(1)](t, h.currTemplate[e]);
                    h.appendContent(n, e), t.preloaded = !0, b("Change", t), o = t.type, h.container.prepend(h.contentContainer), b("AfterChange")
                },
                appendContent: function(t, e) {
                    (h.content = t) ? h.st.showCloseBtn && h.st.closeBtnInside && !0 === h.currTemplate[e] ? h.content.find(".mfp-close").length || h.content.append(x()) : h.content = t: h.content = "", b("BeforeAppend"), h.container.addClass("mfp-" + e + "-holder"), h.contentContainer.append(h.content)
                },
                parseEl: function(t) {
                    var e, i = h.items[t];
                    if ((i = i.tagName ? {
                            el: c(i)
                        } : (e = i.type, {
                            data: i,
                            src: i.src
                        })).el) {
                        for (var n = h.types, o = 0; o < n.length; o++)
                            if (i.el.hasClass("mfp-" + n[o])) {
                                e = n[o];
                                break
                            } i.src = i.el.attr("data-mfp-src"), i.src || (i.src = i.el.attr("href"))
                    }
                    return i.type = e || h.st.type || "inline", i.index = t, i.parsed = !0, h.items[t] = i, b("ElementParse", i), h.items[t]
                },
                addGroup: function(e, i) {
                    var t = function(t) {
                        t.mfpEl = this, h._openClick(t, e, i)
                    };
                    i || (i = {});
                    var n = "click.magnificPopup";
                    i.mainEl = e, i.items ? (i.isObj = !0, e.off(n).on(n, t)) : (i.isObj = !1, i.delegate ? e.off(n).on(n, i.delegate, t) : (i.items = e).off(n).on(n, t))
                },
                _openClick: function(t, e, i) {
                    if ((void 0 !== i.midClick ? i.midClick : c.magnificPopup.defaults.midClick) || !(2 === t.which || t.ctrlKey || t.metaKey || t.altKey || t.shiftKey)) {
                        var n = void 0 !== i.disableOn ? i.disableOn : c.magnificPopup.defaults.disableOn;
                        if (n)
                            if (c.isFunction(n)) {
                                if (!n.call(h)) return !0
                            } else if (g.width() < n) return !0;
                        t.type && (t.preventDefault(), h.isOpen && t.stopPropagation()), i.el = c(t.mfpEl), i.delegate && (i.items = e.find(i.delegate)), h.open(i)
                    }
                },
                updateStatus: function(t, e) {
                    if (h.preloader) {
                        n !== t && h.container.removeClass("mfp-s-" + n), e || "loading" !== t || (e = h.st.tLoading);
                        var i = {
                            status: t,
                            text: e
                        };
                        b("UpdateStatus", i), t = i.status, e = i.text, h.preloader.html(e), h.preloader.find("a").on("click", function(t) {
                            t.stopImmediatePropagation()
                        }), h.container.addClass("mfp-s-" + t), n = t
                    }
                },
                _checkIfClose: function(t) {
                    if (!c(t).hasClass(s)) {
                        var e = h.st.closeOnContentClick,
                            i = h.st.closeOnBgClick;
                        if (e && i) return !0;
                        if (!h.content || c(t).hasClass("mfp-close") || h.preloader && t === h.preloader[0]) return !0;
                        if (t === h.content[0] || c.contains(h.content[0], t)) {
                            if (e) return !0
                        } else if (i && c.contains(document, t)) return !0;
                        return !1
                    }
                },
                _addClassToMFP: function(t) {
                    h.bgOverlay.addClass(t), h.wrap.addClass(t)
                },
                _removeClassFromMFP: function(t) {
                    this.bgOverlay.removeClass(t), h.wrap.removeClass(t)
                },
                _hasScrollBar: function(t) {
                    return (h.isIE7 ? d.height() : document.body.scrollHeight) > (t || g.height())
                },
                _setFocus: function() {
                    (h.st.focus ? h.content.find(h.st.focus).eq(0) : h.wrap).focus()
                },
                _onFocusIn: function(t) {
                    return t.target === h.wrap[0] || c.contains(h.wrap[0], t.target) ? void 0 : (h._setFocus(), !1)
                },
                _parseMarkup: function(o, t, e) {
                    var r;
                    e.data && (t = c.extend(e.data, t)), b(p, [o, t, e]), c.each(t, function(t, e) {
                        if (void 0 === e || !1 === e) return !0;
                        if (1 < (r = t.split("_")).length) {
                            var i = o.find(".mfp-" + r[0]);
                            if (0 < i.length) {
                                var n = r[1];
                                "replaceWith" === n ? i[0] !== e[0] && i.replaceWith(e) : "img" === n ? i.is("img") ? i.attr("src", e) : i.replaceWith(c("<img>").attr("src", e).attr("class", i.attr("class"))) : i.attr(r[1], e)
                            }
                        } else o.find(".mfp-" + t).html(e)
                    })
                },
                _getScrollbarSize: function() {
                    if (void 0 === h.scrollbarSize) {
                        var t = document.createElement("div");
                        t.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(t), h.scrollbarSize = t.offsetWidth - t.clientWidth, document.body.removeChild(t)
                    }
                    return h.scrollbarSize
                }
            }, c.magnificPopup = {
                instance: null,
                proto: t.prototype,
                modules: [],
                open: function(t, e) {
                    return w(), (t = t ? c.extend(!0, {}, t) : {}).isObj = !0, t.index = e || 0, this.instance.open(t)
                },
                close: function() {
                    return c.magnificPopup.instance && c.magnificPopup.instance.close()
                },
                registerModule: function(t, e) {
                    e.options && (c.magnificPopup.defaults[t] = e.options), c.extend(this.proto, e.proto), this.modules.push(t)
                },
                defaults: {
                    disableOn: 0,
                    key: null,
                    midClick: !1,
                    mainClass: "",
                    preloader: !0,
                    focus: "",
                    closeOnContentClick: !1,
                    closeOnBgClick: !0,
                    closeBtnInside: !0,
                    showCloseBtn: !0,
                    enableEscapeKey: !0,
                    modal: !1,
                    alignTop: !1,
                    removalDelay: 0,
                    prependTo: null,
                    fixedContentPos: "auto",
                    fixedBgPos: "auto",
                    overflowY: "auto",
                    closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
                    tClose: "Close (Esc)",
                    tLoading: "Loading...",
                    autoFocusLast: !0
                }
            }, c.fn.magnificPopup = function(t) {
                w();
                var e = c(this);
                if ("string" == typeof t)
                    if ("open" === t) {
                        var i, n = u ? e.data("magnificPopup") : e[0].magnificPopup,
                            o = parseInt(arguments[1], 10) || 0;
                        i = n.items ? n.items[o] : (i = e, n.delegate && (i = i.find(n.delegate)), i.eq(o)), h._openClick({
                            mfpEl: i
                        }, e, n)
                    } else h.isOpen && h[t].apply(h, Array.prototype.slice.call(arguments, 1));
                else t = c.extend(!0, {}, t), u ? e.data("magnificPopup", t) : e[0].magnificPopup = t, h.addGroup(e, t);
                return e
            };
            var _, S, T, E = "inline",
                C = function() {
                    T && (S.after(T.addClass(_)).detach(), T = null)
                };
            c.magnificPopup.registerModule(E, {
                options: {
                    hiddenClass: "hide",
                    markup: "",
                    tNotFound: "Content not found"
                },
                proto: {
                    initInline: function() {
                        h.types.push(E), y(a + "." + E, function() {
                            C()
                        })
                    },
                    getInline: function(t, e) {
                        if (C(), t.src) {
                            var i = h.st.inline,
                                n = c(t.src);
                            if (n.length) {
                                var o = n[0].parentNode;
                                o && o.tagName && (S || (_ = i.hiddenClass, S = v(_), _ = "mfp-" + _), T = n.after(S).detach().removeClass(_)), h.updateStatus("ready")
                            } else h.updateStatus("error", i.tNotFound), n = c("<div>");
                            return t.inlineElement = n
                        }
                        return h.updateStatus("ready"), h._parseMarkup(e, {}, t), e
                    }
                }
            });
            var k, D = "ajax",
                I = function() {
                    k && c(document.body).removeClass(k)
                },
                M = function() {
                    I(), h.req && h.req.abort()
                };
            c.magnificPopup.registerModule(D, {
                options: {
                    settings: null,
                    cursor: "mfp-ajax-cur",
                    tError: '<a href="%url%">The content</a> could not be loaded.'
                },
                proto: {
                    initAjax: function() {
                        h.types.push(D), k = h.st.ajax.cursor, y(a + "." + D, M), y("BeforeChange.ajax", M)
                    },
                    getAjax: function(o) {
                        k && c(document.body).addClass(k), h.updateStatus("loading");
                        var t = c.extend({
                            url: o.src,
                            success: function(t, e, i) {
                                var n = {
                                    data: t,
                                    xhr: i
                                };
                                b("ParseAjax", n), h.appendContent(c(n.data), D), o.finished = !0, I(), h._setFocus(), setTimeout(function() {
                                    h.wrap.addClass(m)
                                }, 16), h.updateStatus("ready"), b("AjaxContentAdded")
                            },
                            error: function() {
                                I(), o.finished = o.loadError = !0, h.updateStatus("error", h.st.ajax.tError.replace("%url%", o.src))
                            }
                        }, h.st.ajax.settings);
                        return h.req = c.ajax(t), ""
                    }
                }
            });
            var P;
            c.magnificPopup.registerModule("image", {
                options: {
                    markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
                    cursor: "mfp-zoom-out-cur",
                    titleSrc: "title",
                    verticalFit: !0,
                    tError: '<a href="%url%">The image</a> could not be loaded.'
                },
                proto: {
                    initImage: function() {
                        var t = h.st.image,
                            e = ".image";
                        h.types.push("image"), y("Open" + e, function() {
                            "image" === h.currItem.type && t.cursor && c(document.body).addClass(t.cursor)
                        }), y(a + e, function() {
                            t.cursor && c(document.body).removeClass(t.cursor), g.off("resize.mfp")
                        }), y("Resize" + e, h.resizeImage), h.isLowIE && y("AfterChange", h.resizeImage)
                    },
                    resizeImage: function() {
                        var t = h.currItem;
                        if (t && t.img && h.st.image.verticalFit) {
                            var e = 0;
                            h.isLowIE && (e = parseInt(t.img.css("padding-top"), 10) + parseInt(t.img.css("padding-bottom"), 10)), t.img.css("max-height", h.wH - e)
                        }
                    },
                    _onImageHasSize: function(t) {
                        t.img && (t.hasSize = !0, P && clearInterval(P), t.isCheckingImgSize = !1, b("ImageHasSize", t), t.imgHidden && (h.content && h.content.removeClass("mfp-loading"), t.imgHidden = !1))
                    },
                    findImageSize: function(e) {
                        var i = 0,
                            n = e.img[0],
                            o = function(t) {
                                P && clearInterval(P), P = setInterval(function() {
                                    return 0 < n.naturalWidth ? void h._onImageHasSize(e) : (200 < i && clearInterval(P), void(3 === ++i ? o(10) : 40 === i ? o(50) : 100 === i && o(500)))
                                }, t)
                            };
                        o(1)
                    },
                    getImage: function(t, e) {
                        var i = 0,
                            n = function() {
                                t && (t.img[0].complete ? (t.img.off(".mfploader"), t === h.currItem && (h._onImageHasSize(t), h.updateStatus("ready")), t.hasSize = !0, t.loaded = !0, b("ImageLoadComplete")) : ++i < 200 ? setTimeout(n, 100) : o())
                            },
                            o = function() {
                                t && (t.img.off(".mfploader"), t === h.currItem && (h._onImageHasSize(t), h.updateStatus("error", r.tError.replace("%url%", t.src))), t.hasSize = !0, t.loaded = !0, t.loadError = !0)
                            },
                            r = h.st.image,
                            s = e.find(".mfp-img");
                        if (s.length) {
                            var a = document.createElement("img");
                            a.className = "mfp-img", t.el && t.el.find("img").length && (a.alt = t.el.find("img").attr("alt")), t.img = c(a).on("load.mfploader", n).on("error.mfploader", o), a.src = t.src, s.is("img") && (t.img = t.img.clone()), 0 < (a = t.img[0]).naturalWidth ? t.hasSize = !0 : a.width || (t.hasSize = !1)
                        }
                        return h._parseMarkup(e, {
                            title: function(t) {
                                if (t.data && void 0 !== t.data.title) return t.data.title;
                                var e = h.st.image.titleSrc;
                                if (e) {
                                    if (c.isFunction(e)) return e.call(h, t);
                                    if (t.el) return t.el.attr(e) || ""
                                }
                                return ""
                            }(t),
                            img_replaceWith: t.img
                        }, t), h.resizeImage(), t.hasSize ? (P && clearInterval(P), t.loadError ? (e.addClass("mfp-loading"), h.updateStatus("error", r.tError.replace("%url%", t.src))) : (e.removeClass("mfp-loading"), h.updateStatus("ready"))) : (h.updateStatus("loading"), t.loading = !0, t.hasSize || (t.imgHidden = !0, e.addClass("mfp-loading"), h.findImageSize(t))), e
                    }
                }
            });
            var O;
            c.magnificPopup.registerModule("zoom", {
                options: {
                    enabled: !1,
                    easing: "ease-in-out",
                    duration: 300,
                    opener: function(t) {
                        return t.is("img") ? t : t.find("img")
                    }
                },
                proto: {
                    initZoom: function() {
                        var t, r = h.st.zoom;
                        if (r.enabled && h.supportsTransition) {
                            var e, i, n = r.duration,
                                o = function(t) {
                                    var e = t.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                                        i = "all " + r.duration / 1e3 + "s " + r.easing,
                                        n = {
                                            position: "fixed",
                                            zIndex: 9999,
                                            left: 0,
                                            top: 0,
                                            "-webkit-backface-visibility": "hidden"
                                        },
                                        o = "transition";
                                    return n["-webkit-" + o] = n["-moz-" + o] = n["-o-" + o] = n[o] = i, e.css(n), e
                                },
                                s = function() {
                                    h.content.css("visibility", "visible")
                                };
                            y("BuildControls.zoom", function() {
                                if (h._allowZoom()) {
                                    if (clearTimeout(e), h.content.css("visibility", "hidden"), !(t = h._getItemToZoom())) return void s();
                                    (i = o(t)).css(h._getOffset()), h.wrap.append(i), e = setTimeout(function() {
                                        i.css(h._getOffset(!0)), e = setTimeout(function() {
                                            s(), setTimeout(function() {
                                                i.remove(), t = i = null, b("ZoomAnimationEnded")
                                            }, 16)
                                        }, n)
                                    }, 16)
                                }
                            }), y(l + ".zoom", function() {
                                if (h._allowZoom()) {
                                    if (clearTimeout(e), h.st.removalDelay = n, !t) {
                                        if (!(t = h._getItemToZoom())) return;
                                        i = o(t)
                                    }
                                    i.css(h._getOffset(!0)), h.wrap.append(i), h.content.css("visibility", "hidden"), setTimeout(function() {
                                        i.css(h._getOffset())
                                    }, 16)
                                }
                            }), y(a + ".zoom", function() {
                                h._allowZoom() && (s(), i && i.remove(), t = null)
                            })
                        }
                    },
                    _allowZoom: function() {
                        return "image" === h.currItem.type
                    },
                    _getItemToZoom: function() {
                        return !!h.currItem.hasSize && h.currItem.img
                    },
                    _getOffset: function(t) {
                        var e, i = (e = t ? h.currItem.img : h.st.zoom.opener(h.currItem.el || h.currItem)).offset(),
                            n = parseInt(e.css("padding-top"), 10),
                            o = parseInt(e.css("padding-bottom"), 10);
                        i.top -= c(window).scrollTop() - n;
                        var r = {
                            width: e.width(),
                            height: (u ? e.innerHeight() : e[0].offsetHeight) - o - n
                        };
                        return void 0 === O && (O = void 0 !== document.createElement("p").style.MozTransform), O ? r["-moz-transform"] = r.transform = "translate(" + i.left + "px," + i.top + "px)" : (r.left = i.left, r.top = i.top), r
                    }
                }
            });
            var z = "iframe",
                L = function(t) {
                    if (h.currTemplate[z]) {
                        var e = h.currTemplate[z].find("iframe");
                        e.length && (t || (e[0].src = "//about:blank"), h.isIE8 && e.css("display", t ? "block" : "none"))
                    }
                };
            c.magnificPopup.registerModule(z, {
                options: {
                    markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
                    srcAction: "iframe_src",
                    patterns: {
                        youtube: {
                            index: "youtube.com",
                            id: "v=",
                            src: "//www.youtube.com/embed/%id%?autoplay=1"
                        },
                        vimeo: {
                            index: "vimeo.com/",
                            id: "/",
                            src: "//player.vimeo.com/video/%id%?autoplay=1"
                        },
                        gmaps: {
                            index: "//maps.google.",
                            src: "%id%&output=embed"
                        }
                    }
                },
                proto: {
                    initIframe: function() {
                        h.types.push(z), y("BeforeChange", function(t, e, i) {
                            e !== i && (e === z ? L() : i === z && L(!0))
                        }), y(a + "." + z, function() {
                            L()
                        })
                    },
                    getIframe: function(t, e) {
                        var i = t.src,
                            n = h.st.iframe;
                        c.each(n.patterns, function() {
                            return -1 < i.indexOf(this.index) ? (this.id && (i = "string" == typeof this.id ? i.substr(i.lastIndexOf(this.id) + this.id.length, i.length) : this.id.call(this, i)), i = this.src.replace("%id%", i), !1) : void 0
                        });
                        var o = {};
                        return n.srcAction && (o[n.srcAction] = i), h._parseMarkup(e, o, t), h.updateStatus("ready"), e
                    }
                }
            });
            var A = function(t) {
                    var e = h.items.length;
                    return e - 1 < t ? t - e : t < 0 ? e + t : t
                },
                N = function(t, e, i) {
                    return t.replace(/%curr%/gi, e + 1).replace(/%total%/gi, i)
                };
            c.magnificPopup.registerModule("gallery", {
                options: {
                    enabled: !1,
                    arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
                    preload: [0, 2],
                    navigateByImgClick: !0,
                    arrows: !0,
                    tPrev: "Previous (Left arrow key)",
                    tNext: "Next (Right arrow key)",
                    tCounter: "%curr% of %total%"
                },
                proto: {
                    initGallery: function() {
                        var r = h.st.gallery,
                            t = ".mfp-gallery";
                        return h.direction = !0, !(!r || !r.enabled) && (f += " mfp-gallery", y("Open" + t, function() {
                            r.navigateByImgClick && h.wrap.on("click" + t, ".mfp-img", function() {
                                return 1 < h.items.length ? (h.next(), !1) : void 0
                            }), d.on("keydown" + t, function(t) {
                                37 === t.keyCode ? h.prev() : 39 === t.keyCode && h.next()
                            })
                        }), y("UpdateStatus" + t, function(t, e) {
                            e.text && (e.text = N(e.text, h.currItem.index, h.items.length))
                        }), y(p + t, function(t, e, i, n) {
                            var o = h.items.length;
                            i.counter = 1 < o ? N(r.tCounter, n.index, o) : ""
                        }), y("BuildControls" + t, function() {
                            if (1 < h.items.length && r.arrows && !h.arrowLeft) {
                                var t = r.arrowMarkup,
                                    e = h.arrowLeft = c(t.replace(/%title%/gi, r.tPrev).replace(/%dir%/gi, "left")).addClass(s),
                                    i = h.arrowRight = c(t.replace(/%title%/gi, r.tNext).replace(/%dir%/gi, "right")).addClass(s);
                                e.click(function() {
                                    h.prev()
                                }), i.click(function() {
                                    h.next()
                                }), h.container.append(e.add(i))
                            }
                        }), y("Change" + t, function() {
                            h._preloadTimeout && clearTimeout(h._preloadTimeout), h._preloadTimeout = setTimeout(function() {
                                h.preloadNearbyImages(), h._preloadTimeout = null
                            }, 16)
                        }), void y(a + t, function() {
                            d.off(t), h.wrap.off("click" + t), h.arrowRight = h.arrowLeft = null
                        }))
                    },
                    next: function() {
                        h.direction = !0, h.index = A(h.index + 1), h.updateItemHTML()
                    },
                    prev: function() {
                        h.direction = !1, h.index = A(h.index - 1), h.updateItemHTML()
                    },
                    goTo: function(t) {
                        h.direction = t >= h.index, h.index = t, h.updateItemHTML()
                    },
                    preloadNearbyImages: function() {
                        var t, e = h.st.gallery.preload,
                            i = Math.min(e[0], h.items.length),
                            n = Math.min(e[1], h.items.length);
                        for (t = 1; t <= (h.direction ? n : i); t++) h._preloadItem(h.index + t);
                        for (t = 1; t <= (h.direction ? i : n); t++) h._preloadItem(h.index - t)
                    },
                    _preloadItem: function(t) {
                        if (t = A(t), !h.items[t].preloaded) {
                            var e = h.items[t];
                            e.parsed || (e = h.parseEl(t)), b("LazyLoad", e), "image" === e.type && (e.img = c('<img class="mfp-img" />').on("load.mfploader", function() {
                                e.hasSize = !0
                            }).on("error.mfploader", function() {
                                e.hasSize = !0, e.loadError = !0, b("LazyLoadError", e)
                            }).attr("src", e.src)), e.preloaded = !0
                        }
                    }
                }
            });
            var j = "retina";
            c.magnificPopup.registerModule(j, {
                options: {
                    replaceSrc: function(t) {
                        return t.src.replace(/\.\w+$/, function(t) {
                            return "@2x" + t
                        })
                    },
                    ratio: 1
                },
                proto: {
                    initRetina: function() {
                        if (1 < window.devicePixelRatio) {
                            var i = h.st.retina,
                                n = i.ratio;
                            1 < (n = isNaN(n) ? n() : n) && (y("ImageHasSize." + j, function(t, e) {
                                e.img.css({
                                    "max-width": e.img[0].naturalWidth / n,
                                    width: "100%"
                                })
                            }), y("ElementParse." + j, function(t, e) {
                                e.src = i.replaceSrc(e, n)
                            }))
                        }
                    }
                }
            }), w()
        }),
        function(t) {
            var e = "";
            screen.width && (width = screen.width ? screen.width : "", height = screen.height ? screen.height : "", e += width + " x " + height);
            var i, n, o, r = navigator.appVersion,
                s = navigator.userAgent,
                a = navigator.appName,
                l = "" + parseFloat(navigator.appVersion),
                u = parseInt(navigator.appVersion, 10); - 1 != (n = s.indexOf("Opera")) && (a = "Opera", l = s.substring(n + 6), -1 != (n = s.indexOf("Version")) && (l = s.substring(n + 8))), -1 != (n = s.indexOf("OPR")) ? (a = "Opera", l = s.substring(n + 4)) : -1 != (n = s.indexOf("Edge")) ? (a = "Edge", l = s.substring(n + 5)) : -1 != (n = s.indexOf("MSIE")) ? (a = "Internet", l = s.substring(n + 5)) : -1 != (n = s.indexOf("Chrome")) ? (a = "Chrome", l = s.substring(n + 7)) : -1 != (n = s.indexOf("Safari")) ? (a = "Safari", l = s.substring(n + 7), -1 != (n = s.indexOf("Version")) && (l = s.substring(n + 8))) : -1 != (n = s.indexOf("Firefox")) ? (a = "Firefox", l = s.substring(n + 8)) : -1 != s.indexOf("Trident/") ? (a = "Internet", l = s.substring(s.indexOf("rv:") + 3)) : (i = s.lastIndexOf(" ") + 1) < (n = s.lastIndexOf("/")) && (a = s.substring(i, n), l = s.substring(n + 1), a.toLowerCase() == a.toUpperCase() && (a = navigator.appName)), -1 != (o = l.indexOf(";")) && (l = l.substring(0, o)), -1 != (o = l.indexOf(" ")) && (l = l.substring(0, o)), -1 != (o = l.indexOf(")")) && (l = l.substring(0, o)), u = parseInt("" + l, 10), isNaN(u) && (l = "" + parseFloat(navigator.appVersion), u = parseInt(navigator.appVersion, 10));
            var c = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(r),
                h = "-",
                d = [{
                    s: "Windows 10",
                    r: /(Windows 10.0|Windows NT 10.0)/
                }, {
                    s: "Windows 8.1",
                    r: /(Windows 8.1|Windows NT 6.3)/
                }, {
                    s: "Windows 8",
                    r: /(Windows 8|Windows NT 6.2)/
                }, {
                    s: "Windows 7",
                    r: /(Windows 7|Windows NT 6.1)/
                }, {
                    s: "Windows Vista",
                    r: /Windows NT 6.0/
                }, {
                    s: "Windows Server 2003",
                    r: /Windows NT 5.2/
                }, {
                    s: "Windows XP",
                    r: /(Windows NT 5.1|Windows XP)/
                }, {
                    s: "Windows 2000",
                    r: /(Windows NT 5.0|Windows 2000)/
                }, {
                    s: "Windows ME",
                    r: /(Win 9x 4.90|Windows ME)/
                }, {
                    s: "Windows 98",
                    r: /(Windows 98|Win98)/
                }, {
                    s: "Windows 95",
                    r: /(Windows 95|Win95|Windows_95)/
                }, {
                    s: "Windows NT 4.0",
                    r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
                }, {
                    s: "Windows CE",
                    r: /Windows CE/
                }, {
                    s: "Windows 3.11",
                    r: /Win16/
                }, {
                    s: "Android",
                    r: /Android/
                }, {
                    s: "Open BSD",
                    r: /OpenBSD/
                }, {
                    s: "Sun OS",
                    r: /SunOS/
                }, {
                    s: "Linux",
                    r: /(Linux|X11)/
                }, {
                    s: "iOS",
                    r: /(iPhone|iPad|iPod)/
                }, {
                    s: "Mac OS X",
                    r: /Mac OS X/
                }, {
                    s: "Mac OS",
                    r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
                }, {
                    s: "QNX",
                    r: /QNX/
                }, {
                    s: "UNIX",
                    r: /UNIX/
                }, {
                    s: "BeOS",
                    r: /BeOS/
                }, {
                    s: "OS/2",
                    r: /OS\/2/
                }, {
                    s: "Search Bot",
                    r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
                }];
            for (var f in d) {
                var p = d[f];
                if (p.r.test(s)) {
                    h = p.s;
                    break
                }
            }
            /Windows/.test(h) && (h = "Windows");
            var m = "no check";
            if ("undefined" != typeof swfobject) {
                var g = swfobject.getFlashPlayerVersion();
                m = 0 < g.major ? g.major + "." + g.minor + " r" + g.release : "-"
            }
            t.jscd = {
                screen: e,
                browser: a,
                browserVersion: l,
                browserMajorVersion: u,
                mobile: c,
                os: h,
                osVersion: "-",
                flashVersion: m
            }
        }(this), jQuery_T4NT("html").addClass("browser-" + jscd.browser + " platform-" + jscd.os),
        function(t) {
            var e;
            if ("function" == typeof define && define.amd && (define(t), e = !0), "object" == typeof exports && (module.exports = t(), e = !0), !e) {
                var i = window.Cookies,
                    n = window.Cookies = t();
                n.noConflict = function() {
                    return window.Cookies = i, n
                }
            }
        }(function() {
            function a() {
                for (var t = 0, e = {}; t < arguments.length; t++) {
                    var i = arguments[t];
                    for (var n in i) e[n] = i[n]
                }
                return e
            }

            function u(t) {
                return t.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent)
            }
            return function t(l) {
                function s() {}

                function i(t, e, i) {
                    if ("undefined" != typeof document) {
                        "number" == typeof(i = a({
                            path: "/"
                        }, s.defaults, i)).expires && (i.expires = new Date(1 * new Date + 864e5 * i.expires)), i.expires = i.expires ? i.expires.toUTCString() : "";
                        try {
                            var n = JSON.stringify(e);
                            /^[\{\[]/.test(n) && (e = n)
                        } catch (t) {}
                        e = l.write ? l.write(e, t) : encodeURIComponent(String(e)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), t = encodeURIComponent(String(t)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
                        var o = "";
                        for (var r in i) i[r] && (o += "; " + r, !0 !== i[r] && (o += "=" + i[r].split(";")[0]));
                        return document.cookie = t + "=" + e + o
                    }
                }

                function e(t, e) {
                    if ("undefined" != typeof document) {
                        for (var i = {}, n = document.cookie ? document.cookie.split("; ") : [], o = 0; o < n.length; o++) {
                            var r = n[o].split("="),
                                s = r.slice(1).join("=");
                            e || '"' !== s.charAt(0) || (s = s.slice(1, -1));
                            try {
                                var a = u(r[0]);
                                if (s = (l.read || l)(s, a) || u(s), e) try {
                                    s = JSON.parse(s)
                                } catch (t) {}
                                if (i[a] = s, t === a) break
                            } catch (t) {}
                        }
                        return t ? i[t] : i
                    }
                }
                return s.set = i, s.get = function(t) {
                    return e(t, !1)
                }, s.getJSON = function(t) {
                    return e(t, !0)
                }, s.remove = function(t, e) {
                    i(t, "", a(e, {
                        expires: -1
                    }))
                }, s.defaults = {}, s.withConverter = t, s
            }(function() {})
        }), ! function(t) {
            "use strict";
            "function" == typeof define && define.amd ? define(["jQuery_T4NT"], t) : t(jQuery_T4NT)
        }(function(o) {
            "use strict";
            var r = [],
                e = [],
                n = {
                    precision: 100,
                    elapse: !1,
                    defer: !1
                };
            e.push(/^[0-9]*$/.source), e.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source), e.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source), e = new RegExp(e.join("|"));
            var m = {
                    Y: "years",
                    m: "months",
                    n: "daysToMonth",
                    d: "daysToWeek",
                    w: "weeks",
                    W: "weeksToMonth",
                    H: "hours",
                    M: "minutes",
                    S: "seconds",
                    D: "totalDays",
                    I: "totalHours",
                    N: "totalMinutes",
                    T: "totalSeconds"
                },
                s = function(t, e, i) {
                    this.el = t, this.$el = o(t), this.interval = null, this.offset = {}, this.options = o.extend({}, n), this.firstTick = !0, this.instanceNumber = r.length, r.push(this), this.$el.data("countdown-instance", this.instanceNumber), i && ("function" == typeof i ? (this.$el.on("update.countdown", i), this.$el.on("stoped.countdown", i), this.$el.on("finish.countdown", i)) : this.options = o.extend({}, n, i)), this.setFinalDate(e), !1 === this.options.defer && this.start()
                };
            o.extend(s.prototype, {
                start: function() {
                    null !== this.interval && clearInterval(this.interval);
                    var t = this;
                    this.update(), this.interval = setInterval(function() {
                        t.update.call(t)
                    }, this.options.precision)
                },
                stop: function() {
                    clearInterval(this.interval), this.interval = null, this.dispatchEvent("stoped")
                },
                toggle: function() {
                    this.interval ? this.stop() : this.start()
                },
                pause: function() {
                    this.stop()
                },
                resume: function() {
                    this.start()
                },
                remove: function() {
                    this.stop.call(this), r[this.instanceNumber] = null, delete this.$el.data().countdownInstance
                },
                setFinalDate: function(t) {
                    this.finalDate = function(t) {
                        if (t instanceof Date) return t;
                        if (String(t).match(e)) return String(t).match(/^[0-9]*$/) && (t = Number(t)), String(t).match(/\-/) && (t = String(t).replace(/\-/g, "/")), new Date(t);
                        throw new Error("Couldn't cast `" + t + "` to a date object.")
                    }(t)
                },
                update: function() {
                    if (0 !== this.$el.closest("html").length) {
                        var t, e = new Date;
                        t = this.finalDate.getTime() - e.getTime(), t = Math.ceil(t / 1e3), t = !this.options.elapse && t < 0 ? 0 : Math.abs(t), this.totalSecsLeft === t || this.firstTick ? this.firstTick = !1 : (this.totalSecsLeft = t, this.elapsed = e >= this.finalDate, this.offset = {
                            seconds: this.totalSecsLeft % 60,
                            minutes: Math.floor(this.totalSecsLeft / 60) % 60,
                            hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
                            days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                            daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                            daysToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 % 30.4368),
                            weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
                            weeksToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7) % 4,
                            months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
                            years: Math.abs(this.finalDate.getFullYear() - e.getFullYear()),
                            totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
                            totalHours: Math.floor(this.totalSecsLeft / 60 / 60),
                            totalMinutes: Math.floor(this.totalSecsLeft / 60),
                            totalSeconds: this.totalSecsLeft
                        }, this.options.elapse || 0 !== this.totalSecsLeft ? this.dispatchEvent("update") : (this.stop(), this.dispatchEvent("finish")))
                    } else this.remove()
                },
                dispatchEvent: function(t) {
                    var p, e = o.Event(t + ".countdown");
                    e.finalDate = this.finalDate, e.elapsed = this.elapsed, e.offset = o.extend({}, this.offset), e.strftime = (p = this.offset, function(t) {
                        var e, i, n, o, r, s = t.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
                        if (s)
                            for (var a = 0, l = s.length; a < l; ++a) {
                                var u = s[a].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),
                                    c = (e = u[0].toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"), new RegExp(e)),
                                    h = u[1] || "",
                                    d = u[3] || "",
                                    f = null;
                                u = u[2], m.hasOwnProperty(u) && (f = m[u], f = Number(p[f])), null !== f && ("!" === h && (n = f, r = o = void 0, o = "s", r = "", (i = d) && (o = 1 === (i = i.replace(/(:|;|\s)/gi, "").split(/\,/)).length ? i[0] : (r = i[0], i[1])), f = 1 < Math.abs(n) ? o : r), "" === h && f < 10 && (f = "0" + f.toString()), t = t.replace(c, f.toString()))
                            }
                        return t.replace(/%%/, "%")
                    }), this.$el.trigger(e)
                }
            }), o.fn.countdown = function() {
                var n = Array.prototype.slice.call(arguments, 0);
                return this.each(function() {
                    var t = o(this).data("countdown-instance");
                    if (void 0 !== t) {
                        var e = r[t],
                            i = n[0];
                        s.prototype.hasOwnProperty(i) ? e[i].apply(e, n.slice(1)) : null === String(i).match(/^[$A-Z_][0-9A-Z_$]*$/i) ? (e.setFinalDate.call(e, i), e.start()) : o.error("Method %s does not exist on jQuery_T4NT.countdown".replace(/\%s/gi, i))
                    } else new s(this, n[0], n[1])
                })
            }
        }),
        function(t, e) {
            "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.moment = e()
        }(this, function() {
            "use strict";
            var t, o;

            function b() {
                return t.apply(null, arguments)
            }

            function c(t) {
                return t instanceof Array || "[object Array]" === Object.prototype.toString.call(t)
            }

            function h(t) {
                return null != t && "[object Object]" === Object.prototype.toString.call(t)
            }

            function x(t, e) {
                return Object.prototype.hasOwnProperty.call(t, e)
            }

            function d(t) {
                if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(t).length;
                for (var e in t)
                    if (x(t, e)) return;
                return 1
            }

            function f(t) {
                return void 0 === t
            }

            function p(t) {
                return "number" == typeof t || "[object Number]" === Object.prototype.toString.call(t)
            }

            function m(t) {
                return t instanceof Date || "[object Date]" === Object.prototype.toString.call(t)
            }

            function g(t, e) {
                for (var i = [], n = 0; n < t.length; ++n) i.push(e(t[n], n));
                return i
            }

            function y(t, e) {
                for (var i in e) x(e, i) && (t[i] = e[i]);
                return x(e, "toString") && (t.toString = e.toString), x(e, "valueOf") && (t.valueOf = e.valueOf), t
            }

            function v(t, e, i, n) {
                return Ee(t, e, i, n, !0).utc()
            }

            function w(t) {
                return null == t._pf && (t._pf = {
                    empty: !1,
                    unusedTokens: [],
                    unusedInput: [],
                    overflow: -2,
                    charsLeftOver: 0,
                    nullInput: !1,
                    invalidEra: null,
                    invalidMonth: null,
                    invalidFormat: !1,
                    userInvalidated: !1,
                    iso: !1,
                    parsedDateParts: [],
                    era: null,
                    meridiem: null,
                    rfc2822: !1,
                    weekdayMismatch: !1
                }), t._pf
            }

            function _(t) {
                if (null == t._isValid) {
                    var e = w(t),
                        i = o.call(e.parsedDateParts, function(t) {
                            return null != t
                        }),
                        n = !isNaN(t._d.getTime()) && e.overflow < 0 && !e.empty && !e.invalidEra && !e.invalidMonth && !e.invalidWeekday && !e.weekdayMismatch && !e.nullInput && !e.invalidFormat && !e.userInvalidated && (!e.meridiem || e.meridiem && i);
                    if (t._strict && (n = n && 0 === e.charsLeftOver && 0 === e.unusedTokens.length && void 0 === e.bigHour), null != Object.isFrozen && Object.isFrozen(t)) return n;
                    t._isValid = n
                }
                return t._isValid
            }

            function S(t) {
                var e = v(NaN);
                return null != t ? y(w(e), t) : w(e).userInvalidated = !0, e
            }
            o = Array.prototype.some ? Array.prototype.some : function(t) {
                for (var e = Object(this), i = e.length >>> 0, n = 0; n < i; n++)
                    if (n in e && t.call(this, e[n], n, e)) return !0;
                return !1
            };
            var r = b.momentProperties = [],
                e = !1;

            function T(t, e) {
                var i, n, o;
                if (f(e._isAMomentObject) || (t._isAMomentObject = e._isAMomentObject), f(e._i) || (t._i = e._i), f(e._f) || (t._f = e._f), f(e._l) || (t._l = e._l), f(e._strict) || (t._strict = e._strict), f(e._tzm) || (t._tzm = e._tzm), f(e._isUTC) || (t._isUTC = e._isUTC), f(e._offset) || (t._offset = e._offset), f(e._pf) || (t._pf = w(e)), f(e._locale) || (t._locale = e._locale), 0 < r.length)
                    for (i = 0; i < r.length; i++) f(o = e[n = r[i]]) || (t[n] = o);
                return t
            }

            function E(t) {
                T(this, t), this._d = new Date(null != t._d ? t._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === e && (e = !0, b.updateOffset(this), e = !1)
            }

            function C(t) {
                return t instanceof E || null != t && null != t._isAMomentObject
            }

            function a(t) {
                !1 === b.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + t)
            }

            function i(o, r) {
                var s = !0;
                return y(function() {
                    if (null != b.deprecationHandler && b.deprecationHandler(null, o), s) {
                        for (var t, e, i = [], n = 0; n < arguments.length; n++) {
                            if (t = "", "object" == typeof arguments[n]) {
                                for (e in t += "\n[" + n + "] ", arguments[0]) x(arguments[0], e) && (t += e + ": " + arguments[0][e] + ", ");
                                t = t.slice(0, -2)
                            } else t = arguments[n];
                            i.push(t)
                        }
                        a(o + "\nArguments: " + Array.prototype.slice.call(i).join("") + "\n" + (new Error).stack), s = !1
                    }
                    return r.apply(this, arguments)
                }, r)
            }
            var n, s = {};

            function l(t, e) {
                null != b.deprecationHandler && b.deprecationHandler(t, e), s[t] || (a(e), s[t] = !0)
            }

            function k(t) {
                return "undefined" != typeof Function && t instanceof Function || "[object Function]" === Object.prototype.toString.call(t)
            }

            function u(t, e) {
                var i, n = y({}, t);
                for (i in e) x(e, i) && (h(t[i]) && h(e[i]) ? (n[i] = {}, y(n[i], t[i]), y(n[i], e[i])) : null != e[i] ? n[i] = e[i] : delete n[i]);
                for (i in t) x(t, i) && !x(e, i) && h(t[i]) && (n[i] = y({}, n[i]));
                return n
            }

            function D(t) {
                null != t && this.set(t)
            }

            function I(t, e, i) {
                var n = "" + Math.abs(t),
                    o = e - n.length;
                return (0 <= t ? i ? "+" : "" : "-") + Math.pow(10, Math.max(0, o)).toString().substr(1) + n
            }
            b.suppressDeprecationWarnings = !1, b.deprecationHandler = null, n = Object.keys ? Object.keys : function(t) {
                var e, i = [];
                for (e in t) x(t, e) && i.push(e);
                return i
            };
            var M = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
                P = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
                O = {},
                z = {};

            function L(t, e, i, n) {
                var o = "string" == typeof n ? function() {
                    return this[n]()
                } : n;
                t && (z[t] = o), e && (z[e[0]] = function() {
                    return I(o.apply(this, arguments), e[1], e[2])
                }), i && (z[i] = function() {
                    return this.localeData().ordinal(o.apply(this, arguments), t)
                })
            }

            function A(t, e) {
                return t.isValid() ? (e = N(e, t.localeData()), O[e] = O[e] || function(n) {
                    for (var t, o = n.match(M), e = 0, r = o.length; e < r; e++) z[o[e]] ? o[e] = z[o[e]] : o[e] = (t = o[e]).match(/\[[\s\S]/) ? t.replace(/^\[|\]$/g, "") : t.replace(/\\/g, "");
                    return function(t) {
                        for (var e = "", i = 0; i < r; i++) e += k(o[i]) ? o[i].call(t, n) : o[i];
                        return e
                    }
                }(e), O[e](t)) : t.localeData().invalidDate()
            }

            function N(t, e) {
                var i = 5;

                function n(t) {
                    return e.longDateFormat(t) || t
                }
                for (P.lastIndex = 0; 0 <= i && P.test(t);) t = t.replace(P, n), P.lastIndex = 0, --i;
                return t
            }
            var j = {};

            function W(t, e) {
                var i = t.toLowerCase();
                j[i] = j[i + "s"] = j[e] = t
            }

            function R(t) {
                return "string" == typeof t ? j[t] || j[t.toLowerCase()] : void 0
            }

            function F(t) {
                var e, i, n = {};
                for (i in t) x(t, i) && (e = R(i)) && (n[e] = t[i]);
                return n
            }
            var H = {};

            function Y(t, e) {
                H[t] = e
            }

            function q(t) {
                return t % 4 == 0 && t % 100 != 0 || t % 400 == 0
            }

            function B(t) {
                return t < 0 ? Math.ceil(t) || 0 : Math.floor(t)
            }

            function U(t) {
                var e = +t,
                    i = 0;
                return 0 != e && isFinite(e) && (i = B(e)), i
            }

            function $(e, i) {
                return function(t) {
                    return null != t ? (G(this, e, t), b.updateOffset(this, i), this) : V(this, e)
                }
            }

            function V(t, e) {
                return t.isValid() ? t._d["get" + (t._isUTC ? "UTC" : "") + e]() : NaN
            }

            function G(t, e, i) {
                t.isValid() && !isNaN(i) && ("FullYear" === e && q(t.year()) && 1 === t.month() && 29 === t.date() ? (i = U(i), t._d["set" + (t._isUTC ? "UTC" : "") + e](i, t.month(), kt(i, t.month()))) : t._d["set" + (t._isUTC ? "UTC" : "") + e](i))
            }
            var Q, X = /\d/,
                Z = /\d\d/,
                J = /\d{3}/,
                K = /\d{4}/,
                tt = /[+-]?\d{6}/,
                et = /\d\d?/,
                it = /\d\d\d\d?/,
                nt = /\d\d\d\d\d\d?/,
                ot = /\d{1,3}/,
                rt = /\d{1,4}/,
                st = /[+-]?\d{1,6}/,
                at = /\d+/,
                lt = /[+-]?\d+/,
                ut = /Z|[+-]\d\d:?\d\d/gi,
                ct = /Z|[+-]\d\d(?::?\d\d)?/gi,
                ht = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

            function dt(t, i, n) {
                Q[t] = k(i) ? i : function(t, e) {
                    return t && n ? n : i
                }
            }

            function ft(t) {
                return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
            }
            Q = {};
            var pt = {};

            function mt(t, i) {
                var e, n = i;
                for ("string" == typeof t && (t = [t]), p(i) && (n = function(t, e) {
                        e[i] = U(t)
                    }), e = 0; e < t.length; e++) pt[t[e]] = n
            }

            function gt(t, o) {
                mt(t, function(t, e, i, n) {
                    i._w = i._w || {}, o(t, i._w, i, n)
                })
            }
            var yt, vt = 0,
                bt = 1,
                xt = 2,
                wt = 3,
                _t = 4,
                St = 5,
                Tt = 6,
                Et = 7,
                Ct = 8;

            function kt(t, e) {
                if (isNaN(t) || isNaN(e)) return NaN;
                var i = (e % 12 + 12) % 12;
                return t += (e - i) / 12, 1 == i ? q(t) ? 29 : 28 : 31 - i % 7 % 2
            }
            yt = Array.prototype.indexOf ? Array.prototype.indexOf : function(t) {
                for (var e = 0; e < this.length; ++e)
                    if (this[e] === t) return e;
                return -1
            }, L("M", ["MM", 2], "Mo", function() {
                return this.month() + 1
            }), L("MMM", 0, 0, function(t) {
                return this.localeData().monthsShort(this, t)
            }), L("MMMM", 0, 0, function(t) {
                return this.localeData().months(this, t)
            }), W("month", "M"), Y("month", 8), dt("M", et), dt("MM", et, Z), dt("MMM", function(t, e) {
                return e.monthsShortRegex(t)
            }), dt("MMMM", function(t, e) {
                return e.monthsRegex(t)
            }), mt(["M", "MM"], function(t, e) {
                e[bt] = U(t) - 1
            }), mt(["MMM", "MMMM"], function(t, e, i, n) {
                var o = i._locale.monthsParse(t, n, i._strict);
                null != o ? e[bt] = o : w(i).invalidMonth = t
            });
            var Dt = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
                It = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
                Mt = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
                Pt = ht,
                Ot = ht;

            function zt(t, e) {
                var i;
                if (!t.isValid()) return t;
                if ("string" == typeof e)
                    if (/^\d+$/.test(e)) e = U(e);
                    else if (!p(e = t.localeData().monthsParse(e))) return t;
                return i = Math.min(t.date(), kt(t.year(), e)), t._d["set" + (t._isUTC ? "UTC" : "") + "Month"](e, i), t
            }

            function Lt(t) {
                return null != t ? (zt(this, t), b.updateOffset(this, !0), this) : V(this, "Month")
            }

            function At() {
                function t(t, e) {
                    return e.length - t.length
                }
                for (var e, i = [], n = [], o = [], r = 0; r < 12; r++) e = v([2e3, r]), i.push(this.monthsShort(e, "")), n.push(this.months(e, "")), o.push(this.months(e, "")), o.push(this.monthsShort(e, ""));
                for (i.sort(t), n.sort(t), o.sort(t), r = 0; r < 12; r++) i[r] = ft(i[r]), n[r] = ft(n[r]);
                for (r = 0; r < 24; r++) o[r] = ft(o[r]);
                this._monthsRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + i.join("|") + ")", "i")
            }

            function Nt(t) {
                return q(t) ? 366 : 365
            }
            L("Y", 0, 0, function() {
                var t = this.year();
                return t <= 9999 ? I(t, 4) : "+" + t
            }), L(0, ["YY", 2], 0, function() {
                return this.year() % 100
            }), L(0, ["YYYY", 4], 0, "year"), L(0, ["YYYYY", 5], 0, "year"), L(0, ["YYYYYY", 6, !0], 0, "year"), W("year", "y"), Y("year", 1), dt("Y", lt), dt("YY", et, Z), dt("YYYY", rt, K), dt("YYYYY", st, tt), dt("YYYYYY", st, tt), mt(["YYYYY", "YYYYYY"], vt), mt("YYYY", function(t, e) {
                e[vt] = 2 === t.length ? b.parseTwoDigitYear(t) : U(t)
            }), mt("YY", function(t, e) {
                e[vt] = b.parseTwoDigitYear(t)
            }), mt("Y", function(t, e) {
                e[vt] = parseInt(t, 10)
            }), b.parseTwoDigitYear = function(t) {
                return U(t) + (68 < U(t) ? 1900 : 2e3)
            };
            var jt = $("FullYear", !0);

            function Wt(t) {
                var e, i;
                return t < 100 && 0 <= t ? ((i = Array.prototype.slice.call(arguments))[0] = t + 400, e = new Date(Date.UTC.apply(null, i)), isFinite(e.getUTCFullYear()) && e.setUTCFullYear(t)) : e = new Date(Date.UTC.apply(null, arguments)), e
            }

            function Rt(t, e, i) {
                var n = 7 + e - i;
                return n - (7 + Wt(t, 0, n).getUTCDay() - e) % 7 - 1
            }

            function Ft(t, e, i, n, o) {
                var r, s = 1 + 7 * (e - 1) + (7 + i - n) % 7 + Rt(t, n, o),
                    a = s <= 0 ? Nt(r = t - 1) + s : s > Nt(t) ? (r = t + 1, s - Nt(t)) : (r = t, s);
                return {
                    year: r,
                    dayOfYear: a
                }
            }

            function Ht(t, e, i) {
                var n, o, r = Rt(t.year(), e, i),
                    s = Math.floor((t.dayOfYear() - r - 1) / 7) + 1;
                return s < 1 ? n = s + Yt(o = t.year() - 1, e, i) : s > Yt(t.year(), e, i) ? (n = s - Yt(t.year(), e, i), o = t.year() + 1) : (o = t.year(), n = s), {
                    week: n,
                    year: o
                }
            }

            function Yt(t, e, i) {
                var n = Rt(t, e, i),
                    o = Rt(t + 1, e, i);
                return (Nt(t) - n + o) / 7
            }

            function qt(t, e) {
                return t.slice(e, 7).concat(t.slice(0, e))
            }
            L("w", ["ww", 2], "wo", "week"), L("W", ["WW", 2], "Wo", "isoWeek"), W("week", "w"), W("isoWeek", "W"), Y("week", 5), Y("isoWeek", 5), dt("w", et), dt("ww", et, Z), dt("W", et), dt("WW", et, Z), gt(["w", "ww", "W", "WW"], function(t, e, i, n) {
                e[n.substr(0, 1)] = U(t)
            }), L("d", 0, "do", "day"), L("dd", 0, 0, function(t) {
                return this.localeData().weekdaysMin(this, t)
            }), L("ddd", 0, 0, function(t) {
                return this.localeData().weekdaysShort(this, t)
            }), L("dddd", 0, 0, function(t) {
                return this.localeData().weekdays(this, t)
            }), L("e", 0, 0, "weekday"), L("E", 0, 0, "isoWeekday"), W("day", "d"), W("weekday", "e"), W("isoWeekday", "E"), Y("day", 11), Y("weekday", 11), Y("isoWeekday", 11), dt("d", et), dt("e", et), dt("E", et), dt("dd", function(t, e) {
                return e.weekdaysMinRegex(t)
            }), dt("ddd", function(t, e) {
                return e.weekdaysShortRegex(t)
            }), dt("dddd", function(t, e) {
                return e.weekdaysRegex(t)
            }), gt(["dd", "ddd", "dddd"], function(t, e, i, n) {
                var o = i._locale.weekdaysParse(t, n, i._strict);
                null != o ? e.d = o : w(i).invalidWeekday = t
            }), gt(["d", "e", "E"], function(t, e, i, n) {
                e[n] = U(t)
            });
            var Bt = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
                Ut = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
                $t = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
                Vt = ht,
                Gt = ht,
                Qt = ht;

            function Xt() {
                function t(t, e) {
                    return e.length - t.length
                }
                for (var e, i, n, o, r = [], s = [], a = [], l = [], u = 0; u < 7; u++) e = v([2e3, 1]).day(u), i = ft(this.weekdaysMin(e, "")), n = ft(this.weekdaysShort(e, "")), o = ft(this.weekdays(e, "")), r.push(i), s.push(n), a.push(o), l.push(i), l.push(n), l.push(o);
                r.sort(t), s.sort(t), a.sort(t), l.sort(t), this._weekdaysRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + r.join("|") + ")", "i")
            }

            function Zt() {
                return this.hours() % 12 || 12
            }

            function Jt(t, e) {
                L(t, 0, 0, function() {
                    return this.localeData().meridiem(this.hours(), this.minutes(), e)
                })
            }

            function Kt(t, e) {
                return e._meridiemParse
            }
            L("H", ["HH", 2], 0, "hour"), L("h", ["hh", 2], 0, Zt), L("k", ["kk", 2], 0, function() {
                return this.hours() || 24
            }), L("hmm", 0, 0, function() {
                return "" + Zt.apply(this) + I(this.minutes(), 2)
            }), L("hmmss", 0, 0, function() {
                return "" + Zt.apply(this) + I(this.minutes(), 2) + I(this.seconds(), 2)
            }), L("Hmm", 0, 0, function() {
                return "" + this.hours() + I(this.minutes(), 2)
            }), L("Hmmss", 0, 0, function() {
                return "" + this.hours() + I(this.minutes(), 2) + I(this.seconds(), 2)
            }), Jt("a", !0), Jt("A", !1), W("hour", "h"), Y("hour", 13), dt("a", Kt), dt("A", Kt), dt("H", et), dt("h", et), dt("k", et), dt("HH", et, Z), dt("hh", et, Z), dt("kk", et, Z), dt("hmm", it), dt("hmmss", nt), dt("Hmm", it), dt("Hmmss", nt), mt(["H", "HH"], wt), mt(["k", "kk"], function(t, e, i) {
                var n = U(t);
                e[wt] = 24 === n ? 0 : n
            }), mt(["a", "A"], function(t, e, i) {
                i._isPm = i._locale.isPM(t), i._meridiem = t
            }), mt(["h", "hh"], function(t, e, i) {
                e[wt] = U(t), w(i).bigHour = !0
            }), mt("hmm", function(t, e, i) {
                var n = t.length - 2;
                e[wt] = U(t.substr(0, n)), e[_t] = U(t.substr(n)), w(i).bigHour = !0
            }), mt("hmmss", function(t, e, i) {
                var n = t.length - 4,
                    o = t.length - 2;
                e[wt] = U(t.substr(0, n)), e[_t] = U(t.substr(n, 2)), e[St] = U(t.substr(o)), w(i).bigHour = !0
            }), mt("Hmm", function(t, e, i) {
                var n = t.length - 2;
                e[wt] = U(t.substr(0, n)), e[_t] = U(t.substr(n))
            }), mt("Hmmss", function(t, e, i) {
                var n = t.length - 4,
                    o = t.length - 2;
                e[wt] = U(t.substr(0, n)), e[_t] = U(t.substr(n, 2)), e[St] = U(t.substr(o))
            });
            var te, ee = $("Hours", !0),
                ie = {
                    calendar: {
                        sameDay: "[Today at] LT",
                        nextDay: "[Tomorrow at] LT",
                        nextWeek: "dddd [at] LT",
                        lastDay: "[Yesterday at] LT",
                        lastWeek: "[Last] dddd [at] LT",
                        sameElse: "L"
                    },
                    longDateFormat: {
                        LTS: "h:mm:ss A",
                        LT: "h:mm A",
                        L: "MM/DD/YYYY",
                        LL: "MMMM D, YYYY",
                        LLL: "MMMM D, YYYY h:mm A",
                        LLLL: "dddd, MMMM D, YYYY h:mm A"
                    },
                    invalidDate: "Invalid date",
                    ordinal: "%d",
                    dayOfMonthOrdinalParse: /\d{1,2}/,
                    relativeTime: {
                        future: "in %s",
                        past: "%s ago",
                        s: "a few seconds",
                        ss: "%d seconds",
                        m: "a minute",
                        mm: "%d minutes",
                        h: "an hour",
                        hh: "%d hours",
                        d: "a day",
                        dd: "%d days",
                        w: "a week",
                        ww: "%d weeks",
                        M: "a month",
                        MM: "%d months",
                        y: "a year",
                        yy: "%d years"
                    },
                    months: Dt,
                    monthsShort: It,
                    week: {
                        dow: 0,
                        doy: 6
                    },
                    weekdays: Bt,
                    weekdaysMin: $t,
                    weekdaysShort: Ut,
                    meridiemParse: /[ap]\.?m?\.?/i
                },
                ne = {},
                oe = {};

            function re(t) {
                return t ? t.toLowerCase().replace("_", "-") : t
            }

            function se(t) {
                var e;
                if (void 0 === ne[t] && "undefined" != typeof module && module && module.exports) try {
                    e = te._abbr, require("./locale/" + t), ae(e)
                } catch (e) {
                    ne[t] = null
                }
                return ne[t]
            }

            function ae(t, e) {
                var i;
                return t && ((i = f(e) ? ue(t) : le(t, e)) ? te = i : "undefined" != typeof console && console.warn && console.warn("Locale " + t + " not found. Did you forget to load it?")), te._abbr
            }

            function le(t, e) {
                if (null === e) return delete ne[t], null;
                var i, n = ie;
                if (e.abbr = t, null != ne[t]) l("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), n = ne[t]._config;
                else if (null != e.parentLocale)
                    if (null != ne[e.parentLocale]) n = ne[e.parentLocale]._config;
                    else {
                        if (null == (i = se(e.parentLocale))) return oe[e.parentLocale] || (oe[e.parentLocale] = []), oe[e.parentLocale].push({
                            name: t,
                            config: e
                        }), null;
                        n = i._config
                    } return ne[t] = new D(u(n, e)), oe[t] && oe[t].forEach(function(t) {
                    le(t.name, t.config)
                }), ae(t), ne[t]
            }

            function ue(t) {
                var e;
                if (t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t) return te;
                if (!c(t)) {
                    if (e = se(t)) return e;
                    t = [t]
                }
                return function(t) {
                    for (var e, i, n, o, r = 0; r < t.length;) {
                        for (e = (o = re(t[r]).split("-")).length, i = (i = re(t[r + 1])) ? i.split("-") : null; 0 < e;) {
                            if (n = se(o.slice(0, e).join("-"))) return n;
                            if (i && i.length >= e && function(t, e) {
                                    for (var i = Math.min(t.length, e.length), n = 0; n < i; n += 1)
                                        if (t[n] !== e[n]) return n;
                                    return i
                                }(o, i) >= e - 1) break;
                            e--
                        }
                        r++
                    }
                    return te
                }(t)
            }

            function ce(t) {
                var e, i = t._a;
                return i && -2 === w(t).overflow && (e = i[bt] < 0 || 11 < i[bt] ? bt : i[xt] < 1 || i[xt] > kt(i[vt], i[bt]) ? xt : i[wt] < 0 || 24 < i[wt] || 24 === i[wt] && (0 !== i[_t] || 0 !== i[St] || 0 !== i[Tt]) ? wt : i[_t] < 0 || 59 < i[_t] ? _t : i[St] < 0 || 59 < i[St] ? St : i[Tt] < 0 || 999 < i[Tt] ? Tt : -1, w(t)._overflowDayOfYear && (e < vt || xt < e) && (e = xt), w(t)._overflowWeeks && -1 === e && (e = Et), w(t)._overflowWeekday && -1 === e && (e = Ct), w(t).overflow = e), t
            }
            var he = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
                de = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
                fe = /Z|[+-]\d\d(?::?\d\d)?/,
                pe = [
                    ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
                    ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
                    ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
                    ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
                    ["YYYY-DDD", /\d{4}-\d{3}/],
                    ["YYYY-MM", /\d{4}-\d\d/, !1],
                    ["YYYYYYMMDD", /[+-]\d{10}/],
                    ["YYYYMMDD", /\d{8}/],
                    ["GGGG[W]WWE", /\d{4}W\d{3}/],
                    ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
                    ["YYYYDDD", /\d{7}/],
                    ["YYYYMM", /\d{6}/, !1],
                    ["YYYY", /\d{4}/, !1]
                ],
                me = [
                    ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
                    ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
                    ["HH:mm:ss", /\d\d:\d\d:\d\d/],
                    ["HH:mm", /\d\d:\d\d/],
                    ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
                    ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
                    ["HHmmss", /\d\d\d\d\d\d/],
                    ["HHmm", /\d\d\d\d/],
                    ["HH", /\d\d/]
                ],
                ge = /^\/?Date\((-?\d+)/i,
                ye = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
                ve = {
                    UT: 0,
                    GMT: 0,
                    EDT: -240,
                    EST: -300,
                    CDT: -300,
                    CST: -360,
                    MDT: -360,
                    MST: -420,
                    PDT: -420,
                    PST: -480
                };

            function be(t) {
                var e, i, n, o, r, s, a = t._i,
                    l = he.exec(a) || de.exec(a);
                if (l) {
                    for (w(t).iso = !0, e = 0, i = pe.length; e < i; e++)
                        if (pe[e][1].exec(l[1])) {
                            o = pe[e][0], n = !1 !== pe[e][2];
                            break
                        } if (null == o) return void(t._isValid = !1);
                    if (l[3]) {
                        for (e = 0, i = me.length; e < i; e++)
                            if (me[e][1].exec(l[3])) {
                                r = (l[2] || " ") + me[e][0];
                                break
                            } if (null == r) return void(t._isValid = !1)
                    }
                    if (!n && null != r) return void(t._isValid = !1);
                    if (l[4]) {
                        if (!fe.exec(l[4])) return void(t._isValid = !1);
                        s = "Z"
                    }
                    t._f = o + (r || "") + (s || ""), Se(t)
                } else t._isValid = !1
            }

            function xe(t) {
                var e, i, n, o, r, s, a, l, u, c, h, d, f = ye.exec(t._i.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, ""));
                if (f) {
                    if (r = f[4], s = f[3], a = f[2], l = f[5], u = f[6], c = f[7], d = [(h = parseInt(r, 10), h <= 49 ? 2e3 + h : h <= 999 ? 1900 + h : h), It.indexOf(s), parseInt(a, 10), parseInt(l, 10), parseInt(u, 10)], c && d.push(parseInt(c, 10)), n = e = d, o = t, (i = f[1]) && Ut.indexOf(i) !== new Date(n[0], n[1], n[2]).getDay() && (w(o).weekdayMismatch = !0, !void(o._isValid = !1))) return;
                    t._a = e, t._tzm = function(t, e, i) {
                        if (t) return ve[t];
                        if (e) return 0;
                        var n = parseInt(i, 10),
                            o = n % 100;
                        return (n - o) / 100 * 60 + o
                    }(f[8], f[9], f[10]), t._d = Wt.apply(null, t._a), t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), w(t).rfc2822 = !0
                } else t._isValid = !1
            }

            function we(t, e, i) {
                return null != t ? t : null != e ? e : i
            }

            function _e(t) {
                var e, i, n, o, r, s, a, l, u, c, h, d, f, p, m, g, y, v = [];
                if (!t._d) {
                    for (s = t, a = new Date(b.now()), n = s._useUTC ? [a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()] : [a.getFullYear(), a.getMonth(), a.getDate()], t._w && null == t._a[xt] && null == t._a[bt] && (y = g = m = p = f = d = h = c = void 0, null != (u = (l = t)._w).GG || null != u.W || null != u.E ? (f = 1, p = 4, c = we(u.GG, l._a[vt], Ht(Ce(), 1, 4).year), h = we(u.W, 1), ((d = we(u.E, 1)) < 1 || 7 < d) && (g = !0)) : (f = l._locale._week.dow, p = l._locale._week.doy, y = Ht(Ce(), f, p), c = we(u.gg, l._a[vt], y.year), h = we(u.w, y.week), null != u.d ? ((d = u.d) < 0 || 6 < d) && (g = !0) : null != u.e ? (d = u.e + f, (u.e < 0 || 6 < u.e) && (g = !0)) : d = f), h < 1 || h > Yt(c, f, p) ? w(l)._overflowWeeks = !0 : null != g ? w(l)._overflowWeekday = !0 : (m = Ft(c, h, d, f, p), l._a[vt] = m.year, l._dayOfYear = m.dayOfYear)), null != t._dayOfYear && (r = we(t._a[vt], n[vt]), (t._dayOfYear > Nt(r) || 0 === t._dayOfYear) && (w(t)._overflowDayOfYear = !0), i = Wt(r, 0, t._dayOfYear), t._a[bt] = i.getUTCMonth(), t._a[xt] = i.getUTCDate()), e = 0; e < 3 && null == t._a[e]; ++e) t._a[e] = v[e] = n[e];
                    for (; e < 7; e++) t._a[e] = v[e] = null == t._a[e] ? 2 === e ? 1 : 0 : t._a[e];
                    24 === t._a[wt] && 0 === t._a[_t] && 0 === t._a[St] && 0 === t._a[Tt] && (t._nextDay = !0, t._a[wt] = 0), t._d = (t._useUTC ? Wt : function(t, e, i, n, o, r, s) {
                        var a;
                        return t < 100 && 0 <= t ? (a = new Date(t + 400, e, i, n, o, r, s), isFinite(a.getFullYear()) && a.setFullYear(t)) : a = new Date(t, e, i, n, o, r, s), a
                    }).apply(null, v), o = t._useUTC ? t._d.getUTCDay() : t._d.getDay(), null != t._tzm && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), t._nextDay && (t._a[wt] = 24), t._w && void 0 !== t._w.d && t._w.d !== o && (w(t).weekdayMismatch = !0)
                }
            }

            function Se(t) {
                if (t._f !== b.ISO_8601)
                    if (t._f !== b.RFC_2822) {
                        t._a = [], w(t).empty = !0;
                        for (var e, i, n, o, r, s, a, l = "" + t._i, u = l.length, c = 0, h = N(t._f, t._locale).match(M) || [], d = 0; d < h.length; d++) i = h[d], (e = (l.match((y = i, v = t, x(Q, y) ? Q[y](v._strict, v._locale) : new RegExp(ft(y.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(t, e, i, n, o) {
                            return e || i || n || o
                        }))))) || [])[0]) && (0 < (n = l.substr(0, l.indexOf(e))).length && w(t).unusedInput.push(n), l = l.slice(l.indexOf(e) + e.length), c += e.length), z[i] ? (e ? w(t).empty = !1 : w(t).unusedTokens.push(i), r = i, a = t, null != (s = e) && x(pt, r) && pt[r](s, a._a, a, r)) : t._strict && !e && w(t).unusedTokens.push(i);
                        w(t).charsLeftOver = u - c, 0 < l.length && w(t).unusedInput.push(l), t._a[wt] <= 12 && !0 === w(t).bigHour && 0 < t._a[wt] && (w(t).bigHour = void 0), w(t).parsedDateParts = t._a.slice(0), w(t).meridiem = t._meridiem, t._a[wt] = (f = t._locale, p = t._a[wt], null == (m = t._meridiem) ? p : null != f.meridiemHour ? f.meridiemHour(p, m) : (null != f.isPM && ((g = f.isPM(m)) && p < 12 && (p += 12), g || 12 !== p || (p = 0)), p)), null !== (o = w(t).era) && (t._a[vt] = t._locale.erasConvertYear(o, t._a[vt])), _e(t), ce(t)
                    } else xe(t);
                else be(t);
                var f, p, m, g, y, v
            }

            function Te(t) {
                var e, i, n, o, r, s, a, l = t._i,
                    u = t._f;
                return t._locale = t._locale || ue(t._l), null === l || void 0 === u && "" === l ? S({
                    nullInput: !0
                }) : ("string" == typeof l && (t._i = l = t._locale.preparse(l)), C(l) ? new E(ce(l)) : (m(l) ? t._d = l : c(u) ? function(t) {
                    var e, i, n, o, r, s, a = !1;
                    if (0 === t._f.length) return w(t).invalidFormat = !0, t._d = new Date(NaN);
                    for (o = 0; o < t._f.length; o++) r = 0, s = !1, e = T({}, t), null != t._useUTC && (e._useUTC = t._useUTC), e._f = t._f[o], Se(e), _(e) && (s = !0), r += w(e).charsLeftOver, r += 10 * w(e).unusedTokens.length, w(e).score = r, a ? r < n && (n = r, i = e) : (null == n || r < n || s) && (n = r, i = e, s && (a = !0));
                    y(t, i || e)
                }(t) : u ? Se(t) : f(i = (e = t)._i) ? e._d = new Date(b.now()) : m(i) ? e._d = new Date(i.valueOf()) : "string" == typeof i ? (s = e, null === (a = ge.exec(s._i)) ? (be(s), !1 === s._isValid && (delete s._isValid, xe(s), !1 === s._isValid && (delete s._isValid, s._strict ? s._isValid = !1 : b.createFromInputFallback(s)))) : s._d = new Date(+a[1])) : c(i) ? (e._a = g(i.slice(0), function(t) {
                    return parseInt(t, 10)
                }), _e(e)) : h(i) ? (n = e)._d || (r = void 0 === (o = F(n._i)).day ? o.date : o.day, n._a = g([o.year, o.month, r, o.hour, o.minute, o.second, o.millisecond], function(t) {
                    return t && parseInt(t, 10)
                }), _e(n)) : p(i) ? e._d = new Date(i) : b.createFromInputFallback(e), _(t) || (t._d = null), t))
            }

            function Ee(t, e, i, n, o) {
                var r, s = {};
                return !0 !== e && !1 !== e || (n = e, e = void 0), !0 !== i && !1 !== i || (n = i, i = void 0), (h(t) && d(t) || c(t) && 0 === t.length) && (t = void 0), s._isAMomentObject = !0, s._useUTC = s._isUTC = o, s._l = i, s._i = t, s._f = e, s._strict = n, (r = new E(ce(Te(s))))._nextDay && (r.add(1, "d"), r._nextDay = void 0), r
            }

            function Ce(t, e, i, n) {
                return Ee(t, e, i, n, !1)
            }
            b.createFromInputFallback = i("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(t) {
                t._d = new Date(t._i + (t._useUTC ? " UTC" : ""))
            }), b.ISO_8601 = function() {}, b.RFC_2822 = function() {};
            var ke = i("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
                    var t = Ce.apply(null, arguments);
                    return this.isValid() && t.isValid() ? t < this ? this : t : S()
                }),
                De = i("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
                    var t = Ce.apply(null, arguments);
                    return this.isValid() && t.isValid() ? this < t ? this : t : S()
                });

            function Ie(t, e) {
                var i, n;
                if (1 === e.length && c(e[0]) && (e = e[0]), !e.length) return Ce();
                for (i = e[0], n = 1; n < e.length; ++n) e[n].isValid() && !e[n][t](i) || (i = e[n]);
                return i
            }
            var Me = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];

            function Pe(t) {
                var e = F(t),
                    i = e.year || 0,
                    n = e.quarter || 0,
                    o = e.month || 0,
                    r = e.week || e.isoWeek || 0,
                    s = e.day || 0,
                    a = e.hour || 0,
                    l = e.minute || 0,
                    u = e.second || 0,
                    c = e.millisecond || 0;
                this._isValid = function(t) {
                    var e, i, n = !1;
                    for (e in t)
                        if (x(t, e) && (-1 === yt.call(Me, e) || null != t[e] && isNaN(t[e]))) return !1;
                    for (i = 0; i < Me.length; ++i)
                        if (t[Me[i]]) {
                            if (n) return !1;
                            parseFloat(t[Me[i]]) !== U(t[Me[i]]) && (n = !0)
                        } return !0
                }(e), this._milliseconds = +c + 1e3 * u + 6e4 * l + 1e3 * a * 60 * 60, this._days = +s + 7 * r, this._months = +o + 3 * n + 12 * i, this._data = {}, this._locale = ue(), this._bubble()
            }

            function Oe(t) {
                return t instanceof Pe
            }

            function ze(t) {
                return t < 0 ? -1 * Math.round(-1 * t) : Math.round(t)
            }

            function Le(t, i) {
                L(t, 0, 0, function() {
                    var t = this.utcOffset(),
                        e = "+";
                    return t < 0 && (t = -t, e = "-"), e + I(~~(t / 60), 2) + i + I(~~t % 60, 2)
                })
            }
            Le("Z", ":"), Le("ZZ", ""), dt("Z", ct), dt("ZZ", ct), mt(["Z", "ZZ"], function(t, e, i) {
                i._useUTC = !0, i._tzm = Ne(ct, t)
            });
            var Ae = /([\+\-]|\d\d)/gi;

            function Ne(t, e) {
                var i, n, o = (e || "").match(t);
                return null === o ? null : 0 === (n = 60 * (i = ((o[o.length - 1] || []) + "").match(Ae) || ["-", 0, 0])[1] + U(i[2])) ? 0 : "+" === i[0] ? n : -n
            }

            function je(t, e) {
                var i, n;
                return e._isUTC ? (i = e.clone(), n = (C(t) || m(t) ? t.valueOf() : Ce(t).valueOf()) - i.valueOf(), i._d.setTime(i._d.valueOf() + n), b.updateOffset(i, !1), i) : Ce(t).local()
            }

            function We(t) {
                return -Math.round(t._d.getTimezoneOffset())
            }

            function Re() {
                return !!this.isValid() && this._isUTC && 0 === this._offset
            }
            b.updateOffset = function() {};
            var Fe = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
                He = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

            function Ye(t, e) {
                var i, n, o, r, s, a, l = t,
                    u = null;
                return Oe(t) ? l = {
                    ms: t._milliseconds,
                    d: t._days,
                    M: t._months
                } : p(t) || !isNaN(+t) ? (l = {}, e ? l[e] = +t : l.milliseconds = +t) : (u = Fe.exec(t)) ? (i = "-" === u[1] ? -1 : 1, l = {
                    y: 0,
                    d: U(u[xt]) * i,
                    h: U(u[wt]) * i,
                    m: U(u[_t]) * i,
                    s: U(u[St]) * i,
                    ms: U(ze(1e3 * u[Tt])) * i
                }) : (u = He.exec(t)) ? (i = "-" === u[1] ? -1 : 1, l = {
                    y: qe(u[2], i),
                    M: qe(u[3], i),
                    w: qe(u[4], i),
                    d: qe(u[5], i),
                    h: qe(u[6], i),
                    m: qe(u[7], i),
                    s: qe(u[8], i)
                }) : null == l ? l = {} : "object" == typeof l && ("from" in l || "to" in l) && (r = Ce(l.from), s = Ce(l.to), o = r.isValid() && s.isValid() ? (s = je(s, r), r.isBefore(s) ? a = Be(r, s) : ((a = Be(s, r)).milliseconds = -a.milliseconds, a.months = -a.months), a) : {
                    milliseconds: 0,
                    months: 0
                }, (l = {}).ms = o.milliseconds, l.M = o.months), n = new Pe(l), Oe(t) && x(t, "_locale") && (n._locale = t._locale), Oe(t) && x(t, "_isValid") && (n._isValid = t._isValid), n
            }

            function qe(t, e) {
                var i = t && parseFloat(t.replace(",", "."));
                return (isNaN(i) ? 0 : i) * e
            }

            function Be(t, e) {
                var i = {};
                return i.months = e.month() - t.month() + 12 * (e.year() - t.year()), t.clone().add(i.months, "M").isAfter(e) && --i.months, i.milliseconds = e - t.clone().add(i.months, "M"), i
            }

            function Ue(n, o) {
                return function(t, e) {
                    var i;
                    return null === e || isNaN(+e) || (l(o, "moment()." + o + "(period, number) is deprecated. Please use moment()." + o + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), i = t, t = e, e = i), $e(this, Ye(t, e), n), this
                }
            }

            function $e(t, e, i, n) {
                var o = e._milliseconds,
                    r = ze(e._days),
                    s = ze(e._months);
                t.isValid() && (n = null == n || n, s && zt(t, V(t, "Month") + s * i), r && G(t, "Date", V(t, "Date") + r * i), o && t._d.setTime(t._d.valueOf() + o * i), n && b.updateOffset(t, r || s))
            }
            Ye.fn = Pe.prototype, Ye.invalid = function() {
                return Ye(NaN)
            };
            var Ve = Ue(1, "add"),
                Ge = Ue(-1, "subtract");

            function Qe(t) {
                return "string" == typeof t || t instanceof String
            }

            function Xe(t, e) {
                if (t.date() < e.date()) return -Xe(e, t);
                var i = 12 * (e.year() - t.year()) + (e.month() - t.month()),
                    n = t.clone().add(i, "months");
                return -(i + (e - n < 0 ? (e - n) / (n - t.clone().add(i - 1, "months")) : (e - n) / (t.clone().add(1 + i, "months") - n))) || 0
            }

            function Ze(t) {
                var e;
                return void 0 === t ? this._locale._abbr : (null != (e = ue(t)) && (this._locale = e), this)
            }
            b.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", b.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
            var Je = i("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(t) {
                return void 0 === t ? this.localeData() : this.locale(t)
            });

            function Ke() {
                return this._locale
            }

            function ti(t, e) {
                return (t % e + e) % e
            }

            function ei(t, e, i) {
                return t < 100 && 0 <= t ? new Date(t + 400, e, i) - 126227808e5 : new Date(t, e, i).valueOf()
            }

            function ii(t, e, i) {
                return t < 100 && 0 <= t ? Date.UTC(t + 400, e, i) - 126227808e5 : Date.UTC(t, e, i)
            }

            function ni(t, e) {
                return e.erasAbbrRegex(t)
            }

            function oi() {
                for (var t = [], e = [], i = [], n = [], o = this.eras(), r = 0, s = o.length; r < s; ++r) e.push(ft(o[r].name)), t.push(ft(o[r].abbr)), i.push(ft(o[r].narrow)), n.push(ft(o[r].name)), n.push(ft(o[r].abbr)), n.push(ft(o[r].narrow));
                this._erasRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp("^(" + i.join("|") + ")", "i")
            }

            function ri(t, e) {
                L(0, [t, t.length], 0, e)
            }

            function si(t, e, i, n, o) {
                var r;
                return null == t ? Ht(this, n, o).year : ((r = Yt(t, n, o)) < e && (e = r), function(t, e, i, n, o) {
                    var r = Ft(t, e, i, n, o),
                        s = Wt(r.year, 0, r.dayOfYear);
                    return this.year(s.getUTCFullYear()), this.month(s.getUTCMonth()), this.date(s.getUTCDate()), this
                }.call(this, t, e, i, n, o))
            }
            L("N", 0, 0, "eraAbbr"), L("NN", 0, 0, "eraAbbr"), L("NNN", 0, 0, "eraAbbr"), L("NNNN", 0, 0, "eraName"), L("NNNNN", 0, 0, "eraNarrow"), L("y", ["y", 1], "yo", "eraYear"), L("y", ["yy", 2], 0, "eraYear"), L("y", ["yyy", 3], 0, "eraYear"), L("y", ["yyyy", 4], 0, "eraYear"), dt("N", ni), dt("NN", ni), dt("NNN", ni), dt("NNNN", function(t, e) {
                return e.erasNameRegex(t)
            }), dt("NNNNN", function(t, e) {
                return e.erasNarrowRegex(t)
            }), mt(["N", "NN", "NNN", "NNNN", "NNNNN"], function(t, e, i, n) {
                var o = i._locale.erasParse(t, n, i._strict);
                o ? w(i).era = o : w(i).invalidEra = t
            }), dt("y", at), dt("yy", at), dt("yyy", at), dt("yyyy", at), dt("yo", function(t, e) {
                return e._eraYearOrdinalRegex || at
            }), mt(["y", "yy", "yyy", "yyyy"], vt), mt(["yo"], function(t, e, i, n) {
                var o;
                i._locale._eraYearOrdinalRegex && (o = t.match(i._locale._eraYearOrdinalRegex)), i._locale.eraYearOrdinalParse ? e[vt] = i._locale.eraYearOrdinalParse(t, o) : e[vt] = parseInt(t, 10)
            }), L(0, ["gg", 2], 0, function() {
                return this.weekYear() % 100
            }), L(0, ["GG", 2], 0, function() {
                return this.isoWeekYear() % 100
            }), ri("gggg", "weekYear"), ri("ggggg", "weekYear"), ri("GGGG", "isoWeekYear"), ri("GGGGG", "isoWeekYear"), W("weekYear", "gg"), W("isoWeekYear", "GG"), Y("weekYear", 1), Y("isoWeekYear", 1), dt("G", lt), dt("g", lt), dt("GG", et, Z), dt("gg", et, Z), dt("GGGG", rt, K), dt("gggg", rt, K), dt("GGGGG", st, tt), dt("ggggg", st, tt), gt(["gggg", "ggggg", "GGGG", "GGGGG"], function(t, e, i, n) {
                e[n.substr(0, 2)] = U(t)
            }), gt(["gg", "GG"], function(t, e, i, n) {
                e[n] = b.parseTwoDigitYear(t)
            }), L("Q", 0, "Qo", "quarter"), W("quarter", "Q"), Y("quarter", 7), dt("Q", X), mt("Q", function(t, e) {
                e[bt] = 3 * (U(t) - 1)
            }), L("D", ["DD", 2], "Do", "date"), W("date", "D"), Y("date", 9), dt("D", et), dt("DD", et, Z), dt("Do", function(t, e) {
                return t ? e._dayOfMonthOrdinalParse || e._ordinalParse : e._dayOfMonthOrdinalParseLenient
            }), mt(["D", "DD"], xt), mt("Do", function(t, e) {
                e[xt] = U(t.match(et)[0])
            });
            var ai = $("Date", !0);
            L("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), W("dayOfYear", "DDD"), Y("dayOfYear", 4), dt("DDD", ot), dt("DDDD", J), mt(["DDD", "DDDD"], function(t, e, i) {
                i._dayOfYear = U(t)
            }), L("m", ["mm", 2], 0, "minute"), W("minute", "m"), Y("minute", 14), dt("m", et), dt("mm", et, Z), mt(["m", "mm"], _t);
            var li = $("Minutes", !1);
            L("s", ["ss", 2], 0, "second"), W("second", "s"), Y("second", 15), dt("s", et), dt("ss", et, Z), mt(["s", "ss"], St);
            var ui, ci, hi = $("Seconds", !1);
            for (L("S", 0, 0, function() {
                    return ~~(this.millisecond() / 100)
                }), L(0, ["SS", 2], 0, function() {
                    return ~~(this.millisecond() / 10)
                }), L(0, ["SSS", 3], 0, "millisecond"), L(0, ["SSSS", 4], 0, function() {
                    return 10 * this.millisecond()
                }), L(0, ["SSSSS", 5], 0, function() {
                    return 100 * this.millisecond()
                }), L(0, ["SSSSSS", 6], 0, function() {
                    return 1e3 * this.millisecond()
                }), L(0, ["SSSSSSS", 7], 0, function() {
                    return 1e4 * this.millisecond()
                }), L(0, ["SSSSSSSS", 8], 0, function() {
                    return 1e5 * this.millisecond()
                }), L(0, ["SSSSSSSSS", 9], 0, function() {
                    return 1e6 * this.millisecond()
                }), W("millisecond", "ms"), Y("millisecond", 16), dt("S", ot, X), dt("SS", ot, Z), dt("SSS", ot, J), ui = "SSSS"; ui.length <= 9; ui += "S") dt(ui, at);

            function di(t, e) {
                e[Tt] = U(1e3 * ("0." + t))
            }
            for (ui = "S"; ui.length <= 9; ui += "S") mt(ui, di);
            ci = $("Milliseconds", !1), L("z", 0, 0, "zoneAbbr"), L("zz", 0, 0, "zoneName");
            var fi = E.prototype;

            function pi(t) {
                return t
            }
            fi.add = Ve, fi.calendar = function(t, e) {
                var i, n, o, r;
                1 === arguments.length && (arguments[0] ? C(i = arguments[0]) || m(i) || Qe(i) || p(i) || (r = !1, (o = c(n = i)) && (r = 0 === n.filter(function(t) {
                    return !p(t) && Qe(n)
                }).length), o && r) || function(t) {
                    var e, i = h(t) && !d(t),
                        n = !1,
                        o = ["years", "year", "y", "months", "month", "M", "days", "day", "d", "dates", "date", "D", "hours", "hour", "h", "minutes", "minute", "m", "seconds", "second", "s", "milliseconds", "millisecond", "ms"];
                    for (e = 0; e < o.length; e += 1) n = n || x(t, o[e]);
                    return i && n
                }(i) || null == i ? (t = arguments[0], e = void 0) : function(t) {
                    for (var e = h(t) && !d(t), i = !1, n = ["sameDay", "nextDay", "lastDay", "nextWeek", "lastWeek", "sameElse"], o = 0; o < n.length; o += 1) i = i || x(t, n[o]);
                    return e && i
                }(arguments[0]) && (e = arguments[0], t = void 0) : e = t = void 0);
                var s = t || Ce(),
                    a = je(s, this).startOf("day"),
                    l = b.calendarFormat(this, a) || "sameElse",
                    u = e && (k(e[l]) ? e[l].call(this, s) : e[l]);
                return this.format(u || this.localeData().calendar(l, this, Ce(s)))
            }, fi.clone = function() {
                return new E(this)
            }, fi.diff = function(t, e, i) {
                var n, o, r;
                if (!this.isValid()) return NaN;
                if (!(n = je(t, this)).isValid()) return NaN;
                switch (o = 6e4 * (n.utcOffset() - this.utcOffset()), e = R(e)) {
                    case "year":
                        r = Xe(this, n) / 12;
                        break;
                    case "month":
                        r = Xe(this, n);
                        break;
                    case "quarter":
                        r = Xe(this, n) / 3;
                        break;
                    case "second":
                        r = (this - n) / 1e3;
                        break;
                    case "minute":
                        r = (this - n) / 6e4;
                        break;
                    case "hour":
                        r = (this - n) / 36e5;
                        break;
                    case "day":
                        r = (this - n - o) / 864e5;
                        break;
                    case "week":
                        r = (this - n - o) / 6048e5;
                        break;
                    default:
                        r = this - n
                }
                return i ? r : B(r)
            }, fi.endOf = function(t) {
                var e, i;
                if (void 0 === (t = R(t)) || "millisecond" === t || !this.isValid()) return this;
                switch (i = this._isUTC ? ii : ei, t) {
                    case "year":
                        e = i(this.year() + 1, 0, 1) - 1;
                        break;
                    case "quarter":
                        e = i(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                        break;
                    case "month":
                        e = i(this.year(), this.month() + 1, 1) - 1;
                        break;
                    case "week":
                        e = i(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                        break;
                    case "isoWeek":
                        e = i(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                        break;
                    case "day":
                    case "date":
                        e = i(this.year(), this.month(), this.date() + 1) - 1;
                        break;
                    case "hour":
                        e = this._d.valueOf(), e += 36e5 - ti(e + (this._isUTC ? 0 : 6e4 * this.utcOffset()), 36e5) - 1;
                        break;
                    case "minute":
                        e = this._d.valueOf(), e += 6e4 - ti(e, 6e4) - 1;
                        break;
                    case "second":
                        e = this._d.valueOf(), e += 1e3 - ti(e, 1e3) - 1
                }
                return this._d.setTime(e), b.updateOffset(this, !0), this
            }, fi.format = function(t) {
                var e = A(this, t = t || (this.isUtc() ? b.defaultFormatUtc : b.defaultFormat));
                return this.localeData().postformat(e)
            }, fi.from = function(t, e) {
                return this.isValid() && (C(t) && t.isValid() || Ce(t).isValid()) ? Ye({
                    to: this,
                    from: t
                }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate()
            }, fi.fromNow = function(t) {
                return this.from(Ce(), t)
            }, fi.to = function(t, e) {
                return this.isValid() && (C(t) && t.isValid() || Ce(t).isValid()) ? Ye({
                    from: this,
                    to: t
                }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate()
            }, fi.toNow = function(t) {
                return this.to(Ce(), t)
            }, fi.get = function(t) {
                return k(this[t = R(t)]) ? this[t]() : this
            }, fi.invalidAt = function() {
                return w(this).overflow
            }, fi.isAfter = function(t, e) {
                var i = C(t) ? t : Ce(t);
                return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = R(e) || "millisecond") ? this.valueOf() > i.valueOf() : i.valueOf() < this.clone().startOf(e).valueOf())
            }, fi.isBefore = function(t, e) {
                var i = C(t) ? t : Ce(t);
                return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = R(e) || "millisecond") ? this.valueOf() < i.valueOf() : this.clone().endOf(e).valueOf() < i.valueOf())
            }, fi.isBetween = function(t, e, i, n) {
                var o = C(t) ? t : Ce(t),
                    r = C(e) ? e : Ce(e);
                return !!(this.isValid() && o.isValid() && r.isValid()) && ("(" === (n = n || "()")[0] ? this.isAfter(o, i) : !this.isBefore(o, i)) && (")" === n[1] ? this.isBefore(r, i) : !this.isAfter(r, i))
            }, fi.isSame = function(t, e) {
                var i, n = C(t) ? t : Ce(t);
                return !(!this.isValid() || !n.isValid()) && ("millisecond" === (e = R(e) || "millisecond") ? this.valueOf() === n.valueOf() : (i = n.valueOf(), this.clone().startOf(e).valueOf() <= i && i <= this.clone().endOf(e).valueOf()))
            }, fi.isSameOrAfter = function(t, e) {
                return this.isSame(t, e) || this.isAfter(t, e)
            }, fi.isSameOrBefore = function(t, e) {
                return this.isSame(t, e) || this.isBefore(t, e)
            }, fi.isValid = function() {
                return _(this)
            }, fi.lang = Je, fi.locale = Ze, fi.localeData = Ke, fi.max = De, fi.min = ke, fi.parsingFlags = function() {
                return y({}, w(this))
            }, fi.set = function(t, e) {
                if ("object" == typeof t)
                    for (var i = function(t) {
                            var e, i = [];
                            for (e in t) x(t, e) && i.push({
                                unit: e,
                                priority: H[e]
                            });
                            return i.sort(function(t, e) {
                                return t.priority - e.priority
                            }), i
                        }(t = F(t)), n = 0; n < i.length; n++) this[i[n].unit](t[i[n].unit]);
                else if (k(this[t = R(t)])) return this[t](e);
                return this
            }, fi.startOf = function(t) {
                var e, i;
                if (void 0 === (t = R(t)) || "millisecond" === t || !this.isValid()) return this;
                switch (i = this._isUTC ? ii : ei, t) {
                    case "year":
                        e = i(this.year(), 0, 1);
                        break;
                    case "quarter":
                        e = i(this.year(), this.month() - this.month() % 3, 1);
                        break;
                    case "month":
                        e = i(this.year(), this.month(), 1);
                        break;
                    case "week":
                        e = i(this.year(), this.month(), this.date() - this.weekday());
                        break;
                    case "isoWeek":
                        e = i(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                        break;
                    case "day":
                    case "date":
                        e = i(this.year(), this.month(), this.date());
                        break;
                    case "hour":
                        e = this._d.valueOf(), e -= ti(e + (this._isUTC ? 0 : 6e4 * this.utcOffset()), 36e5);
                        break;
                    case "minute":
                        e = this._d.valueOf(), e -= ti(e, 6e4);
                        break;
                    case "second":
                        e = this._d.valueOf(), e -= ti(e, 1e3)
                }
                return this._d.setTime(e), b.updateOffset(this, !0), this
            }, fi.subtract = Ge, fi.toArray = function() {
                return [this.year(), this.month(), this.date(), this.hour(), this.minute(), this.second(), this.millisecond()]
            }, fi.toObject = function() {
                return {
                    years: this.year(),
                    months: this.month(),
                    date: this.date(),
                    hours: this.hours(),
                    minutes: this.minutes(),
                    seconds: this.seconds(),
                    milliseconds: this.milliseconds()
                }
            }, fi.toDate = function() {
                return new Date(this.valueOf())
            }, fi.toISOString = function(t) {
                if (!this.isValid()) return null;
                var e = !0 !== t,
                    i = e ? this.clone().utc() : this;
                return i.year() < 0 || 9999 < i.year() ? A(i, e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : k(Date.prototype.toISOString) ? e ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", A(i, "Z")) : A(i, e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ")
            }, fi.inspect = function() {
                if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
                var t, e, i, n = "moment",
                    o = "";
                return this.isLocal() || (n = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", o = "Z"), t = "[" + n + '("]', e = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", i = o + '[")]', this.format(t + e + "-MM-DD[T]HH:mm:ss.SSS" + i)
            }, "undefined" != typeof Symbol && null != Symbol.for && (fi[Symbol.for("nodejs.util.inspect.custom")] = function() {
                return "Moment<" + this.format() + ">"
            }), fi.toJSON = function() {
                return this.isValid() ? this.toISOString() : null
            }, fi.toString = function() {
                return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")
            }, fi.unix = function() {
                return Math.floor(this.valueOf() / 1e3)
            }, fi.valueOf = function() {
                return this._d.valueOf() - 6e4 * (this._offset || 0)
            }, fi.creationData = function() {
                return {
                    input: this._i,
                    format: this._f,
                    locale: this._locale,
                    isUTC: this._isUTC,
                    strict: this._strict
                }
            }, fi.eraName = function() {
                for (var t, e = this.localeData().eras(), i = 0, n = e.length; i < n; ++i) {
                    if (t = this.clone().startOf("day").valueOf(), e[i].since <= t && t <= e[i].until) return e[i].name;
                    if (e[i].until <= t && t <= e[i].since) return e[i].name
                }
                return ""
            }, fi.eraNarrow = function() {
                for (var t, e = this.localeData().eras(), i = 0, n = e.length; i < n; ++i) {
                    if (t = this.clone().startOf("day").valueOf(), e[i].since <= t && t <= e[i].until) return e[i].narrow;
                    if (e[i].until <= t && t <= e[i].since) return e[i].narrow
                }
                return ""
            }, fi.eraAbbr = function() {
                for (var t, e = this.localeData().eras(), i = 0, n = e.length; i < n; ++i) {
                    if (t = this.clone().startOf("day").valueOf(), e[i].since <= t && t <= e[i].until) return e[i].abbr;
                    if (e[i].until <= t && t <= e[i].since) return e[i].abbr
                }
                return ""
            }, fi.eraYear = function() {
                for (var t, e, i = this.localeData().eras(), n = 0, o = i.length; n < o; ++n)
                    if (t = i[n].since <= i[n].until ? 1 : -1, e = this.clone().startOf("day").valueOf(), i[n].since <= e && e <= i[n].until || i[n].until <= e && e <= i[n].since) return (this.year() - b(i[n].since).year()) * t + i[n].offset;
                return this.year()
            }, fi.year = jt, fi.isLeapYear = function() {
                return q(this.year())
            }, fi.weekYear = function(t) {
                return si.call(this, t, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy)
            }, fi.isoWeekYear = function(t) {
                return si.call(this, t, this.isoWeek(), this.isoWeekday(), 1, 4)
            }, fi.quarter = fi.quarters = function(t) {
                return null == t ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (t - 1) + this.month() % 3)
            }, fi.month = Lt, fi.daysInMonth = function() {
                return kt(this.year(), this.month())
            }, fi.week = fi.weeks = function(t) {
                var e = this.localeData().week(this);
                return null == t ? e : this.add(7 * (t - e), "d")
            }, fi.isoWeek = fi.isoWeeks = function(t) {
                var e = Ht(this, 1, 4).week;
                return null == t ? e : this.add(7 * (t - e), "d")
            }, fi.weeksInYear = function() {
                var t = this.localeData()._week;
                return Yt(this.year(), t.dow, t.doy)
            }, fi.weeksInWeekYear = function() {
                var t = this.localeData()._week;
                return Yt(this.weekYear(), t.dow, t.doy)
            }, fi.isoWeeksInYear = function() {
                return Yt(this.year(), 1, 4)
            }, fi.isoWeeksInISOWeekYear = function() {
                return Yt(this.isoWeekYear(), 1, 4)
            }, fi.date = ai, fi.day = fi.days = function(t) {
                if (!this.isValid()) return null != t ? this : NaN;
                var e, i, n = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
                return null != t ? (e = t, i = this.localeData(), t = "string" != typeof e ? e : isNaN(e) ? "number" == typeof(e = i.weekdaysParse(e)) ? e : null : parseInt(e, 10), this.add(t - n, "d")) : n
            }, fi.weekday = function(t) {
                if (!this.isValid()) return null != t ? this : NaN;
                var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
                return null == t ? e : this.add(t - e, "d")
            }, fi.isoWeekday = function(t) {
                if (!this.isValid()) return null != t ? this : NaN;
                if (null == t) return this.day() || 7;
                var e, i, n = (e = t, i = this.localeData(), "string" == typeof e ? i.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e);
                return this.day(this.day() % 7 ? n : n - 7)
            }, fi.dayOfYear = function(t) {
                var e = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
                return null == t ? e : this.add(t - e, "d")
            }, fi.hour = fi.hours = ee, fi.minute = fi.minutes = li, fi.second = fi.seconds = hi, fi.millisecond = fi.milliseconds = ci, fi.utcOffset = function(t, e, i) {
                var n, o = this._offset || 0;
                if (!this.isValid()) return null != t ? this : NaN;
                if (null == t) return this._isUTC ? o : We(this);
                if ("string" == typeof t) {
                    if (null === (t = Ne(ct, t))) return this
                } else Math.abs(t) < 16 && !i && (t *= 60);
                return !this._isUTC && e && (n = We(this)), this._offset = t, this._isUTC = !0, null != n && this.add(n, "m"), o !== t && (!e || this._changeInProgress ? $e(this, Ye(t - o, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, b.updateOffset(this, !0), this._changeInProgress = null)), this
            }, fi.utc = function(t) {
                return this.utcOffset(0, t)
            }, fi.local = function(t) {
                return this._isUTC && (this.utcOffset(0, t), this._isUTC = !1, t && this.subtract(We(this), "m")), this
            }, fi.parseZone = function() {
                var t;
                return null != this._tzm ? this.utcOffset(this._tzm, !1, !0) : "string" == typeof this._i && (null != (t = Ne(ut, this._i)) ? this.utcOffset(t) : this.utcOffset(0, !0)), this
            }, fi.hasAlignedHourOffset = function(t) {
                return !!this.isValid() && (t = t ? Ce(t).utcOffset() : 0, (this.utcOffset() - t) % 60 == 0)
            }, fi.isDST = function() {
                return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset()
            }, fi.isLocal = function() {
                return !!this.isValid() && !this._isUTC
            }, fi.isUtcOffset = function() {
                return !!this.isValid() && this._isUTC
            }, fi.isUtc = Re, fi.isUTC = Re, fi.zoneAbbr = function() {
                return this._isUTC ? "UTC" : ""
            }, fi.zoneName = function() {
                return this._isUTC ? "Coordinated Universal Time" : ""
            }, fi.dates = i("dates accessor is deprecated. Use date instead.", ai), fi.months = i("months accessor is deprecated. Use month instead", Lt), fi.years = i("years accessor is deprecated. Use year instead", jt), fi.zone = i("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function(t, e) {
                return null != t ? ("string" != typeof t && (t = -t), this.utcOffset(t, e), this) : -this.utcOffset()
            }), fi.isDSTShifted = i("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function() {
                if (!f(this._isDSTShifted)) return this._isDSTShifted;
                var t, e = {};
                return T(e, this), (e = Te(e))._a ? (t = (e._isUTC ? v : Ce)(e._a), this._isDSTShifted = this.isValid() && 0 < function(t, e, i) {
                    for (var n = Math.min(t.length, e.length), o = Math.abs(t.length - e.length), r = 0, s = 0; s < n; s++) U(t[s]) !== U(e[s]) && r++;
                    return r + o
                }(e._a, t.toArray())) : this._isDSTShifted = !1, this._isDSTShifted
            });
            var mi = D.prototype;

            function gi(t, e, i, n) {
                var o = ue(),
                    r = v().set(n, e);
                return o[i](r, t)
            }

            function yi(t, e, i) {
                if (p(t) && (e = t, t = void 0), t = t || "", null != e) return gi(t, e, i, "month");
                for (var n = [], o = 0; o < 12; o++) n[o] = gi(t, o, i, "month");
                return n
            }

            function vi(t, e, i, n) {
                "boolean" == typeof t ? p(e) && (i = e, e = void 0) : (e = t, t = !1, p(i = e) && (i = e, e = void 0)), e = e || "";
                var o, r = ue(),
                    s = t ? r._week.dow : 0,
                    a = [];
                if (null != i) return gi(e, (i + s) % 7, n, "day");
                for (o = 0; o < 7; o++) a[o] = gi(e, (o + s) % 7, n, "day");
                return a
            }
            mi.calendar = function(t, e, i) {
                var n = this._calendar[t] || this._calendar.sameElse;
                return k(n) ? n.call(e, i) : n
            }, mi.longDateFormat = function(t) {
                var e = this._longDateFormat[t],
                    i = this._longDateFormat[t.toUpperCase()];
                return e || !i ? e : (this._longDateFormat[t] = i.match(M).map(function(t) {
                    return "MMMM" === t || "MM" === t || "DD" === t || "dddd" === t ? t.slice(1) : t
                }).join(""), this._longDateFormat[t])
            }, mi.invalidDate = function() {
                return this._invalidDate
            }, mi.ordinal = function(t) {
                return this._ordinal.replace("%d", t)
            }, mi.preparse = pi, mi.postformat = pi, mi.relativeTime = function(t, e, i, n) {
                var o = this._relativeTime[i];
                return k(o) ? o(t, e, i, n) : o.replace(/%d/i, t)
            }, mi.pastFuture = function(t, e) {
                var i = this._relativeTime[0 < t ? "future" : "past"];
                return k(i) ? i(e) : i.replace(/%s/i, e)
            }, mi.set = function(t) {
                var e, i;
                for (i in t) x(t, i) && (k(e = t[i]) ? this[i] = e : this["_" + i] = e);
                this._config = t, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source)
            }, mi.eras = function(t, e) {
                for (var i, n = this._eras || ue("en")._eras, o = 0, r = n.length; o < r; ++o) {
                    switch (typeof n[o].since) {
                        case "string":
                            i = b(n[o].since).startOf("day"), n[o].since = i.valueOf()
                    }
                    switch (typeof n[o].until) {
                        case "undefined":
                            n[o].until = 1 / 0;
                            break;
                        case "string":
                            i = b(n[o].until).startOf("day").valueOf(), n[o].until = i.valueOf()
                    }
                }
                return n
            }, mi.erasParse = function(t, e, i) {
                var n, o, r, s, a, l = this.eras();
                for (t = t.toUpperCase(), n = 0, o = l.length; n < o; ++n)
                    if (r = l[n].name.toUpperCase(), s = l[n].abbr.toUpperCase(), a = l[n].narrow.toUpperCase(), i) switch (e) {
                        case "N":
                        case "NN":
                        case "NNN":
                            if (s === t) return l[n];
                            break;
                        case "NNNN":
                            if (r === t) return l[n];
                            break;
                        case "NNNNN":
                            if (a === t) return l[n]
                    } else if (0 <= [r, s, a].indexOf(t)) return l[n]
            }, mi.erasConvertYear = function(t, e) {
                var i = t.since <= t.until ? 1 : -1;
                return void 0 === e ? b(t.since).year() : b(t.since).year() + (e - t.offset) * i
            }, mi.erasAbbrRegex = function(t) {
                return x(this, "_erasAbbrRegex") || oi.call(this), t ? this._erasAbbrRegex : this._erasRegex
            }, mi.erasNameRegex = function(t) {
                return x(this, "_erasNameRegex") || oi.call(this), t ? this._erasNameRegex : this._erasRegex
            }, mi.erasNarrowRegex = function(t) {
                return x(this, "_erasNarrowRegex") || oi.call(this), t ? this._erasNarrowRegex : this._erasRegex
            }, mi.months = function(t, e) {
                return t ? c(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || Mt).test(e) ? "format" : "standalone"][t.month()] : c(this._months) ? this._months : this._months.standalone
            }, mi.monthsShort = function(t, e) {
                return t ? c(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[Mt.test(e) ? "format" : "standalone"][t.month()] : c(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone
            }, mi.monthsParse = function(t, e, i) {
                var n, o, r;
                if (this._monthsParseExact) return function(t, e, i) {
                    var n, o, r, s = t.toLocaleLowerCase();
                    if (!this._monthsParse)
                        for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n) r = v([2e3, n]), this._shortMonthsParse[n] = this.monthsShort(r, "").toLocaleLowerCase(), this._longMonthsParse[n] = this.months(r, "").toLocaleLowerCase();
                    return i ? "MMM" === e ? -1 !== (o = yt.call(this._shortMonthsParse, s)) ? o : null : -1 !== (o = yt.call(this._longMonthsParse, s)) ? o : null : "MMM" === e ? -1 !== (o = yt.call(this._shortMonthsParse, s)) || -1 !== (o = yt.call(this._longMonthsParse, s)) ? o : null : -1 !== (o = yt.call(this._longMonthsParse, s)) || -1 !== (o = yt.call(this._shortMonthsParse, s)) ? o : null
                }.call(this, t, e, i);
                for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n = 0; n < 12; n++) {
                    if (o = v([2e3, n]), i && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp("^" + this.months(o, "").replace(".", "") + "$", "i"), this._shortMonthsParse[n] = new RegExp("^" + this.monthsShort(o, "").replace(".", "") + "$", "i")), i || this._monthsParse[n] || (r = "^" + this.months(o, "") + "|^" + this.monthsShort(o, ""), this._monthsParse[n] = new RegExp(r.replace(".", ""), "i")), i && "MMMM" === e && this._longMonthsParse[n].test(t)) return n;
                    if (i && "MMM" === e && this._shortMonthsParse[n].test(t)) return n;
                    if (!i && this._monthsParse[n].test(t)) return n
                }
            }, mi.monthsRegex = function(t) {
                return this._monthsParseExact ? (x(this, "_monthsRegex") || At.call(this), t ? this._monthsStrictRegex : this._monthsRegex) : (x(this, "_monthsRegex") || (this._monthsRegex = Ot), this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex)
            }, mi.monthsShortRegex = function(t) {
                return this._monthsParseExact ? (x(this, "_monthsRegex") || At.call(this), t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (x(this, "_monthsShortRegex") || (this._monthsShortRegex = Pt), this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex)
            }, mi.week = function(t) {
                return Ht(t, this._week.dow, this._week.doy).week
            }, mi.firstDayOfYear = function() {
                return this._week.doy
            }, mi.firstDayOfWeek = function() {
                return this._week.dow
            }, mi.weekdays = function(t, e) {
                var i = c(this._weekdays) ? this._weekdays : this._weekdays[t && !0 !== t && this._weekdays.isFormat.test(e) ? "format" : "standalone"];
                return !0 === t ? qt(i, this._week.dow) : t ? i[t.day()] : i
            }, mi.weekdaysMin = function(t) {
                return !0 === t ? qt(this._weekdaysMin, this._week.dow) : t ? this._weekdaysMin[t.day()] : this._weekdaysMin
            }, mi.weekdaysShort = function(t) {
                return !0 === t ? qt(this._weekdaysShort, this._week.dow) : t ? this._weekdaysShort[t.day()] : this._weekdaysShort
            }, mi.weekdaysParse = function(t, e, i) {
                var n, o, r;
                if (this._weekdaysParseExact) return function(t, e, i) {
                    var n, o, r, s = t.toLocaleLowerCase();
                    if (!this._weekdaysParse)
                        for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n) r = v([2e3, 1]).day(n), this._minWeekdaysParse[n] = this.weekdaysMin(r, "").toLocaleLowerCase(), this._shortWeekdaysParse[n] = this.weekdaysShort(r, "").toLocaleLowerCase(), this._weekdaysParse[n] = this.weekdays(r, "").toLocaleLowerCase();
                    return i ? "dddd" === e ? -1 !== (o = yt.call(this._weekdaysParse, s)) ? o : null : "ddd" === e ? -1 !== (o = yt.call(this._shortWeekdaysParse, s)) ? o : null : -1 !== (o = yt.call(this._minWeekdaysParse, s)) ? o : null : "dddd" === e ? -1 !== (o = yt.call(this._weekdaysParse, s)) || -1 !== (o = yt.call(this._shortWeekdaysParse, s)) || -1 !== (o = yt.call(this._minWeekdaysParse, s)) ? o : null : "ddd" === e ? -1 !== (o = yt.call(this._shortWeekdaysParse, s)) || -1 !== (o = yt.call(this._weekdaysParse, s)) || -1 !== (o = yt.call(this._minWeekdaysParse, s)) ? o : null : -1 !== (o = yt.call(this._minWeekdaysParse, s)) || -1 !== (o = yt.call(this._weekdaysParse, s)) || -1 !== (o = yt.call(this._shortWeekdaysParse, s)) ? o : null
                }.call(this, t, e, i);
                for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n = 0; n < 7; n++) {
                    if (o = v([2e3, 1]).day(n), i && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp("^" + this.weekdays(o, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[n] = new RegExp("^" + this.weekdaysShort(o, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[n] = new RegExp("^" + this.weekdaysMin(o, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[n] || (r = "^" + this.weekdays(o, "") + "|^" + this.weekdaysShort(o, "") + "|^" + this.weekdaysMin(o, ""), this._weekdaysParse[n] = new RegExp(r.replace(".", ""), "i")), i && "dddd" === e && this._fullWeekdaysParse[n].test(t)) return n;
                    if (i && "ddd" === e && this._shortWeekdaysParse[n].test(t)) return n;
                    if (i && "dd" === e && this._minWeekdaysParse[n].test(t)) return n;
                    if (!i && this._weekdaysParse[n].test(t)) return n
                }
            }, mi.weekdaysRegex = function(t) {
                return this._weekdaysParseExact ? (x(this, "_weekdaysRegex") || Xt.call(this), t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (x(this, "_weekdaysRegex") || (this._weekdaysRegex = Vt), this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex)
            }, mi.weekdaysShortRegex = function(t) {
                return this._weekdaysParseExact ? (x(this, "_weekdaysRegex") || Xt.call(this), t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (x(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Gt), this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
            }, mi.weekdaysMinRegex = function(t) {
                return this._weekdaysParseExact ? (x(this, "_weekdaysRegex") || Xt.call(this), t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (x(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Qt), this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
            }, mi.isPM = function(t) {
                return "p" === (t + "").toLowerCase().charAt(0)
            }, mi.meridiem = function(t, e, i) {
                return 11 < t ? i ? "pm" : "PM" : i ? "am" : "AM"
            }, ae("en", {
                eras: [{
                    since: "0001-01-01",
                    until: 1 / 0,
                    offset: 1,
                    name: "Anno Domini",
                    narrow: "AD",
                    abbr: "AD"
                }, {
                    since: "0000-12-31",
                    until: -1 / 0,
                    offset: 1,
                    name: "Before Christ",
                    narrow: "BC",
                    abbr: "BC"
                }],
                dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
                ordinal: function(t) {
                    var e = t % 10;
                    return t + (1 === U(t % 100 / 10) ? "th" : 1 == e ? "st" : 2 == e ? "nd" : 3 == e ? "rd" : "th")
                }
            }), b.lang = i("moment.lang is deprecated. Use moment.locale instead.", ae), b.langData = i("moment.langData is deprecated. Use moment.localeData instead.", ue);
            var bi = Math.abs;

            function xi(t, e, i, n) {
                var o = Ye(e, i);
                return t._milliseconds += n * o._milliseconds, t._days += n * o._days, t._months += n * o._months, t._bubble()
            }

            function wi(t) {
                return t < 0 ? Math.floor(t) : Math.ceil(t)
            }

            function _i(t) {
                return 4800 * t / 146097
            }

            function Si(t) {
                return 146097 * t / 4800
            }

            function Ti(t) {
                return function() {
                    return this.as(t)
                }
            }
            var Ei = Ti("ms"),
                Ci = Ti("s"),
                ki = Ti("m"),
                Di = Ti("h"),
                Ii = Ti("d"),
                Mi = Ti("w"),
                Pi = Ti("M"),
                Oi = Ti("Q"),
                zi = Ti("y");

            function Li(t) {
                return function() {
                    return this.isValid() ? this._data[t] : NaN
                }
            }
            var Ai = Li("milliseconds"),
                Ni = Li("seconds"),
                ji = Li("minutes"),
                Wi = Li("hours"),
                Ri = Li("days"),
                Fi = Li("months"),
                Hi = Li("years"),
                Yi = Math.round,
                qi = {
                    ss: 44,
                    s: 45,
                    m: 45,
                    h: 22,
                    d: 26,
                    w: null,
                    M: 11
                },
                Bi = Math.abs;

            function Ui(t) {
                return (0 < t) - (t < 0) || +t
            }

            function $i() {
                if (!this.isValid()) return this.localeData().invalidDate();
                var t, e, i, n, o, r, s, a, l = Bi(this._milliseconds) / 1e3,
                    u = Bi(this._days),
                    c = Bi(this._months),
                    h = this.asSeconds();
                return h ? (e = B((t = B(l / 60)) / 60), l %= 60, t %= 60, i = B(c / 12), c %= 12, n = l ? l.toFixed(3).replace(/\.?0+$/, "") : "", o = h < 0 ? "-" : "", r = Ui(this._months) !== Ui(h) ? "-" : "", s = Ui(this._days) !== Ui(h) ? "-" : "", a = Ui(this._milliseconds) !== Ui(h) ? "-" : "", o + "P" + (i ? r + i + "Y" : "") + (c ? r + c + "M" : "") + (u ? s + u + "D" : "") + (e || t || l ? "T" : "") + (e ? a + e + "H" : "") + (t ? a + t + "M" : "") + (l ? a + n + "S" : "")) : "P0D"
            }
            var Vi = Pe.prototype;
            return Vi.isValid = function() {
                return this._isValid
            }, Vi.abs = function() {
                var t = this._data;
                return this._milliseconds = bi(this._milliseconds), this._days = bi(this._days), this._months = bi(this._months), t.milliseconds = bi(t.milliseconds), t.seconds = bi(t.seconds), t.minutes = bi(t.minutes), t.hours = bi(t.hours), t.months = bi(t.months), t.years = bi(t.years), this
            }, Vi.add = function(t, e) {
                return xi(this, t, e, 1)
            }, Vi.subtract = function(t, e) {
                return xi(this, t, e, -1)
            }, Vi.as = function(t) {
                if (!this.isValid()) return NaN;
                var e, i, n = this._milliseconds;
                if ("month" === (t = R(t)) || "quarter" === t || "year" === t) switch (e = this._days + n / 864e5, i = this._months + _i(e), t) {
                    case "month":
                        return i;
                    case "quarter":
                        return i / 3;
                    case "year":
                        return i / 12
                } else switch (e = this._days + Math.round(Si(this._months)), t) {
                    case "week":
                        return e / 7 + n / 6048e5;
                    case "day":
                        return e + n / 864e5;
                    case "hour":
                        return 24 * e + n / 36e5;
                    case "minute":
                        return 1440 * e + n / 6e4;
                    case "second":
                        return 86400 * e + n / 1e3;
                    case "millisecond":
                        return Math.floor(864e5 * e) + n;
                    default:
                        throw new Error("Unknown unit " + t)
                }
            }, Vi.asMilliseconds = Ei, Vi.asSeconds = Ci, Vi.asMinutes = ki, Vi.asHours = Di, Vi.asDays = Ii, Vi.asWeeks = Mi, Vi.asMonths = Pi, Vi.asQuarters = Oi, Vi.asYears = zi, Vi.valueOf = function() {
                return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * U(this._months / 12) : NaN
            }, Vi._bubble = function() {
                var t, e, i, n, o, r = this._milliseconds,
                    s = this._days,
                    a = this._months,
                    l = this._data;
                return 0 <= r && 0 <= s && 0 <= a || r <= 0 && s <= 0 && a <= 0 || (r += 864e5 * wi(Si(a) + s), a = s = 0), l.milliseconds = r % 1e3, t = B(r / 1e3), l.seconds = t % 60, e = B(t / 60), l.minutes = e % 60, i = B(e / 60), l.hours = i % 24, a += o = B(_i(s += B(i / 24))), s -= wi(Si(o)), n = B(a / 12), a %= 12, l.days = s, l.months = a, l.years = n, this
            }, Vi.clone = function() {
                return Ye(this)
            }, Vi.get = function(t) {
                return t = R(t), this.isValid() ? this[t + "s"]() : NaN
            }, Vi.milliseconds = Ai, Vi.seconds = Ni, Vi.minutes = ji, Vi.hours = Wi, Vi.days = Ri, Vi.weeks = function() {
                return B(this.days() / 7)
            }, Vi.months = Fi, Vi.years = Hi, Vi.humanize = function(t, e) {
                if (!this.isValid()) return this.localeData().invalidDate();
                var i, n, o, r, s, a, l, u, c, h, d, f, p, m, g = !1,
                    y = qi;
                return "object" == typeof t && (e = t, t = !1), "boolean" == typeof t && (g = t), "object" == typeof e && (y = Object.assign({}, qi, e), null != e.s && null == e.ss && (y.ss = e.s - 1)), o = !g, r = y, s = i = this.localeData(), a = Ye(this).abs(), l = Yi(a.as("s")), u = Yi(a.as("m")), c = Yi(a.as("h")), h = Yi(a.as("d")), d = Yi(a.as("M")), f = Yi(a.as("w")), p = Yi(a.as("y")), m = (l <= r.ss ? ["s", l] : l < r.s && ["ss", l]) || u <= 1 && ["m"] || u < r.m && ["mm", u] || c <= 1 && ["h"] || c < r.h && ["hh", c] || h <= 1 && ["d"] || h < r.d && ["dd", h], null != r.w && (m = m || f <= 1 && ["w"] || f < r.w && ["ww", f]), (m = m || d <= 1 && ["M"] || d < r.M && ["MM", d] || p <= 1 && ["y"] || ["yy", p])[2] = o, m[3] = 0 < +this, m[4] = s, n = function(t, e, i, n, o) {
                    return o.relativeTime(e || 1, !!i, t, n)
                }.apply(null, m), g && (n = i.pastFuture(+this, n)), i.postformat(n)
            }, Vi.toISOString = $i, Vi.toString = $i, Vi.toJSON = $i, Vi.locale = Ze, Vi.localeData = Ke, Vi.toIsoString = i("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", $i), Vi.lang = Je, L("X", 0, 0, "unix"), L("x", 0, 0, "valueOf"), dt("x", lt), dt("X", /[+-]?\d+(\.\d{1,3})?/), mt("X", function(t, e, i) {
                i._d = new Date(1e3 * parseFloat(t))
            }), mt("x", function(t, e, i) {
                i._d = new Date(U(t))
            }), b.version = "2.29.1", t = Ce, b.fn = fi, b.min = function() {
                return Ie("isBefore", [].slice.call(arguments, 0))
            }, b.max = function() {
                return Ie("isAfter", [].slice.call(arguments, 0))
            }, b.now = function() {
                return Date.now ? Date.now() : +new Date
            }, b.utc = v, b.unix = function(t) {
                return Ce(1e3 * t)
            }, b.months = function(t, e) {
                return yi(t, e, "months")
            }, b.isDate = m, b.locale = ae, b.invalid = S, b.duration = Ye, b.isMoment = C, b.weekdays = function(t, e, i) {
                return vi(t, e, i, "weekdays")
            }, b.parseZone = function() {
                return Ce.apply(null, arguments).parseZone()
            }, b.localeData = ue, b.isDuration = Oe, b.monthsShort = function(t, e) {
                return yi(t, e, "monthsShort")
            }, b.weekdaysMin = function(t, e, i) {
                return vi(t, e, i, "weekdaysMin")
            }, b.defineLocale = le, b.updateLocale = function(t, e) {
                var i, n, o;
                return null != e ? (o = ie, null != ne[t] && null != ne[t].parentLocale ? ne[t].set(u(ne[t]._config, e)) : (null != (n = se(t)) && (o = n._config), e = u(o, e), null == n && (e.abbr = t), (i = new D(e)).parentLocale = ne[t], ne[t] = i), ae(t)) : null != ne[t] && (null != ne[t].parentLocale ? (ne[t] = ne[t].parentLocale, t === ae() && ae(t)) : null != ne[t] && delete ne[t]), ne[t]
            }, b.locales = function() {
                return n(ne)
            }, b.weekdaysShort = function(t, e, i) {
                return vi(t, e, i, "weekdaysShort")
            }, b.normalizeUnits = R, b.relativeTimeRounding = function(t) {
                return void 0 === t ? Yi : "function" == typeof t && (Yi = t, !0)
            }, b.relativeTimeThreshold = function(t, e) {
                return void 0 !== qi[t] && (void 0 === e ? qi[t] : (qi[t] = e, "s" === t && (qi.ss = e - 1), !0))
            }, b.calendarFormat = function(t, e) {
                var i = t.diff(e, "days", !0);
                return i < -6 ? "sameElse" : i < -1 ? "lastWeek" : i < 0 ? "lastDay" : i < 1 ? "sameDay" : i < 2 ? "nextDay" : i < 7 ? "nextWeek" : "sameElse"
            }, b.prototype = fi, b.HTML5_FMT = {
                DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
                DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
                DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
                DATE: "YYYY-MM-DD",
                TIME: "HH:mm",
                TIME_SECONDS: "HH:mm:ss",
                TIME_MS: "HH:mm:ss.SSS",
                WEEK: "GGGG-[W]WW",
                MONTH: "YYYY-MM"
            }, b
        }),
        function(i) {
            var n = {};

            function o(t) {
                if (n[t]) return n[t].exports;
                var e = n[t] = {
                    i: t,
                    l: !1,
                    exports: {}
                };
                return i[t].call(e.exports, e, e.exports, o), e.l = !0, e.exports
            }
            o.m = i, o.c = n, o.d = function(t, e, i) {
                o.o(t, e) || Object.defineProperty(t, e, {
                    enumerable: !0,
                    get: i
                })
            }, o.r = function(t) {
                "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(t, "__esModule", {
                    value: !0
                })
            }, o.t = function(e, t) {
                if (1 & t && (e = o(e)), 8 & t) return e;
                if (4 & t && "object" == typeof e && e && e.__esModule) return e;
                var i = Object.create(null);
                if (o.r(i), Object.defineProperty(i, "default", {
                        enumerable: !0,
                        value: e
                    }), 2 & t && "string" != typeof e)
                    for (var n in e) o.d(i, n, function(t) {
                        return e[t]
                    }.bind(null, n));
                return i
            }, o.n = function(t) {
                var e = t && t.__esModule ? function() {
                    return t.default
                } : function() {
                    return t
                };
                return o.d(e, "a", e), e
            }, o.o = function(t, e) {
                return Object.prototype.hasOwnProperty.call(t, e)
            }, o.p = "", o(o.s = 11)
        }([, , function(t, e) {
            t.exports = function(t) {
                "complete" === document.readyState || "interactive" === document.readyState ? t.call() : document.attachEvent ? document.attachEvent("onreadystatechange", function() {
                    "interactive" === document.readyState && t.call()
                }) : document.addEventListener && document.addEventListener("DOMContentLoaded", t)
            }
        }, , function(i, t, e) {
            (function(t) {
                var e;
                e = "undefined" != typeof window ? window : void 0 !== t ? t : "undefined" != typeof self ? self : {}, i.exports = e
            }).call(this, e(5))
        }, function(t, e) {
            function i(t) {
                return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                })(t)
            }
            var n;
            n = function() {
                return this
            }();
            try {
                n = n || new Function("return this")()
            } catch (t) {
                "object" === ("undefined" == typeof window ? "undefined" : i(window)) && (n = window)
            }
            t.exports = n
        }, , , , , , function(t, e, i) {
            t.exports = i(12)
        }, function(t, e, i) {
            "use strict";
            i.r(e);
            var n = i(2),
                o = i.n(n),
                r = i(4),
                s = i(13);

            function a(t) {
                return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                })(t)
            }
            var l = r.window.jarallax;
            if (r.window.jarallax = s.default, r.window.jarallax.noConflict = function() {
                    return r.window.jarallax = l, this
                }, void 0 !== r.jQuery_T4NT) {
                var u = function() {
                    var t = arguments || [];
                    Array.prototype.unshift.call(t, this);
                    var e = s.default.apply(r.window, t);
                    return "object" !== a(e) ? e : this
                };
                u.constructor = s.default.constructor;
                var c = r.jQuery_T4NT.fn.jarallax;
                r.jQuery_T4NT.fn.jarallax = u, r.jQuery_T4NT.fn.jarallax.noConflict = function() {
                    return r.jQuery_T4NT.fn.jarallax = c, this
                }
            }
            o()(function() {
                Object(s.default)(document.querySelectorAll("[data-jarallax]"))
            })
        }, function(t, e, i) {
            "use strict";
            i.r(e);
            var n = i(2),
                o = i.n(n),
                r = i(14),
                s = i.n(r),
                y = i(4);

            function h(t) {
                return (h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                })(t)
            }

            function a(t, e) {
                for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
                }
            }
            var l, v, u = -1 < navigator.userAgent.indexOf("MSIE ") || -1 < navigator.userAgent.indexOf("Trident/") || -1 < navigator.userAgent.indexOf("Edge/"),
                c = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
                d = function() {
                    for (var t = "transform WebkitTransform MozTransform".split(" "), e = document.createElement("div"), i = 0; i < t.length; i++)
                        if (e && void 0 !== e.style[t[i]]) return t[i];
                    return !1
                }();

            function f() {
                v = c ? (!l && document.body && ((l = document.createElement("div")).style.cssText = "position: fixed; top: -9999px; left: 0; height: 100vh; width: 0;", document.body.appendChild(l)), (l ? l.clientHeight : 0) || y.window.innerHeight || document.documentElement.clientHeight) : y.window.innerHeight || document.documentElement.clientHeight
            }
            f(), y.window.addEventListener("resize", f), y.window.addEventListener("orientationchange", f), y.window.addEventListener("load", f), o()(function() {
                f()
            });
            var p = [];

            function m() {
                p.length && (p.forEach(function(t, e) {
                    var i = t.instance,
                        n = t.oldData,
                        o = i.$item.getBoundingClientRect(),
                        r = {
                            width: o.width,
                            height: o.height,
                            top: o.top,
                            bottom: o.bottom,
                            wndW: y.window.innerWidth,
                            wndH: v
                        },
                        s = !n || n.wndW !== r.wndW || n.wndH !== r.wndH || n.width !== r.width || n.height !== r.height,
                        a = s || !n || n.top !== r.top || n.bottom !== r.bottom;
                    p[e].oldData = r, s && i.onResize(), a && i.onScroll()
                }), s()(m))
            }

            function g(t, e) {
                ("object" === ("undefined" == typeof HTMLElement ? "undefined" : h(HTMLElement)) ? t instanceof HTMLElement : t && "object" === h(t) && null !== t && 1 === t.nodeType && "string" == typeof t.nodeName) && (t = [t]);
                for (var i, n = e, o = Array.prototype.slice.call(arguments, 2), r = t.length, s = 0; s < r; s++)
                    if ("object" === h(n) || void 0 === n ? t[s].jarallax || (t[s].jarallax = new x(t[s], n)) : t[s].jarallax && (i = t[s].jarallax[n].apply(t[s].jarallax, o)), void 0 !== i) return i;
                return t
            }
            var b = 0,
                x = function() {
                    function c(t, e) {
                        ! function(t, e) {
                            if (!(t instanceof c)) throw new TypeError("Cannot call a class as a function")
                        }(this);
                        var i = this;
                        i.instanceID = b++, i.$item = t, i.defaults = {
                            type: "scroll",
                            speed: .5,
                            imgSrc: null,
                            imgElement: ".jarallax-img",
                            imgSize: "cover",
                            imgPosition: "50% 50%",
                            imgRepeat: "no-repeat",
                            keepImg: !1,
                            elementInViewport: null,
                            zIndex: -100,
                            disableParallax: !1,
                            disableVideo: !1,
                            videoSrc: null,
                            videoStartTime: 0,
                            videoEndTime: 0,
                            videoVolume: 0,
                            videoLoop: !0,
                            videoPlayOnlyVisible: !0,
                            videoLazyLoading: !0,
                            onScroll: null,
                            onInit: null,
                            onDestroy: null,
                            onCoverImage: null
                        };
                        var n = i.$item.dataset || {},
                            o = {};
                        if (Object.keys(n).forEach(function(t) {
                                var e = t.substr(0, 1).toLowerCase() + t.substr(1);
                                e && void 0 !== i.defaults[e] && (o[e] = n[t])
                            }), i.options = i.extend({}, i.defaults, o, e), i.pureOptions = i.extend({}, i.options), Object.keys(i.options).forEach(function(t) {
                                "true" === i.options[t] ? i.options[t] = !0 : "false" === i.options[t] && (i.options[t] = !1)
                            }), i.options.speed = Math.min(2, Math.max(-1, parseFloat(i.options.speed))), "string" == typeof i.options.disableParallax && (i.options.disableParallax = new RegExp(i.options.disableParallax)), i.options.disableParallax instanceof RegExp) {
                            var r = i.options.disableParallax;
                            i.options.disableParallax = function() {
                                return r.test(navigator.userAgent)
                            }
                        }
                        if ("function" != typeof i.options.disableParallax && (i.options.disableParallax = function() {
                                return !1
                            }), "string" == typeof i.options.disableVideo && (i.options.disableVideo = new RegExp(i.options.disableVideo)), i.options.disableVideo instanceof RegExp) {
                            var s = i.options.disableVideo;
                            i.options.disableVideo = function() {
                                return s.test(navigator.userAgent)
                            }
                        }
                        "function" != typeof i.options.disableVideo && (i.options.disableVideo = function() {
                            return !1
                        });
                        var a, l, u = i.options.elementInViewport;
                        u && "object" === h(u) && void 0 !== u.length && (u = (a = u, l = 1, function(t) {
                            if (Array.isArray(t)) return t
                        }(a) || function(t, e) {
                            if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) {
                                var i = [],
                                    n = !0,
                                    o = !1,
                                    r = void 0;
                                try {
                                    for (var s, a = t[Symbol.iterator](); !(n = (s = a.next()).done) && (i.push(s.value), !e || i.length !== e); n = !0);
                                } catch (t) {
                                    o = !0, r = t
                                } finally {
                                    try {
                                        n || null == a.return || a.return()
                                    } finally {
                                        if (o) throw r
                                    }
                                }
                                return i
                            }
                        }(a, l) || function() {
                            throw new TypeError("Invalid attempt to destructure non-iterable instance")
                        }())[0]), u instanceof Element || (u = null), i.options.elementInViewport = u, i.image = {
                            src: i.options.imgSrc || null,
                            $container: null,
                            useImgTag: !1,
                            position: /iPad|iPhone|iPod|Android/.test(navigator.userAgent) ? "absolute" : "fixed"
                        }, i.initImg() && i.canInitParallax() && i.init()
                    }
                    return a(c.prototype, [{
                        key: "css",
                        value: function(e, i) {
                            return "string" == typeof i ? y.window.getComputedStyle(e).getPropertyValue(i) : (i.transform && d && (i[d] = i.transform), Object.keys(i).forEach(function(t) {
                                e.style[t] = i[t]
                            }), e)
                        }
                    }, {
                        key: "extend",
                        value: function(i) {
                            var n = arguments;
                            return i = i || {}, Object.keys(arguments).forEach(function(e) {
                                n[e] && Object.keys(n[e]).forEach(function(t) {
                                    i[t] = n[e][t]
                                })
                            }), i
                        }
                    }, {
                        key: "getWindowData",
                        value: function() {
                            return {
                                width: y.window.innerWidth || document.documentElement.clientWidth,
                                height: v,
                                y: document.documentElement.scrollTop
                            }
                        }
                    }, {
                        key: "initImg",
                        value: function() {
                            var t = this,
                                e = t.options.imgElement;
                            return e && "string" == typeof e && (e = t.$item.querySelector(e)), e instanceof Element || (t.options.imgSrc ? (e = new Image).src = t.options.imgSrc : e = null), e && (t.options.keepImg ? t.image.$item = e.cloneNode(!0) : (t.image.$item = e, t.image.$itemParent = e.parentNode), t.image.useImgTag = !0), !(!t.image.$item && (null === t.image.src && (t.image.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", t.image.bgImage = t.css(t.$item, "background-image")), !t.image.bgImage || "none" === t.image.bgImage))
                        }
                    }, {
                        key: "canInitParallax",
                        value: function() {
                            return d && !this.options.disableParallax()
                        }
                    }, {
                        key: "init",
                        value: function() {
                            var t = this,
                                e = {
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    overflow: "hidden",
                                    pointerEvents: "none"
                                },
                                i = {};
                            if (!t.options.keepImg) {
                                var n = t.$item.getAttribute("style");
                                if (n && t.$item.setAttribute("data-jarallax-original-styles", n), t.image.useImgTag) {
                                    var o = t.image.$item.getAttribute("style");
                                    o && t.image.$item.setAttribute("data-jarallax-original-styles", o)
                                }
                            }
                            if ("static" === t.css(t.$item, "position") && t.css(t.$item, {
                                    position: "relative"
                                }), "auto" === t.css(t.$item, "z-index") && t.css(t.$item, {
                                    zIndex: 0
                                }), t.image.$container = document.createElement("div"), t.css(t.image.$container, e), t.css(t.image.$container, {
                                    "z-index": t.options.zIndex
                                }), u && t.css(t.image.$container, {
                                    opacity: .9999
                                }), t.image.$container.setAttribute("id", "jarallax-container-".concat(t.instanceID)), t.$item.appendChild(t.image.$container), t.image.useImgTag ? i = t.extend({
                                    "object-fit": t.options.imgSize,
                                    "object-position": t.options.imgPosition,
                                    "font-family": "object-fit: ".concat(t.options.imgSize, "; object-position: ").concat(t.options.imgPosition, ";"),
                                    "max-width": "none"
                                }, e, i) : (t.image.$item = document.createElement("div"), t.image.src && (i = t.extend({
                                    "background-position": t.options.imgPosition,
                                    "background-size": t.options.imgSize,
                                    "background-repeat": t.options.imgRepeat,
                                    "background-image": t.image.bgImage || 'url("'.concat(t.image.src, '")')
                                }, e, i))), "opacity" !== t.options.type && "scale" !== t.options.type && "scale-opacity" !== t.options.type && 1 !== t.options.speed || (t.image.position = "absolute"), "fixed" === t.image.position) {
                                var r = function(t) {
                                    for (var e = []; null !== t.parentElement;) 1 === (t = t.parentElement).nodeType && e.push(t);
                                    return e
                                }(t.$item).filter(function(t) {
                                    var e = y.window.getComputedStyle(t),
                                        i = e["-webkit-transform"] || e["-moz-transform"] || e.transform;
                                    return i && "none" !== i || /(auto|scroll)/.test(e.overflow + e["overflow-y"] + e["overflow-x"])
                                });
                                t.image.position = r.length ? "absolute" : "fixed"
                            }
                            i.position = t.image.position, t.css(t.image.$item, i), t.image.$container.appendChild(t.image.$item), t.onResize(), t.onScroll(!0), t.options.onInit && t.options.onInit.call(t), "none" !== t.css(t.$item, "background-image") && t.css(t.$item, {
                                "background-image": "none"
                            }), t.addToParallaxList()
                        }
                    }, {
                        key: "addToParallaxList",
                        value: function() {
                            p.push({
                                instance: this
                            }), 1 === p.length && m()
                        }
                    }, {
                        key: "removeFromParallaxList",
                        value: function() {
                            var i = this;
                            p.forEach(function(t, e) {
                                t.instance.instanceID === i.instanceID && p.splice(e, 1)
                            })
                        }
                    }, {
                        key: "destroy",
                        value: function() {
                            var t = this;
                            t.removeFromParallaxList();
                            var e = t.$item.getAttribute("data-jarallax-original-styles");
                            if (t.$item.removeAttribute("data-jarallax-original-styles"), e ? t.$item.setAttribute("style", e) : t.$item.removeAttribute("style"), t.image.useImgTag) {
                                var i = t.image.$item.getAttribute("data-jarallax-original-styles");
                                t.image.$item.removeAttribute("data-jarallax-original-styles"), i ? t.image.$item.setAttribute("style", e) : t.image.$item.removeAttribute("style"), t.image.$itemParent && t.image.$itemParent.appendChild(t.image.$item)
                            }
                            t.$clipStyles && t.$clipStyles.parentNode.removeChild(t.$clipStyles), t.image.$container && t.image.$container.parentNode.removeChild(t.image.$container), t.options.onDestroy && t.options.onDestroy.call(t), delete t.$item.jarallax
                        }
                    }, {
                        key: "clipContainer",
                        value: function() {
                            if ("fixed" === this.image.position) {
                                var t = this,
                                    e = t.image.$container.getBoundingClientRect(),
                                    i = e.width,
                                    n = e.height;
                                t.$clipStyles || (t.$clipStyles = document.createElement("style"), t.$clipStyles.setAttribute("type", "text/css"), t.$clipStyles.setAttribute("id", "jarallax-clip-".concat(t.instanceID)), (document.head || document.getElementsByTagName("head")[0]).appendChild(t.$clipStyles));
                                var o = "#jarallax-container-".concat(t.instanceID, " {\n           clip: rect(0 ").concat(i, "px ").concat(n, "px 0);\n           clip: rect(0, ").concat(i, "px, ").concat(n, "px, 0);\n        }");
                                t.$clipStyles.styleSheet ? t.$clipStyles.styleSheet.cssText = o : t.$clipStyles.innerHTML = o
                            }
                        }
                    }, {
                        key: "coverImage",
                        value: function() {
                            var t, e = this,
                                i = e.image.$container.getBoundingClientRect(),
                                n = i.height,
                                o = e.options.speed,
                                r = "scroll" === e.options.type || "scroll-opacity" === e.options.type,
                                s = 0,
                                a = n;
                            return r && (o < 0 ? (s = o * Math.max(n, v), v < n && (s -= o * (n - v))) : s = o * (n + v), 1 < o ? a = Math.abs(s - v) : o < 0 ? a = s / o + Math.abs(s) : a += (v - n) * (1 - o), s /= 2), e.parallaxScrollDistance = s, t = r ? (v - a) / 2 : (n - a) / 2, e.css(e.image.$item, {
                                height: "".concat(a, "px"),
                                marginTop: "".concat(t, "px"),
                                left: "fixed" === e.image.position ? "".concat(i.left, "px") : "0",
                                width: "".concat(i.width, "px")
                            }), e.options.onCoverImage && e.options.onCoverImage.call(e), {
                                image: {
                                    height: a,
                                    marginTop: t
                                },
                                container: i
                            }
                        }
                    }, {
                        key: "isVisible",
                        value: function() {
                            return this.isElementInViewport || !1
                        }
                    }, {
                        key: "onScroll",
                        value: function(t) {
                            var e = this,
                                i = e.$item.getBoundingClientRect(),
                                n = i.top,
                                o = i.height,
                                r = {},
                                s = i;
                            if (e.options.elementInViewport && (s = e.options.elementInViewport.getBoundingClientRect()), e.isElementInViewport = 0 <= s.bottom && 0 <= s.right && s.top <= v && s.left <= y.window.innerWidth, t || e.isElementInViewport) {
                                var a = Math.max(0, n),
                                    l = Math.max(0, o + n),
                                    u = Math.max(0, -n),
                                    c = Math.max(0, n + o - v),
                                    h = Math.max(0, o - (n + o - v)),
                                    d = Math.max(0, -n + v - o),
                                    f = 1 - 2 * (v - n) / (v + o),
                                    p = 1;
                                if (o < v ? p = 1 - (u || c) / o : l <= v ? p = l / v : h <= v && (p = h / v), "opacity" !== e.options.type && "scale-opacity" !== e.options.type && "scroll-opacity" !== e.options.type || (r.transform = "translate3d(0,0,0)", r.opacity = p), "scale" === e.options.type || "scale-opacity" === e.options.type) {
                                    var m = 1;
                                    e.options.speed < 0 ? m -= e.options.speed * p : m += e.options.speed * (1 - p), r.transform = "scale(".concat(m, ") translate3d(0,0,0)")
                                }
                                if ("scroll" === e.options.type || "scroll-opacity" === e.options.type) {
                                    var g = e.parallaxScrollDistance * f;
                                    "absolute" === e.image.position && (g -= n), r.transform = "translate3d(0,".concat(g, "px,0)")
                                }
                                e.css(e.image.$item, r), e.options.onScroll && e.options.onScroll.call(e, {
                                    section: i,
                                    beforeTop: a,
                                    beforeTopEnd: l,
                                    afterTop: u,
                                    beforeBottom: c,
                                    beforeBottomEnd: h,
                                    afterBottom: d,
                                    visiblePercent: p,
                                    fromViewportCenter: f
                                })
                            }
                        }
                    }, {
                        key: "onResize",
                        value: function() {
                            this.coverImage(), this.clipContainer()
                        }
                    }]), c
                }();
            g.constructor = x, e.default = g
        }, function(t, e, i) {
            var n = i(15),
                o = n.requestAnimationFrame || n.webkitRequestAnimationFrame || n.mozRequestAnimationFrame || function(t) {
                    var e = +new Date,
                        i = Math.max(0, 16 - (e - r)),
                        n = setTimeout(t, i);
                    return r = e, n
                },
                r = +new Date,
                s = n.cancelAnimationFrame || n.webkitCancelAnimationFrame || n.mozCancelAnimationFrame || clearTimeout;
            Function.prototype.bind && (o = o.bind(n), s = s.bind(n)), (t.exports = o).cancel = s
        }, function(i, t, e) {
            (function(t) {
                var e;
                e = "undefined" != typeof window ? window : void 0 !== t ? t : "undefined" != typeof self ? self : {}, i.exports = e
            }).call(this, e(5))
        }]),
        function(t, e) {
            "undefined" != typeof module && module.exports ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : this.$script = e()
        }(0, function() {
            function u(t, e) {
                for (var i = 0, n = t.length; i < n; ++i)
                    if (!e(t[i])) return a;
                return 1
            }

            function c(t, e) {
                u(t, function(t) {
                    return e(t), 1
                })
            }

            function h(t, e, i) {
                function n(t) {
                    return t.call ? t() : g[t]
                }

                function o() {
                    if (!--l)
                        for (var t in g[a] = 1, s && s(), v) u(t.split("|"), n) && !c(v[t], n) && (v[t] = [])
                }
                t = t[p] ? t : [t];
                var r = e && e.call,
                    s = r ? e : i,
                    a = r ? t.join("") : e,
                    l = t.length;
                return setTimeout(function() {
                    c(t, function t(e, i) {
                        return null === e ? o() : (!i && !/^https?:\/\//.test(e) && f && (e = -1 === e.indexOf(".js") ? f + e + ".js" : f + e), b[e] ? (a && (y[a] = 1), 2 == b[e] ? o() : setTimeout(function() {
                            t(e, !0)
                        }, 0)) : (b[e] = 1, a && (y[a] = 1), void d(e, o)))
                    })
                }, 0), h
            }

            function d(t, e) {
                var i, n = r.createElement("script");
                n.onload = n.onerror = n[m] = function() {
                    n[l] && !/^c|loade/.test(n[l]) || i || (n.onload = n[m] = null, i = 1, b[t] = 2, e())
                }, n.async = 1, n.src = o ? t + (-1 === t.indexOf("?") ? "?" : "&") + o : t, s.insertBefore(n, s.lastChild)
            }
            var f, o, r = document,
                s = r.getElementsByTagName("head")[0],
                a = !1,
                p = "push",
                l = "readyState",
                m = "onreadystatechange",
                g = {},
                y = {},
                v = {},
                b = {};
            return h.get = d, h.order = function(i, n, o) {
                ! function t(e) {
                    e = i.shift(), i.length ? h(e, t) : h(e, n, o)
                }()
            }, h.path = function(t) {
                f = t
            }, h.urlArgs = function(t) {
                o = t
            }, h.ready = function(t, e, i) {
                t = t[p] ? t : [t];
                var n, o = [];
                return !c(t, function(t) {
                    g[t] || o[p](t)
                }) && u(t, function(t) {
                    return g[t]
                }) ? e() : (n = t.join("|"), v[n] = v[n] || [], v[n][p](e), i && i(o)), h
            }, h.done = function(t) {
                h([null], t)
            }, h
        });
    var JSNTT4 = jQuery_T4NT("#js_ntt4"),
        $jbody = jQuery_T4NT("body");
    $script(JSNTT4.data("stt"), function() {
        $script(JSNTT4.data("theme"))
    })
}